webpackJsonp([115786611955454],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(43);
	var isBuffer = __webpack_require__(142);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(54);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(158),
	    getValue = __webpack_require__(177);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(15),
	    getRawTag = __webpack_require__(176),
	    objectToString = __webpack_require__(202);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(99);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(189),
	    listCacheDelete = __webpack_require__(190),
	    listCacheGet = __webpack_require__(191),
	    listCacheHas = __webpack_require__(192),
	    listCacheSet = __webpack_require__(193);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(5);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(59);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(50),
	    baseAssignValue = __webpack_require__(51);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(187);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(6);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(2);
	var normalizeHeaderName = __webpack_require__(113);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(39);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(39);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(6),
	    root = __webpack_require__(5);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(148);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(151),
	    stubArray = __webpack_require__(65);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(143),
	    Map = __webpack_require__(23),
	    Promise = __webpack_require__(145),
	    Set = __webpack_require__(146),
	    WeakMap = __webpack_require__(149),
	    baseGetTag = __webpack_require__(9),
	    toSource = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(54);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)(module)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(9),
	    isObjectLike = __webpack_require__(7);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(47),
	    baseKeys = __webpack_require__(161),
	    isArrayLike = __webpack_require__(60);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	var settle = __webpack_require__(105);
	var buildURL = __webpack_require__(108);
	var parseHeaders = __webpack_require__(114);
	var isURLSameOrigin = __webpack_require__(112);
	var createError = __webpack_require__(42);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(107);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(110);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(104);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(194),
	    mapCacheDelete = __webpack_require__(195),
	    mapCacheGet = __webpack_require__(196),
	    mapCacheHas = __webpack_require__(197),
	    mapCacheSet = __webpack_require__(198);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(163),
	    isArguments = __webpack_require__(211),
	    isArray = __webpack_require__(10),
	    isBuffer = __webpack_require__(61),
	    isIndex = __webpack_require__(186),
	    isTypedArray = __webpack_require__(214);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(51),
	    eq = __webpack_require__(59);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(173);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(49),
	    isArray = __webpack_require__(10);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(57);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(49),
	    getPrototype = __webpack_require__(55),
	    getSymbols = __webpack_require__(26),
	    stubArray = __webpack_require__(65);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(62),
	    isLength = __webpack_require__(63);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(5),
	    stubFalse = __webpack_require__(216);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)(module)))

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(9),
	    isObject = __webpack_require__(11);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(47),
	    baseKeysIn = __webpack_require__(162),
	    isArrayLike = __webpack_require__(60);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(73);
	var isArguments = __webpack_require__(72);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(79);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(71);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(78);
	
	var _HelmetConstants = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(76);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(74);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(80);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {/*! UIkit 3.0.3 | http://www.getuikit.com | (c) 2014 - 2018 YOOtheme | MIT License */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define('uikit', factory) :
	    (global = global || self, global.UIkit = factory());
	}(this, function () { 'use strict';
	
	    function bind(fn, context) {
	        return function (a) {
	            var l = arguments.length;
	            return l ? l > 1 ? fn.apply(context, arguments) : fn.call(context, a) : fn.call(context);
	        };
	    }
	
	    var objPrototype = Object.prototype;
	    var hasOwnProperty = objPrototype.hasOwnProperty;
	
	    function hasOwn(obj, key) {
	        return hasOwnProperty.call(obj, key);
	    }
	
	    var hyphenateCache = {};
	    var hyphenateRe = /([a-z\d])([A-Z])/g;
	
	    function hyphenate(str) {
	
	        if (!(str in hyphenateCache)) {
	            hyphenateCache[str] = str
	                .replace(hyphenateRe, '$1-$2')
	                .toLowerCase();
	        }
	
	        return hyphenateCache[str];
	    }
	
	    var camelizeRe = /-(\w)/g;
	
	    function camelize(str) {
	        return str.replace(camelizeRe, toUpper);
	    }
	
	    function toUpper(_, c) {
	        return c ? c.toUpperCase() : '';
	    }
	
	    function ucfirst(str) {
	        return str.length ? toUpper(null, str.charAt(0)) + str.slice(1) : '';
	    }
	
	    var strPrototype = String.prototype;
	    var startsWithFn = strPrototype.startsWith || function (search) { return this.lastIndexOf(search, 0) === 0; };
	
	    function startsWith(str, search) {
	        return startsWithFn.call(str, search);
	    }
	
	    var endsWithFn = strPrototype.endsWith || function (search) { return this.substr(-search.length) === search; };
	
	    function endsWith(str, search) {
	        return endsWithFn.call(str, search);
	    }
	
	    var includesFn = function (search) { return ~this.indexOf(search); };
	    var includesStr = strPrototype.includes || includesFn;
	    var includesArray = Array.prototype.includes || includesFn;
	
	    function includes(obj, search) {
	        return obj && (isString(obj) ? includesStr : includesArray).call(obj, search);
	    }
	
	    var isArray = Array.isArray;
	
	    function isFunction(obj) {
	        return typeof obj === 'function';
	    }
	
	    function isObject(obj) {
	        return obj !== null && typeof obj === 'object';
	    }
	
	    function isPlainObject(obj) {
	        return isObject(obj) && Object.getPrototypeOf(obj) === objPrototype;
	    }
	
	    function isWindow(obj) {
	        return isObject(obj) && obj === obj.window;
	    }
	
	    function isDocument(obj) {
	        return isObject(obj) && obj.nodeType === 9;
	    }
	
	    function isJQuery(obj) {
	        return isObject(obj) && !!obj.jquery;
	    }
	
	    function isNode(obj) {
	        return obj instanceof Node || isObject(obj) && obj.nodeType >= 1;
	    }
	
	    var toString = objPrototype.toString;
	    function isNodeCollection(obj) {
	        return toString.call(obj).match(/^\[object (NodeList|HTMLCollection)\]$/);
	    }
	
	    function isBoolean(value) {
	        return typeof value === 'boolean';
	    }
	
	    function isString(value) {
	        return typeof value === 'string';
	    }
	
	    function isNumber(value) {
	        return typeof value === 'number';
	    }
	
	    function isNumeric(value) {
	        return isNumber(value) || isString(value) && !isNaN(value - parseFloat(value));
	    }
	
	    function isUndefined(value) {
	        return value === void 0;
	    }
	
	    function toBoolean(value) {
	        return isBoolean(value)
	            ? value
	            : value === 'true' || value === '1' || value === ''
	                ? true
	                : value === 'false' || value === '0'
	                    ? false
	                    : value;
	    }
	
	    function toNumber(value) {
	        var number = Number(value);
	        return !isNaN(number) ? number : false;
	    }
	
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	
	    function toNode(element) {
	        return isNode(element) || isWindow(element) || isDocument(element)
	            ? element
	            : isNodeCollection(element) || isJQuery(element)
	                ? element[0]
	                : isArray(element)
	                    ? toNode(element[0])
	                    : null;
	    }
	
	    var arrayProto = Array.prototype;
	    function toNodes(element) {
	        return isNode(element)
	            ? [element]
	            : isNodeCollection(element)
	                ? arrayProto.slice.call(element)
	                : isArray(element)
	                    ? element.map(toNode).filter(Boolean)
	                    : isJQuery(element)
	                        ? element.toArray()
	                        : [];
	    }
	
	    function toList(value) {
	        return isArray(value)
	            ? value
	            : isString(value)
	                ? value.split(/,(?![^(]*\))/).map(function (value) { return isNumeric(value)
	                    ? toNumber(value)
	                    : toBoolean(value.trim()); })
	                : [value];
	    }
	
	    function toMs(time) {
	        return !time
	            ? 0
	            : endsWith(time, 'ms')
	                ? toFloat(time)
	                : toFloat(time) * 1000;
	    }
	
	    function isEqual(value, other) {
	        return value === other
	            || isObject(value)
	            && isObject(other)
	            && Object.keys(value).length === Object.keys(other).length
	            && each(value, function (val, key) { return val === other[key]; });
	    }
	
	    function swap(value, a, b) {
	        return value.replace(new RegExp((a + "|" + b), 'mg'), function (match) {
	            return match === a ? b : a;
	        });
	    }
	
	    var assign = Object.assign || function (target) {
	        var args = [], len = arguments.length - 1;
	        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
	        target = Object(target);
	        for (var i = 0; i < args.length; i++) {
	            var source = args[i];
	            if (source !== null) {
	                for (var key in source) {
	                    if (hasOwn(source, key)) {
	                        target[key] = source[key];
	                    }
	                }
	            }
	        }
	        return target;
	    };
	
	    function each(obj, cb) {
	        for (var key in obj) {
	            if (false === cb(obj[key], key)) {
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function sortBy(collection, prop) {
	        return collection.sort(function (ref, ref$1) {
	                var propA = ref[prop]; if ( propA === void 0 ) propA = 0;
	                var propB = ref$1[prop]; if ( propB === void 0 ) propB = 0;
	
	                return propA > propB
	                ? 1
	                : propB > propA
	                    ? -1
	                    : 0;
	        }
	        );
	    }
	
	    function clamp(number, min, max) {
	        if ( min === void 0 ) min = 0;
	        if ( max === void 0 ) max = 1;
	
	        return Math.min(Math.max(toNumber(number) || 0, min), max);
	    }
	
	    function noop() {}
	
	    function intersectRect(r1, r2) {
	        return r1.left < r2.right &&
	            r1.right > r2.left &&
	            r1.top < r2.bottom &&
	            r1.bottom > r2.top;
	    }
	
	    function pointInRect(point, rect) {
	        return point.x <= rect.right &&
	            point.x >= rect.left &&
	            point.y <= rect.bottom &&
	            point.y >= rect.top;
	    }
	
	    var Dimensions = {
	
	        ratio: function(dimensions, prop, value) {
	            var obj;
	
	
	            var aProp = prop === 'width' ? 'height' : 'width';
	
	            return ( obj = {}, obj[aProp] = dimensions[prop] ? Math.round(value * dimensions[aProp] / dimensions[prop]) : dimensions[aProp], obj[prop] = value, obj );
	        },
	
	        contain: function(dimensions, maxDimensions) {
	            var this$1 = this;
	
	            dimensions = assign({}, dimensions);
	
	            each(dimensions, function (_, prop) { return dimensions = dimensions[prop] > maxDimensions[prop]
	                ? this$1.ratio(dimensions, prop, maxDimensions[prop])
	                : dimensions; }
	            );
	
	            return dimensions;
	        },
	
	        cover: function(dimensions, maxDimensions) {
	            var this$1 = this;
	
	            dimensions = this.contain(dimensions, maxDimensions);
	
	            each(dimensions, function (_, prop) { return dimensions = dimensions[prop] < maxDimensions[prop]
	                ? this$1.ratio(dimensions, prop, maxDimensions[prop])
	                : dimensions; }
	            );
	
	            return dimensions;
	        }
	
	    };
	
	    function attr(element, name, value) {
	
	        if (isObject(name)) {
	            for (var key in name) {
	                attr(element, key, name[key]);
	            }
	            return;
	        }
	
	        if (isUndefined(value)) {
	            element = toNode(element);
	            return element && element.getAttribute(name);
	        } else {
	            toNodes(element).forEach(function (element) {
	
	                if (isFunction(value)) {
	                    value = value.call(element, attr(element, name));
	                }
	
	                if (value === null) {
	                    removeAttr(element, name);
	                } else {
	                    element.setAttribute(name, value);
	                }
	            });
	        }
	
	    }
	
	    function hasAttr(element, name) {
	        return toNodes(element).some(function (element) { return element.hasAttribute(name); });
	    }
	
	    function removeAttr(element, name) {
	        element = toNodes(element);
	        name.split(' ').forEach(function (name) { return element.forEach(function (element) { return element.removeAttribute(name); }
	            ); }
	        );
	    }
	
	    function data(element, attribute) {
	        for (var i = 0, attrs = [attribute, ("data-" + attribute)]; i < attrs.length; i++) {
	            if (hasAttr(element, attrs[i])) {
	                return attr(element, attrs[i]);
	            }
	        }
	    }
	
	    function query(selector, context) {
	        return toNode(selector) || find(selector, getContext(selector, context));
	    }
	
	    function queryAll(selector, context) {
	        var nodes = toNodes(selector);
	        return nodes.length && nodes || findAll(selector, getContext(selector, context));
	    }
	
	    function getContext(selector, context) {
	        if ( context === void 0 ) context = document;
	
	        return isContextSelector(selector) || isDocument(context)
	            ? context
	            : context.ownerDocument;
	    }
	
	    function find(selector, context) {
	        return toNode(_query(selector, context, 'querySelector'));
	    }
	
	    function findAll(selector, context) {
	        return toNodes(_query(selector, context, 'querySelectorAll'));
	    }
	
	    function _query(selector, context, queryFn) {
	        if ( context === void 0 ) context = document;
	
	
	        if (!selector || !isString(selector)) {
	            return null;
	        }
	
	        selector = selector.replace(contextSanitizeRe, '$1 *');
	
	        var removes;
	
	        if (isContextSelector(selector)) {
	
	            removes = [];
	
	            selector = selector.split(',').map(function (selector, i) {
	
	                var ctx = context;
	
	                selector = selector.trim();
	
	                if (selector[0] === '!') {
	
	                    var selectors = selector.substr(1).trim().split(' ');
	                    ctx = closest(context.parentNode, selectors[0]);
	                    selector = selectors.slice(1).join(' ').trim();
	
	                }
	
	                if (selector[0] === '-') {
	
	                    var selectors$1 = selector.substr(1).trim().split(' ');
	                    var prev = (ctx || context).previousElementSibling;
	                    ctx = matches(prev, selector.substr(1)) ? prev : null;
	                    selector = selectors$1.slice(1).join(' ');
	
	                }
	
	                if (!ctx) {
	                    return null;
	                }
	
	                if (!ctx.id) {
	                    ctx.id = "uk-" + (Date.now()) + i;
	                    removes.push(function () { return removeAttr(ctx, 'id'); });
	                }
	
	                return ("#" + (escape(ctx.id)) + " " + selector);
	
	            }).filter(Boolean).join(',');
	
	            context = document;
	
	        }
	
	        try {
	
	            return context[queryFn](selector);
	
	        } catch (e) {
	
	            return null;
	
	        } finally {
	
	            removes && removes.forEach(function (remove) { return remove(); });
	
	        }
	
	    }
	
	    var contextSelectorRe = /(^|,)\s*[!>+~-]/;
	    var contextSanitizeRe = /([!>+~-])(?=\s+[!>+~-]|\s*$)/g;
	
	    function isContextSelector(selector) {
	        return isString(selector) && selector.match(contextSelectorRe);
	    }
	
	    var elProto = Element.prototype;
	    var matchesFn = elProto.matches || elProto.webkitMatchesSelector || elProto.msMatchesSelector;
	
	    function matches(element, selector) {
	        return toNodes(element).some(function (element) { return matchesFn.call(element, selector); });
	    }
	
	    var closestFn = elProto.closest || function (selector) {
	        var ancestor = this;
	
	        do {
	
	            if (matches(ancestor, selector)) {
	                return ancestor;
	            }
	
	            ancestor = ancestor.parentNode;
	
	        } while (ancestor && ancestor.nodeType === 1);
	    };
	
	    function closest(element, selector) {
	
	        if (startsWith(selector, '>')) {
	            selector = selector.slice(1);
	        }
	
	        return isNode(element)
	            ? element.parentNode && closestFn.call(element, selector)
	            : toNodes(element).map(function (element) { return closest(element, selector); }).filter(Boolean);
	    }
	
	    function parents(element, selector) {
	        var elements = [];
	        var parent = toNode(element).parentNode;
	
	        while (parent && parent.nodeType === 1) {
	
	            if (matches(parent, selector)) {
	                elements.push(parent);
	            }
	
	            parent = parent.parentNode;
	        }
	
	        return elements;
	    }
	
	    var escapeFn = window.CSS && CSS.escape || function (css) { return css.replace(/([^\x7f-\uFFFF\w-])/g, function (match) { return ("\\" + match); }); };
	    function escape(css) {
	        return isString(css) ? escapeFn.call(null, css) : '';
	    }
	
	    var voidElements = {
	        area: true,
	        base: true,
	        br: true,
	        col: true,
	        embed: true,
	        hr: true,
	        img: true,
	        input: true,
	        keygen: true,
	        link: true,
	        menuitem: true,
	        meta: true,
	        param: true,
	        source: true,
	        track: true,
	        wbr: true
	    };
	    function isVoidElement(element) {
	        return toNodes(element).some(function (element) { return voidElements[element.tagName.toLowerCase()]; });
	    }
	
	    function isVisible(element) {
	        return toNodes(element).some(function (element) { return element.offsetWidth || element.offsetHeight || element.getClientRects().length; });
	    }
	
	    var selInput = 'input,select,textarea,button';
	    function isInput(element) {
	        return toNodes(element).some(function (element) { return matches(element, selInput); });
	    }
	
	    function filter(element, selector) {
	        return toNodes(element).filter(function (element) { return matches(element, selector); });
	    }
	
	    function within(element, selector) {
	        return !isString(selector)
	            ? element === selector || (isDocument(selector)
	                ? selector.documentElement
	                : toNode(selector)).contains(toNode(element)) // IE 11 document does not implement contains
	            : matches(element, selector) || closest(element, selector);
	    }
	
	    /* global DocumentTouch */
	
	    var isIE = /msie|trident/i.test(window.navigator.userAgent);
	    var isRtl = attr(document.documentElement, 'dir') === 'rtl';
	
	    var hasTouchEvents = 'ontouchstart' in window;
	    var hasPointerEvents = window.PointerEvent;
	    var hasTouch = hasTouchEvents
	        || window.DocumentTouch && document instanceof DocumentTouch
	        || navigator.maxTouchPoints; // IE >=11
	
	    var pointerDown = hasPointerEvents ? 'pointerdown' : hasTouchEvents ? 'touchstart' : 'mousedown';
	    var pointerMove = hasPointerEvents ? 'pointermove' : hasTouchEvents ? 'touchmove' : 'mousemove';
	    var pointerUp = hasPointerEvents ? 'pointerup' : hasTouchEvents ? 'touchend' : 'mouseup';
	    var pointerEnter = hasPointerEvents ? 'pointerenter' : hasTouchEvents ? '' : 'mouseenter';
	    var pointerLeave = hasPointerEvents ? 'pointerleave' : hasTouchEvents ? '' : 'mouseleave';
	    var pointerCancel = hasPointerEvents ? 'pointercancel' : 'touchcancel';
	
	    function on() {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	
	        var ref = getArgs(args);
	        var targets = ref[0];
	        var type = ref[1];
	        var selector = ref[2];
	        var listener = ref[3];
	        var useCapture = ref[4];
	
	        targets = toEventTargets(targets);
	
	        if (selector) {
	            listener = delegate(targets, selector, listener);
	        }
	
	        if (listener.length > 1) {
	            listener = detail(listener);
	        }
	
	        type.split(' ').forEach(function (type) { return targets.forEach(function (target) { return target.addEventListener(type, listener, useCapture); }
	            ); }
	        );
	        return function () { return off(targets, type, listener, useCapture); };
	    }
	
	    function off(targets, type, listener, useCapture) {
	        if ( useCapture === void 0 ) useCapture = false;
	
	        targets = toEventTargets(targets);
	        type.split(' ').forEach(function (type) { return targets.forEach(function (target) { return target.removeEventListener(type, listener, useCapture); }
	            ); }
	        );
	    }
	
	    function once() {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	
	        var ref = getArgs(args);
	        var element = ref[0];
	        var type = ref[1];
	        var selector = ref[2];
	        var listener = ref[3];
	        var useCapture = ref[4];
	        var condition = ref[5];
	        var off = on(element, type, selector, function (e) {
	            var result = !condition || condition(e);
	            if (result) {
	                off();
	                listener(e, result);
	            }
	        }, useCapture);
	
	        return off;
	    }
	
	    function trigger(targets, event, detail) {
	        return toEventTargets(targets).reduce(function (notCanceled, target) { return notCanceled && target.dispatchEvent(createEvent(event, true, true, detail)); }
	            , true);
	    }
	
	    function createEvent(e, bubbles, cancelable, detail) {
	        if ( bubbles === void 0 ) bubbles = true;
	        if ( cancelable === void 0 ) cancelable = false;
	
	        if (isString(e)) {
	            var event = document.createEvent('CustomEvent'); // IE 11
	            event.initCustomEvent(e, bubbles, cancelable, detail);
	            e = event;
	        }
	
	        return e;
	    }
	
	    function getArgs(args) {
	        if (isFunction(args[2])) {
	            args.splice(2, 0, false);
	        }
	        return args;
	    }
	
	    function delegate(delegates, selector, listener) {
	        var this$1 = this;
	
	        return function (e) {
	
	            delegates.forEach(function (delegate) {
	
	                var current = selector[0] === '>'
	                    ? findAll(selector, delegate).reverse().filter(function (element) { return within(e.target, element); })[0]
	                    : closest(e.target, selector);
	
	                if (current) {
	                    e.delegate = delegate;
	                    e.current = current;
	
	                    listener.call(this$1, e);
	                }
	
	            });
	
	        };
	    }
	
	    function detail(listener) {
	        return function (e) { return isArray(e.detail) ? listener.apply(void 0, [e].concat(e.detail)) : listener(e); };
	    }
	
	    function isEventTarget(target) {
	        return target && 'addEventListener' in target;
	    }
	
	    function toEventTarget(target) {
	        return isEventTarget(target) ? target : toNode(target);
	    }
	
	    function toEventTargets(target) {
	        return isArray(target)
	                ? target.map(toEventTarget).filter(Boolean)
	                : isString(target)
	                    ? findAll(target)
	                    : isEventTarget(target)
	                        ? [target]
	                        : toNodes(target);
	    }
	
	    function preventClick() {
	
	        var timer = setTimeout(once(document, 'click', function (e) {
	
	            e.preventDefault();
	            e.stopImmediatePropagation();
	
	            clearTimeout(timer);
	
	        }, true));
	
	        trigger(document, pointerCancel);
	
	    }
	
	    /* global setImmediate */
	
	    var Promise = 'Promise' in window ? window.Promise : PromiseFn;
	
	    var Deferred = function() {
	        var this$1 = this;
	
	        this.promise = new Promise(function (resolve, reject) {
	            this$1.reject = reject;
	            this$1.resolve = resolve;
	        });
	    };
	
	    /**
	     * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	     */
	
	    var RESOLVED = 0;
	    var REJECTED = 1;
	    var PENDING = 2;
	
	    var async = 'setImmediate' in window ? setImmediate : setTimeout;
	
	    function PromiseFn(executor) {
	
	        this.state = PENDING;
	        this.value = undefined;
	        this.deferred = [];
	
	        var promise = this;
	
	        try {
	            executor(
	                function (x) {
	                    promise.resolve(x);
	                },
	                function (r) {
	                    promise.reject(r);
	                }
	            );
	        } catch (e) {
	            promise.reject(e);
	        }
	    }
	
	    PromiseFn.reject = function (r) {
	        return new PromiseFn(function (resolve, reject) {
	            reject(r);
	        });
	    };
	
	    PromiseFn.resolve = function (x) {
	        return new PromiseFn(function (resolve, reject) {
	            resolve(x);
	        });
	    };
	
	    PromiseFn.all = function all(iterable) {
	        return new PromiseFn(function (resolve, reject) {
	            var result = [];
	            var count = 0;
	
	            if (iterable.length === 0) {
	                resolve(result);
	            }
	
	            function resolver(i) {
	                return function (x) {
	                    result[i] = x;
	                    count += 1;
	
	                    if (count === iterable.length) {
	                        resolve(result);
	                    }
	                };
	            }
	
	            for (var i = 0; i < iterable.length; i += 1) {
	                PromiseFn.resolve(iterable[i]).then(resolver(i), reject);
	            }
	        });
	    };
	
	    PromiseFn.race = function race(iterable) {
	        return new PromiseFn(function (resolve, reject) {
	            for (var i = 0; i < iterable.length; i += 1) {
	                PromiseFn.resolve(iterable[i]).then(resolve, reject);
	            }
	        });
	    };
	
	    var p = PromiseFn.prototype;
	
	    p.resolve = function resolve(x) {
	        var promise = this;
	
	        if (promise.state === PENDING) {
	            if (x === promise) {
	                throw new TypeError('Promise settled with itself.');
	            }
	
	            var called = false;
	
	            try {
	                var then = x && x.then;
	
	                if (x !== null && isObject(x) && isFunction(then)) {
	                    then.call(
	                        x,
	                        function (x) {
	                            if (!called) {
	                                promise.resolve(x);
	                            }
	                            called = true;
	                        },
	                        function (r) {
	                            if (!called) {
	                                promise.reject(r);
	                            }
	                            called = true;
	                        }
	                    );
	                    return;
	                }
	            } catch (e) {
	                if (!called) {
	                    promise.reject(e);
	                }
	                return;
	            }
	
	            promise.state = RESOLVED;
	            promise.value = x;
	            promise.notify();
	        }
	    };
	
	    p.reject = function reject(reason) {
	        var promise = this;
	
	        if (promise.state === PENDING) {
	            if (reason === promise) {
	                throw new TypeError('Promise settled with itself.');
	            }
	
	            promise.state = REJECTED;
	            promise.value = reason;
	            promise.notify();
	        }
	    };
	
	    p.notify = function notify() {
	        var this$1 = this;
	
	        async(function () {
	            if (this$1.state !== PENDING) {
	                while (this$1.deferred.length) {
	                    var ref = this$1.deferred.shift();
	                    var onResolved = ref[0];
	                    var onRejected = ref[1];
	                    var resolve = ref[2];
	                    var reject = ref[3];
	
	                    try {
	                        if (this$1.state === RESOLVED) {
	                            if (isFunction(onResolved)) {
	                                resolve(onResolved.call(undefined, this$1.value));
	                            } else {
	                                resolve(this$1.value);
	                            }
	                        } else if (this$1.state === REJECTED) {
	                            if (isFunction(onRejected)) {
	                                resolve(onRejected.call(undefined, this$1.value));
	                            } else {
	                                reject(this$1.value);
	                            }
	                        }
	                    } catch (e) {
	                        reject(e);
	                    }
	                }
	            }
	        });
	    };
	
	    p.then = function then(onResolved, onRejected) {
	        var this$1 = this;
	
	        return new PromiseFn(function (resolve, reject) {
	            this$1.deferred.push([onResolved, onRejected, resolve, reject]);
	            this$1.notify();
	        });
	    };
	
	    p.catch = function (onRejected) {
	        return this.then(undefined, onRejected);
	    };
	
	    function ajax(url, options) {
	        return new Promise(function (resolve, reject) {
	
	            var env = assign({
	                data: null,
	                method: 'GET',
	                headers: {},
	                xhr: new XMLHttpRequest(),
	                beforeSend: noop,
	                responseType: ''
	            }, options);
	
	            env.beforeSend(env);
	
	            var xhr = env.xhr;
	
	            for (var prop in env) {
	                if (prop in xhr) {
	                    try {
	
	                        xhr[prop] = env[prop];
	
	                    } catch (e) {}
	                }
	            }
	
	            xhr.open(env.method.toUpperCase(), url);
	
	            for (var header in env.headers) {
	                xhr.setRequestHeader(header, env.headers[header]);
	            }
	
	            on(xhr, 'load', function () {
	
	                if (xhr.status === 0 || xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
	                    resolve(xhr);
	                } else {
	                    reject(assign(Error(xhr.statusText), {
	                        xhr: xhr,
	                        status: xhr.status
	                    }));
	                }
	
	            });
	
	            on(xhr, 'error', function () { return reject(assign(Error('Network Error'), {xhr: xhr})); });
	            on(xhr, 'timeout', function () { return reject(assign(Error('Network Timeout'), {xhr: xhr})); });
	
	            xhr.send(env.data);
	        });
	    }
	
	    function getImage(src, srcset, sizes) {
	
	        return new Promise(function (resolve, reject) {
	            var img = new Image();
	
	            img.onerror = reject;
	            img.onload = function () { return resolve(img); };
	
	            sizes && (img.sizes = sizes);
	            srcset && (img.srcset = srcset);
	            img.src = src;
	        });
	
	    }
	
	    function ready(fn) {
	
	        if (document.readyState !== 'loading') {
	            fn();
	            return;
	        }
	
	        var unbind = on(document, 'DOMContentLoaded', function () {
	            unbind();
	            fn();
	        });
	    }
	
	    function index(element, ref) {
	        return ref
	            ? toNodes(element).indexOf(toNode(ref))
	            : toNodes((element = toNode(element)) && element.parentNode.children).indexOf(element);
	    }
	
	    function getIndex(i, elements, current, finite) {
	        if ( current === void 0 ) current = 0;
	        if ( finite === void 0 ) finite = false;
	
	
	        elements = toNodes(elements);
	
	        var length = elements.length;
	
	        i = isNumeric(i)
	            ? toNumber(i)
	            : i === 'next'
	                ? current + 1
	                : i === 'previous'
	                    ? current - 1
	                    : index(elements, i);
	
	        if (finite) {
	            return clamp(i, 0, length - 1);
	        }
	
	        i %= length;
	
	        return i < 0 ? i + length : i;
	    }
	
	    function empty(element) {
	        element = $(element);
	        element.innerHTML = '';
	        return element;
	    }
	
	    function html(parent, html) {
	        parent = $(parent);
	        return isUndefined(html)
	            ? parent.innerHTML
	            : append(parent.hasChildNodes() ? empty(parent) : parent, html);
	    }
	
	    function prepend(parent, element) {
	
	        parent = $(parent);
	
	        if (!parent.hasChildNodes()) {
	            return append(parent, element);
	        } else {
	            return insertNodes(element, function (element) { return parent.insertBefore(element, parent.firstChild); });
	        }
	    }
	
	    function append(parent, element) {
	        parent = $(parent);
	        return insertNodes(element, function (element) { return parent.appendChild(element); });
	    }
	
	    function before(ref, element) {
	        ref = $(ref);
	        return insertNodes(element, function (element) { return ref.parentNode.insertBefore(element, ref); });
	    }
	
	    function after(ref, element) {
	        ref = $(ref);
	        return insertNodes(element, function (element) { return ref.nextSibling
	            ? before(ref.nextSibling, element)
	            : append(ref.parentNode, element); }
	        );
	    }
	
	    function insertNodes(element, fn) {
	        element = isString(element) ? fragment(element) : element;
	        return element
	            ? 'length' in element
	                ? toNodes(element).map(fn)
	                : fn(element)
	            : null;
	    }
	
	    function remove(element) {
	        toNodes(element).map(function (element) { return element.parentNode && element.parentNode.removeChild(element); });
	    }
	
	    function wrapAll(element, structure) {
	
	        structure = toNode(before(element, structure));
	
	        while (structure.firstChild) {
	            structure = structure.firstChild;
	        }
	
	        append(structure, element);
	
	        return structure;
	    }
	
	    function wrapInner(element, structure) {
	        return toNodes(toNodes(element).map(function (element) { return element.hasChildNodes ? wrapAll(toNodes(element.childNodes), structure) : append(element, structure); }
	        ));
	    }
	
	    function unwrap(element) {
	        toNodes(element)
	            .map(function (element) { return element.parentNode; })
	            .filter(function (value, index, self) { return self.indexOf(value) === index; })
	            .forEach(function (parent) {
	                before(parent, parent.childNodes);
	                remove(parent);
	            });
	    }
	
	    var fragmentRe = /^\s*<(\w+|!)[^>]*>/;
	    var singleTagRe = /^<(\w+)\s*\/?>(?:<\/\1>)?$/;
	
	    function fragment(html) {
	
	        var matches$$1 = singleTagRe.exec(html);
	        if (matches$$1) {
	            return document.createElement(matches$$1[1]);
	        }
	
	        var container = document.createElement('div');
	        if (fragmentRe.test(html)) {
	            container.insertAdjacentHTML('beforeend', html.trim());
	        } else {
	            container.textContent = html;
	        }
	
	        return container.childNodes.length > 1 ? toNodes(container.childNodes) : container.firstChild;
	
	    }
	
	    function apply(node, fn) {
	
	        if (!node || node.nodeType !== 1) {
	            return;
	        }
	
	        fn(node);
	        node = node.firstElementChild;
	        while (node) {
	            apply(node, fn);
	            node = node.nextElementSibling;
	        }
	    }
	
	    function $(selector, context) {
	        return !isString(selector)
	            ? toNode(selector)
	            : isHtml(selector)
	                ? toNode(fragment(selector))
	                : find(selector, context);
	    }
	
	    function $$(selector, context) {
	        return !isString(selector)
	            ? toNodes(selector)
	            : isHtml(selector)
	                ? toNodes(fragment(selector))
	                : findAll(selector, context);
	    }
	
	    function isHtml(str) {
	        return str[0] === '<' || str.match(/^\s*</);
	    }
	
	    function addClass(element) {
	        var args = [], len = arguments.length - 1;
	        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
	        apply$1(element, args, 'add');
	    }
	
	    function removeClass(element) {
	        var args = [], len = arguments.length - 1;
	        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
	        apply$1(element, args, 'remove');
	    }
	
	    function removeClasses(element, cls) {
	        attr(element, 'class', function (value) { return (value || '').replace(new RegExp(("\\b" + cls + "\\b"), 'g'), ''); });
	    }
	
	    function replaceClass(element) {
	        var args = [], len = arguments.length - 1;
	        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
	        args[0] && removeClass(element, args[0]);
	        args[1] && addClass(element, args[1]);
	    }
	
	    function hasClass(element, cls) {
	        return cls && toNodes(element).some(function (element) { return element.classList.contains(cls.split(' ')[0]); });
	    }
	
	    function toggleClass(element) {
	        var args = [], len = arguments.length - 1;
	        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
	
	        if (!args.length) {
	            return;
	        }
	
	        args = getArgs$1(args);
	
	        var force = !isString(args[args.length - 1]) ? args.pop() : []; // in iOS 9.3 force === undefined evaluates to false
	
	        args = args.filter(Boolean);
	
	        toNodes(element).forEach(function (ref) {
	            var classList = ref.classList;
	
	            for (var i = 0; i < args.length; i++) {
	                supports.Force
	                    ? classList.toggle.apply(classList, [args[i]].concat(force))
	                    : (classList[(!isUndefined(force) ? force : !classList.contains(args[i])) ? 'add' : 'remove'](args[i]));
	            }
	        });
	
	    }
	
	    function apply$1(element, args, fn) {
	        args = getArgs$1(args).filter(Boolean);
	
	        args.length && toNodes(element).forEach(function (ref) {
	            var classList = ref.classList;
	
	            supports.Multiple
	                ? classList[fn].apply(classList, args)
	                : args.forEach(function (cls) { return classList[fn](cls); });
	        });
	    }
	
	    function getArgs$1(args) {
	        return args.reduce(function (args, arg) { return args.concat.call(args, isString(arg) && includes(arg, ' ') ? arg.trim().split(' ') : arg); }
	            , []);
	    }
	
	    var supports = {};
	
	    // IE 11
	    (function () {
	
	        var list = document.createElement('_').classList;
	        if (list) {
	            list.add('a', 'b');
	            list.toggle('c', false);
	            supports.Multiple = list.contains('b');
	            supports.Force = !list.contains('c');
	        }
	        list = null;
	
	    })();
	
	    var cssNumber = {
	        'animation-iteration-count': true,
	        'column-count': true,
	        'fill-opacity': true,
	        'flex-grow': true,
	        'flex-shrink': true,
	        'font-weight': true,
	        'line-height': true,
	        'opacity': true,
	        'order': true,
	        'orphans': true,
	        'widows': true,
	        'z-index': true,
	        'zoom': true
	    };
	
	    function css(element, property, value) {
	
	        return toNodes(element).map(function (element) {
	
	            if (isString(property)) {
	
	                property = propName(property);
	
	                if (isUndefined(value)) {
	                    return getStyle(element, property);
	                } else if (!value && !isNumber(value)) {
	                    element.style.removeProperty(property);
	                } else {
	                    element.style[property] = isNumeric(value) && !cssNumber[property] ? (value + "px") : value;
	                }
	
	            } else if (isArray(property)) {
	
	                var styles = getStyles(element);
	
	                return property.reduce(function (props, property) {
	                    props[property] = styles[propName(property)];
	                    return props;
	                }, {});
	
	            } else if (isObject(property)) {
	                each(property, function (value, property) { return css(element, property, value); });
	            }
	
	            return element;
	
	        })[0];
	
	    }
	
	    function getStyles(element, pseudoElt) {
	        element = toNode(element);
	        return element.ownerDocument.defaultView.getComputedStyle(element, pseudoElt);
	    }
	
	    function getStyle(element, property, pseudoElt) {
	        return getStyles(element, pseudoElt)[property];
	    }
	
	    var vars = {};
	
	    function getCssVar(name) {
	
	        var docEl = document.documentElement;
	
	        if (!isIE) {
	            return getStyles(docEl).getPropertyValue(("--uk-" + name));
	        }
	
	        if (!(name in vars)) {
	
	            /* usage in css: .uk-name:before { content:"xyz" } */
	
	            var element = append(docEl, document.createElement('div'));
	
	            addClass(element, ("uk-" + name));
	
	            vars[name] = getStyle(element, 'content', ':before').replace(/^["'](.*)["']$/, '$1');
	
	            remove(element);
	
	        }
	
	        return vars[name];
	
	    }
	
	    var cssProps = {};
	
	    function propName(name) {
	
	        var ret = cssProps[name];
	        if (!ret) {
	            ret = cssProps[name] = vendorPropName(name) || name;
	        }
	        return ret;
	    }
	
	    var cssPrefixes = ['webkit', 'moz', 'ms'];
	    var ref = document.createElement('_');
	    var style = ref.style;
	
	    function vendorPropName(name) {
	
	        name = hyphenate(name);
	
	        if (name in style) {
	            return name;
	        }
	
	        var i = cssPrefixes.length, prefixedName;
	
	        while (i--) {
	            prefixedName = "-" + (cssPrefixes[i]) + "-" + name;
	            if (prefixedName in style) {
	                return prefixedName;
	            }
	        }
	    }
	
	    function transition(element, props, duration, timing) {
	        if ( duration === void 0 ) duration = 400;
	        if ( timing === void 0 ) timing = 'linear';
	
	
	        return Promise.all(toNodes(element).map(function (element) { return new Promise(function (resolve, reject) {
	
	                for (var name in props) {
	                    var value = css(element, name);
	                    if (value === '') {
	                        css(element, name, value);
	                    }
	                }
	
	                var timer = setTimeout(function () { return trigger(element, 'transitionend'); }, duration);
	
	                once(element, 'transitionend transitioncanceled', function (ref) {
	                    var type = ref.type;
	
	                    clearTimeout(timer);
	                    removeClass(element, 'uk-transition');
	                    css(element, {
	                        'transition-property': '',
	                        'transition-duration': '',
	                        'transition-timing-function': ''
	                    });
	                    type === 'transitioncanceled' ? reject() : resolve();
	                }, false, function (ref) {
	                    var target = ref.target;
	
	                    return element === target;
	                });
	
	                addClass(element, 'uk-transition');
	                css(element, assign({
	                    'transition-property': Object.keys(props).map(propName).join(','),
	                    'transition-duration': (duration + "ms"),
	                    'transition-timing-function': timing
	                }, props));
	
	            }); }
	        ));
	
	    }
	
	    var Transition = {
	
	        start: transition,
	
	        stop: function(element) {
	            trigger(element, 'transitionend');
	            return Promise.resolve();
	        },
	
	        cancel: function(element) {
	            trigger(element, 'transitioncanceled');
	        },
	
	        inProgress: function(element) {
	            return hasClass(element, 'uk-transition');
	        }
	
	    };
	
	    var animationPrefix = 'uk-animation-';
	    var clsCancelAnimation = 'uk-cancel-animation';
	
	    function animate(element, animation, duration, origin, out) {
	        var arguments$1 = arguments;
	        if ( duration === void 0 ) duration = 200;
	
	
	        return Promise.all(toNodes(element).map(function (element) { return new Promise(function (resolve, reject) {
	
	                if (hasClass(element, clsCancelAnimation)) {
	                    requestAnimationFrame(function () { return Promise.resolve().then(function () { return animate.apply(void 0, arguments$1).then(resolve, reject); }
	                        ); }
	                    );
	                    return;
	                }
	
	                var cls = animation + " " + animationPrefix + (out ? 'leave' : 'enter');
	
	                if (startsWith(animation, animationPrefix)) {
	
	                    if (origin) {
	                        cls += " uk-transform-origin-" + origin;
	                    }
	
	                    if (out) {
	                        cls += " " + animationPrefix + "reverse";
	                    }
	
	                }
	
	                reset();
	
	                once(element, 'animationend animationcancel', function (ref) {
	                    var type = ref.type;
	
	
	                    var hasReset = false;
	
	                    if (type === 'animationcancel') {
	                        reject();
	                        reset();
	                    } else {
	                        resolve();
	                        Promise.resolve().then(function () {
	                            hasReset = true;
	                            reset();
	                        });
	                    }
	
	                    requestAnimationFrame(function () {
	                        if (!hasReset) {
	                            addClass(element, clsCancelAnimation);
	
	                            requestAnimationFrame(function () { return removeClass(element, clsCancelAnimation); });
	                        }
	                    });
	
	                }, false, function (ref) {
	                    var target = ref.target;
	
	                    return element === target;
	                });
	
	                css(element, 'animationDuration', (duration + "ms"));
	                addClass(element, cls);
	
	                function reset() {
	                    css(element, 'animationDuration', '');
	                    removeClasses(element, (animationPrefix + "\\S*"));
	                }
	
	            }); }
	        ));
	
	    }
	
	    var inProgress = new RegExp((animationPrefix + "(enter|leave)"));
	    var Animation = {
	
	        in: function(element, animation, duration, origin) {
	            return animate(element, animation, duration, origin, false);
	        },
	
	        out: function(element, animation, duration, origin) {
	            return animate(element, animation, duration, origin, true);
	        },
	
	        inProgress: function(element) {
	            return inProgress.test(attr(element, 'class'));
	        },
	
	        cancel: function(element) {
	            trigger(element, 'animationcancel');
	        }
	
	    };
	
	    var dirs = {
	        width: ['x', 'left', 'right'],
	        height: ['y', 'top', 'bottom']
	    };
	
	    function positionAt(element, target, elAttach, targetAttach, elOffset, targetOffset, flip, boundary) {
	
	        elAttach = getPos(elAttach);
	        targetAttach = getPos(targetAttach);
	
	        var flipped = {element: elAttach, target: targetAttach};
	
	        if (!element || !target) {
	            return flipped;
	        }
	
	        var dim = getDimensions(element);
	        var targetDim = getDimensions(target);
	        var position = targetDim;
	
	        moveTo(position, elAttach, dim, -1);
	        moveTo(position, targetAttach, targetDim, 1);
	
	        elOffset = getOffsets(elOffset, dim.width, dim.height);
	        targetOffset = getOffsets(targetOffset, targetDim.width, targetDim.height);
	
	        elOffset['x'] += targetOffset['x'];
	        elOffset['y'] += targetOffset['y'];
	
	        position.left += elOffset['x'];
	        position.top += elOffset['y'];
	
	        if (flip) {
	
	            var boundaries = [getDimensions(window$1(element))];
	
	            if (boundary) {
	                boundaries.unshift(getDimensions(boundary));
	            }
	
	            each(dirs, function (ref, prop) {
	                var dir = ref[0];
	                var align = ref[1];
	                var alignFlip = ref[2];
	
	
	                if (!(flip === true || includes(flip, dir))) {
	                    return;
	                }
	
	                boundaries.some(function (boundary) {
	
	                    var elemOffset = elAttach[dir] === align
	                        ? -dim[prop]
	                        : elAttach[dir] === alignFlip
	                            ? dim[prop]
	                            : 0;
	
	                    var targetOffset = targetAttach[dir] === align
	                        ? targetDim[prop]
	                        : targetAttach[dir] === alignFlip
	                            ? -targetDim[prop]
	                            : 0;
	
	                    if (position[align] < boundary[align] || position[align] + dim[prop] > boundary[alignFlip]) {
	
	                        var centerOffset = dim[prop] / 2;
	                        var centerTargetOffset = targetAttach[dir] === 'center' ? -targetDim[prop] / 2 : 0;
	
	                        return elAttach[dir] === 'center' && (
	                            apply(centerOffset, centerTargetOffset)
	                            || apply(-centerOffset, -centerTargetOffset)
	                        ) || apply(elemOffset, targetOffset);
	
	                    }
	
	                    function apply(elemOffset, targetOffset) {
	
	                        var newVal = position[align] + elemOffset + targetOffset - elOffset[dir] * 2;
	
	                        if (newVal >= boundary[align] && newVal + dim[prop] <= boundary[alignFlip]) {
	                            position[align] = newVal;
	
	                            ['element', 'target'].forEach(function (el) {
	                                flipped[el][dir] = !elemOffset
	                                    ? flipped[el][dir]
	                                    : flipped[el][dir] === dirs[prop][1]
	                                        ? dirs[prop][2]
	                                        : dirs[prop][1];
	                            });
	
	                            return true;
	                        }
	
	                    }
	
	                });
	
	            });
	        }
	
	        offset(element, position);
	
	        return flipped;
	    }
	
	    function offset(element, coordinates) {
	
	        element = toNode(element);
	
	        if (coordinates) {
	
	            var currentOffset = offset(element);
	            var pos = css(element, 'position');
	
	            ['left', 'top'].forEach(function (prop) {
	                if (prop in coordinates) {
	                    var value = css(element, prop);
	                    css(element, prop, coordinates[prop] - currentOffset[prop]
	                        + toFloat(pos === 'absolute' && value === 'auto'
	                            ? position(element)[prop]
	                            : value)
	                    );
	                }
	            });
	
	            return;
	        }
	
	        return getDimensions(element);
	    }
	
	    function getDimensions(element) {
	
	        element = toNode(element);
	
	        var ref = window$1(element);
	        var top = ref.pageYOffset;
	        var left = ref.pageXOffset;
	
	        if (isWindow(element)) {
	
	            var height = element.innerHeight;
	            var width = element.innerWidth;
	
	            return {
	                top: top,
	                left: left,
	                height: height,
	                width: width,
	                bottom: top + height,
	                right: left + width,
	            };
	        }
	
	        var style, hidden;
	
	        if (!isVisible(element)) {
	            style = attr(element, 'style');
	            hidden = attr(element, 'hidden');
	
	            attr(element, {
	                style: ((style || '') + ";display:block !important;"),
	                hidden: null
	            });
	        }
	
	        var rect = element.getBoundingClientRect();
	
	        if (!isUndefined(style)) {
	            attr(element, {style: style, hidden: hidden});
	        }
	
	        return {
	            height: rect.height,
	            width: rect.width,
	            top: rect.top + top,
	            left: rect.left + left,
	            bottom: rect.bottom + top,
	            right: rect.right + left,
	        };
	    }
	
	    function position(element) {
	        element = toNode(element);
	
	        var parent = element.offsetParent || docEl(element);
	        var parentOffset = offset(parent);
	        var ref = ['top', 'left'].reduce(function (props, prop) {
	            var propName$$1 = ucfirst(prop);
	            props[prop] -= parentOffset[prop]
	                + toFloat(css(element, ("margin" + propName$$1)))
	                + toFloat(css(parent, ("border" + propName$$1 + "Width")));
	            return props;
	        }, offset(element));
	        var top = ref.top;
	        var left = ref.left;
	
	        return {top: top, left: left};
	    }
	
	    var height = dimension('height');
	    var width = dimension('width');
	
	    function dimension(prop) {
	        var propName$$1 = ucfirst(prop);
	        return function (element, value) {
	
	            element = toNode(element);
	
	            if (isUndefined(value)) {
	
	                if (isWindow(element)) {
	                    return element[("inner" + propName$$1)];
	                }
	
	                if (isDocument(element)) {
	                    var doc = element.documentElement;
	                    return Math.max(doc[("offset" + propName$$1)], doc[("scroll" + propName$$1)]);
	                }
	
	                value = css(element, prop);
	                value = value === 'auto' ? element[("offset" + propName$$1)] : toFloat(value) || 0;
	
	                return value - boxModelAdjust(prop, element);
	
	            } else {
	
	                css(element, prop, !value && value !== 0
	                    ? ''
	                    : +value + boxModelAdjust(prop, element) + 'px'
	                );
	
	            }
	
	        };
	    }
	
	    function boxModelAdjust(prop, element, sizing) {
	        if ( sizing === void 0 ) sizing = 'border-box';
	
	        return css(element, 'boxSizing') === sizing
	            ? dirs[prop].slice(1).map(ucfirst).reduce(function (value, prop) { return value
	                + toFloat(css(element, ("padding" + prop)))
	                + toFloat(css(element, ("border" + prop + "Width"))); }
	                , 0)
	            : 0;
	    }
	
	    function moveTo(position, attach, dim, factor) {
	        each(dirs, function (ref, prop) {
	            var dir = ref[0];
	            var align = ref[1];
	            var alignFlip = ref[2];
	
	            if (attach[dir] === alignFlip) {
	                position[align] += dim[prop] * factor;
	            } else if (attach[dir] === 'center') {
	                position[align] += dim[prop] * factor / 2;
	            }
	        });
	    }
	
	    function getPos(pos) {
	
	        var x = /left|center|right/;
	        var y = /top|center|bottom/;
	
	        pos = (pos || '').split(' ');
	
	        if (pos.length === 1) {
	            pos = x.test(pos[0])
	                ? pos.concat(['center'])
	                : y.test(pos[0])
	                    ? ['center'].concat(pos)
	                    : ['center', 'center'];
	        }
	
	        return {
	            x: x.test(pos[0]) ? pos[0] : 'center',
	            y: y.test(pos[1]) ? pos[1] : 'center'
	        };
	    }
	
	    function getOffsets(offsets, width, height) {
	
	        var ref = (offsets || '').split(' ');
	        var x = ref[0];
	        var y = ref[1];
	
	        return {
	            x: x ? toFloat(x) * (endsWith(x, '%') ? width / 100 : 1) : 0,
	            y: y ? toFloat(y) * (endsWith(y, '%') ? height / 100 : 1) : 0
	        };
	    }
	
	    function flipPosition(pos) {
	        switch (pos) {
	            case 'left':
	                return 'right';
	            case 'right':
	                return 'left';
	            case 'top':
	                return 'bottom';
	            case 'bottom':
	                return 'top';
	            default:
	                return pos;
	        }
	    }
	
	    function isInView(element, topOffset, leftOffset) {
	        if ( topOffset === void 0 ) topOffset = 0;
	        if ( leftOffset === void 0 ) leftOffset = 0;
	
	
	        if (!isVisible(element)) {
	            return false;
	        }
	
	        element = toNode(element);
	
	        var win = window$1(element);
	        var client = element.getBoundingClientRect();
	        var bounding = {
	            top: -topOffset,
	            left: -leftOffset,
	            bottom: topOffset + height(win),
	            right: leftOffset + width(win)
	        };
	
	        return intersectRect(client, bounding) || pointInRect({x: client.left, y: client.top}, bounding);
	
	    }
	
	    function scrolledOver(element, heightOffset) {
	        if ( heightOffset === void 0 ) heightOffset = 0;
	
	
	        if (!isVisible(element)) {
	            return 0;
	        }
	
	        element = toNode(element);
	
	        var win = window$1(element);
	        var doc = document$1(element);
	        var elHeight = element.offsetHeight + heightOffset;
	        var ref = offsetPosition(element);
	        var top = ref[0];
	        var vp = height(win);
	        var vh = vp + Math.min(0, top - vp);
	        var diff = Math.max(0, vp - (height(doc) + heightOffset - (top + elHeight)));
	
	        return clamp(((vh + win.pageYOffset - top) / ((vh + (elHeight - (diff < vp ? diff : 0))) / 100)) / 100);
	    }
	
	    function scrollTop(element, top) {
	        element = toNode(element);
	
	        if (isWindow(element) || isDocument(element)) {
	            var ref = window$1(element);
	            var scrollTo = ref.scrollTo;
	            var pageXOffset = ref.pageXOffset;
	            scrollTo(pageXOffset, top);
	        } else {
	            element.scrollTop = top;
	        }
	    }
	
	    function offsetPosition(element) {
	        var offset = [0, 0];
	
	        do {
	
	            offset[0] += element.offsetTop;
	            offset[1] += element.offsetLeft;
	
	            if (css(element, 'position') === 'fixed') {
	                var win = window$1(element);
	                offset[0] += win.pageYOffset;
	                offset[1] += win.pageXOffset;
	                return offset;
	            }
	
	        } while ((element = element.offsetParent));
	
	        return offset;
	    }
	
	    function window$1(element) {
	        return isWindow(element) ? element : document$1(element).defaultView;
	    }
	
	    function document$1(element) {
	        return toNode(element).ownerDocument;
	    }
	
	    function docEl(element) {
	        return document$1(element).documentElement;
	    }
	
	    /*
	        Based on:
	        Copyright (c) 2016 Wilson Page wilsonpage@me.com
	        https://github.com/wilsonpage/fastdom
	    */
	
	    var fastdom = {
	
	        reads: [],
	        writes: [],
	
	        read: function(task) {
	            this.reads.push(task);
	            scheduleFlush();
	            return task;
	        },
	
	        write: function(task) {
	            this.writes.push(task);
	            scheduleFlush();
	            return task;
	        },
	
	        clear: function(task) {
	            return remove$1(this.reads, task) || remove$1(this.writes, task);
	        },
	
	        flush: function() {
	
	            runTasks(this.reads);
	            runTasks(this.writes.splice(0, this.writes.length));
	
	            this.scheduled = false;
	
	            if (this.reads.length || this.writes.length) {
	                scheduleFlush();
	            }
	
	        }
	
	    };
	
	    function scheduleFlush() {
	        if (!fastdom.scheduled) {
	            fastdom.scheduled = true;
	            requestAnimationFrame(fastdom.flush.bind(fastdom));
	        }
	    }
	
	    function runTasks(tasks) {
	        var task;
	        while ((task = tasks.shift())) {
	            task();
	        }
	    }
	
	    function remove$1(array, item) {
	        var index = array.indexOf(item);
	        return !!~index && !!array.splice(index, 1);
	    }
	
	    function MouseTracker() {}
	
	    MouseTracker.prototype = {
	
	        positions: [],
	        position: null,
	
	        init: function() {
	            var this$1 = this;
	
	
	            this.positions = [];
	            this.position = null;
	
	            var ticking = false;
	            this.unbind = on(document, 'mousemove', function (e) {
	
	                if (ticking) {
	                    return;
	                }
	
	                setTimeout(function () {
	
	                    var time = Date.now();
	                    var ref = this$1.positions;
	                    var length = ref.length;
	
	                    if (length && (time - this$1.positions[length - 1].time > 100)) {
	                        this$1.positions.splice(0, length);
	                    }
	
	                    this$1.positions.push({time: time, x: e.pageX, y: e.pageY});
	
	                    if (this$1.positions.length > 5) {
	                        this$1.positions.shift();
	                    }
	
	                    ticking = false;
	                }, 5);
	
	                ticking = true;
	            });
	
	        },
	
	        cancel: function() {
	            if (this.unbind) {
	                this.unbind();
	            }
	        },
	
	        movesTo: function(target) {
	
	            if (this.positions.length < 2) {
	                return false;
	            }
	
	            var p = offset(target);
	            var position$$1 = this.positions[this.positions.length - 1];
	            var ref = this.positions;
	            var prevPos = ref[0];
	
	            if (p.left <= position$$1.x && position$$1.x <= p.right && p.top <= position$$1.y && position$$1.y <= p.bottom) {
	                return false;
	            }
	
	            var points = [
	                [{x: p.left, y: p.top}, {x: p.right, y: p.bottom}],
	                [{x: p.right, y: p.top}, {x: p.left, y: p.bottom}]
	            ];
	
	            if (p.right <= position$$1.x) ; else if (p.left >= position$$1.x) {
	                points[0].reverse();
	                points[1].reverse();
	            } else if (p.bottom <= position$$1.y) {
	                points[0].reverse();
	            } else if (p.top >= position$$1.y) {
	                points[1].reverse();
	            }
	
	            return !!points.reduce(function (result, point) {
	                return result + (slope(prevPos, point[0]) < slope(position$$1, point[0]) && slope(prevPos, point[1]) > slope(position$$1, point[1]));
	            }, 0);
	        }
	
	    };
	
	    function slope(a, b) {
	        return (b.y - a.y) / (b.x - a.x);
	    }
	
	    var strats = {};
	
	    strats.events =
	    strats.created =
	    strats.beforeConnect =
	    strats.connected =
	    strats.beforeDisconnect =
	    strats.disconnected =
	    strats.destroy = concatStrat;
	
	    // args strategy
	    strats.args = function (parentVal, childVal) {
	        return concatStrat(childVal || parentVal);
	    };
	
	    // update strategy
	    strats.update = function (parentVal, childVal) {
	        return sortBy(concatStrat(parentVal, isFunction(childVal) ? {read: childVal} : childVal), 'order');
	    };
	
	    // property strategy
	    strats.props = function (parentVal, childVal) {
	
	        if (isArray(childVal)) {
	            childVal = childVal.reduce(function (value, key) {
	                value[key] = String;
	                return value;
	            }, {});
	        }
	
	        return strats.methods(parentVal, childVal);
	    };
	
	    // extend strategy
	    strats.computed =
	    strats.methods = function (parentVal, childVal) {
	        return childVal
	            ? parentVal
	                ? assign({}, parentVal, childVal)
	                : childVal
	            : parentVal;
	    };
	
	    // data strategy
	    strats.data = function (parentVal, childVal, vm) {
	
	        if (!vm) {
	
	            if (!childVal) {
	                return parentVal;
	            }
	
	            if (!parentVal) {
	                return childVal;
	            }
	
	            return function (vm) {
	                return mergeFnData(parentVal, childVal, vm);
	            };
	
	        }
	
	        return mergeFnData(parentVal, childVal, vm);
	    };
	
	    function mergeFnData(parentVal, childVal, vm) {
	        return strats.computed(
	            isFunction(parentVal)
	                ? parentVal.call(vm, vm)
	                : parentVal,
	            isFunction(childVal)
	                ? childVal.call(vm, vm)
	                : childVal
	        );
	    }
	
	    // concat strategy
	    function concatStrat(parentVal, childVal) {
	
	        parentVal = parentVal && !isArray(parentVal) ? [parentVal] : parentVal;
	
	        return childVal
	            ? parentVal
	                ? parentVal.concat(childVal)
	                : isArray(childVal)
	                    ? childVal
	                    : [childVal]
	            : parentVal;
	    }
	
	    // default strategy
	    function defaultStrat(parentVal, childVal) {
	        return isUndefined(childVal) ? parentVal : childVal;
	    }
	
	    function mergeOptions(parent, child, vm) {
	
	        var options = {};
	
	        if (isFunction(child)) {
	            child = child.options;
	        }
	
	        if (child.extends) {
	            parent = mergeOptions(parent, child.extends, vm);
	        }
	
	        if (child.mixins) {
	            for (var i = 0, l = child.mixins.length; i < l; i++) {
	                parent = mergeOptions(parent, child.mixins[i], vm);
	            }
	        }
	
	        for (var key in parent) {
	            mergeKey(key);
	        }
	
	        for (var key$1 in child) {
	            if (!hasOwn(parent, key$1)) {
	                mergeKey(key$1);
	            }
	        }
	
	        function mergeKey(key) {
	            options[key] = (strats[key] || defaultStrat)(parent[key], child[key], vm);
	        }
	
	        return options;
	    }
	
	    function parseOptions(options, args) {
	        var obj;
	
	        if ( args === void 0 ) args = [];
	
	        try {
	
	            return !options
	                ? {}
	                : startsWith(options, '{')
	                    ? JSON.parse(options)
	                    : args.length && !includes(options, ':')
	                        ? (( obj = {}, obj[args[0]] = options, obj ))
	                        : options.split(';').reduce(function (options, option) {
	                            var ref = option.split(/:(.*)/);
	                            var key = ref[0];
	                            var value = ref[1];
	                            if (key && !isUndefined(value)) {
	                                options[key.trim()] = value.trim();
	                            }
	                            return options;
	                        }, {});
	
	        } catch (e) {
	            return {};
	        }
	
	    }
	
	    var id = 0;
	
	    var Player = function(el) {
	        this.id = ++id;
	        this.el = toNode(el);
	    };
	
	    Player.prototype.isVideo = function () {
	        return this.isYoutube() || this.isVimeo() || this.isHTML5();
	    };
	
	    Player.prototype.isHTML5 = function () {
	        return this.el.tagName === 'VIDEO';
	    };
	
	    Player.prototype.isIFrame = function () {
	        return this.el.tagName === 'IFRAME';
	    };
	
	    Player.prototype.isYoutube = function () {
	        return this.isIFrame() && !!this.el.src.match(/\/\/.*?youtube(-nocookie)?\.[a-z]+\/(watch\?v=[^&\s]+|embed)|youtu\.be\/.*/);
	    };
	
	    Player.prototype.isVimeo = function () {
	        return this.isIFrame() && !!this.el.src.match(/vimeo\.com\/video\/.*/);
	    };
	
	    Player.prototype.enableApi = function () {
	            var this$1 = this;
	
	
	        if (this.ready) {
	            return this.ready;
	        }
	
	        var youtube = this.isYoutube();
	        var vimeo = this.isVimeo();
	
	        var poller;
	
	        if (youtube || vimeo) {
	
	            return this.ready = new Promise(function (resolve) {
	
	                once(this$1.el, 'load', function () {
	                    if (youtube) {
	                        var listener = function () { return post(this$1.el, {event: 'listening', id: this$1.id}); };
	                        poller = setInterval(listener, 100);
	                        listener();
	                    }
	                });
	
	                listen(function (data$$1) { return youtube && data$$1.id === this$1.id && data$$1.event === 'onReady' || vimeo && Number(data$$1.player_id) === this$1.id; })
	                    .then(function () {
	                        resolve();
	                        poller && clearInterval(poller);
	                    });
	
	                attr(this$1.el, 'src', ("" + (this$1.el.src) + (includes(this$1.el.src, '?') ? '&' : '?') + (youtube ? 'enablejsapi=1' : ("api=1&player_id=" + (this$1.id)))));
	
	            });
	
	        }
	
	        return Promise.resolve();
	
	    };
	
	    Player.prototype.play = function () {
	            var this$1 = this;
	
	
	        if (!this.isVideo()) {
	            return;
	        }
	
	        if (this.isIFrame()) {
	            this.enableApi().then(function () { return post(this$1.el, {func: 'playVideo', method: 'play'}); });
	        } else if (this.isHTML5()) {
	            try {
	                var promise = this.el.play();
	
	                if (promise) {
	                    promise.catch(noop);
	                }
	            } catch (e) {}
	        }
	    };
	
	    Player.prototype.pause = function () {
	            var this$1 = this;
	
	
	        if (!this.isVideo()) {
	            return;
	        }
	
	        if (this.isIFrame()) {
	            this.enableApi().then(function () { return post(this$1.el, {func: 'pauseVideo', method: 'pause'}); });
	        } else if (this.isHTML5()) {
	            this.el.pause();
	        }
	    };
	
	    Player.prototype.mute = function () {
	            var this$1 = this;
	
	
	        if (!this.isVideo()) {
	            return;
	        }
	
	        if (this.isIFrame()) {
	            this.enableApi().then(function () { return post(this$1.el, {func: 'mute', method: 'setVolume', value: 0}); });
	        } else if (this.isHTML5()) {
	            this.el.muted = true;
	            attr(this.el, 'muted', '');
	        }
	
	    };
	
	    function post(el, cmd) {
	        try {
	            el.contentWindow.postMessage(JSON.stringify(assign({event: 'command'}, cmd)), '*');
	        } catch (e) {}
	    }
	
	    function listen(cb) {
	
	        return new Promise(function (resolve) {
	
	            once(window, 'message', function (_, data$$1) { return resolve(data$$1); }, false, function (ref) {
	                var data$$1 = ref.data;
	
	
	                if (!data$$1 || !isString(data$$1)) {
	                    return;
	                }
	
	                try {
	                    data$$1 = JSON.parse(data$$1);
	                } catch (e) {
	                    return;
	                }
	
	                return data$$1 && cb(data$$1);
	
	            });
	
	        });
	
	    }
	
	    var IntersectionObserver = 'IntersectionObserver' in window
	        ? window.IntersectionObserver
	        : /*@__PURE__*/(function () {
	        function IntersectionObserverClass(callback, ref) {
	            var this$1 = this;
	            if ( ref === void 0 ) ref = {};
	            var rootMargin = ref.rootMargin; if ( rootMargin === void 0 ) rootMargin = '0 0';
	
	
	                this.targets = [];
	
	                var ref$1 = (rootMargin || '0 0').split(' ').map(toFloat);
	            var offsetTop = ref$1[0];
	            var offsetLeft = ref$1[1];
	
	                this.offsetTop = offsetTop;
	                this.offsetLeft = offsetLeft;
	
	                var pending;
	                this.apply = function () {
	
	                    if (pending) {
	                        return;
	                    }
	
	                    pending = requestAnimationFrame(function () { return setTimeout(function () {
	                        var records = this$1.takeRecords();
	
	                        if (records.length) {
	                            callback(records, this$1);
	                        }
	
	                        pending = false;
	                    }); });
	
	                };
	
	                this.off = on(window, 'scroll resize load', this.apply, {passive: true, capture: true});
	
	            }
	
	            IntersectionObserverClass.prototype.takeRecords = function () {
	                var this$1 = this;
	
	                return this.targets.filter(function (entry) {
	
	                    var inView = isInView(entry.target, this$1.offsetTop, this$1.offsetLeft);
	
	                    if (entry.isIntersecting === null || inView ^ entry.isIntersecting) {
	                        entry.isIntersecting = inView;
	                        return true;
	                    }
	
	                });
	            };
	
	            IntersectionObserverClass.prototype.observe = function (target) {
	                this.targets.push({
	                    target: target,
	                    isIntersecting: null
	                });
	                this.apply();
	            };
	
	            IntersectionObserverClass.prototype.disconnect = function () {
	                this.targets = [];
	                this.off();
	            };
	
	        return IntersectionObserverClass;
	    }());
	
	    var touch = {}, swipeTimeout, touching;
	
	    on(document, pointerDown, function (e) {
	
	        if (touch.el) {
	            touch = {};
	        }
	
	        var target = e.target;
	        var ref = getPos$1(e);
	        var x = ref.x;
	        var y = ref.y;
	
	        touch.el = 'tagName' in target ? target : target.parentNode;
	        touch.x = x;
	        touch.y = y;
	
	        touching = isTouch(e);
	
	    });
	
	    on(document, pointerUp, function (e) {
	
	        var ref = getPos$1(e);
	        var x = ref.x;
	        var y = ref.y;
	
	        // swipe
	        if (touch.el && x && Math.abs(touch.x - x) > 100 || y && Math.abs(touch.y - y) > 100) {
	
	            swipeTimeout = setTimeout(function () {
	                if (touch.el) {
	                    trigger(touch.el, 'swipe');
	                    trigger(touch.el, ("swipe" + (swipeDirection(touch.x, touch.y, x, y))));
	                }
	                touch = {};
	            });
	
	        } else {
	            touch = {};
	        }
	
	        setTimeout(function () { return touching = false; });
	
	    });
	
	    on(document, pointerCancel, cancelAll);
	
	    function isTouch(e) {
	        return e.pointerType === 'touch' || e.touches || touching;
	    }
	
	    function getPos$1(e, prop) {
	        if ( prop === void 0 ) prop = 'client';
	
	        var touches = e.touches;
	        var changedTouches = e.changedTouches;
	        var ref = touches && touches[0] || changedTouches && changedTouches[0] || e;
	        var x = ref[(prop + "X")];
	        var y = ref[(prop + "Y")];
	
	        return {x: x, y: y};
	    }
	
	    function swipeDirection(x1, y1, x2, y2) {
	        return Math.abs(x1 - x2) >= Math.abs(y1 - y2)
	            ? x1 - x2 > 0
	                ? 'Left'
	                : 'Right'
	            : y1 - y2 > 0
	                ? 'Up'
	                : 'Down';
	    }
	
	    function cancelAll() {
	        swipeTimeout && clearTimeout(swipeTimeout);
	        swipeTimeout = null;
	        touch = {};
	    }
	
	
	
	    var util = /*#__PURE__*/Object.freeze({
	        ajax: ajax,
	        getImage: getImage,
	        transition: transition,
	        Transition: Transition,
	        animate: animate,
	        Animation: Animation,
	        attr: attr,
	        hasAttr: hasAttr,
	        removeAttr: removeAttr,
	        data: data,
	        addClass: addClass,
	        removeClass: removeClass,
	        removeClasses: removeClasses,
	        replaceClass: replaceClass,
	        hasClass: hasClass,
	        toggleClass: toggleClass,
	        positionAt: positionAt,
	        offset: offset,
	        position: position,
	        height: height,
	        width: width,
	        boxModelAdjust: boxModelAdjust,
	        flipPosition: flipPosition,
	        isInView: isInView,
	        scrolledOver: scrolledOver,
	        scrollTop: scrollTop,
	        offsetPosition: offsetPosition,
	        ready: ready,
	        index: index,
	        getIndex: getIndex,
	        empty: empty,
	        html: html,
	        prepend: prepend,
	        append: append,
	        before: before,
	        after: after,
	        remove: remove,
	        wrapAll: wrapAll,
	        wrapInner: wrapInner,
	        unwrap: unwrap,
	        fragment: fragment,
	        apply: apply,
	        $: $,
	        $$: $$,
	        isIE: isIE,
	        isRtl: isRtl,
	        hasTouch: hasTouch,
	        pointerDown: pointerDown,
	        pointerMove: pointerMove,
	        pointerUp: pointerUp,
	        pointerEnter: pointerEnter,
	        pointerLeave: pointerLeave,
	        pointerCancel: pointerCancel,
	        on: on,
	        off: off,
	        once: once,
	        trigger: trigger,
	        createEvent: createEvent,
	        toEventTargets: toEventTargets,
	        preventClick: preventClick,
	        fastdom: fastdom,
	        isVoidElement: isVoidElement,
	        isVisible: isVisible,
	        selInput: selInput,
	        isInput: isInput,
	        filter: filter,
	        within: within,
	        bind: bind,
	        hasOwn: hasOwn,
	        hyphenate: hyphenate,
	        camelize: camelize,
	        ucfirst: ucfirst,
	        startsWith: startsWith,
	        endsWith: endsWith,
	        includes: includes,
	        isArray: isArray,
	        isFunction: isFunction,
	        isObject: isObject,
	        isPlainObject: isPlainObject,
	        isWindow: isWindow,
	        isDocument: isDocument,
	        isJQuery: isJQuery,
	        isNode: isNode,
	        isNodeCollection: isNodeCollection,
	        isBoolean: isBoolean,
	        isString: isString,
	        isNumber: isNumber,
	        isNumeric: isNumeric,
	        isUndefined: isUndefined,
	        toBoolean: toBoolean,
	        toNumber: toNumber,
	        toFloat: toFloat,
	        toNode: toNode,
	        toNodes: toNodes,
	        toList: toList,
	        toMs: toMs,
	        isEqual: isEqual,
	        swap: swap,
	        assign: assign,
	        each: each,
	        sortBy: sortBy,
	        clamp: clamp,
	        noop: noop,
	        intersectRect: intersectRect,
	        pointInRect: pointInRect,
	        Dimensions: Dimensions,
	        MouseTracker: MouseTracker,
	        mergeOptions: mergeOptions,
	        parseOptions: parseOptions,
	        Player: Player,
	        Promise: Promise,
	        Deferred: Deferred,
	        IntersectionObserver: IntersectionObserver,
	        query: query,
	        queryAll: queryAll,
	        find: find,
	        findAll: findAll,
	        matches: matches,
	        closest: closest,
	        parents: parents,
	        escape: escape,
	        css: css,
	        getStyles: getStyles,
	        getStyle: getStyle,
	        getCssVar: getCssVar,
	        propName: propName,
	        isTouch: isTouch,
	        getPos: getPos$1
	    });
	
	    function componentAPI (UIkit) {
	
	        var DATA = UIkit.data;
	
	        var components = {};
	
	        UIkit.component = function (name, options) {
	
	            if (!options) {
	
	                if (isPlainObject(components[name])) {
	                    components[name] = UIkit.extend(components[name]);
	                }
	
	                return components[name];
	
	            }
	
	            UIkit[name] = function (element, data$$1) {
	                var i = arguments.length, argsArray = Array(i);
	                while ( i-- ) argsArray[i] = arguments[i];
	
	
	                var component = UIkit.component(name);
	
	                if (isPlainObject(element)) {
	                    return new component({data: element});
	                }
	
	                if (component.options.functional) {
	                    return new component({data: [].concat( argsArray )});
	                }
	
	                return element && element.nodeType ? init(element) : $$(element).map(init)[0];
	
	                function init(element) {
	
	                    var instance = UIkit.getComponent(element, name);
	
	                    if (instance) {
	                        if (!data$$1) {
	                            return instance;
	                        } else {
	                            instance.$destroy();
	                        }
	                    }
	
	                    return new component({el: element, data: data$$1});
	
	                }
	
	            };
	
	            var opt = isPlainObject(options) ? assign({}, options) : options.options;
	
	            opt.name = name;
	
	            if (opt.install) {
	                opt.install(UIkit, opt, name);
	            }
	
	            if (UIkit._initialized && !opt.functional) {
	                var id = hyphenate(name);
	                fastdom.read(function () { return UIkit[name](("[uk-" + id + "],[data-uk-" + id + "]")); });
	            }
	
	            return components[name] = isPlainObject(options) ? opt : options;
	        };
	
	        UIkit.getComponents = function (element) { return element && element[DATA] || {}; };
	        UIkit.getComponent = function (element, name) { return UIkit.getComponents(element)[name]; };
	
	        UIkit.connect = function (node) {
	
	            if (node[DATA]) {
	                for (var name in node[DATA]) {
	                    node[DATA][name]._callConnected();
	                }
	            }
	
	            for (var i = 0; i < node.attributes.length; i++) {
	
	                var name$1 = getComponentName(node.attributes[i].name);
	
	                if (name$1 && name$1 in components) {
	                    UIkit[name$1](node);
	                }
	
	            }
	
	        };
	
	        UIkit.disconnect = function (node) {
	            for (var name in node[DATA]) {
	                node[DATA][name]._callDisconnected();
	            }
	        };
	
	    }
	
	    function getComponentName(attribute) {
	        return startsWith(attribute, 'uk-') || startsWith(attribute, 'data-uk-')
	            ? camelize(attribute.replace('data-uk-', '').replace('uk-', ''))
	            : false;
	    }
	
	    function boot (UIkit) {
	
	        var connect = UIkit.connect;
	        var disconnect = UIkit.disconnect;
	
	        if (!('MutationObserver' in window)) {
	            return;
	        }
	
	        if (document.body) {
	
	            init();
	
	        } else {
	
	            (new MutationObserver(function () {
	
	                if (document.body) {
	                    this.disconnect();
	                    init();
	                }
	
	            })).observe(document, {childList: true, subtree: true});
	
	        }
	
	        function init() {
	
	            apply$$1(document.body, connect);
	
	            fastdom.flush();
	
	            (new MutationObserver(function (mutations) { return mutations.forEach(applyMutation); })).observe(document, {
	                childList: true,
	                subtree: true,
	                characterData: true,
	                attributes: true
	            });
	
	            UIkit._initialized = true;
	        }
	
	        function applyMutation(mutation) {
	
	            var target = mutation.target;
	            var type = mutation.type;
	
	            var update = type !== 'attributes'
	                ? applyChildList(mutation)
	                : applyAttribute(mutation);
	
	            update && UIkit.update(target);
	
	        }
	
	        function applyAttribute(ref) {
	            var target = ref.target;
	            var attributeName = ref.attributeName;
	
	
	            if (attributeName === 'href') {
	                return true;
	            }
	
	            var name = getComponentName(attributeName);
	
	            if (!name || !(name in UIkit)) {
	                return;
	            }
	
	            if (hasAttr(target, attributeName)) {
	                UIkit[name](target);
	                return true;
	            }
	
	            var component = UIkit.getComponent(target, name);
	
	            if (component) {
	                component.$destroy();
	                return true;
	            }
	
	        }
	
	        function applyChildList(ref) {
	            var addedNodes = ref.addedNodes;
	            var removedNodes = ref.removedNodes;
	
	
	            for (var i = 0; i < addedNodes.length; i++) {
	                apply$$1(addedNodes[i], connect);
	            }
	
	            for (var i$1 = 0; i$1 < removedNodes.length; i$1++) {
	                apply$$1(removedNodes[i$1], disconnect);
	            }
	
	            return true;
	        }
	
	        function apply$$1(node, fn) {
	
	            if (node.nodeType !== 1 || hasAttr(node, 'uk-no-boot')) {
	                return;
	            }
	
	            fn(node);
	            node = node.firstElementChild;
	            while (node) {
	                var next = node.nextElementSibling;
	                apply$$1(node, fn);
	                node = next;
	            }
	        }
	
	    }
	
	    function globalAPI (UIkit) {
	
	        var DATA = UIkit.data;
	
	        UIkit.use = function (plugin) {
	
	            if (plugin.installed) {
	                return;
	            }
	
	            plugin.call(null, this);
	            plugin.installed = true;
	
	            return this;
	        };
	
	        UIkit.mixin = function (mixin, component) {
	            component = (isString(component) ? UIkit.component(component) : component) || this;
	            component.options = mergeOptions(component.options, mixin);
	        };
	
	        UIkit.extend = function (options) {
	
	            options = options || {};
	
	            var Super = this;
	            var Sub = function UIkitComponent (options) {
	                this._init(options);
	            };
	
	            Sub.prototype = Object.create(Super.prototype);
	            Sub.prototype.constructor = Sub;
	            Sub.options = mergeOptions(Super.options, options);
	
	            Sub.super = Super;
	            Sub.extend = Super.extend;
	
	            return Sub;
	        };
	
	        UIkit.update = function (element, e) {
	
	            element = element ? toNode(element) : document.body;
	
	            path(element, function (element) { return update(element[DATA], e); });
	            apply(element, function (element) { return update(element[DATA], e); });
	
	        };
	
	        var container;
	        Object.defineProperty(UIkit, 'container', {
	
	            get: function() {
	                return container || document.body;
	            },
	
	            set: function(element) {
	                container = $(element);
	            }
	
	        });
	
	        function update(data$$1, e) {
	
	            if (!data$$1) {
	                return;
	            }
	
	            for (var name in data$$1) {
	                if (data$$1[name]._connected) {
	                    data$$1[name]._callUpdate(e);
	                }
	            }
	
	        }
	
	        function path(node, fn) {
	            if (node && node !== document.body && node.parentNode) {
	                path(node.parentNode, fn);
	                fn(node.parentNode);
	            }
	        }
	
	    }
	
	    function hooksAPI (UIkit) {
	
	        UIkit.prototype._callHook = function (hook) {
	            var this$1 = this;
	
	
	            var handlers = this.$options[hook];
	
	            if (handlers) {
	                handlers.forEach(function (handler) { return handler.call(this$1); });
	            }
	        };
	
	        UIkit.prototype._callConnected = function () {
	
	            if (this._connected) {
	                return;
	            }
	
	            this._data = {};
	            this._computeds = {};
	            this._initProps();
	
	            this._callHook('beforeConnect');
	            this._connected = true;
	
	            this._initEvents();
	            this._initObserver();
	
	            this._callHook('connected');
	            this._callUpdate();
	        };
	
	        UIkit.prototype._callDisconnected = function () {
	
	            if (!this._connected) {
	                return;
	            }
	
	            this._callHook('beforeDisconnect');
	
	            if (this._observer) {
	                this._observer.disconnect();
	                this._observer = null;
	            }
	
	            this._unbindEvents();
	            this._callHook('disconnected');
	
	            this._connected = false;
	
	        };
	
	        UIkit.prototype._callUpdate = function (e) {
	            var this$1 = this;
	            if ( e === void 0 ) e = 'update';
	
	
	            var type = e.type || e;
	
	            if (includes(['update', 'resize'], type)) {
	                this._callWatches();
	            }
	
	            var updates = this.$options.update;
	            var ref = this._frames;
	            var reads = ref.reads;
	            var writes = ref.writes;
	
	            if (!updates) {
	                return;
	            }
	
	            updates.forEach(function (ref, i) {
	                var read = ref.read;
	                var write = ref.write;
	                var events = ref.events;
	
	
	                if (type !== 'update' && !includes(events, type)) {
	                    return;
	                }
	
	                if (read && !includes(fastdom.reads, reads[i])) {
	                    reads[i] = fastdom.read(function () {
	
	                        var result = this$1._connected && read.call(this$1, this$1._data, type);
	
	                        if (result === false && write) {
	                            fastdom.clear(writes[i]);
	                        } else if (isPlainObject(result)) {
	                            assign(this$1._data, result);
	                        }
	                    });
	                }
	
	                if (write && !includes(fastdom.writes, writes[i])) {
	                    writes[i] = fastdom.write(function () { return this$1._connected && write.call(this$1, this$1._data, type); });
	                }
	
	            });
	
	        };
	
	    }
	
	    function stateAPI (UIkit) {
	
	        var uid = 0;
	
	        UIkit.prototype._init = function (options) {
	
	            options = options || {};
	            options.data = normalizeData(options, this.constructor.options);
	
	            this.$options = mergeOptions(this.constructor.options, options, this);
	            this.$el = null;
	            this.$props = {};
	
	            this._frames = {reads: {}, writes: {}};
	            this._events = [];
	
	            this._uid = uid++;
	            this._initData();
	            this._initMethods();
	            this._initComputeds();
	            this._callHook('created');
	
	            if (options.el) {
	                this.$mount(options.el);
	            }
	        };
	
	        UIkit.prototype._initData = function () {
	
	            var ref = this.$options;
	            var data$$1 = ref.data; if ( data$$1 === void 0 ) data$$1 = {};
	
	            for (var key in data$$1) {
	                this.$props[key] = this[key] = data$$1[key];
	            }
	        };
	
	        UIkit.prototype._initMethods = function () {
	
	            var ref = this.$options;
	            var methods = ref.methods;
	
	            if (methods) {
	                for (var key in methods) {
	                    this[key] = bind(methods[key], this);
	                }
	            }
	        };
	
	        UIkit.prototype._initComputeds = function () {
	
	            var ref = this.$options;
	            var computed = ref.computed;
	
	            this._computeds = {};
	
	            if (computed) {
	                for (var key in computed) {
	                    registerComputed(this, key, computed[key]);
	                }
	            }
	        };
	
	        UIkit.prototype._callWatches = function () {
	
	            var ref = this;
	            var computed = ref.$options.computed;
	            var _computeds = ref._computeds;
	
	            for (var key in _computeds) {
	
	                var value = _computeds[key];
	                delete _computeds[key];
	
	                if (computed[key].watch && !isEqual(value, this[key])) {
	                    computed[key].watch.call(this, this[key], value);
	                }
	
	            }
	
	        };
	
	        UIkit.prototype._initProps = function (props) {
	
	            var key;
	
	            props = props || getProps(this.$options, this.$name);
	
	            for (key in props) {
	                if (!isUndefined(props[key])) {
	                    this.$props[key] = props[key];
	                }
	            }
	
	            var exclude = [this.$options.computed, this.$options.methods];
	            for (key in this.$props) {
	                if (key in props && notIn(exclude, key)) {
	                    this[key] = this.$props[key];
	                }
	            }
	        };
	
	        UIkit.prototype._initEvents = function () {
	            var this$1 = this;
	
	
	            var ref = this.$options;
	            var events = ref.events;
	
	            if (events) {
	
	                events.forEach(function (event) {
	
	                    if (!hasOwn(event, 'handler')) {
	                        for (var key in event) {
	                            registerEvent(this$1, event[key], key);
	                        }
	                    } else {
	                        registerEvent(this$1, event);
	                    }
	
	                });
	            }
	        };
	
	        UIkit.prototype._unbindEvents = function () {
	            this._events.forEach(function (unbind) { return unbind(); });
	            this._events = [];
	        };
	
	        UIkit.prototype._initObserver = function () {
	            var this$1 = this;
	
	
	            var ref = this.$options;
	            var attrs = ref.attrs;
	            var props = ref.props;
	            var el = ref.el;
	            if (this._observer || !props || attrs === false) {
	                return;
	            }
	
	            attrs = isArray(attrs) ? attrs : Object.keys(props);
	
	            this._observer = new MutationObserver(function () {
	
	                var data$$1 = getProps(this$1.$options, this$1.$name);
	                if (attrs.some(function (key) { return !isUndefined(data$$1[key]) && data$$1[key] !== this$1.$props[key]; })) {
	                    this$1.$reset();
	                }
	
	            });
	
	            var filter$$1 = attrs.map(function (key) { return hyphenate(key); }).concat(this.$name);
	
	            this._observer.observe(el, {
	                attributes: true,
	                attributeFilter: filter$$1.concat(filter$$1.map(function (key) { return ("data-" + key); }))
	            });
	        };
	
	        function getProps(opts, name) {
	
	            var data$$1 = {};
	            var args = opts.args; if ( args === void 0 ) args = [];
	            var props = opts.props; if ( props === void 0 ) props = {};
	            var el = opts.el;
	
	            if (!props) {
	                return data$$1;
	            }
	
	            for (var key in props) {
	                var prop = hyphenate(key);
	                var value = data(el, prop);
	
	                if (!isUndefined(value)) {
	
	                    value = props[key] === Boolean && value === ''
	                        ? true
	                        : coerce(props[key], value);
	
	                    if (prop === 'target' && (!value || startsWith(value, '_'))) {
	                        continue;
	                    }
	
	                    data$$1[key] = value;
	                }
	            }
	
	            var options = parseOptions(data(el, name), args);
	
	            for (var key$1 in options) {
	                var prop$1 = camelize(key$1);
	                if (props[prop$1] !== undefined) {
	                    data$$1[prop$1] = coerce(props[prop$1], options[key$1]);
	                }
	            }
	
	            return data$$1;
	        }
	
	        function registerComputed(component, key, cb) {
	            Object.defineProperty(component, key, {
	
	                enumerable: true,
	
	                get: function() {
	
	                    var _computeds = component._computeds;
	                    var $props = component.$props;
	                    var $el = component.$el;
	
	                    if (!hasOwn(_computeds, key)) {
	                        _computeds[key] = (cb.get || cb).call(component, $props, $el);
	                    }
	
	                    return _computeds[key];
	                },
	
	                set: function(value) {
	
	                    var _computeds = component._computeds;
	
	                    _computeds[key] = cb.set ? cb.set.call(component, value) : value;
	
	                    if (isUndefined(_computeds[key])) {
	                        delete _computeds[key];
	                    }
	                }
	
	            });
	        }
	
	        function registerEvent(component, event, key) {
	
	            if (!isPlainObject(event)) {
	                event = ({name: key, handler: event});
	            }
	
	            var name = event.name;
	            var el = event.el;
	            var handler = event.handler;
	            var capture = event.capture;
	            var passive = event.passive;
	            var delegate = event.delegate;
	            var filter$$1 = event.filter;
	            var self = event.self;
	            el = isFunction(el)
	                ? el.call(component)
	                : el || component.$el;
	
	            if (isArray(el)) {
	                el.forEach(function (el) { return registerEvent(component, assign({}, event, {el: el}), key); });
	                return;
	            }
	
	            if (!el || filter$$1 && !filter$$1.call(component)) {
	                return;
	            }
	
	            handler = detail(isString(handler) ? component[handler] : bind(handler, component));
	
	            if (self) {
	                handler = selfFilter(handler);
	            }
	
	            component._events.push(
	                on(
	                    el,
	                    name,
	                    !delegate
	                        ? null
	                        : isString(delegate)
	                            ? delegate
	                            : delegate.call(component),
	                    handler,
	                    isBoolean(passive)
	                        ? {passive: passive, capture: capture}
	                        : capture
	                )
	            );
	
	        }
	
	        function selfFilter(handler) {
	            return function selfHandler(e) {
	                if (e.target === e.currentTarget || e.target === e.current) {
	                    return handler.call(null, e);
	                }
	            };
	        }
	
	        function notIn(options, key) {
	            return options.every(function (arr) { return !arr || !hasOwn(arr, key); });
	        }
	
	        function detail(listener) {
	            return function (e) { return isArray(e.detail) ? listener.apply(void 0, [e].concat(e.detail)) : listener(e); };
	        }
	
	        function coerce(type, value) {
	
	            if (type === Boolean) {
	                return toBoolean(value);
	            } else if (type === Number) {
	                return toNumber(value);
	            } else if (type === 'list') {
	                return toList(value);
	            }
	
	            return type ? type(value) : value;
	        }
	
	        function normalizeData(ref, ref$1) {
	            var data$$1 = ref.data;
	            var el = ref.el;
	            var args = ref$1.args;
	            var props = ref$1.props; if ( props === void 0 ) props = {};
	
	            data$$1 = isArray(data$$1)
	                ? args && args.length
	                    ? data$$1.slice(0, args.length).reduce(function (data$$1, value, index$$1) {
	                        if (isPlainObject(value)) {
	                            assign(data$$1, value);
	                        } else {
	                            data$$1[args[index$$1]] = value;
	                        }
	                        return data$$1;
	                    }, {})
	                    : undefined
	                : data$$1;
	
	            if (data$$1) {
	                for (var key in data$$1) {
	                    if (isUndefined(data$$1[key])) {
	                        delete data$$1[key];
	                    } else {
	                        data$$1[key] = props[key] ? coerce(props[key], data$$1[key], el) : data$$1[key];
	                    }
	                }
	            }
	
	            return data$$1;
	        }
	    }
	
	    function instanceAPI (UIkit) {
	
	        var DATA = UIkit.data;
	
	        UIkit.prototype.$mount = function (el) {
	
	            var ref = this.$options;
	            var name = ref.name;
	
	            if (!el[DATA]) {
	                el[DATA] = {};
	            }
	
	            if (el[DATA][name]) {
	                return;
	            }
	
	            el[DATA][name] = this;
	
	            this.$el = this.$options.el = this.$options.el || el;
	
	            if (within(el, document)) {
	                this._callConnected();
	            }
	        };
	
	        UIkit.prototype.$emit = function (e) {
	            this._callUpdate(e);
	        };
	
	        UIkit.prototype.$reset = function () {
	            this._callDisconnected();
	            this._callConnected();
	        };
	
	        UIkit.prototype.$destroy = function (removeEl) {
	            if ( removeEl === void 0 ) removeEl = false;
	
	
	            var ref = this.$options;
	            var el = ref.el;
	            var name = ref.name;
	
	            if (el) {
	                this._callDisconnected();
	            }
	
	            this._callHook('destroy');
	
	            if (!el || !el[DATA]) {
	                return;
	            }
	
	            delete el[DATA][name];
	
	            if (!Object.keys(el[DATA]).length) {
	                delete el[DATA];
	            }
	
	            if (removeEl) {
	                remove(this.$el);
	            }
	        };
	
	        UIkit.prototype.$create = function (component, element, data$$1) {
	            return UIkit[component](element, data$$1);
	        };
	
	        UIkit.prototype.$update = UIkit.update;
	        UIkit.prototype.$getComponent = UIkit.getComponent;
	
	        var names = {};
	        Object.defineProperties(UIkit.prototype, {
	
	            $container: Object.getOwnPropertyDescriptor(UIkit, 'container'),
	
	            $name: {
	
	                get: function() {
	                    var ref = this.$options;
	                    var name = ref.name;
	
	                    if (!names[name]) {
	                        names[name] = UIkit.prefix + hyphenate(name);
	                    }
	
	                    return names[name];
	                }
	
	            }
	
	        });
	
	    }
	
	    var UIkit = function (options) {
	        this._init(options);
	    };
	
	    UIkit.util = util;
	    UIkit.data = '__uikit__';
	    UIkit.prefix = 'uk-';
	    UIkit.options = {};
	
	    globalAPI(UIkit);
	    hooksAPI(UIkit);
	    stateAPI(UIkit);
	    componentAPI(UIkit);
	    instanceAPI(UIkit);
	
	    var Class = {
	
	        connected: function() {
	            !hasClass(this.$el, this.$name) && addClass(this.$el, this.$name);
	        }
	
	    };
	
	    var Togglable = {
	
	        props: {
	            cls: Boolean,
	            animation: 'list',
	            duration: Number,
	            origin: String,
	            transition: String,
	            queued: Boolean
	        },
	
	        data: {
	            cls: false,
	            animation: [false],
	            duration: 200,
	            origin: false,
	            transition: 'linear',
	            queued: false,
	
	            initProps: {
	                overflow: '',
	                height: '',
	                paddingTop: '',
	                paddingBottom: '',
	                marginTop: '',
	                marginBottom: ''
	            },
	
	            hideProps: {
	                overflow: 'hidden',
	                height: 0,
	                paddingTop: 0,
	                paddingBottom: 0,
	                marginTop: 0,
	                marginBottom: 0
	            }
	
	        },
	
	        computed: {
	
	            hasAnimation: function(ref) {
	                var animation = ref.animation;
	
	                return !!animation[0];
	            },
	
	            hasTransition: function(ref) {
	                var animation = ref.animation;
	
	                return this.hasAnimation && animation[0] === true;
	            }
	
	        },
	
	        methods: {
	
	            toggleElement: function(targets, show, animate$$1) {
	                var this$1 = this;
	
	                return new Promise(function (resolve) {
	
	                    targets = toNodes(targets);
	
	                    var all = function (targets) { return Promise.all(targets.map(function (el) { return this$1._toggleElement(el, show, animate$$1); })); };
	                    var toggled = targets.filter(function (el) { return this$1.isToggled(el); });
	                    var untoggled = targets.filter(function (el) { return !includes(toggled, el); });
	
	                    var p;
	
	                    if (!this$1.queued || !isUndefined(animate$$1) || !isUndefined(show) || !this$1.hasAnimation || targets.length < 2) {
	
	                        p = all(untoggled.concat(toggled));
	
	                    } else {
	
	                        var body = document.body;
	                        var scroll = body.scrollTop;
	                        var el = toggled[0];
	                        var inProgress = Animation.inProgress(el) && hasClass(el, 'uk-animation-leave')
	                                || Transition.inProgress(el) && el.style.height === '0px';
	
	                        p = all(toggled);
	
	                        if (!inProgress) {
	                            p = p.then(function () {
	                                var p = all(untoggled);
	                                body.scrollTop = scroll;
	                                return p;
	                            });
	                        }
	
	                    }
	
	                    p.then(resolve, noop);
	
	                });
	            },
	
	            toggleNow: function(targets, show) {
	                var this$1 = this;
	
	                return new Promise(function (resolve) { return Promise.all(toNodes(targets).map(function (el) { return this$1._toggleElement(el, show, false); })).then(resolve, noop); });
	            },
	
	            isToggled: function(el) {
	                var nodes = toNodes(el || this.$el);
	                return this.cls
	                    ? hasClass(nodes, this.cls.split(' ')[0])
	                    : !hasAttr(nodes, 'hidden');
	            },
	
	            updateAria: function(el) {
	                if (this.cls === false) {
	                    attr(el, 'aria-hidden', !this.isToggled(el));
	                }
	            },
	
	            _toggleElement: function(el, show, animate$$1) {
	                var this$1 = this;
	
	
	                show = isBoolean(show)
	                    ? show
	                    : Animation.inProgress(el)
	                        ? hasClass(el, 'uk-animation-leave')
	                        : Transition.inProgress(el)
	                            ? el.style.height === '0px'
	                            : !this.isToggled(el);
	
	                if (!trigger(el, ("before" + (show ? 'show' : 'hide')), [this])) {
	                    return Promise.reject();
	                }
	
	                var promise = (
	                    isFunction(animate$$1)
	                        ? animate$$1
	                        : animate$$1 === false || !this.hasAnimation
	                            ? this._toggle
	                            : this.hasTransition
	                                ? toggleHeight(this)
	                                : toggleAnimation(this)
	                )(el, show);
	
	                trigger(el, show ? 'show' : 'hide', [this]);
	
	                var final = function () {
	                    trigger(el, show ? 'shown' : 'hidden', [this$1]);
	                    this$1.$update(el);
	                };
	
	                return promise ? promise.then(final) : Promise.resolve(final());
	            },
	
	            _toggle: function(el, toggled) {
	
	                if (!el) {
	                    return;
	                }
	
	                toggled = Boolean(toggled);
	
	                var changed;
	                if (this.cls) {
	                    changed = includes(this.cls, ' ') || toggled !== hasClass(el, this.cls);
	                    changed && toggleClass(el, this.cls, includes(this.cls, ' ') ? undefined : toggled);
	                } else {
	                    changed = toggled === hasAttr(el, 'hidden');
	                    changed && attr(el, 'hidden', !toggled ? '' : null);
	                }
	
	                $$('[autofocus]', el).some(function (el) { return isVisible(el) ? el.focus() || true : el.blur(); });
	
	                this.updateAria(el);
	                changed && this.$update(el);
	            }
	
	        }
	
	    };
	
	    function toggleHeight(ref) {
	        var isToggled = ref.isToggled;
	        var duration = ref.duration;
	        var initProps = ref.initProps;
	        var hideProps = ref.hideProps;
	        var transition$$1 = ref.transition;
	        var _toggle = ref._toggle;
	
	        return function (el, show) {
	
	            var inProgress = Transition.inProgress(el);
	            var inner = el.hasChildNodes ? toFloat(css(el.firstElementChild, 'marginTop')) + toFloat(css(el.lastElementChild, 'marginBottom')) : 0;
	            var currentHeight = isVisible(el) ? height(el) + (inProgress ? 0 : inner) : 0;
	
	            Transition.cancel(el);
	
	            if (!isToggled(el)) {
	                _toggle(el, true);
	            }
	
	            height(el, '');
	
	            // Update child components first
	            fastdom.flush();
	
	            var endHeight = height(el) + (inProgress ? 0 : inner);
	            height(el, currentHeight);
	
	            return (show
	                    ? Transition.start(el, assign({}, initProps, {overflow: 'hidden', height: endHeight}), Math.round(duration * (1 - currentHeight / endHeight)), transition$$1)
	                    : Transition.start(el, hideProps, Math.round(duration * (currentHeight / endHeight)), transition$$1).then(function () { return _toggle(el, false); })
	            ).then(function () { return css(el, initProps); });
	
	        };
	    }
	
	    function toggleAnimation(ref) {
	        var animation = ref.animation;
	        var duration = ref.duration;
	        var origin = ref.origin;
	        var _toggle = ref._toggle;
	
	        return function (el, show) {
	
	            Animation.cancel(el);
	
	            if (show) {
	                _toggle(el, true);
	                return Animation.in(el, animation[0], duration, origin);
	            }
	
	            return Animation.out(el, animation[1] || animation[0], duration, origin).then(function () { return _toggle(el, false); });
	        };
	    }
	
	    var Accordion = {
	
	        mixins: [Class, Togglable],
	
	        props: {
	            targets: String,
	            active: null,
	            collapsible: Boolean,
	            multiple: Boolean,
	            toggle: String,
	            content: String,
	            transition: String
	        },
	
	        data: {
	            targets: '> *',
	            active: false,
	            animation: [true],
	            collapsible: true,
	            multiple: false,
	            clsOpen: 'uk-open',
	            toggle: '> .uk-accordion-title',
	            content: '> .uk-accordion-content',
	            transition: 'ease'
	        },
	
	        computed: {
	
	            items: function(ref, $el) {
	                var targets = ref.targets;
	
	                return $$(targets, $el);
	            }
	
	        },
	
	        events: [
	
	            {
	
	                name: 'click',
	
	                delegate: function() {
	                    return ((this.targets) + " " + (this.$props.toggle));
	                },
	
	                handler: function(e) {
	                    e.preventDefault();
	                    this.toggle(index($$(((this.targets) + " " + (this.$props.toggle)), this.$el), e.current));
	                }
	
	            }
	
	        ],
	
	        connected: function() {
	
	            if (this.active === false) {
	                return;
	            }
	
	            var active = this.items[Number(this.active)];
	            if (active && !hasClass(active, this.clsOpen)) {
	                this.toggle(active, false);
	            }
	        },
	
	        update: function() {
	            var this$1 = this;
	
	
	            this.items.forEach(function (el) { return this$1._toggle($(this$1.content, el), hasClass(el, this$1.clsOpen)); });
	
	            var active = !this.collapsible && !hasClass(this.items, this.clsOpen) && this.items[0];
	            if (active) {
	                this.toggle(active, false);
	            }
	        },
	
	        methods: {
	
	            toggle: function(item, animate$$1) {
	                var this$1 = this;
	
	
	                var index$$1 = getIndex(item, this.items);
	                var active = filter(this.items, ("." + (this.clsOpen)));
	
	                item = this.items[index$$1];
	
	                item && [item]
	                    .concat(!this.multiple && !includes(active, item) && active || [])
	                    .forEach(function (el) {
	
	                        var isItem = el === item;
	                        var state = isItem && !hasClass(el, this$1.clsOpen);
	
	                        if (!state && isItem && !this$1.collapsible && active.length < 2) {
	                            return;
	                        }
	
	                        toggleClass(el, this$1.clsOpen, state);
	
	                        var content = el._wrapper ? el._wrapper.firstElementChild : $(this$1.content, el);
	
	                        if (!el._wrapper) {
	                            el._wrapper = wrapAll(content, '<div>');
	                            attr(el._wrapper, 'hidden', state ? '' : null);
	                        }
	
	                        this$1._toggle(content, true);
	                        this$1.toggleElement(el._wrapper, state, animate$$1).then(function () {
	
	                            if (hasClass(el, this$1.clsOpen) !== state) {
	                                return;
	                            }
	
	                            if (!state) {
	                                this$1._toggle(content, false);
	                            }
	
	                            el._wrapper = null;
	                            unwrap(content);
	
	                        });
	
	                    });
	            }
	
	        }
	
	    };
	
	    var Alert = {
	
	        mixins: [Class, Togglable],
	
	        args: 'animation',
	
	        props: {
	            close: String
	        },
	
	        data: {
	            animation: [true],
	            selClose: '.uk-alert-close',
	            duration: 150,
	            hideProps: assign({opacity: 0}, Togglable.data.hideProps)
	        },
	
	        events: [
	
	            {
	
	                name: 'click',
	
	                delegate: function() {
	                    return this.selClose;
	                },
	
	                handler: function(e) {
	                    e.preventDefault();
	                    this.close();
	                }
	
	            }
	
	        ],
	
	        methods: {
	
	            close: function() {
	                var this$1 = this;
	
	                this.toggleElement(this.$el).then(function () { return this$1.$destroy(true); });
	            }
	
	        }
	
	    };
	
	    function Core (UIkit) {
	
	        ready(function () {
	
	            UIkit.update();
	            on(window, 'load resize', function () { return UIkit.update(null, 'resize'); });
	            on(document, 'loadedmetadata load', function (ref) {
	                var target = ref.target;
	
	                return UIkit.update(target, 'resize');
	            }, true);
	
	            // throttle `scroll` event (Safari triggers multiple `scroll` events per frame)
	            var pending;
	            on(window, 'scroll', function (e) {
	
	                if (pending) {
	                    return;
	                }
	                pending = true;
	                fastdom.write(function () { return pending = false; });
	
	                var target = e.target;
	                UIkit.update(target.nodeType !== 1 ? document.body : target, e.type);
	
	            }, {passive: true, capture: true});
	
	            var started = 0;
	            on(document, 'animationstart', function (ref) {
	                var target = ref.target;
	
	                if ((css(target, 'animationName') || '').match(/^uk-.*(left|right)/)) {
	
	                    started++;
	                    css(document.body, 'overflowX', 'hidden');
	                    setTimeout(function () {
	                        if (!--started) {
	                            css(document.body, 'overflowX', '');
	                        }
	                    }, toMs(css(target, 'animationDuration')) + 100);
	                }
	            }, true);
	
	        });
	
	    }
	
	    var Video = {
	
	        args: 'autoplay',
	
	        props: {
	            automute: Boolean,
	            autoplay: Boolean,
	        },
	
	        data: {
	            automute: false,
	            autoplay: true
	        },
	
	        computed: {
	
	            inView: function(ref) {
	                var autoplay = ref.autoplay;
	
	                return autoplay === 'inview';
	            }
	
	        },
	
	        connected: function() {
	
	            if (this.inView && !hasAttr(this.$el, 'preload')) {
	                this.$el.preload = 'none';
	            }
	
	            this.player = new Player(this.$el);
	
	            if (this.automute) {
	                this.player.mute();
	            }
	
	        },
	
	        update: {
	
	            read: function() {
	
	                return !this.player
	                    ? false
	                    : {
	                        visible: isVisible(this.$el) && css(this.$el, 'visibility') !== 'hidden',
	                        inView: this.inView && isInView(this.$el)
	                    };
	            },
	
	            write: function(ref) {
	                var visible = ref.visible;
	                var inView = ref.inView;
	
	
	                if (!visible || this.inView && !inView) {
	                    this.player.pause();
	                } else if (this.autoplay === true || this.inView && inView) {
	                    this.player.play();
	                }
	
	            },
	
	            events: ['resize', 'scroll']
	
	        }
	
	    };
	
	    var Cover = {
	
	        mixins: [Class, Video],
	
	        props: {
	            width: Number,
	            height: Number
	        },
	
	        data: {
	            automute: true
	        },
	
	        update: {
	
	            read: function() {
	
	                var el = this.$el;
	
	                if (!isVisible(el)) {
	                    return false;
	                }
	
	                var ref = el.parentNode;
	                var height$$1 = ref.offsetHeight;
	                var width$$1 = ref.offsetWidth;
	
	                return {height: height$$1, width: width$$1};
	            },
	
	            write: function(ref) {
	                var height$$1 = ref.height;
	                var width$$1 = ref.width;
	
	
	                var el = this.$el;
	                var elWidth = this.width || el.naturalWidth || el.videoWidth || el.clientWidth;
	                var elHeight = this.height || el.naturalHeight || el.videoHeight || el.clientHeight;
	
	                if (!elWidth || !elHeight) {
	                    return;
	                }
	
	                css(el, Dimensions.cover(
	                    {
	                        width: elWidth,
	                        height: elHeight
	                    },
	                    {
	                        width: width$$1 + (width$$1 % 2 ? 1 : 0),
	                        height: height$$1 + (height$$1 % 2 ? 1 : 0)
	                    }
	                ));
	
	            },
	
	            events: ['resize']
	
	        }
	
	    };
	
	    var Position = {
	
	        props: {
	            pos: String,
	            offset: null,
	            flip: Boolean,
	            clsPos: String
	        },
	
	        data: {
	            pos: ("bottom-" + (!isRtl ? 'left' : 'right')),
	            flip: true,
	            offset: false,
	            clsPos: ''
	        },
	
	        computed: {
	
	            pos: function(ref) {
	                var pos = ref.pos;
	
	                return (pos + (!includes(pos, '-') ? '-center' : '')).split('-');
	            },
	
	            dir: function() {
	                return this.pos[0];
	            },
	
	            align: function() {
	                return this.pos[1];
	            }
	
	        },
	
	        methods: {
	
	            positionAt: function(element, target, boundary) {
	
	                removeClasses(element, ((this.clsPos) + "-(top|bottom|left|right)(-[a-z]+)?"));
	                css(element, {top: '', left: ''});
	
	                var node;
	                var ref = this;
	                var offset$$1 = ref.offset;
	                var axis = this.getAxis();
	
	                if (!isNumeric(offset$$1)) {
	                    node = $(offset$$1);
	                    offset$$1 = node
	                        ? offset(node)[axis === 'x' ? 'left' : 'top'] - offset(target)[axis === 'x' ? 'right' : 'bottom']
	                        : 0;
	                }
	
	                var ref$1 = positionAt(
	                    element,
	                    target,
	                    axis === 'x' ? ((flipPosition(this.dir)) + " " + (this.align)) : ((this.align) + " " + (flipPosition(this.dir))),
	                    axis === 'x' ? ((this.dir) + " " + (this.align)) : ((this.align) + " " + (this.dir)),
	                    axis === 'x' ? ("" + (this.dir === 'left' ? -offset$$1 : offset$$1)) : (" " + (this.dir === 'top' ? -offset$$1 : offset$$1)),
	                    null,
	                    this.flip,
	                    boundary
	                ).target;
	                var x = ref$1.x;
	                var y = ref$1.y;
	
	                this.dir = axis === 'x' ? x : y;
	                this.align = axis === 'x' ? y : x;
	
	                toggleClass(element, ((this.clsPos) + "-" + (this.dir) + "-" + (this.align)), this.offset === false);
	
	            },
	
	            getAxis: function() {
	                return this.dir === 'top' || this.dir === 'bottom' ? 'y' : 'x';
	            }
	
	        }
	
	    };
	
	    var active;
	
	    var Drop = {
	
	        mixins: [Position, Togglable],
	
	        args: 'pos',
	
	        props: {
	            mode: 'list',
	            toggle: Boolean,
	            boundary: Boolean,
	            boundaryAlign: Boolean,
	            delayShow: Number,
	            delayHide: Number,
	            clsDrop: String
	        },
	
	        data: {
	            mode: ['click', 'hover'],
	            toggle: '- *',
	            boundary: window,
	            boundaryAlign: false,
	            delayShow: 0,
	            delayHide: 800,
	            clsDrop: false,
	            hoverIdle: 200,
	            animation: ['uk-animation-fade'],
	            cls: 'uk-open'
	        },
	
	        computed: {
	
	            boundary: function(ref, $el) {
	                var boundary = ref.boundary;
	
	                return query(boundary, $el);
	            },
	
	            clsDrop: function(ref) {
	                var clsDrop = ref.clsDrop;
	
	                return clsDrop || ("uk-" + (this.$options.name));
	            },
	
	            clsPos: function() {
	                return this.clsDrop;
	            }
	
	        },
	
	        created: function() {
	            this.tracker = new MouseTracker();
	        },
	
	        connected: function() {
	
	            addClass(this.$el, this.clsDrop);
	
	            var ref = this.$props;
	            var toggle = ref.toggle;
	            this.toggle = toggle && this.$create('toggle', query(toggle, this.$el), {
	                target: this.$el,
	                mode: this.mode
	            });
	
	            !this.toggle && trigger(this.$el, 'updatearia');
	
	        },
	
	        events: [
	
	
	            {
	
	                name: 'click',
	
	                delegate: function() {
	                    return ("." + (this.clsDrop) + "-close");
	                },
	
	                handler: function(e) {
	                    e.preventDefault();
	                    this.hide(false);
	                }
	
	            },
	
	            {
	
	                name: 'click',
	
	                delegate: function() {
	                    return 'a[href^="#"]';
	                },
	
	                handler: function(e) {
	
	                    if (e.defaultPrevented) {
	                        return;
	                    }
	
	                    var id = e.target.hash;
	
	                    if (!id) {
	                        e.preventDefault();
	                    }
	
	                    if (!id || !within(id, this.$el)) {
	                        this.hide(false);
	                    }
	                }
	
	            },
	
	            {
	
	                name: 'beforescroll',
	
	                handler: function() {
	                    this.hide(false);
	                }
	
	            },
	
	            {
	
	                name: 'toggle',
	
	                self: true,
	
	                handler: function(e, toggle) {
	
	                    e.preventDefault();
	
	                    if (this.isToggled()) {
	                        this.hide(false);
	                    } else {
	                        this.show(toggle, false);
	                    }
	                }
	
	            },
	
	            {
	
	                name: pointerEnter,
	
	                filter: function() {
	                    return includes(this.mode, 'hover');
	                },
	
	                handler: function(e) {
	
	                    if (isTouch(e)) {
	                        return;
	                    }
	
	                    if (active
	                        && active !== this
	                        && active.toggle
	                        && includes(active.toggle.mode, 'hover')
	                        && !within(e.target, active.toggle.$el)
	                        && !pointInRect({x: e.pageX, y: e.pageY}, offset(active.$el))
	                    ) {
	                        active.hide(false);
	                    }
	
	                    e.preventDefault();
	                    this.show(this.toggle);
	                }
	
	            },
	
	            {
	
	                name: 'toggleshow',
	
	                handler: function(e, toggle) {
	
	                    if (toggle && !includes(toggle.target, this.$el)) {
	                        return;
	                    }
	
	                    e.preventDefault();
	                    this.show(toggle || this.toggle);
	                }
	
	            },
	
	            {
	
	                name: ("togglehide " + pointerLeave),
	
	                handler: function(e, toggle) {
	
	                    if (isTouch(e) || toggle && !includes(toggle.target, this.$el)) {
	                        return;
	                    }
	
	                    e.preventDefault();
	
	                    if (this.toggle && includes(this.toggle.mode, 'hover')) {
	                        this.hide();
	                    }
	                }
	
	            },
	
	            {
	
	                name: 'beforeshow',
	
	                self: true,
	
	                handler: function() {
	                    this.clearTimers();
	                    Animation.cancel(this.$el);
	                    this.position();
	                }
	
	            },
	
	            {
	
	                name: 'show',
	
	                self: true,
	
	                handler: function() {
	                    this.tracker.init();
	                    trigger(this.$el, 'updatearia');
	                    registerEvent();
	                }
	
	            },
	
	            {
	
	                name: 'beforehide',
	
	                self: true,
	
	                handler: function() {
	                    this.clearTimers();
	                }
	
	            },
	
	            {
	
	                name: 'hide',
	
	                handler: function(ref) {
	                    var target = ref.target;
	
	
	                    if (this.$el !== target) {
	                        active = active === null && within(target, this.$el) && this.isToggled() ? this : active;
	                        return;
	                    }
	
	                    active = this.isActive() ? null : active;
	                    trigger(this.$el, 'updatearia');
	                    this.tracker.cancel();
	                }
	
	            },
	
	            {
	
	                name: 'updatearia',
	
	                self: true,
	
	                handler: function(e, toggle) {
	
	                    e.preventDefault();
	
	                    this.updateAria(this.$el);
	
	                    if (toggle || this.toggle) {
	                        attr((toggle || this.toggle).$el, 'aria-expanded', this.isToggled() ? 'true' : 'false');
	                        toggleClass(this.toggle.$el, this.cls, this.isToggled());
	                    }
	                }
	            }
	
	        ],
	
	        update: {
	
	            write: function() {
	
	                if (this.isToggled() && !Animation.inProgress(this.$el)) {
	                    this.position();
	                }
	
	            },
	
	            events: ['resize']
	
	        },
	
	        methods: {
	
	            show: function(toggle, delay) {
	                var this$1 = this;
	                if ( delay === void 0 ) delay = true;
	
	
	                var show = function () { return !this$1.isToggled() && this$1.toggleElement(this$1.$el, true); };
	                var tryShow = function () {
	
	                    this$1.toggle = toggle || this$1.toggle;
	
	                    this$1.clearTimers();
	
	                    if (this$1.isActive()) {
	                        return;
	                    } else if (delay && active && active !== this$1 && active.isDelaying) {
	                        this$1.showTimer = setTimeout(this$1.show, 10);
	                        return;
	                    } else if (this$1.isParentOf(active)) {
	
	                        if (active.hideTimer) {
	                            active.hide(false);
	                        } else {
	                            return;
	                        }
	
	                    } else if (active && this$1.isChildOf(active)) {
	
	                        active.clearTimers();
	
	                    } else if (active && !this$1.isChildOf(active) && !this$1.isParentOf(active)) {
	
	                        var prev;
	                        while (active && active !== prev && !this$1.isChildOf(active)) {
	                            prev = active;
	                            active.hide(false);
	                        }
	
	                    }
	
	                    if (delay && this$1.delayShow) {
	                        this$1.showTimer = setTimeout(show, this$1.delayShow);
	                    } else {
	                        show();
	                    }
	
	                    active = this$1;
	                };
	
	                if (toggle && this.toggle && toggle.$el !== this.toggle.$el) {
	
	                    once(this.$el, 'hide', tryShow);
	                    this.hide(false);
	
	                } else {
	                    tryShow();
	                }
	            },
	
	            hide: function(delay) {
	                var this$1 = this;
	                if ( delay === void 0 ) delay = true;
	
	
	                var hide = function () { return this$1.toggleNow(this$1.$el, false); };
	
	                this.clearTimers();
	
	                this.isDelaying = this.tracker.movesTo(this.$el);
	
	                if (delay && this.isDelaying) {
	                    this.hideTimer = setTimeout(this.hide, this.hoverIdle);
	                } else if (delay && this.delayHide) {
	                    this.hideTimer = setTimeout(hide, this.delayHide);
	                } else {
	                    hide();
	                }
	            },
	
	            clearTimers: function() {
	                clearTimeout(this.showTimer);
	                clearTimeout(this.hideTimer);
	                this.showTimer = null;
	                this.hideTimer = null;
	                this.isDelaying = false;
	            },
	
	            isActive: function() {
	                return active === this;
	            },
	
	            isChildOf: function(drop) {
	                return drop && drop !== this && within(this.$el, drop.$el);
	            },
	
	            isParentOf: function(drop) {
	                return drop && drop !== this && within(drop.$el, this.$el);
	            },
	
	            position: function() {
	
	                removeClasses(this.$el, ((this.clsDrop) + "-(stack|boundary)"));
	                css(this.$el, {top: '', left: '', display: 'block'});
	                toggleClass(this.$el, ((this.clsDrop) + "-boundary"), this.boundaryAlign);
	
	                var boundary = offset(this.boundary);
	                var alignTo = this.boundaryAlign ? boundary : offset(this.toggle.$el);
	
	                if (this.align === 'justify') {
	                    var prop = this.getAxis() === 'y' ? 'width' : 'height';
	                    css(this.$el, prop, alignTo[prop]);
	                } else if (this.$el.offsetWidth > Math.max(boundary.right - alignTo.left, alignTo.right - boundary.left)) {
	                    addClass(this.$el, ((this.clsDrop) + "-stack"));
	                }
	
	                this.positionAt(this.$el, this.boundaryAlign ? this.boundary : this.toggle.$el, this.boundary);
	
	                css(this.$el, 'display', '');
	
	            }
	
	        }
	
	    };
	
	    var registered;
	
	    function registerEvent() {
	
	        if (registered) {
	            return;
	        }
	
	        registered = true;
	        on(document, pointerUp, function (ref) {
	            var target = ref.target;
	            var defaultPrevented = ref.defaultPrevented;
	
	            var prev;
	
	            if (defaultPrevented) {
	                return;
	            }
	
	            while (active && active !== prev && !within(target, active.$el) && !(active.toggle && within(target, active.toggle.$el))) {
	                prev = active;
	                active.hide(false);
	            }
	        });
	    }
	
	    var Dropdown = {
	
	        extends: Drop
	
	    };
	
	    var FormCustom = {
	
	        mixins: [Class],
	
	        args: 'target',
	
	        props: {
	            target: Boolean
	        },
	
	        data: {
	            target: false
	        },
	
	        computed: {
	
	            input: function(_, $el) {
	                return $(selInput, $el);
	            },
	
	            state: function() {
	                return this.input.nextElementSibling;
	            },
	
	            target: function(ref, $el) {
	                var target = ref.target;
	
	                return target && (target === true
	                    && this.input.parentNode === $el
	                    && this.input.nextElementSibling
	                    || query(target, $el));
	            }
	
	        },
	
	        update: function() {
	
	            var ref = this;
	            var target = ref.target;
	            var input = ref.input;
	
	            if (!target) {
	                return;
	            }
	
	            var option;
	            var prop = isInput(target) ? 'value' : 'textContent';
	            var prev = target[prop];
	            var value = input.files && input.files[0]
	                ? input.files[0].name
	                : matches(input, 'select') && (option = $$('option', input).filter(function (el) { return el.selected; })[0])
	                    ? option.textContent
	                    : input.value;
	
	            if (prev !== value) {
	                target[prop] = value;
	            }
	
	        },
	
	        events: {
	
	            change: function() {
	                this.$emit();
	            }
	
	        }
	
	    };
	
	    // Deprecated
	    var Gif = {
	
	        update: {
	
	            read: function(data$$1) {
	
	                var inview = isInView(this.$el);
	
	                if (!inview || data$$1.isInView === inview) {
	                    return false;
	                }
	
	                data$$1.isInView = inview;
	            },
	
	            write: function() {
	                this.$el.src = this.$el.src;
	            },
	
	            events: ['scroll', 'resize']
	        }
	
	    };
	
	    var Margin = {
	
	        props: {
	            margin: String,
	            firstColumn: Boolean
	        },
	
	        data: {
	            margin: 'uk-margin-small-top',
	            firstColumn: 'uk-first-column'
	        },
	
	        update: {
	
	            read: function(data$$1) {
	
	                var items = this.$el.children;
	                var rows = [[]];
	
	                if (!items.length || !isVisible(this.$el)) {
	                    return data$$1.rows = rows;
	                }
	
	                data$$1.rows = getRows(items);
	                data$$1.stacks = !data$$1.rows.some(function (row) { return row.length > 1; });
	
	            },
	
	            write: function(ref) {
	                var this$1 = this;
	                var rows = ref.rows;
	
	
	                rows.forEach(function (row, i) { return row.forEach(function (el, j) {
	                        toggleClass(el, this$1.margin, i !== 0);
	                        toggleClass(el, this$1.firstColumn, j === 0);
	                    }); }
	                );
	
	            },
	
	            events: ['resize']
	
	        }
	
	    };
	
	    function getRows(items) {
	        var rows = [[]];
	
	        for (var i = 0; i < items.length; i++) {
	
	            var el = items[i];
	            var dim = getOffset(el);
	
	            if (!dim.height) {
	                continue;
	            }
	
	            for (var j = rows.length - 1; j >= 0; j--) {
	
	                var row = rows[j];
	
	                if (!row[0]) {
	                    row.push(el);
	                    break;
	                }
	
	                var leftDim = (void 0);
	                if (row[0].offsetParent === el.offsetParent) {
	                    leftDim = getOffset(row[0]);
	                } else {
	                    dim = getOffset(el, true);
	                    leftDim = getOffset(row[0], true);
	                }
	
	                if (dim.top >= leftDim.bottom - 1) {
	                    rows.push([el]);
	                    break;
	                }
	
	                if (dim.bottom > leftDim.top) {
	
	                    if (dim.left < leftDim.left && !isRtl) {
	                        row.unshift(el);
	                        break;
	                    }
	
	                    row.push(el);
	                    break;
	                }
	
	                if (j === 0) {
	                    rows.unshift([el]);
	                    break;
	                }
	
	            }
	
	        }
	
	        return rows;
	
	    }
	
	    function getOffset(element, offset$$1) {
	        var assign$$1;
	
	        if ( offset$$1 === void 0 ) offset$$1 = false;
	
	        var offsetTop = element.offsetTop;
	        var offsetLeft = element.offsetLeft;
	        var offsetHeight = element.offsetHeight;
	
	        if (offset$$1) {
	            (assign$$1 = offsetPosition(element), offsetTop = assign$$1[0], offsetLeft = assign$$1[1]);
	        }
	
	        return {
	            top: offsetTop,
	            left: offsetLeft,
	            height: offsetHeight,
	            bottom: offsetTop + offsetHeight
	        };
	    }
	
	    var Grid = {
	
	        extends: Margin,
	
	        mixins: [Class],
	
	        name: 'grid',
	
	        props: {
	            masonry: Boolean,
	            parallax: Number
	        },
	
	        data: {
	            margin: 'uk-grid-margin',
	            clsStack: 'uk-grid-stack',
	            masonry: false,
	            parallax: 0
	        },
	
	        computed: {
	
	            length: function(_, $el) {
	                return $el.children.length;
	            },
	
	            parallax: function(ref) {
	                var parallax = ref.parallax;
	
	                return parallax && this.length ? Math.abs(parallax) : '';
	            }
	
	        },
	
	        connected: function() {
	            this.masonry && addClass(this.$el, 'uk-flex-top uk-flex-wrap-top');
	        },
	
	        update: [
	
	            {
	
	                read: function(ref) {
	                    var rows = ref.rows;
	
	
	                    if (this.masonry || this.parallax) {
	                        rows = rows.map(function (elements) { return sortBy(elements, 'offsetLeft'); });
	
	                        if (isRtl) {
	                            rows.map(function (row) { return row.reverse(); });
	                        }
	
	                    }
	
	                    var transitionInProgress = rows.some(function (elements) { return elements.some(Transition.inProgress); });
	                    var translates = false;
	                    var elHeight = '';
	
	                    if (this.masonry && this.length) {
	
	                        var height$$1 = 0;
	
	                        translates = rows.reduce(function (translates, row, i) {
	
	                            translates[i] = row.map(function (_, j) { return i === 0 ? 0 : toFloat(translates[i - 1][j]) + (height$$1 - toFloat(rows[i - 1][j] && rows[i - 1][j].offsetHeight)); });
	                            height$$1 = row.reduce(function (height$$1, el) { return Math.max(height$$1, el.offsetHeight); }, 0);
	
	                            return translates;
	
	                        }, []);
	
	                        elHeight = maxColumnHeight(rows) + getMarginTop(this.$el, this.margin) * (rows.length - 1);
	
	                    }
	
	                    return {rows: rows, translates: translates, height: !transitionInProgress ? elHeight : false};
	
	                },
	
	                write: function(ref) {
	                    var stacks = ref.stacks;
	                    var height$$1 = ref.height;
	
	
	                    toggleClass(this.$el, this.clsStack, stacks);
	
	                    css(this.$el, 'paddingBottom', this.parallax);
	                    height$$1 !== false && css(this.$el, 'height', height$$1);
	
	                },
	
	                events: ['resize']
	
	            },
	
	            {
	
	                read: function(ref) {
	                    var height$$1 = ref.height;
	
	                    return {
	                        scrolled: this.parallax
	                            ? scrolledOver(this.$el, height$$1 ? height$$1 - height(this.$el) : 0) * this.parallax
	                            : false
	                    };
	                },
	
	                write: function(ref) {
	                    var rows = ref.rows;
	                    var scrolled = ref.scrolled;
	                    var translates = ref.translates;
	
	
	                    if (scrolled === false && !translates) {
	                        return;
	                    }
	
	                    rows.forEach(function (row, i) { return row.forEach(function (el, j) { return css(el, 'transform', !scrolled && !translates ? '' : ("translateY(" + ((translates && -translates[i][j]) + (scrolled ? j % 2 ? scrolled : scrolled / 8 : 0)) + "px)")); }
	                        ); }
	                    );
	
	                },
	
	                events: ['scroll', 'resize']
	
	            }
	
	        ]
	
	    };
	
	    function getMarginTop(root, cls) {
	
	        var nodes = toNodes(root.children);
	        var ref = nodes.filter(function (el) { return hasClass(el, cls); });
	        var node = ref[0];
	
	        return toFloat(node
	            ? css(node, 'marginTop')
	            : css(nodes[0], 'paddingLeft'));
	    }
	
	    function maxColumnHeight(rows) {
	        return Math.max.apply(Math, rows.reduce(function (sum, row) {
	            row.forEach(function (el, i) { return sum[i] = (sum[i] || 0) + el.offsetHeight; });
	            return sum;
	        }, []));
	    }
	
	    // IE 11 fix (min-height on a flex container won't apply to its flex items)
	    var FlexBug = isIE ? {
	
	        data: {
	            selMinHeight: false,
	            forceHeight: false
	        },
	
	        computed: {
	
	            elements: function(ref, $el) {
	                var selMinHeight = ref.selMinHeight;
	
	                return selMinHeight ? $$(selMinHeight, $el) : [$el];
	            }
	
	        },
	
	        update: [
	
	            {
	
	                read: function() {
	                    css(this.elements, 'height', '');
	                },
	
	                order: -5,
	
	                events: ['resize']
	
	            },
	
	            {
	
	                write: function() {
	                    var this$1 = this;
	
	                    this.elements.forEach(function (el) {
	                        var height$$1 = toFloat(css(el, 'minHeight'));
	                        if (height$$1 && (this$1.forceHeight || Math.round(height$$1 + boxModelAdjust('height', el, 'content-box')) >= el.offsetHeight)) {
	                            css(el, 'height', height$$1);
	                        }
	                    });
	                },
	
	                order: 5,
	
	                events: ['resize']
	
	            }
	
	        ]
	
	    } : {};
	
	    var HeightMatch = {
	
	        mixins: [FlexBug],
	
	        args: 'target',
	
	        props: {
	            target: String,
	            row: Boolean
	        },
	
	        data: {
	            target: '> *',
	            row: true,
	            forceHeight: true
	        },
	
	        computed: {
	
	            elements: function(ref, $el) {
	                var target = ref.target;
	
	                return $$(target, $el);
	            }
	
	        },
	
	        update: {
	
	            read: function() {
	                return {
	                    rows: (this.row ? getRows(this.elements) : [this.elements]).map(match)
	                };
	            },
	
	            write: function(ref) {
	                var rows = ref.rows;
	
	                rows.forEach(function (ref) {
	                        var heights = ref.heights;
	                        var elements = ref.elements;
	
	                        return elements.forEach(function (el, i) { return css(el, 'minHeight', heights[i]); }
	                    );
	                }
	                );
	            },
	
	            events: ['resize']
	
	        }
	
	    };
	
	    function match(elements) {
	        var assign$$1;
	
	
	        if (elements.length < 2) {
	            return {heights: [''], elements: elements};
	        }
	
	        var ref = getHeights(elements);
	        var heights = ref.heights;
	        var max = ref.max;
	        var hasMinHeight = elements.some(function (el) { return el.style.minHeight; });
	        var hasShrunk = elements.some(function (el, i) { return !el.style.minHeight && heights[i] < max; });
	
	        if (hasMinHeight && hasShrunk) {
	            css(elements, 'minHeight', '');
	            ((assign$$1 = getHeights(elements), heights = assign$$1.heights, max = assign$$1.max));
	        }
	
	        heights = elements.map(function (el, i) { return heights[i] === max && toFloat(el.style.minHeight).toFixed(2) !== max.toFixed(2) ? '' : max; }
	        );
	
	        return {heights: heights, elements: elements};
	    }
	
	    function getHeights(elements) {
	        var heights = elements.map(function (el) { return offset(el).height - boxModelAdjust('height', el, 'content-box'); });
	        var max = Math.max.apply(null, heights);
	
	        return {heights: heights, max: max};
	    }
	
	    var HeightViewport = {
	
	        mixins: [FlexBug],
	
	        props: {
	            expand: Boolean,
	            offsetTop: Boolean,
	            offsetBottom: Boolean,
	            minHeight: Number
	        },
	
	        data: {
	            expand: false,
	            offsetTop: false,
	            offsetBottom: false,
	            minHeight: 0
	        },
	
	        update: {
	
	            read: function() {
	
	                var minHeight = '';
	                var box = boxModelAdjust('height', this.$el, 'content-box');
	
	                if (this.expand) {
	
	                    minHeight = height(window) - (offsetHeight(document.documentElement) - offsetHeight(this.$el)) - box || '';
	
	                } else {
	
	                    // on mobile devices (iOS and Android) window.innerHeight !== 100vh
	                    minHeight = 'calc(100vh';
	
	                    if (this.offsetTop) {
	
	                        var ref = offset(this.$el);
	                        var top = ref.top;
	                        minHeight += top < height(window) / 2 ? (" - " + top + "px") : '';
	
	                    }
	
	                    if (this.offsetBottom === true) {
	
	                        minHeight += " - " + (offsetHeight(this.$el.nextElementSibling)) + "px";
	
	                    } else if (isNumeric(this.offsetBottom)) {
	
	                        minHeight += " - " + (this.offsetBottom) + "vh";
	
	                    } else if (this.offsetBottom && endsWith(this.offsetBottom, 'px')) {
	
	                        minHeight += " - " + (toFloat(this.offsetBottom)) + "px";
	
	                    } else if (isString(this.offsetBottom)) {
	
	                        minHeight += " - " + (offsetHeight(query(this.offsetBottom, this.$el))) + "px";
	
	                    }
	
	                    minHeight += (box ? (" - " + box + "px") : '') + ")";
	
	                }
	
	                return {minHeight: minHeight};
	            },
	
	            write: function(ref) {
	                var minHeight = ref.minHeight;
	
	
	                css(this.$el, {minHeight: minHeight});
	
	                if (this.minHeight && toFloat(css(this.$el, 'minHeight')) < this.minHeight) {
	                    css(this.$el, 'minHeight', this.minHeight);
	                }
	
	            },
	
	            events: ['resize']
	
	        }
	
	    };
	
	    function offsetHeight(el) {
	        return el && el.offsetHeight || 0;
	    }
	
	    var svgs = {};
	
	    var SVG = {
	
	        args: 'src',
	
	        props: {
	            id: String,
	            icon: String,
	            src: String,
	            style: String,
	            width: Number,
	            height: Number,
	            ratio: Number,
	            'class': String
	        },
	
	        data: {
	            ratio: 1,
	            id: false,
	            exclude: ['ratio', 'src', 'icon'],
	            'class': ''
	        },
	
	        connected: function() {
	            var this$1 = this;
	            var assign$$1;
	
	
	            this.class += ' uk-svg';
	
	            if (!this.icon && includes(this.src, '#')) {
	
	                var parts = this.src.split('#');
	
	                if (parts.length > 1) {
	                    (assign$$1 = parts, this.src = assign$$1[0], this.icon = assign$$1[1]);
	                }
	            }
	
	            this.svg = this.getSvg().then(function (svg) {
	
	                var el;
	
	                if (isString(svg)) {
	
	                    if (this$1.icon && includes(svg, '<symbol')) {
	                        svg = parseSymbols(svg, this$1.icon) || svg;
	                    }
	
	                    el = $(svg.substr(svg.indexOf('<svg')));
	
	                } else {
	                    el = svg.cloneNode(true);
	                }
	
	                if (!el) {
	                    return Promise.reject('SVG not found.');
	                }
	
	                var dimensions = attr(el, 'viewBox');
	
	                if (dimensions) {
	                    dimensions = dimensions.split(' ');
	                    this$1.width = this$1.$props.width || dimensions[2];
	                    this$1.height = this$1.$props.height || dimensions[3];
	                }
	
	                this$1.width *= this$1.ratio;
	                this$1.height *= this$1.ratio;
	
	                for (var prop in this$1.$options.props) {
	                    if (this$1[prop] && !includes(this$1.exclude, prop)) {
	                        attr(el, prop, this$1[prop]);
	                    }
	                }
	
	                if (!this$1.id) {
	                    removeAttr(el, 'id');
	                }
	
	                if (this$1.width && !this$1.height) {
	                    removeAttr(el, 'height');
	                }
	
	                if (this$1.height && !this$1.width) {
	                    removeAttr(el, 'width');
	                }
	
	                var src = this$1.icon || this$1.src;
	                attr(el, 'data-svg', src);
	
	                var root = this$1.$el;
	                if (isVoidElement(root) || root.tagName === 'CANVAS') {
	
	                    attr(root, {hidden: true, id: null});
	
	                    var next = root.nextElementSibling;
	                    if (src === attr(next, 'data-svg')) {
	                        el = next;
	                    } else {
	                        after(root, el);
	                    }
	
	                } else {
	
	                    var last = root.lastElementChild;
	                    if (src === attr(last, 'data-svg')) {
	                        el = last;
	                    } else {
	                        append(root, el);
	                    }
	
	                }
	
	                this$1.svgEl = el;
	
	                return el;
	
	            }, noop);
	
	        },
	
	        disconnected: function() {
	            var this$1 = this;
	
	
	            if (isVoidElement(this.$el)) {
	                attr(this.$el, {hidden: null, id: this.id || null});
	            }
	
	            if (this.svg) {
	                this.svg.then(function (svg) { return (!this$1._connected || svg !== this$1.svgEl) && remove(svg); }, noop);
	            }
	
	            this.svg = this.svgEl = null;
	
	        },
	
	        methods: {
	
	            getSvg: function() {
	                var this$1 = this;
	
	
	                if (!this.src) {
	                    return Promise.reject();
	                }
	
	                if (svgs[this.src]) {
	                    return svgs[this.src];
	                }
	
	                svgs[this.src] = new Promise(function (resolve, reject) {
	
	                    if (startsWith(this$1.src, 'data:')) {
	                        resolve(decodeURIComponent(this$1.src.split(',')[1]));
	                    } else {
	
	                        ajax(this$1.src).then(
	                            function (xhr) { return resolve(xhr.response); },
	                            function () { return reject('SVG not found.'); }
	                        );
	
	                    }
	
	                });
	
	                return svgs[this.src];
	
	            }
	
	        }
	
	    };
	
	    var symbolRe = /<symbol(.*?id=(['"])(.*?)\2[^]*?<\/)symbol>/g;
	    var symbols = {};
	
	    function parseSymbols(svg, icon) {
	
	        if (!symbols[svg]) {
	
	            symbols[svg] = {};
	
	            var match;
	            while ((match = symbolRe.exec(svg))) {
	                symbols[svg][match[3]] = "<svg xmlns=\"http://www.w3.org/2000/svg\"" + (match[1]) + "svg>";
	            }
	
	            symbolRe.lastIndex = 0;
	
	        }
	
	        return symbols[svg][icon];
	    }
	
	    var closeIcon = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"1\" y1=\"1\" x2=\"13\" y2=\"13\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"13\" y1=\"1\" x2=\"1\" y2=\"13\"/></svg>";
	
	    var closeLarge = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" x1=\"1\" y1=\"1\" x2=\"19\" y2=\"19\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" x1=\"19\" y1=\"1\" x2=\"1\" y2=\"19\"/></svg>";
	
	    var marker = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"9\" y=\"4\" width=\"1\" height=\"11\"/><rect x=\"4\" y=\"9\" width=\"11\" height=\"1\"/></svg>";
	
	    var navbarToggleIcon = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><rect y=\"9\" width=\"20\" height=\"2\"/><rect y=\"3\" width=\"20\" height=\"2\"/><rect y=\"15\" width=\"20\" height=\"2\"/></svg>";
	
	    var overlayIcon = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"19\" y=\"0\" width=\"1\" height=\"40\"/><rect x=\"0\" y=\"19\" width=\"40\" height=\"1\"/></svg>";
	
	    var paginationNext = "<svg width=\"7\" height=\"12\" viewBox=\"0 0 7 12\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" points=\"1 1 6 6 1 11\"/></svg>";
	
	    var paginationPrevious = "<svg width=\"7\" height=\"12\" viewBox=\"0 0 7 12\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" points=\"6 1 1 6 6 11\"/></svg>";
	
	    var searchIcon = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"9\" cy=\"9\" r=\"7\"/><path fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" d=\"M14,14 L18,18 L14,14 Z\"/></svg>";
	
	    var searchLarge = "<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.8\" cx=\"17.5\" cy=\"17.5\" r=\"16.5\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.8\" x1=\"38\" y1=\"39\" x2=\"29\" y2=\"30\"/></svg>";
	
	    var searchNavbar = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" cx=\"10.5\" cy=\"10.5\" r=\"9.5\"/><line fill=\"none\" stroke=\"#000\" stroke-width=\"1.1\" x1=\"23\" y1=\"23\" x2=\"17\" y2=\"17\"/></svg>";
	
	    var slidenavNext = "<svg width=\"14px\" height=\"24px\" viewBox=\"0 0 14 24\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" points=\"1.225,23 12.775,12 1.225,1 \"/></svg>";
	
	    var slidenavNextLarge = "<svg width=\"25px\" height=\"40px\" viewBox=\"0 0 25 40\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"2\" points=\"4.002,38.547 22.527,20.024 4,1.5 \"/></svg>";
	
	    var slidenavPrevious = "<svg width=\"14px\" height=\"24px\" viewBox=\"0 0 14 24\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" points=\"12.775,1 1.225,12 12.775,23 \"/></svg>";
	
	    var slidenavPreviousLarge = "<svg width=\"25px\" height=\"40px\" viewBox=\"0 0 25 40\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"2\" points=\"20.527,1.5 2,20.024 20.525,38.547 \"/></svg>";
	
	    var spinner = "<svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><circle fill=\"none\" stroke=\"#000\" cx=\"15\" cy=\"15\" r=\"14\"/></svg>";
	
	    var totop = "<svg width=\"18\" height=\"10\" viewBox=\"0 0 18 10\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.2\" points=\"1 9 9 1 17 9 \"/></svg>";
	
	    var parsed = {};
	    var icons = {
	        spinner: spinner,
	        totop: totop,
	        marker: marker,
	        'close-icon': closeIcon,
	        'close-large': closeLarge,
	        'navbar-toggle-icon': navbarToggleIcon,
	        'overlay-icon': overlayIcon,
	        'pagination-next': paginationNext,
	        'pagination-previous': paginationPrevious,
	        'search-icon': searchIcon,
	        'search-large': searchLarge,
	        'search-navbar': searchNavbar,
	        'slidenav-next': slidenavNext,
	        'slidenav-next-large': slidenavNextLarge,
	        'slidenav-previous': slidenavPrevious,
	        'slidenav-previous-large': slidenavPreviousLarge
	    };
	
	    var Icon = {
	
	        install: install,
	
	        attrs: ['icon', 'ratio'],
	
	        mixins: [Class, SVG],
	
	        args: 'icon',
	
	        props: ['icon'],
	
	        data: {exclude: ['id', 'style', 'class', 'src', 'icon', 'ratio']},
	
	        isIcon: true,
	
	        connected: function() {
	            addClass(this.$el, 'uk-icon');
	        },
	
	        methods: {
	
	            getSvg: function() {
	
	                var icon = getIcon(applyRtl(this.icon));
	
	                if (!icon) {
	                    return Promise.reject('Icon not found.');
	                }
	
	                return Promise.resolve(icon);
	            }
	
	        }
	
	    };
	
	    var IconComponent = {
	
	        extends: Icon,
	
	        data: function (vm) { return ({
	            icon: hyphenate(vm.constructor.options.name)
	        }); }
	
	    };
	
	    var Slidenav = {
	
	        extends: IconComponent,
	
	        connected: function() {
	            addClass(this.$el, 'uk-slidenav');
	        },
	
	        computed: {
	
	            icon: function(ref, $el) {
	                var icon = ref.icon;
	
	                return hasClass($el, 'uk-slidenav-large')
	                    ? (icon + "-large")
	                    : icon;
	            }
	
	        }
	
	    };
	
	    var Search = {
	
	        extends: IconComponent,
	
	        computed: {
	
	            icon: function(ref, $el) {
	                var icon = ref.icon;
	
	                return hasClass($el, 'uk-search-icon') && parents($el, '.uk-search-large').length
	                    ? 'search-large'
	                    : parents($el, '.uk-search-navbar').length
	                        ? 'search-navbar'
	                        : icon;
	            }
	
	        }
	
	    };
	
	    var Close = {
	
	        extends: IconComponent,
	
	        computed: {
	
	            icon: function() {
	                return ("close-" + (hasClass(this.$el, 'uk-close-large') ? 'large' : 'icon'));
	            }
	
	        }
	
	    };
	
	    var Spinner = {
	
	        extends: IconComponent,
	
	        connected: function() {
	            var this$1 = this;
	
	            this.svg.then(function (svg) { return this$1.ratio !== 1 && css($('circle', svg), 'strokeWidth', 1 / this$1.ratio); }, noop);
	        }
	
	    };
	
	    function install(UIkit) {
	        UIkit.icon.add = function (name, svg) {
	            var obj;
	
	
	            var added = isString(name) ? (( obj = {}, obj[name] = svg, obj )) : name;
	            each(added, function (svg, name) {
	                icons[name] = svg;
	                delete parsed[name];
	            });
	
	            if (UIkit._initialized) {
	                apply(document.body, function (el) { return each(UIkit.getComponents(el), function (cmp) {
	                        cmp.$options.isIcon && cmp.icon in added && cmp.$reset();
	                    }); }
	                );
	            }
	        };
	    }
	
	    function getIcon(icon) {
	
	        if (!icons[icon]) {
	            return null;
	        }
	
	        if (!parsed[icon]) {
	            parsed[icon] = $(icons[icon].trim());
	        }
	
	        return parsed[icon];
	    }
	
	    function applyRtl(icon) {
	        return isRtl ? swap(swap(icon, 'left', 'right'), 'previous', 'next') : icon;
	    }
	
	    var Img = {
	
	        props: {
	            dataSrc: String,
	            dataSrcset: Boolean,
	            sizes: String,
	            width: Number,
	            height: Number,
	            offsetTop: String,
	            offsetLeft: String,
	            target: String
	        },
	
	        data: {
	            dataSrc: '',
	            dataSrcset: false,
	            sizes: false,
	            width: false,
	            height: false,
	            offsetTop: '50vh',
	            offsetLeft: 0,
	            target: false
	        },
	
	        computed: {
	
	            cacheKey: function(ref) {
	                var dataSrc = ref.dataSrc;
	
	                return ((this.$name) + "." + dataSrc);
	            },
	
	            width: function(ref) {
	                var width$$1 = ref.width;
	                var dataWidth = ref.dataWidth;
	
	                return width$$1 || dataWidth;
	            },
	
	            height: function(ref) {
	                var height$$1 = ref.height;
	                var dataHeight = ref.dataHeight;
	
	                return height$$1 || dataHeight;
	            },
	
	            sizes: function(ref) {
	                var sizes = ref.sizes;
	                var dataSizes = ref.dataSizes;
	
	                return sizes || dataSizes;
	            },
	
	            isImg: function(_, $el) {
	                return isImg($el);
	            },
	
	            target: {
	
	                get: function(ref) {
	                    var target = ref.target;
	
	                    return [this.$el].concat(queryAll(target, this.$el));
	                },
	
	                watch: function() {
	                    this.observe();
	                }
	
	            },
	
	            offsetTop: function(ref) {
	                var offsetTop = ref.offsetTop;
	
	                return toPx(offsetTop, 'height');
	            },
	
	            offsetLeft: function(ref) {
	                var offsetLeft = ref.offsetLeft;
	
	                return toPx(offsetLeft, 'width');
	            }
	
	        },
	
	        connected: function() {
	
	            if (storage[this.cacheKey]) {
	                setSrcAttrs(this.$el, storage[this.cacheKey] || this.dataSrc, this.dataSrcset, this.sizes);
	            } else if (this.isImg && this.width && this.height) {
	                setSrcAttrs(this.$el, getPlaceholderImage(this.width, this.height, this.sizes));
	            }
	
	            this.observer = new IntersectionObserver(this.load, {
	                rootMargin: ((this.offsetTop) + "px " + (this.offsetLeft) + "px"),
	            });
	
	            requestAnimationFrame(this.observe);
	
	        },
	
	        disconnected: function() {
	            this.observer.disconnect();
	        },
	
	        update: {
	
	            read: function(ref) {
	                var this$1 = this;
	                var image = ref.image;
	
	
	                if (!image && document.readyState === 'complete') {
	                    this.load(this.observer.takeRecords());
	                }
	
	                if (this.isImg) {
	                    return false;
	                }
	
	                image && image.then(function (img) { return img && img.currentSrc !== '' && setSrcAttrs(this$1.$el, currentSrc(img)); });
	
	            },
	
	            write: function(data$$1) {
	
	                if (this.dataSrcset && window.devicePixelRatio !== 1) {
	
	                    var bgSize = css(this.$el, 'backgroundSize');
	                    if (bgSize.match(/^(auto\s?)+$/) || toFloat(bgSize) === data$$1.bgSize) {
	                        data$$1.bgSize = getSourceSize(this.dataSrcset, this.sizes);
	                        css(this.$el, 'backgroundSize', ((data$$1.bgSize) + "px"));
	                    }
	
	                }
	
	            },
	
	            events: ['resize']
	
	        },
	
	        methods: {
	
	            load: function(entries) {
	                var this$1 = this;
	
	
	                if (!entries.some(function (entry) { return entry.isIntersecting; })) {
	                    return;
	                }
	
	                this._data.image = getImage(this.dataSrc, this.dataSrcset, this.sizes).then(function (img) {
	
	                    setSrcAttrs(this$1.$el, currentSrc(img), img.srcset, img.sizes);
	                    storage[this$1.cacheKey] = currentSrc(img);
	                    return img;
	
	                }, noop);
	
	                this.observer.disconnect();
	            },
	
	            observe: function() {
	                var this$1 = this;
	
	                if (!this._data.image && this._connected) {
	                    this.target.forEach(function (el) { return this$1.observer.observe(el); });
	                }
	            }
	
	        }
	
	    };
	
	    function setSrcAttrs(el, src, srcset, sizes) {
	
	        if (isImg(el)) {
	            sizes && (el.sizes = sizes);
	            srcset && (el.srcset = srcset);
	            src && (el.src = src);
	        } else if (src) {
	
	            var change = !includes(el.style.backgroundImage, src);
	            if (change) {
	                css(el, 'backgroundImage', ("url(" + (escape(src)) + ")"));
	                trigger(el, createEvent('load', false));
	            }
	
	        }
	
	    }
	
	    function getPlaceholderImage(width$$1, height$$1, sizes) {
	        var assign$$1;
	
	
	        if (sizes) {
	            ((assign$$1 = Dimensions.ratio({width: width$$1, height: height$$1}, 'width', toPx(sizesToPixel(sizes))), width$$1 = assign$$1.width, height$$1 = assign$$1.height));
	        }
	
	        return ("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"" + width$$1 + "\" height=\"" + height$$1 + "\"></svg>");
	    }
	
	    var sizesRe = /\s*(.*?)\s*(\w+|calc\(.*?\))\s*(?:,|$)/g;
	    function sizesToPixel(sizes) {
	        var matches$$1;
	
	        sizesRe.lastIndex = 0;
	
	        while ((matches$$1 = sizesRe.exec(sizes))) {
	            if (!matches$$1[1] || window.matchMedia(matches$$1[1]).matches) {
	                matches$$1 = evaluateSize(matches$$1[2]);
	                break;
	            }
	        }
	
	        return matches$$1 || '100vw';
	    }
	
	    var sizeRe = /\d+(?:\w+|%)/g;
	    var additionRe = /[+-]?(\d+)/g;
	    function evaluateSize(size) {
	        return startsWith(size, 'calc')
	            ? size
	                .substring(5, size.length - 1)
	                .replace(sizeRe, function (size) { return toPx(size); })
	                .replace(/ /g, '')
	                .match(additionRe)
	                .reduce(function (a, b) { return a + +b; }, 0)
	            : size;
	    }
	
	    function toPx(value, property, element) {
	        if ( property === void 0 ) property = 'width';
	        if ( element === void 0 ) element = window;
	
	        return isNumeric(value)
	            ? +value
	            : endsWith(value, 'vw')
	                ? percent(element, 'width', value)
	                : endsWith(value, 'vh')
	                    ? percent(element, 'height', value)
	                    : endsWith(value, '%')
	                        ? percent(element, property, value)
	                        : toFloat(value);
	    }
	
	    var srcSetRe = /\s+\d+w\s*(?:,|$)/g;
	    function getSourceSize(srcset, sizes) {
	        var srcSize = toPx(sizesToPixel(sizes));
	        var descriptors = (srcset.match(srcSetRe) || []).map(toFloat).sort(function (a, b) { return a - b; });
	
	        return descriptors.filter(function (size) { return size >= srcSize; })[0] || descriptors.pop() || '';
	    }
	
	    var dimensions = {height: height, width: width};
	    function percent(element, property, value) {
	        return dimensions[property](element) * toFloat(value) / 100;
	    }
	
	    function isImg(el) {
	        return el.tagName === 'IMG';
	    }
	
	    function currentSrc(el) {
	        return el.currentSrc || el.src;
	    }
	
	    var key = '__test__';
	    var storage;
	
	    // workaround for Safari's private browsing mode and accessing sessionStorage in Blink
	    try {
	        storage = window.sessionStorage || {};
	        storage[key] = 1;
	        delete storage[key];
	    } catch (e) {
	        storage = {};
	    }
	
	    var Media = {
	
	        props: {
	            media: Boolean
	        },
	
	        data: {
	            media: false
	        },
	
	        computed: {
	
	            matchMedia: function() {
	                var media = toMedia(this.media);
	                return !media || window.matchMedia(media).matches;
	            }
	
	        }
	
	    };
	
	    function toMedia(value) {
	
	        if (isString(value)) {
	            if (value[0] === '@') {
	                var name = "breakpoint-" + (value.substr(1));
	                value = toFloat(getCssVar(name));
	            } else if (isNaN(value)) {
	                return value;
	            }
	        }
	
	        return value && !isNaN(value) ? ("(min-width: " + value + "px)") : false;
	    }
	
	    var Leader = {
	
	        mixins: [Class, Media],
	
	        props: {
	            fill: String
	        },
	
	        data: {
	            fill: '',
	            clsWrapper: 'uk-leader-fill',
	            clsHide: 'uk-leader-hide',
	            attrFill: 'data-fill'
	        },
	
	        computed: {
	
	            fill: function(ref) {
	                var fill = ref.fill;
	
	                return fill || getCssVar('leader-fill-content');
	            }
	
	        },
	
	        connected: function() {
	            var assign$$1;
	
	            (assign$$1 = wrapInner(this.$el, ("<span class=\"" + (this.clsWrapper) + "\">")), this.wrapper = assign$$1[0]);
	        },
	
	        disconnected: function() {
	            unwrap(this.wrapper.childNodes);
	        },
	
	        update: {
	
	            read: function(ref) {
	                var changed = ref.changed;
	                var width$$1 = ref.width;
	
	
	                var prev = width$$1;
	
	                width$$1 = Math.floor(this.$el.offsetWidth / 2);
	
	                return {
	                    width: width$$1,
	                    changed: changed || prev !== width$$1,
	                    hide: !this.matchMedia
	                };
	            },
	
	            write: function(data$$1) {
	
	                toggleClass(this.wrapper, this.clsHide, data$$1.hide);
	
	                if (data$$1.changed) {
	                    data$$1.changed = false;
	                    attr(this.wrapper, this.attrFill, new Array(data$$1.width).join(this.fill));
	                }
	
	            },
	
	            events: ['resize']
	
	        }
	
	    };
	
	    var Container = {
	
	        props: {
	            container: Boolean
	        },
	
	        data: {
	            container: true
	        },
	
	        computed: {
	
	            container: function(ref) {
	                var container = ref.container;
	
	                return container === true && this.$container || container && $(container);
	            }
	
	        }
	
	    };
	
	    var active$1;
	
	    var Modal = {
	
	        mixins: [Class, Container, Togglable],
	
	        props: {
	            selPanel: String,
	            selClose: String,
	            escClose: Boolean,
	            bgClose: Boolean,
	            stack: Boolean
	        },
	
	        data: {
	            cls: 'uk-open',
	            escClose: true,
	            bgClose: true,
	            overlay: true,
	            stack: false
	        },
	
	        computed: {
	
	            panel: function(ref, $el) {
	                var selPanel = ref.selPanel;
	
	                return $(selPanel, $el);
	            },
	
	            transitionElement: function() {
	                return this.panel;
	            },
	
	            bgClose: function(ref) {
	                var bgClose = ref.bgClose;
	
	                return bgClose && this.panel;
	            }
	
	        },
	
	        beforeDisconnect: function() {
	            if (this.isToggled()) {
	                this.toggleNow(this.$el, false);
	            }
	        },
	
	        events: [
	
	            {
	
	                name: 'click',
	
	                delegate: function() {
	                    return this.selClose;
	                },
	
	                handler: function(e) {
	                    e.preventDefault();
	                    this.hide();
	                }
	
	            },
	
	            {
	
	                name: 'toggle',
	
	                self: true,
	
	                handler: function(e) {
	
	                    if (e.defaultPrevented) {
	                        return;
	                    }
	
	                    e.preventDefault();
	                    this.toggle();
	                }
	
	            },
	
	            {
	                name: 'beforeshow',
	
	                self: true,
	
	                handler: function(e) {
	
	                    var prev = active$1 && active$1 !== this && active$1;
	
	                    active$1 = this;
	
	                    if (prev) {
	                        if (this.stack) {
	                            this.prev = prev;
	                        } else {
	
	                            active$1 = prev;
	
	                            if (prev.isToggled()) {
	                                prev.hide().then(this.show);
	                            } else {
	                                once(prev.$el, 'beforeshow hidden', this.show, false, function (ref) {
	                                    var target = ref.target;
	                                    var type = ref.type;
	
	                                    return type === 'hidden' && target === prev.$el;
	                                });
	                            }
	                            e.preventDefault();
	
	                        }
	
	                        return;
	                    }
	
	                    registerEvents();
	
	                }
	
	            },
	
	            {
	
	                name: 'show',
	
	                self: true,
	
	                handler: function() {
	
	                    if (!hasClass(document.documentElement, this.clsPage)) {
	                        this.scrollbarWidth = width(window) - width(document);
	                        css(document.body, 'overflowY', this.scrollbarWidth && this.overlay ? 'scroll' : '');
	                    }
	
	                    addClass(document.documentElement, this.clsPage);
	
	                }
	
	            },
	
	            {
	
	                name: 'hide',
	
	                self: true,
	
	                handler: function() {
	                    if (!active$1 || active$1 === this && !this.prev) {
	                        deregisterEvents();
	                    }
	                }
	
	            },
	
	            {
	
	                name: 'hidden',
	
	                self: true,
	
	                handler: function() {
	
	                    var found;
	                    var ref = this;
	                    var prev = ref.prev;
	
	                    active$1 = active$1 && active$1 !== this && active$1 || prev;
	
	                    if (!active$1) {
	
	                        css(document.body, 'overflowY', '');
	
	                    } else {
	                        while (prev) {
	
	                            if (prev.clsPage === this.clsPage) {
	                                found = true;
	                                break;
	                            }
	
	                            prev = prev.prev;
	
	                        }
	
	                    }
	
	                    if (!found) {
	                        removeClass(document.documentElement, this.clsPage);
	                    }
	
	                }
	
	            }
	
	        ],
	
	        methods: {
	
	            toggle: function() {
	                return this.isToggled() ? this.hide() : this.show();
	            },
	
	            show: function() {
	                var this$1 = this;
	
	
	                if (this.isToggled()) {
	                    return Promise.resolve();
	                }
	
	                if (this.container && this.$el.parentNode !== this.container) {
	                    append(this.container, this.$el);
	                    return new Promise(function (resolve) { return requestAnimationFrame(function () { return this$1.show().then(resolve); }
	                        ); }
	                    );
	                }
	
	                return this.toggleElement(this.$el, true, animate$1(this));
	            },
	
	            hide: function() {
	                return this.isToggled()
	                    ? this.toggleElement(this.$el, false, animate$1(this))
	                    : Promise.resolve();
	            },
	
	            getActive: function() {
	                return active$1;
	            }
	
	        }
	
	    };
	
	    var events;
	
	    function registerEvents() {
	
	        if (events) {
	            return;
	        }
	
	        events = [
	            on(document, pointerUp, function (ref) {
	                var target = ref.target;
	                var defaultPrevented = ref.defaultPrevented;
	
	                if (active$1 && active$1.bgClose && !defaultPrevented && (!active$1.overlay || within(target, active$1.$el)) && !within(target, active$1.panel)) {
	                    active$1.hide();
	                }
	            }),
	            on(document, 'keydown', function (e) {
	                if (e.keyCode === 27 && active$1 && active$1.escClose) {
	                    e.preventDefault();
	                    active$1.hide();
	                }
	            })
	        ];
	    }
	
	    function deregisterEvents() {
	        events && events.forEach(function (unbind) { return unbind(); });
	        events = null;
	    }
	
	    function animate$1(ref) {
	        var transitionElement = ref.transitionElement;
	        var _toggle = ref._toggle;
	
	        return function (el, show) { return new Promise(function (resolve, reject) { return once(el, 'show hide', function () {
	                    el._reject && el._reject();
	                    el._reject = reject;
	
	                    _toggle(el, show);
	
	                    if (toMs(css(transitionElement, 'transitionDuration'))) {
	                        once(transitionElement, 'transitionend', resolve, false, function (e) { return e.target === transitionElement; });
	                    } else {
	                        resolve();
	                    }
	                }); }
	            ); };
	    }
	
	    var Modal$1 = {
	
	        install: install$1,
	
	        mixins: [Modal],
	
	        data: {
	            clsPage: 'uk-modal-page',
	            selPanel: '.uk-modal-dialog',
	            selClose: '.uk-modal-close, .uk-modal-close-default, .uk-modal-close-outside, .uk-modal-close-full'
	        },
	
	        events: [
	
	            {
	                name: 'show',
	
	                self: true,
	
	                handler: function() {
	
	                    if (hasClass(this.panel, 'uk-margin-auto-vertical')) {
	                        addClass(this.$el, 'uk-flex');
	                    } else {
	                        css(this.$el, 'display', 'block');
	                    }
	
	                    height(this.$el); // force reflow
	                }
	            },
	
	            {
	                name: 'hidden',
	
	                self: true,
	
	                handler: function() {
	
	                    css(this.$el, 'display', '');
	                    removeClass(this.$el, 'uk-flex');
	
	                }
	            }
	
	        ]
	
	    };
	
	    function install$1 (UIkit) {
	
	        UIkit.modal.dialog = function (content, options) {
	
	            var dialog = UIkit.modal((" <div class=\"uk-modal\"> <div class=\"uk-modal-dialog\">" + content + "</div> </div> "), options);
	
	            dialog.show();
	
	            on(dialog.$el, 'hidden', function (ref) {
	                var target = ref.target;
	                var currentTarget = ref.currentTarget;
	
	                if (target === currentTarget) {
	                    Promise.resolve(function () { return dialog.$destroy(true); });
	                }
	            });
	
	            return dialog;
	        };
	
	        UIkit.modal.alert = function (message, options) {
	
	            options = assign({bgClose: false, escClose: false, labels: UIkit.modal.labels}, options);
	
	            return new Promise(
	                function (resolve) { return on(UIkit.modal.dialog((" <div class=\"uk-modal-body\">" + (isString(message) ? message : html(message)) + "</div> <div class=\"uk-modal-footer uk-text-right\"> <button class=\"uk-button uk-button-primary uk-modal-close\" autofocus>" + (options.labels.ok) + "</button> </div> "), options).$el, 'hide', resolve); }
	            );
	        };
	
	        UIkit.modal.confirm = function (message, options) {
	
	            options = assign({bgClose: false, escClose: true, labels: UIkit.modal.labels}, options);
	
	            return new Promise(function (resolve, reject) {
	
	                var confirm = UIkit.modal.dialog((" <form> <div class=\"uk-modal-body\">" + (isString(message) ? message : html(message)) + "</div> <div class=\"uk-modal-footer uk-text-right\"> <button class=\"uk-button uk-button-default uk-modal-close\" type=\"button\">" + (options.labels.cancel) + "</button> <button class=\"uk-button uk-button-primary\" autofocus>" + (options.labels.ok) + "</button> </div> </form> "), options);
	
	                var resolved = false;
	
	                on(confirm.$el, 'submit', 'form', function (e) {
	                    e.preventDefault();
	                    resolve();
	                    resolved = true;
	                    confirm.hide();
	                });
	                on(confirm.$el, 'hide', function () {
	                    if (!resolved) {
	                        reject();
	                    }
	                });
	
	            });
	        };
	
	        UIkit.modal.prompt = function (message, value, options) {
	
	            options = assign({bgClose: false, escClose: true, labels: UIkit.modal.labels}, options);
	
	            return new Promise(function (resolve) {
	
	                var prompt = UIkit.modal.dialog((" <form class=\"uk-form-stacked\"> <div class=\"uk-modal-body\"> <label>" + (isString(message) ? message : html(message)) + "</label> <input class=\"uk-input\" autofocus> </div> <div class=\"uk-modal-footer uk-text-right\"> <button class=\"uk-button uk-button-default uk-modal-close\" type=\"button\">" + (options.labels.cancel) + "</button> <button class=\"uk-button uk-button-primary\">" + (options.labels.ok) + "</button> </div> </form> "), options),
	                    input = $('input', prompt.$el);
	
	                input.value = value;
	
	                var resolved = false;
	
	                on(prompt.$el, 'submit', 'form', function (e) {
	                    e.preventDefault();
	                    resolve(input.value);
	                    resolved = true;
	                    prompt.hide();
	                });
	                on(prompt.$el, 'hide', function () {
	                    if (!resolved) {
	                        resolve(null);
	                    }
	                });
	
	            });
	        };
	
	        UIkit.modal.labels = {
	            ok: 'Ok',
	            cancel: 'Cancel'
	        };
	
	    }
	
	    var Nav = {
	
	        extends: Accordion,
	
	        data: {
	            targets: '> .uk-parent',
	            toggle: '> a',
	            content: '> ul'
	        }
	
	    };
	
	    var Navbar = {
	
	        mixins: [Class, FlexBug],
	
	        props: {
	            dropdown: String,
	            mode: 'list',
	            align: String,
	            offset: Number,
	            boundary: Boolean,
	            boundaryAlign: Boolean,
	            clsDrop: String,
	            delayShow: Number,
	            delayHide: Number,
	            dropbar: Boolean,
	            dropbarMode: String,
	            dropbarAnchor: Boolean,
	            duration: Number
	        },
	
	        data: {
	            dropdown: '.uk-navbar-nav > li',
	            align: !isRtl ? 'left' : 'right',
	            clsDrop: 'uk-navbar-dropdown',
	            mode: undefined,
	            offset: undefined,
	            delayShow: undefined,
	            delayHide: undefined,
	            boundaryAlign: undefined,
	            flip: 'x',
	            boundary: true,
	            dropbar: false,
	            dropbarMode: 'slide',
	            dropbarAnchor: false,
	            duration: 200,
	            forceHeight: true,
	            selMinHeight: '.uk-navbar-nav > li > a, .uk-navbar-item, .uk-navbar-toggle'
	        },
	
	        computed: {
	
	            boundary: function(ref, $el) {
	                var boundary = ref.boundary;
	                var boundaryAlign = ref.boundaryAlign;
	
	                return (boundary === true || boundaryAlign) ? $el : boundary;
	            },
	
	            dropbarAnchor: function(ref, $el) {
	                var dropbarAnchor = ref.dropbarAnchor;
	
	                return query(dropbarAnchor, $el);
	            },
	
	            pos: function(ref) {
	                var align = ref.align;
	
	                return ("bottom-" + align);
	            },
	
	            dropdowns: function(ref, $el) {
	                var dropdown = ref.dropdown;
	                var clsDrop = ref.clsDrop;
	
	                return $$((dropdown + " ." + clsDrop), $el);
	            }
	
	        },
	
	        beforeConnect: function() {
	
	            var ref = this.$props;
	            var dropbar = ref.dropbar;
	
	            this.dropbar = dropbar && (query(dropbar, this.$el) || $('+ .uk-navbar-dropbar', this.$el) || $('<div></div>'));
	
	            if (this.dropbar) {
	
	                addClass(this.dropbar, 'uk-navbar-dropbar');
	
	                if (this.dropbarMode === 'slide') {
	                    addClass(this.dropbar, 'uk-navbar-dropbar-slide');
	                }
	            }
	
	        },
	
	        disconnected: function() {
	            this.dropbar && remove(this.dropbar);
	        },
	
	        update: function() {
	            var this$1 = this;
	
	
	            this.$create(
	                'drop',
	                this.dropdowns.filter(function (el) { return !this$1.getDropdown(el); }),
	                assign({}, this.$props, {boundary: this.boundary, pos: this.pos, offset: this.dropbar || this.offset})
	            );
	
	        },
	
	        events: [
	
	            {
	                name: 'mouseover',
	
	                delegate: function() {
	                    return this.dropdown;
	                },
	
	                handler: function(ref) {
	                    var current = ref.current;
	
	                    var active = this.getActive();
	                    if (active && active.toggle && !within(active.toggle.$el, current) && !active.tracker.movesTo(active.$el)) {
	                        active.hide(false);
	                    }
	                }
	
	            },
	
	            {
	                name: 'mouseleave',
	
	                el: function() {
	                    return this.dropbar;
	                },
	
	                handler: function() {
	                    var active = this.getActive();
	
	                    if (active && !matches(this.dropbar, ':hover')) {
	                        active.hide();
	                    }
	                }
	            },
	
	            {
	                name: 'beforeshow',
	
	                capture: true,
	
	                filter: function() {
	                    return this.dropbar;
	                },
	
	                handler: function() {
	
	                    if (!this.dropbar.parentNode) {
	                        after(this.dropbarAnchor || this.$el, this.dropbar);
	                    }
	
	                }
	            },
	
	            {
	                name: 'show',
	
	                capture: true,
	
	                filter: function() {
	                    return this.dropbar;
	                },
	
	                handler: function(_, drop) {
	
	                    var $el = drop.$el;
	                    var dir = drop.dir;
	
	                    this.clsDrop && addClass($el, ((this.clsDrop) + "-dropbar"));
	
	                    if (dir === 'bottom') {
	                        this.transitionTo($el.offsetHeight + toFloat(css($el, 'marginTop')) + toFloat(css($el, 'marginBottom')), $el);
	                    }
	                }
	            },
	
	            {
	                name: 'beforehide',
	
	                filter: function() {
	                    return this.dropbar;
	                },
	
	                handler: function(e, ref) {
	                    var $el = ref.$el;
	
	
	                    var active = this.getActive();
	
	                    if (matches(this.dropbar, ':hover') && active && active.$el === $el) {
	                        e.preventDefault();
	                    }
	                }
	            },
	
	            {
	                name: 'hide',
	
	                filter: function() {
	                    return this.dropbar;
	                },
	
	                handler: function(_, ref) {
	                    var $el = ref.$el;
	
	
	                    var active = this.getActive();
	
	                    if (!active || active && active.$el === $el) {
	                        this.transitionTo(0);
	                    }
	                }
	            }
	
	        ],
	
	        methods: {
	
	            getActive: function() {
	                var ref = this.dropdowns.map(this.getDropdown).filter(function (drop) { return drop && drop.isActive(); });
	                var active = ref[0];
	                return active && includes(active.mode, 'hover') && within(active.toggle.$el, this.$el) && active;
	            },
	
	            transitionTo: function(newHeight, el) {
	                var this$1 = this;
	
	
	                var ref = this;
	                var dropbar = ref.dropbar;
	                var oldHeight = isVisible(dropbar) ? height(dropbar) : 0;
	
	                el = oldHeight < newHeight && el;
	
	                css(el, 'clip', ("rect(0," + (el.offsetWidth) + "px," + oldHeight + "px,0)"));
	
	                height(dropbar, oldHeight);
	
	                Transition.cancel([el, dropbar]);
	                return Promise.all([
	                    Transition.start(dropbar, {height: newHeight}, this.duration),
	                    Transition.start(el, {clip: ("rect(0," + (el.offsetWidth) + "px," + newHeight + "px,0)")}, this.duration)
	                ])
	                    .catch(noop)
	                    .then(function () {
	                        css(el, {clip: ''});
	                        this$1.$update(dropbar);
	                    });
	            },
	
	            getDropdown: function(el) {
	                return this.$getComponent(el, 'drop') || this.$getComponent(el, 'dropdown');
	            }
	
	        }
	
	    };
	
	    var Offcanvas = {
	
	        mixins: [Modal],
	
	        args: 'mode',
	
	        props: {
	            mode: String,
	            flip: Boolean,
	            overlay: Boolean
	        },
	
	        data: {
	            mode: 'slide',
	            flip: false,
	            overlay: false,
	            clsPage: 'uk-offcanvas-page',
	            clsContainer: 'uk-offcanvas-container',
	            selPanel: '.uk-offcanvas-bar',
	            clsFlip: 'uk-offcanvas-flip',
	            clsContainerAnimation: 'uk-offcanvas-container-animation',
	            clsSidebarAnimation: 'uk-offcanvas-bar-animation',
	            clsMode: 'uk-offcanvas',
	            clsOverlay: 'uk-offcanvas-overlay',
	            selClose: '.uk-offcanvas-close'
	        },
	
	        computed: {
	
	            clsFlip: function(ref) {
	                var flip = ref.flip;
	                var clsFlip = ref.clsFlip;
	
	                return flip ? clsFlip : '';
	            },
	
	            clsOverlay: function(ref) {
	                var overlay = ref.overlay;
	                var clsOverlay = ref.clsOverlay;
	
	                return overlay ? clsOverlay : '';
	            },
	
	            clsMode: function(ref) {
	                var mode = ref.mode;
	                var clsMode = ref.clsMode;
	
	                return (clsMode + "-" + mode);
	            },
	
	            clsSidebarAnimation: function(ref) {
	                var mode = ref.mode;
	                var clsSidebarAnimation = ref.clsSidebarAnimation;
	
	                return mode === 'none' || mode === 'reveal' ? '' : clsSidebarAnimation;
	            },
	
	            clsContainerAnimation: function(ref) {
	                var mode = ref.mode;
	                var clsContainerAnimation = ref.clsContainerAnimation;
	
	                return mode !== 'push' && mode !== 'reveal' ? '' : clsContainerAnimation;
	            },
	
	            transitionElement: function(ref) {
	                var mode = ref.mode;
	
	                return mode === 'reveal' ? this.panel.parentNode : this.panel;
	            }
	
	        },
	
	        events: [
	
	            {
	
	                name: 'click',
	
	                delegate: function() {
	                    return 'a[href^="#"]';
	                },
	
	                handler: function(ref) {
	                    var current = ref.current;
	
	                    if (current.hash && $(current.hash, document.body)) {
	                        this.hide();
	                    }
	                }
	
	            },
	
	            {
	                name: 'touchstart',
	
	                el: function() {
	                    return this.panel;
	                },
	
	                handler: function(ref) {
	                    var targetTouches = ref.targetTouches;
	
	
	                    if (targetTouches.length === 1) {
	                        this.clientY = targetTouches[0].clientY;
	                    }
	
	                }
	
	            },
	
	            {
	                name: 'touchmove',
	
	                self: true,
	                passive: false,
	
	                filter: function() {
	                    return this.overlay;
	                },
	
	                handler: function(e) {
	                    e.preventDefault();
	                }
	
	            },
	
	            {
	                name: 'touchmove',
	
	                passive: false,
	
	                el: function() {
	                    return this.panel;
	                },
	
	                handler: function(e) {
	
	                    if (e.targetTouches.length !== 1) {
	                        return;
	                    }
	
	                    var clientY = event.targetTouches[0].clientY - this.clientY;
	                    var ref = this.panel;
	                    var scrollTop$$1 = ref.scrollTop;
	                    var scrollHeight = ref.scrollHeight;
	                    var clientHeight = ref.clientHeight;
	
	                    if (clientHeight >= scrollHeight
	                        || scrollTop$$1 === 0 && clientY > 0
	                        || scrollHeight - scrollTop$$1 <= clientHeight && clientY < 0
	                    ) {
	                        e.preventDefault();
	                    }
	
	                }
	
	            },
	
	            {
	                name: 'show',
	
	                self: true,
	
	                handler: function() {
	
	                    if (this.mode === 'reveal' && !hasClass(this.panel.parentNode, this.clsMode)) {
	                        wrapAll(this.panel, '<div>');
	                        addClass(this.panel.parentNode, this.clsMode);
	                    }
	
	                    css(document.documentElement, 'overflowY', this.overlay ? 'hidden' : '');
	                    addClass(document.body, this.clsContainer, this.clsFlip);
	                    css(this.$el, 'display', 'block');
	                    addClass(this.$el, this.clsOverlay);
	                    addClass(this.panel, this.clsSidebarAnimation, this.mode !== 'reveal' ? this.clsMode : '');
	
	                    height(document.body); // force reflow
	                    addClass(document.body, this.clsContainerAnimation);
	
	                    this.clsContainerAnimation && suppressUserScale();
	
	                }
	            },
	
	            {
	                name: 'hide',
	
	                self: true,
	
	                handler: function() {
	                    removeClass(document.body, this.clsContainerAnimation);
	
	                    var active = this.getActive();
	                    if (this.mode === 'none' || active && active !== this && active !== this.prev) {
	                        trigger(this.panel, 'transitionend');
	                    }
	                }
	            },
	
	            {
	                name: 'hidden',
	
	                self: true,
	
	                handler: function() {
	
	                    this.clsContainerAnimation && resumeUserScale();
	
	                    if (this.mode === 'reveal') {
	                        unwrap(this.panel);
	                    }
	
	                    removeClass(this.panel, this.clsSidebarAnimation, this.clsMode);
	                    removeClass(this.$el, this.clsOverlay);
	                    css(this.$el, 'display', '');
	                    removeClass(document.body, this.clsContainer, this.clsFlip);
	
	                    css(document.documentElement, 'overflowY', '');
	
	                }
	            },
	
	            {
	                name: 'swipeLeft swipeRight',
	
	                handler: function(e) {
	
	                    if (this.isToggled() && isTouch(e) && e.type === 'swipeLeft' ^ this.flip) {
	                        this.hide();
	                    }
	
	                }
	            }
	
	        ]
	
	    };
	
	    // Chrome in responsive mode zooms page upon opening offcanvas
	    function suppressUserScale() {
	        getViewport().content += ',user-scalable=0';
	    }
	
	    function resumeUserScale() {
	        var viewport = getViewport();
	        viewport.content = viewport.content.replace(/,user-scalable=0$/, '');
	    }
	
	    function getViewport() {
	        return $('meta[name="viewport"]', document.head) || append(document.head, '<meta name="viewport">');
	    }
	
	    var OverflowAuto = {
	
	        mixins: [Class],
	
	        props: {
	            selContainer: String,
	            selContent: String,
	        },
	
	        data: {
	            selContainer: '.uk-modal',
	            selContent: '.uk-modal-dialog',
	        },
	
	        computed: {
	
	            container: function(ref, $el) {
	                var selContainer = ref.selContainer;
	
	                return closest($el, selContainer);
	            },
	
	            content: function(ref, $el) {
	                var selContent = ref.selContent;
	
	                return closest($el, selContent);
	            }
	
	        },
	
	        connected: function() {
	            css(this.$el, 'minHeight', 150);
	        },
	
	        update: {
	
	            read: function() {
	
	                if (!this.content || !this.container) {
	                    return false;
	                }
	
	                return {
	                    current: toFloat(css(this.$el, 'maxHeight')),
	                    max: Math.max(150, height(this.container) - (offset(this.content).height - height(this.$el)))
	                };
	            },
	
	            write: function(ref) {
	                var current = ref.current;
	                var max = ref.max;
	
	                css(this.$el, 'maxHeight', max);
	                if (Math.round(current) !== Math.round(max)) {
	                    trigger(this.$el, 'resize');
	                }
	            },
	
	            events: ['resize']
	
	        }
	
	    };
	
	    var Responsive = {
	
	        props: ['width', 'height'],
	
	        connected: function() {
	            addClass(this.$el, 'uk-responsive-width');
	        },
	
	        update: {
	
	            read: function() {
	                return isVisible(this.$el) && this.width && this.height
	                    ? {width: width(this.$el.parentNode), height: this.height}
	                    : false;
	            },
	
	            write: function(dim) {
	                height(this.$el, Dimensions.contain({
	                    height: this.height,
	                    width: this.width
	                }, dim).height);
	            },
	
	            events: ['resize']
	
	        }
	
	    };
	
	    var Scroll = {
	
	        props: {
	            duration: Number,
	            offset: Number
	        },
	
	        data: {
	            duration: 1000,
	            offset: 0
	        },
	
	        methods: {
	
	            scrollTo: function(el) {
	                var this$1 = this;
	
	
	                el = el && $(el) || document.body;
	
	                var docHeight = height(document);
	                var winHeight = height(window);
	
	                var target = offset(el).top - this.offset;
	                if (target + winHeight > docHeight) {
	                    target = docHeight - winHeight;
	                }
	
	                if (!trigger(this.$el, 'beforescroll', [this, el])) {
	                    return;
	                }
	
	                var start = Date.now();
	                var startY = window.pageYOffset;
	                var step = function () {
	
	                    var currentY = startY + (target - startY) * ease(clamp((Date.now() - start) / this$1.duration));
	
	                    scrollTop(window, currentY);
	
	                    // scroll more if we have not reached our destination
	                    if (currentY !== target) {
	                        requestAnimationFrame(step);
	                    } else {
	                        trigger(this$1.$el, 'scrolled', [this$1, el]);
	                    }
	
	                };
	
	                step();
	
	            }
	
	        },
	
	        events: {
	
	            click: function(e) {
	
	                if (e.defaultPrevented) {
	                    return;
	                }
	
	                e.preventDefault();
	                this.scrollTo(escape(decodeURIComponent(this.$el.hash)).substr(1));
	            }
	
	        }
	
	    };
	
	    function ease(k) {
	        return 0.5 * (1 - Math.cos(Math.PI * k));
	    }
	
	    var Scrollspy = {
	
	        args: 'cls',
	
	        props: {
	            cls: 'list',
	            target: String,
	            hidden: Boolean,
	            offsetTop: Number,
	            offsetLeft: Number,
	            repeat: Boolean,
	            delay: Number
	        },
	
	        data: function () { return ({
	            cls: [],
	            target: false,
	            hidden: true,
	            offsetTop: 0,
	            offsetLeft: 0,
	            repeat: false,
	            delay: 0,
	            inViewClass: 'uk-scrollspy-inview'
	        }); },
	
	        computed: {
	
	            elements: function(ref, $el) {
	                var target = ref.target;
	
	                return target ? $$(target, $el) : [$el];
	            }
	
	        },
	
	        update: [
	
	            {
	
	                write: function() {
	                    if (this.hidden) {
	                        css(filter(this.elements, (":not(." + (this.inViewClass) + ")")), 'visibility', 'hidden');
	                    }
	                }
	
	            },
	
	            {
	
	                read: function(els) {
	                    var this$1 = this;
	
	
	                    if (!els.update) {
	                        return;
	                    }
	
	                    this.elements.forEach(function (el, i) {
	
	                        var elData = els[i];
	
	                        if (!elData || elData.el !== el) {
	                            var cls = data(el, 'uk-scrollspy-class');
	                            elData = {el: el, toggles: cls && cls.split(',') || this$1.cls};
	                        }
	
	                        elData.show = isInView(el, this$1.offsetTop, this$1.offsetLeft);
	                        els[i] = elData;
	
	                    });
	
	                },
	
	                write: function(els) {
	                    var this$1 = this;
	
	
	                    // Let child components be applied at least once first
	                    if (!els.update) {
	                        this.$emit();
	                        return els.update = true;
	                    }
	
	                    this.elements.forEach(function (el, i) {
	
	                        var elData = els[i];
	                        var cls = elData.toggles[i] || elData.toggles[0];
	
	                        if (elData.show && !elData.inview && !elData.queued) {
	
	                            var show = function () {
	
	                                css(el, 'visibility', '');
	                                addClass(el, this$1.inViewClass);
	                                toggleClass(el, cls);
	
	                                trigger(el, 'inview');
	
	                                this$1.$update(el);
	
	                                elData.inview = true;
	                                elData.abort && elData.abort();
	                            };
	
	                            if (this$1.delay) {
	
	                                elData.queued = true;
	                                els.promise = (els.promise || Promise.resolve()).then(function () {
	                                    return !elData.inview && new Promise(function (resolve) {
	
	                                        var timer = setTimeout(function () {
	
	                                            show();
	                                            resolve();
	
	                                        }, els.promise || this$1.elements.length === 1 ? this$1.delay : 0);
	
	                                        elData.abort = function () {
	                                            clearTimeout(timer);
	                                            resolve();
	                                            elData.queued = false;
	                                        };
	
	                                    });
	
	                                });
	
	                            } else {
	                                show();
	                            }
	
	                        } else if (!elData.show && (elData.inview || elData.queued) && this$1.repeat) {
	
	                            elData.abort && elData.abort();
	
	                            if (!elData.inview) {
	                                return;
	                            }
	
	                            css(el, 'visibility', this$1.hidden ? 'hidden' : '');
	                            removeClass(el, this$1.inViewClass);
	                            toggleClass(el, cls);
	
	                            trigger(el, 'outview');
	
	                            this$1.$update(el);
	
	                            elData.inview = false;
	
	                        }
	
	
	                    });
	
	                },
	
	                events: ['scroll', 'resize']
	
	            }
	
	        ]
	
	    };
	
	    var ScrollspyNav = {
	
	        props: {
	            cls: String,
	            closest: String,
	            scroll: Boolean,
	            overflow: Boolean,
	            offset: Number
	        },
	
	        data: {
	            cls: 'uk-active',
	            closest: false,
	            scroll: false,
	            overflow: true,
	            offset: 0
	        },
	
	        computed: {
	
	            links: function(_, $el) {
	                return $$('a[href^="#"]', $el).filter(function (el) { return el.hash; });
	            },
	
	            elements: function(ref) {
	                var selector = ref.closest;
	
	                return closest(this.links, selector || '*');
	            },
	
	            targets: function() {
	                return $$(this.links.map(function (el) { return el.hash; }).join(','));
	            }
	
	        },
	
	        update: [
	
	            {
	
	                read: function() {
	                    if (this.scroll) {
	                        this.$create('scroll', this.links, {offset: this.offset || 0});
	                    }
	                }
	
	            },
	
	            {
	
	                read: function(data$$1) {
	                    var this$1 = this;
	
	
	                    var scroll = window.pageYOffset + this.offset + 1;
	                    var max = height(document) - height(window) + this.offset;
	
	                    data$$1.active = false;
	
	                    this.targets.every(function (el, i) {
	
	                        var ref = offset(el);
	                        var top = ref.top;
	                        var last = i + 1 === this$1.targets.length;
	
	                        if (!this$1.overflow && (i === 0 && top > scroll || last && top + el.offsetTop < scroll)) {
	                            return false;
	                        }
	
	                        if (!last && offset(this$1.targets[i + 1]).top <= scroll) {
	                            return true;
	                        }
	
	                        if (scroll >= max) {
	                            for (var j = this$1.targets.length - 1; j > i; j--) {
	                                if (isInView(this$1.targets[j])) {
	                                    el = this$1.targets[j];
	                                    break;
	                                }
	                            }
	                        }
	
	                        return !(data$$1.active = $(filter(this$1.links, ("[href=\"#" + (el.id) + "\"]"))));
	
	                    });
	
	                },
	
	                write: function(ref) {
	                    var active = ref.active;
	
	
	                    this.links.forEach(function (el) { return el.blur(); });
	                    removeClass(this.elements, this.cls);
	
	                    if (active) {
	                        trigger(this.$el, 'active', [active, addClass(this.closest ? closest(active, this.closest) : active, this.cls)]);
	                    }
	
	                },
	
	                events: ['scroll', 'resize']
	
	            }
	
	        ]
	
	    };
	
	    var Sticky = {
	
	        mixins: [Class, Media],
	
	        props: {
	            top: null,
	            bottom: Boolean,
	            offset: Number,
	            animation: String,
	            clsActive: String,
	            clsInactive: String,
	            clsFixed: String,
	            clsBelow: String,
	            selTarget: String,
	            widthElement: Boolean,
	            showOnUp: Boolean,
	            targetOffset: Number
	        },
	
	        data: {
	            top: 0,
	            bottom: false,
	            offset: 0,
	            animation: '',
	            clsActive: 'uk-active',
	            clsInactive: '',
	            clsFixed: 'uk-sticky-fixed',
	            clsBelow: 'uk-sticky-below',
	            selTarget: '',
	            widthElement: false,
	            showOnUp: false,
	            targetOffset: false
	        },
	
	        computed: {
	
	            selTarget: function(ref, $el) {
	                var selTarget = ref.selTarget;
	
	                return selTarget && $(selTarget, $el) || $el;
	            },
	
	            widthElement: function(ref, $el) {
	                var widthElement = ref.widthElement;
	
	                return query(widthElement, $el) || this.placeholder;
	            },
	
	            isActive: {
	
	                get: function() {
	                    return hasClass(this.selTarget, this.clsActive);
	                },
	
	                set: function(value) {
	                    if (value && !this.isActive) {
	                        replaceClass(this.selTarget, this.clsInactive, this.clsActive);
	                        trigger(this.$el, 'active');
	                    } else if (!value && !hasClass(this.selTarget, this.clsInactive)) {
	                        replaceClass(this.selTarget, this.clsActive, this.clsInactive);
	                        trigger(this.$el, 'inactive');
	                    }
	                }
	
	            },
	
	        },
	
	        connected: function() {
	            this.placeholder = $('+ .uk-sticky-placeholder', this.$el) || $('<div class="uk-sticky-placeholder"></div>');
	            this.isFixed = false;
	            this.isActive = false;
	        },
	
	        disconnected: function() {
	
	            if (this.isFixed) {
	                this.hide();
	                removeClass(this.selTarget, this.clsInactive);
	            }
	
	            remove(this.placeholder);
	            this.placeholder = null;
	            this.widthElement = null;
	        },
	
	        events: [
	
	            {
	
	                name: 'load hashchange popstate',
	
	                el: window,
	
	                handler: function() {
	                    var this$1 = this;
	
	
	                    if (!(this.targetOffset !== false && location.hash && window.pageYOffset > 0)) {
	                        return;
	                    }
	
	                    var target = $(location.hash);
	
	                    if (target) {
	                        fastdom.read(function () {
	
	                            var ref = offset(target);
	                            var top = ref.top;
	                            var elTop = offset(this$1.$el).top;
	                            var elHeight = this$1.$el.offsetHeight;
	
	                            if (this$1.isFixed && elTop + elHeight >= top && elTop <= top + target.offsetHeight) {
	                                scrollTop(window, top - elHeight - (isNumeric(this$1.targetOffset) ? this$1.targetOffset : 0) - this$1.offset);
	                            }
	
	                        });
	                    }
	
	                }
	
	            }
	
	        ],
	
	        update: [
	
	            {
	
	                read: function(ref, type) {
	                    var height$$1 = ref.height;
	
	
	                    if (this.isActive && type !== 'update') {
	
	                        this.hide();
	                        height$$1 = this.$el.offsetHeight;
	                        this.show();
	
	                    }
	
	                    height$$1 = !this.isActive ? this.$el.offsetHeight : height$$1;
	
	                    this.topOffset = offset(this.isFixed ? this.placeholder : this.$el).top;
	                    this.bottomOffset = this.topOffset + height$$1;
	
	                    var bottom = parseProp('bottom', this);
	
	                    this.top = Math.max(toFloat(parseProp('top', this)), this.topOffset) - this.offset;
	                    this.bottom = bottom && bottom - height$$1;
	                    this.inactive = !this.matchMedia;
	
	                    return {
	                        lastScroll: false,
	                        height: height$$1,
	                        margins: css(this.$el, ['marginTop', 'marginBottom', 'marginLeft', 'marginRight'])
	                    };
	                },
	
	                write: function(ref) {
	                    var height$$1 = ref.height;
	                    var margins = ref.margins;
	
	
	                    var ref$1 = this;
	                    var placeholder = ref$1.placeholder;
	
	                    css(placeholder, assign({height: height$$1}, margins));
	
	                    if (!within(placeholder, document)) {
	                        after(this.$el, placeholder);
	                        attr(placeholder, 'hidden', '');
	                    }
	
	                    // ensure active/inactive classes are applied
	                    this.isActive = this.isActive;
	
	                },
	
	                events: ['resize']
	
	            },
	
	            {
	
	                read: function(ref) {
	                    var scroll = ref.scroll; if ( scroll === void 0 ) scroll = 0;
	
	
	                    this.width = (isVisible(this.widthElement) ? this.widthElement : this.$el).offsetWidth;
	
	                    this.scroll = window.pageYOffset;
	
	                    return {
	                        dir: scroll <= this.scroll ? 'down' : 'up',
	                        scroll: this.scroll,
	                        visible: isVisible(this.$el),
	                        top: offsetPosition(this.placeholder)[0]
	                    };
	                },
	
	                write: function(data$$1, type) {
	                    var this$1 = this;
	
	
	                    var initTimestamp = data$$1.initTimestamp; if ( initTimestamp === void 0 ) initTimestamp = 0;
	                    var dir = data$$1.dir;
	                    var lastDir = data$$1.lastDir;
	                    var lastScroll = data$$1.lastScroll;
	                    var scroll = data$$1.scroll;
	                    var top = data$$1.top;
	                    var visible = data$$1.visible;
	                    var now = performance.now();
	
	                    data$$1.lastScroll = scroll;
	
	                    if (scroll < 0 || scroll === lastScroll || !visible || this.disabled || this.showOnUp && type !== 'scroll') {
	                        return;
	                    }
	
	                    if (now - initTimestamp > 300 || dir !== lastDir) {
	                        data$$1.initScroll = scroll;
	                        data$$1.initTimestamp = now;
	                    }
	
	                    data$$1.lastDir = dir;
	
	                    if (this.showOnUp && Math.abs(data$$1.initScroll - scroll) <= 30 && Math.abs(lastScroll - scroll) <= 10) {
	                        return;
	                    }
	
	                    if (this.inactive
	                        || scroll < this.top
	                        || this.showOnUp && (scroll <= this.top || dir === 'down' || dir === 'up' && !this.isFixed && scroll <= this.bottomOffset)
	                    ) {
	
	                        if (!this.isFixed) {
	
	                            if (Animation.inProgress(this.$el) && top > scroll) {
	                                Animation.cancel(this.$el);
	                                this.hide();
	                            }
	
	                            return;
	                        }
	
	                        this.isFixed = false;
	
	                        if (this.animation && scroll > this.topOffset) {
	                            Animation.cancel(this.$el);
	                            Animation.out(this.$el, this.animation).then(function () { return this$1.hide(); }, noop);
	                        } else {
	                            this.hide();
	                        }
	
	                    } else if (this.isFixed) {
	
	                        this.update();
	
	                    } else if (this.animation) {
	
	                        Animation.cancel(this.$el);
	                        this.show();
	                        Animation.in(this.$el, this.animation).catch(noop);
	
	                    } else {
	                        this.show();
	                    }
	
	                },
	
	                events: ['resize', 'scroll']
	
	            } ],
	
	        methods: {
	
	            show: function() {
	
	                this.isFixed = true;
	                this.update();
	                attr(this.placeholder, 'hidden', null);
	
	            },
	
	            hide: function() {
	
	                this.isActive = false;
	                removeClass(this.$el, this.clsFixed, this.clsBelow);
	                css(this.$el, {position: '', top: '', width: ''});
	                attr(this.placeholder, 'hidden', '');
	
	            },
	
	            update: function() {
	
	                var active = this.top !== 0 || this.scroll > this.top;
	                var top = Math.max(0, this.offset);
	
	                if (this.bottom && this.scroll > this.bottom - this.offset) {
	                    top = this.bottom - this.scroll;
	                }
	
	                css(this.$el, {
	                    position: 'fixed',
	                    top: (top + "px"),
	                    width: this.width
	                });
	
	                this.isActive = active;
	                toggleClass(this.$el, this.clsBelow, this.scroll > this.bottomOffset);
	                addClass(this.$el, this.clsFixed);
	
	            }
	
	        }
	
	    };
	
	    function parseProp(prop, ref) {
	        var $props = ref.$props;
	        var $el = ref.$el;
	        var propOffset = ref[(prop + "Offset")];
	
	
	        var value = $props[prop];
	
	        if (!value) {
	            return;
	        }
	
	        if (isNumeric(value)) {
	
	            return propOffset + toFloat(value);
	
	        } else if (isString(value) && value.match(/^-?\d+vh$/)) {
	
	            return height(window) * toFloat(value) / 100;
	
	        } else {
	
	            var el = value === true ? $el.parentNode : query(value, $el);
	
	            if (el) {
	                return offset(el).top + el.offsetHeight;
	            }
	
	        }
	    }
	
	    var Switcher = {
	
	        mixins: [Togglable],
	
	        args: 'connect',
	
	        props: {
	            connect: String,
	            toggle: String,
	            active: Number,
	            swiping: Boolean
	        },
	
	        data: {
	            connect: '~.uk-switcher',
	            toggle: '> * > :first-child',
	            active: 0,
	            swiping: true,
	            cls: 'uk-active',
	            clsContainer: 'uk-switcher',
	            attrItem: 'uk-switcher-item',
	            queued: true
	        },
	
	        computed: {
	
	            connects: function(ref, $el) {
	                var connect = ref.connect;
	
	                return queryAll(connect, $el);
	            },
	
	            toggles: function(ref, $el) {
	                var toggle = ref.toggle;
	
	                return $$(toggle, $el);
	            }
	
	        },
	
	        events: [
	
	            {
	
	                name: 'click',
	
	                delegate: function() {
	                    return ((this.toggle) + ":not(.uk-disabled)");
	                },
	
	                handler: function(e) {
	                    e.preventDefault();
	                    this.show(toNodes(this.$el.children).filter(function (el) { return within(e.current, el); })[0]);
	                }
	
	            },
	
	            {
	                name: 'click',
	
	                el: function() {
	                    return this.connects;
	                },
	
	                delegate: function() {
	                    return ("[" + (this.attrItem) + "],[data-" + (this.attrItem) + "]");
	                },
	
	                handler: function(e) {
	                    e.preventDefault();
	                    this.show(data(e.current, this.attrItem));
	                }
	            },
	
	            {
	                name: 'swipeRight swipeLeft',
	
	                filter: function() {
	                    return this.swiping;
	                },
	
	                el: function() {
	                    return this.connects;
	                },
	
	                handler: function(e) {
	                    if (!isTouch(e)) {
	                        return;
	                    }
	
	                    e.preventDefault();
	                    if (!window.getSelection().toString()) {
	                        this.show(e.type === 'swipeLeft' ? 'next' : 'previous');
	                    }
	                }
	            }
	
	        ],
	
	        update: function() {
	            var this$1 = this;
	
	
	            this.connects.forEach(function (list) { return this$1.updateAria(list.children); });
	            var ref = this.$el;
	            var children = ref.children;
	            this.show(filter(children, ("." + (this.cls)))[0] || children[this.active] || children[0]);
	
	        },
	
	        methods: {
	
	            index: function() {
	                return !!this.connects.length && index(filter(this.connects[0].children, ("." + (this.cls)))[0]);
	            },
	
	            show: function(item) {
	                var this$1 = this;
	
	
	                var ref = this.$el;
	                var children = ref.children;
	                var length = children.length;
	                var prev = this.index();
	                var hasPrev = prev >= 0;
	                var dir = item === 'previous' ? -1 : 1;
	
	                var toggle, active, next = getIndex(item, children, prev);
	
	                for (var i = 0; i < length; i++, next = (next + dir + length) % length) {
	                    if (!matches(this.toggles[next], '.uk-disabled *, .uk-disabled, [disabled]')) {
	                        toggle = this.toggles[next];
	                        active = children[next];
	                        break;
	                    }
	                }
	
	                if (!active || prev >= 0 && hasClass(active, this.cls) || prev === next) {
	                    return;
	                }
	
	                removeClass(children, this.cls);
	                addClass(active, this.cls);
	                attr(this.toggles, 'aria-expanded', false);
	                attr(toggle, 'aria-expanded', true);
	
	                this.connects.forEach(function (list) {
	                    if (!hasPrev) {
	                        this$1.toggleNow(list.children[next]);
	                    } else {
	                        this$1.toggleElement([list.children[prev], list.children[next]]);
	                    }
	                });
	
	            }
	
	        }
	
	    };
	
	    var Tab = {
	
	        mixins: [Class],
	
	        extends: Switcher,
	
	        props: {
	            media: Boolean
	        },
	
	        data: {
	            media: 960,
	            attrItem: 'uk-tab-item'
	        },
	
	        connected: function() {
	
	            var cls = hasClass(this.$el, 'uk-tab-left')
	                ? 'uk-tab-left'
	                : hasClass(this.$el, 'uk-tab-right')
	                    ? 'uk-tab-right'
	                    : false;
	
	            if (cls) {
	                this.$create('toggle', this.$el, {cls: cls, mode: 'media', media: this.media});
	            }
	        }
	
	    };
	
	    var Toggle = {
	
	        mixins: [Media, Togglable],
	
	        args: 'target',
	
	        props: {
	            href: String,
	            target: null,
	            mode: 'list',
	        },
	
	        data: {
	            href: false,
	            target: false,
	            mode: 'click',
	            queued: true,
	        },
	
	        computed: {
	
	            target: function(ref, $el) {
	                var href = ref.href;
	                var target = ref.target;
	
	                target = queryAll(target || href, $el);
	                return target.length && target || [$el];
	            }
	
	        },
	
	        connected: function() {
	            trigger(this.target, 'updatearia', [this]);
	        },
	
	        events: [
	
	            {
	
	                name: (pointerEnter + " " + pointerLeave),
	
	                filter: function() {
	                    return includes(this.mode, 'hover');
	                },
	
	                handler: function(e) {
	                    if (!isTouch(e)) {
	                        this.toggle(("toggle" + (e.type === pointerEnter ? 'show' : 'hide')));
	                    }
	                }
	
	            },
	
	            {
	
	                name: 'click',
	
	                filter: function() {
	                    return includes(this.mode, 'click') || hasTouch && includes(this.mode, 'hover');
	                },
	
	                handler: function(e) {
	
	                    if (!isTouch(e) && !includes(this.mode, 'click')) {
	                        return;
	                    }
	
	                    // TODO better isToggled handling
	                    var link;
	                    if (closest(e.target, 'a[href="#"], a[href=""], button')
	                        || (link = closest(e.target, 'a[href]')) && (
	                            this.cls
	                            || !isVisible(this.target)
	                            || link.hash && matches(this.target, link.hash)
	                        )
	                    ) {
	                        e.preventDefault();
	                    }
	
	                    this.toggle();
	                }
	
	            }
	
	        ],
	
	        update: {
	
	            write: function() {
	
	                if (!includes(this.mode, 'media') || !this.media) {
	                    return;
	                }
	
	                var toggled = this.isToggled(this.target);
	                if (this.matchMedia ? !toggled : toggled) {
	                    this.toggle();
	                }
	
	            },
	
	            events: ['resize']
	
	        },
	
	        methods: {
	
	            toggle: function(type) {
	                if (trigger(this.target, type || 'toggle', [this])) {
	                    this.toggleElement(this.target);
	                }
	            }
	
	        }
	
	    };
	
	    function core (UIkit) {
	
	        // core components
	        UIkit.component('accordion', Accordion);
	        UIkit.component('alert', Alert);
	        UIkit.component('cover', Cover);
	        UIkit.component('drop', Drop);
	        UIkit.component('dropdown', Dropdown);
	        UIkit.component('formCustom', FormCustom);
	        UIkit.component('gif', Gif);
	        UIkit.component('grid', Grid);
	        UIkit.component('heightMatch', HeightMatch);
	        UIkit.component('heightViewport', HeightViewport);
	        UIkit.component('icon', Icon);
	        UIkit.component('img', Img);
	        UIkit.component('leader', Leader);
	        UIkit.component('margin', Margin);
	        UIkit.component('modal', Modal$1);
	        UIkit.component('nav', Nav);
	        UIkit.component('navbar', Navbar);
	        UIkit.component('offcanvas', Offcanvas);
	        UIkit.component('overflowAuto', OverflowAuto);
	        UIkit.component('responsive', Responsive);
	        UIkit.component('scroll', Scroll);
	        UIkit.component('scrollspy', Scrollspy);
	        UIkit.component('scrollspyNav', ScrollspyNav);
	        UIkit.component('sticky', Sticky);
	        UIkit.component('svg', SVG);
	        UIkit.component('switcher', Switcher);
	        UIkit.component('tab', Tab);
	        UIkit.component('toggle', Toggle);
	        UIkit.component('video', Video);
	
	        // Icon components
	        UIkit.component('close', Close);
	        UIkit.component('marker', IconComponent);
	        UIkit.component('navbarToggleIcon', IconComponent);
	        UIkit.component('overlayIcon', IconComponent);
	        UIkit.component('paginationNext', IconComponent);
	        UIkit.component('paginationPrevious', IconComponent);
	        UIkit.component('searchIcon', Search);
	        UIkit.component('slidenavNext', Slidenav);
	        UIkit.component('slidenavPrevious', Slidenav);
	        UIkit.component('spinner', Spinner);
	        UIkit.component('totop', IconComponent);
	
	        // core functionality
	        UIkit.use(Core);
	
	    }
	
	    UIkit.version = '3.0.3';
	
	    core(UIkit);
	
	    var Countdown = {
	
	        mixins: [Class],
	
	        props: {
	            date: String,
	            clsWrapper: String
	        },
	
	        data: {
	            date: '',
	            clsWrapper: '.uk-countdown-%unit%'
	        },
	
	        computed: {
	
	            date: function(ref) {
	                var date = ref.date;
	
	                return Date.parse(date);
	            },
	
	            days: function(ref, $el) {
	                var clsWrapper = ref.clsWrapper;
	
	                return $(clsWrapper.replace('%unit%', 'days'), $el);
	            },
	
	            hours: function(ref, $el) {
	                var clsWrapper = ref.clsWrapper;
	
	                return $(clsWrapper.replace('%unit%', 'hours'), $el);
	            },
	
	            minutes: function(ref, $el) {
	                var clsWrapper = ref.clsWrapper;
	
	                return $(clsWrapper.replace('%unit%', 'minutes'), $el);
	            },
	
	            seconds: function(ref, $el) {
	                var clsWrapper = ref.clsWrapper;
	
	                return $(clsWrapper.replace('%unit%', 'seconds'), $el);
	            },
	
	            units: function() {
	                var this$1 = this;
	
	                return ['days', 'hours', 'minutes', 'seconds'].filter(function (unit) { return this$1[unit]; });
	            }
	
	        },
	
	        connected: function() {
	            this.start();
	        },
	
	        disconnected: function() {
	            var this$1 = this;
	
	            this.stop();
	            this.units.forEach(function (unit) { return empty(this$1[unit]); });
	        },
	
	        events: [
	
	            {
	
	                name: 'visibilitychange',
	
	                el: document,
	
	                handler: function() {
	                    if (document.hidden) {
	                        this.stop();
	                    } else {
	                        this.start();
	                    }
	                }
	
	            }
	
	        ],
	
	        update: {
	
	            write: function() {
	                var this$1 = this;
	
	
	                var timespan = getTimeSpan(this.date);
	
	                if (timespan.total <= 0) {
	
	                    this.stop();
	
	                    timespan.days
	                        = timespan.hours
	                        = timespan.minutes
	                        = timespan.seconds
	                        = 0;
	                }
	
	                this.units.forEach(function (unit) {
	
	                    var digits = String(Math.floor(timespan[unit]));
	
	                    digits = digits.length < 2 ? ("0" + digits) : digits;
	
	                    var el = this$1[unit];
	                    if (el.textContent !== digits) {
	                        digits = digits.split('');
	
	                        if (digits.length !== el.children.length) {
	                            html(el, digits.map(function () { return '<span></span>'; }).join(''));
	                        }
	
	                        digits.forEach(function (digit, i) { return el.children[i].textContent = digit; });
	                    }
	
	                });
	
	            }
	
	        },
	
	        methods: {
	
	            start: function() {
	                var this$1 = this;
	
	
	                this.stop();
	
	                if (this.date && this.units.length) {
	                    this.$emit();
	                    this.timer = setInterval(function () { return this$1.$emit(); }, 1000);
	                }
	
	            },
	
	            stop: function() {
	
	                if (this.timer) {
	                    clearInterval(this.timer);
	                    this.timer = null;
	                }
	
	            }
	
	        }
	
	    };
	
	    function getTimeSpan(date) {
	
	        var total = date - Date.now();
	
	        return {
	            total: total,
	            seconds: total / 1000 % 60,
	            minutes: total / 1000 / 60 % 60,
	            hours: total / 1000 / 60 / 60 % 24,
	            days: total / 1000 / 60 / 60 / 24
	        };
	    }
	
	    var targetClass = 'uk-animation-target';
	
	    var Animate = {
	
	        props: {
	            animation: Number
	        },
	
	        data: {
	            animation: 150
	        },
	
	        computed: {
	
	            target: function() {
	                return this.$el;
	            }
	
	        },
	
	        methods: {
	
	            animate: function(action) {
	                var this$1 = this;
	
	
	                addStyle();
	
	                var children = toNodes(this.target.children);
	                var propsFrom = children.map(function (el) { return getProps(el, true); });
	
	                var oldHeight = height(this.target);
	                var oldScrollY = window.pageYOffset;
	
	                action();
	
	                Transition.cancel(this.target);
	                children.forEach(Transition.cancel);
	
	                reset(this.target);
	                this.$update(this.target);
	                fastdom.flush();
	
	                var newHeight = height(this.target);
	
	                children = children.concat(toNodes(this.target.children).filter(function (el) { return !includes(children, el); }));
	
	                var propsTo = children.map(function (el, i) { return el.parentNode && i in propsFrom
	                        ? propsFrom[i]
	                        ? isVisible(el)
	                            ? getPositionWithMargin(el)
	                            : {opacity: 0}
	                        : {opacity: isVisible(el) ? 1 : 0}
	                        : false; }
	                );
	
	                propsFrom = propsTo.map(function (props, i) {
	                    var from = children[i].parentNode === this$1.target
	                        ? propsFrom[i] || getProps(children[i])
	                        : false;
	
	                    if (from) {
	                        if (!props) {
	                            delete from.opacity;
	                        } else if (!('opacity' in props)) {
	                            var opacity = from.opacity;
	
	                            if (opacity % 1) {
	                                props.opacity = 1;
	                            } else {
	                                delete from.opacity;
	                            }
	                        }
	                    }
	
	                    return from;
	                });
	
	                addClass(this.target, targetClass);
	                children.forEach(function (el, i) { return propsFrom[i] && css(el, propsFrom[i]); });
	                css(this.target, 'height', oldHeight);
	                scrollTop(window, oldScrollY);
	
	                return Promise.all(children.map(function (el, i) { return propsFrom[i] && propsTo[i]
	                        ? Transition.start(el, propsTo[i], this$1.animation, 'ease')
	                        : Promise.resolve(); }
	                ).concat(Transition.start(this.target, {height: newHeight}, this.animation, 'ease'))).then(function () {
	                    children.forEach(function (el, i) { return css(el, {display: propsTo[i].opacity === 0 ? 'none' : '', zIndex: ''}); });
	                    reset(this$1.target);
	                    this$1.$update(this$1.target);
	                    fastdom.flush(); // needed for IE11
	                }, noop);
	
	            }
	        }
	    };
	
	    function getProps(el, opacity) {
	
	        var zIndex = css(el, 'zIndex');
	
	        return isVisible(el)
	            ? assign({
	                display: '',
	                opacity: opacity ? css(el, 'opacity') : '0',
	                pointerEvents: 'none',
	                position: 'absolute',
	                zIndex: zIndex === 'auto' ? index(el) : zIndex
	            }, getPositionWithMargin(el))
	            : false;
	    }
	
	    function reset(el) {
	        css(el.children, {
	            height: '',
	            left: '',
	            opacity: '',
	            pointerEvents: '',
	            position: '',
	            top: '',
	            width: ''
	        });
	        removeClass(el, targetClass);
	        css(el, 'height', '');
	    }
	
	    function getPositionWithMargin(el) {
	        var ref = el.getBoundingClientRect();
	        var height$$1 = ref.height;
	        var width$$1 = ref.width;
	        var ref$1 = position(el);
	        var top = ref$1.top;
	        var left = ref$1.left;
	        top += toFloat(css(el, 'marginTop'));
	
	        return {top: top, left: left, height: height$$1, width: width$$1};
	    }
	
	    var style$1;
	
	    function addStyle() {
	        if (!style$1) {
	            style$1 = append(document.head, '<style>').sheet;
	            style$1.insertRule(
	                ("." + targetClass + " > * {\n                    margin-top: 0 !important;\n                    transform: none !important;\n                }"), 0
	            );
	        }
	    }
	
	    var Filter = {
	
	        mixins: [Animate],
	
	        args: 'target',
	
	        props: {
	            target: Boolean,
	            selActive: Boolean
	        },
	
	        data: {
	            target: null,
	            selActive: false,
	            attrItem: 'uk-filter-control',
	            cls: 'uk-active',
	            animation: 250
	        },
	
	        computed: {
	
	            toggles: {
	
	                get: function(ref, $el) {
	                    var attrItem = ref.attrItem;
	
	                    return $$(("[" + (this.attrItem) + "],[data-" + (this.attrItem) + "]"), $el);
	                },
	
	                watch: function() {
	                    this.setState(this.getState(), false);
	                }
	
	            },
	
	            target: function(ref, $el) {
	                var target = ref.target;
	
	                return $(target, $el);
	            },
	
	            children: {
	
	                get: function() {
	                    return toNodes(this.target.children);
	                },
	
	                watch: function(list, old) {
	                    if (!isEqualList(list, old)) {
	                        this.updateState();
	                    }
	                }
	            }
	
	        },
	
	        events: [
	
	            {
	
	                name: 'click',
	
	                delegate: function() {
	                    return ("[" + (this.attrItem) + "],[data-" + (this.attrItem) + "]");
	                },
	
	                handler: function(e) {
	
	                    e.preventDefault();
	                    this.apply(e.current);
	
	                }
	
	            }
	
	        ],
	
	        connected: function() {
	            var this$1 = this;
	
	
	            if (this.selActive === false) {
	                return;
	            }
	
	            var actives = $$(this.selActive, this.$el);
	            this.toggles.forEach(function (el) { return toggleClass(el, this$1.cls, includes(actives, el)); });
	        },
	
	        methods: {
	
	            apply: function(el) {
	                this.setState(mergeState(el, this.attrItem, this.getState()));
	            },
	
	            getState: function() {
	                var this$1 = this;
	
	                return this.toggles
	                    .filter(function (item) { return hasClass(item, this$1.cls); })
	                    .reduce(function (state, el) { return mergeState(el, this$1.attrItem, state); }, {filter: {'': ''}, sort: []});
	            },
	
	            setState: function(state, animate$$1) {
	                var this$1 = this;
	                if ( animate$$1 === void 0 ) animate$$1 = true;
	
	
	                state = assign({filter: {'': ''}, sort: []}, state);
	
	                trigger(this.$el, 'beforeFilter', [this, state]);
	
	                var ref = this;
	                var children = ref.children;
	
	                this.toggles.forEach(function (el) { return toggleClass(el, this$1.cls, matchFilter(el, this$1.attrItem, state)); });
	
	                var apply$$1 = function () {
	
	                    var selector = getSelector(state);
	
	                    children.forEach(function (el) { return css(el, 'display', selector && !matches(el, selector) ? 'none' : ''); });
	
	                    var ref = state.sort;
	                    var sort = ref[0];
	                    var order = ref[1];
	
	                    if (sort) {
	                        var sorted = sortItems(children, sort, order);
	                        if (!isEqual(sorted, children)) {
	                            sorted.forEach(function (el) { return append(this$1.target, el); });
	                        }
	                    }
	
	                };
	
	                if (animate$$1) {
	                    this.animate(apply$$1).then(function () { return trigger(this$1.$el, 'afterFilter', [this$1]); });
	                } else {
	                    apply$$1();
	                    trigger(this.$el, 'afterFilter', [this]);
	                }
	
	            },
	
	            updateState: function() {
	                this.setState(this.getState(), false);
	            }
	
	        }
	
	    };
	
	    function getFilter(el, attr$$1) {
	        return parseOptions(data(el, attr$$1), ['filter']);
	    }
	
	    function mergeState(el, attr$$1, state) {
	
	        toNodes(el).forEach(function (el) {
	            var filterBy = getFilter(el, attr$$1);
	            var filter$$1 = filterBy.filter;
	            var group = filterBy.group;
	            var sort = filterBy.sort;
	            var order = filterBy.order; if ( order === void 0 ) order = 'asc';
	
	            if (filter$$1 || isUndefined(sort)) {
	
	                if (group) {
	                    delete state.filter[''];
	                    state.filter[group] = filter$$1;
	                } else {
	                    state.filter = {'': filter$$1 || ''};
	                }
	
	            }
	
	            if (!isUndefined(sort)) {
	                state.sort = [sort, order];
	            }
	        });
	
	        return state;
	    }
	
	    function matchFilter(el, attr$$1, ref) {
	        var stateFilter = ref.filter; if ( stateFilter === void 0 ) stateFilter = {'': ''};
	        var ref_sort = ref.sort;
	        var stateSort = ref_sort[0];
	        var stateOrder = ref_sort[1];
	
	
	        var ref$1 = getFilter(el, attr$$1);
	        var filter$$1 = ref$1.filter;
	        var group = ref$1.group; if ( group === void 0 ) group = '';
	        var sort = ref$1.sort;
	        var order = ref$1.order; if ( order === void 0 ) order = 'asc';
	
	        filter$$1 = isUndefined(sort) ? filter$$1 || '' : filter$$1;
	        sort = isUndefined(filter$$1) ? sort || '' : sort;
	
	        return (isUndefined(filter$$1) || group in stateFilter && filter$$1 === stateFilter[group])
	            && (isUndefined(sort) || stateSort === sort && stateOrder === order);
	    }
	
	    function isEqualList(listA, listB) {
	        return listA.length === listB.length
	            && listA.every(function (el) { return ~listB.indexOf(el); });
	    }
	
	    function getSelector(ref) {
	        var filter$$1 = ref.filter;
	
	        var selector = '';
	        each(filter$$1, function (value) { return selector += value || ''; });
	        return selector;
	    }
	
	    function sortItems(nodes, sort, order) {
	        return assign([], nodes).sort(function (a, b) { return data(a, sort).localeCompare(data(b, sort), undefined, {numeric: true}) * (order === 'asc' || -1); });
	    }
	
	    var Animations = {
	
	        slide: {
	
	            show: function(dir) {
	                return [
	                    {transform: translate(dir * -100)},
	                    {transform: translate()}
	                ];
	            },
	
	            percent: function(current) {
	                return translated(current);
	            },
	
	            translate: function(percent, dir) {
	                return [
	                    {transform: translate(dir * -100 * percent)},
	                    {transform: translate(dir * 100 * (1 - percent))}
	                ];
	            }
	
	        }
	
	    };
	
	    function translated(el) {
	        return Math.abs(css(el, 'transform').split(',')[4] / el.offsetWidth) || 0;
	    }
	
	    function translate(value, unit) {
	        if ( value === void 0 ) value = 0;
	        if ( unit === void 0 ) unit = '%';
	
	        return ("translateX(" + value + (value ? unit : '') + ")"); // currently not translate3d to support IE, translate3d within translate3d does not work while transitioning
	    }
	
	    function scale3d(value) {
	        return ("scale3d(" + value + ", " + value + ", 1)");
	    }
	
	    var Animations$1 = assign({}, Animations, {
	
	        fade: {
	
	            show: function() {
	                return [
	                    {opacity: 0},
	                    {opacity: 1}
	                ];
	            },
	
	            percent: function(current) {
	                return 1 - css(current, 'opacity');
	            },
	
	            translate: function(percent) {
	                return [
	                    {opacity: 1 - percent},
	                    {opacity: percent}
	                ];
	            }
	
	        },
	
	        scale: {
	
	            show: function() {
	                return [
	                    {opacity: 0, transform: scale3d(1 - .2)},
	                    {opacity: 1, transform: scale3d(1)}
	                ];
	            },
	
	            percent: function(current) {
	                return 1 - css(current, 'opacity');
	            },
	
	            translate: function(percent) {
	                return [
	                    {opacity: 1 - percent, transform: scale3d(1 - .2 * percent)},
	                    {opacity: percent, transform: scale3d(1 - .2 + .2 * percent)}
	                ];
	            }
	
	        }
	
	    });
	
	    function Transitioner(prev, next, dir, ref) {
	        var animation = ref.animation;
	        var easing = ref.easing;
	
	
	        var percent = animation.percent;
	        var translate = animation.translate;
	        var show = animation.show; if ( show === void 0 ) show = noop;
	        var props = show(dir);
	        var deferred = new Deferred();
	
	        return {
	
	            dir: dir,
	
	            show: function(duration, percent, linear) {
	                var this$1 = this;
	                if ( percent === void 0 ) percent = 0;
	
	
	                var timing = linear ? 'linear' : easing;
	                duration -= Math.round(duration * clamp(percent, -1, 1));
	
	                this.translate(percent);
	
	                triggerUpdate(next, 'itemin', {percent: percent, duration: duration, timing: timing, dir: dir});
	                triggerUpdate(prev, 'itemout', {percent: 1 - percent, duration: duration, timing: timing, dir: dir});
	
	                Promise.all([
	                    Transition.start(next, props[1], duration, timing),
	                    Transition.start(prev, props[0], duration, timing)
	                ]).then(function () {
	                    this$1.reset();
	                    deferred.resolve();
	                }, noop);
	
	                return deferred.promise;
	            },
	
	            stop: function() {
	                return Transition.stop([next, prev]);
	            },
	
	            cancel: function() {
	                Transition.cancel([next, prev]);
	            },
	
	            reset: function() {
	                for (var prop in props[0]) {
	                    css([next, prev], prop, '');
	                }
	            },
	
	            forward: function(duration, percent) {
	                if ( percent === void 0 ) percent = this.percent();
	
	                Transition.cancel([next, prev]);
	                return this.show(duration, percent, true);
	
	            },
	
	            translate: function(percent) {
	
	                this.reset();
	
	                var props = translate(percent, dir);
	                css(next, props[1]);
	                css(prev, props[0]);
	                triggerUpdate(next, 'itemtranslatein', {percent: percent, dir: dir});
	                triggerUpdate(prev, 'itemtranslateout', {percent: 1 - percent, dir: dir});
	
	            },
	
	            percent: function() {
	                return percent(prev || next, next, dir);
	            },
	
	            getDistance: function() {
	                return prev && prev.offsetWidth;
	            }
	
	        };
	
	    }
	
	    function triggerUpdate(el, type, data$$1) {
	        trigger(el, createEvent(type, false, false, data$$1));
	    }
	
	    var SliderAutoplay = {
	
	        props: {
	            autoplay: Boolean,
	            autoplayInterval: Number,
	            pauseOnHover: Boolean
	        },
	
	        data: {
	            autoplay: false,
	            autoplayInterval: 7000,
	            pauseOnHover: true
	        },
	
	        connected: function() {
	            this.startAutoplay();
	            this.userInteracted = false;
	        },
	
	        disconnected: function() {
	            this.stopAutoplay();
	        },
	
	        events: [
	
	            {
	
	                name: 'visibilitychange',
	
	                el: document,
	
	                handler: function() {
	                    if (document.hidden) {
	                        this.stopAutoplay();
	                    } else {
	                        !this.userInteracted && this.startAutoplay();
	                    }
	                }
	
	            },
	
	            {
	
	                name: pointerDown,
	                handler: function() {
	                    this.userInteracted = true;
	                    this.stopAutoplay();
	                }
	
	            },
	
	            {
	
	                name: 'mouseenter',
	
	                filter: function() {
	                    return this.autoplay;
	                },
	
	                handler: function() {
	                    this.isHovering = true;
	                }
	
	            },
	
	            {
	
	                name: 'mouseleave',
	
	                filter: function() {
	                    return this.autoplay;
	                },
	
	                handler: function() {
	                    this.isHovering = false;
	                }
	
	            }
	
	        ],
	
	        methods: {
	
	            startAutoplay: function() {
	                var this$1 = this;
	
	
	                this.stopAutoplay();
	
	                if (this.autoplay) {
	                    this.interval = setInterval(
	                        function () { return !(this$1.isHovering && this$1.pauseOnHover) && !this$1.stack.length && this$1.show('next'); },
	                        this.autoplayInterval
	                    );
	                }
	
	            },
	
	            stopAutoplay: function() {
	                if (this.interval) {
	                    clearInterval(this.interval);
	                }
	            }
	
	        }
	
	    };
	
	    var SliderDrag = {
	
	        props: {
	            draggable: Boolean
	        },
	
	        data: {
	            draggable: true,
	            threshold: 10
	        },
	
	        created: function() {
	            var this$1 = this;
	
	
	            ['start', 'move', 'end'].forEach(function (key) {
	
	                var fn = this$1[key];
	                this$1[key] = function (e) {
	
	                    var pos = getPos$1(e).x * (isRtl ? -1 : 1);
	
	                    this$1.prevPos = pos !== this$1.pos ? this$1.pos : this$1.prevPos;
	                    this$1.pos = pos;
	
	                    fn(e);
	                };
	
	            });
	
	        },
	
	        events: [
	
	            {
	
	                name: pointerDown,
	
	                delegate: function() {
	                    return this.selSlides;
	                },
	
	                handler: function(e) {
	
	                    if (!this.draggable
	                        || !isTouch(e) && hasTextNodesOnly(e.target)
	                        || e.button > 0
	                        || this.length < 2
	                    ) {
	                        return;
	                    }
	
	                    this.start(e);
	                }
	
	            },
	
	            {
	
	                // Workaround for iOS 11 bug: https://bugs.webkit.org/show_bug.cgi?id=184250
	
	                name: 'touchmove',
	                passive: false,
	                handler: 'move',
	                delegate: function() {
	                    return this.selSlides;
	                }
	
	            },
	
	            {
	                name: 'dragstart',
	
	                handler: function(e) {
	                    e.preventDefault();
	                }
	            }
	
	        ],
	
	        methods: {
	
	            start: function() {
	                var this$1 = this;
	
	
	                this.drag = this.pos;
	
	                if (this._transitioner) {
	
	                    this.percent = this._transitioner.percent();
	                    this.drag += this._transitioner.getDistance() * this.percent * this.dir;
	
	                    this._transitioner.cancel();
	                    this._transitioner.translate(this.percent);
	
	                    this.dragging = true;
	
	                    this.stack = [];
	
	                } else {
	                    this.prevIndex = this.index;
	                }
	
	                // See above workaround notice
	                var off$$1 = pointerMove !== 'touchmove'
	                    ? on(document, pointerMove, this.move, {passive: false})
	                    : noop;
	                this.unbindMove = function () {
	                    off$$1();
	                    this$1.unbindMove = null;
	                };
	                on(window, 'scroll', this.unbindMove);
	                on(document, pointerUp, this.end, true);
	
	            },
	
	            move: function(e) {
	                var this$1 = this;
	
	
	                // See above workaround notice
	                if (!this.unbindMove) {
	                    return;
	                }
	
	                var distance = this.pos - this.drag;
	
	                if (distance === 0 || this.prevPos === this.pos || !this.dragging && Math.abs(distance) < this.threshold) {
	                    return;
	                }
	
	                e.cancelable && e.preventDefault();
	
	                this.dragging = true;
	                this.dir = (distance < 0 ? 1 : -1);
	
	                var ref = this;
	                var slides = ref.slides;
	                var ref$1 = this;
	                var prevIndex = ref$1.prevIndex;
	                var dis = Math.abs(distance);
	                var nextIndex = this.getIndex(prevIndex + this.dir, prevIndex);
	                var width$$1 = this._getDistance(prevIndex, nextIndex) || slides[prevIndex].offsetWidth;
	
	                while (nextIndex !== prevIndex && dis > width$$1) {
	
	                    this.drag -= width$$1 * this.dir;
	
	                    prevIndex = nextIndex;
	                    dis -= width$$1;
	                    nextIndex = this.getIndex(prevIndex + this.dir, prevIndex);
	                    width$$1 = this._getDistance(prevIndex, nextIndex) || slides[prevIndex].offsetWidth;
	
	                }
	
	                this.percent = dis / width$$1;
	
	                var prev = slides[prevIndex];
	                var next = slides[nextIndex];
	                var changed = this.index !== nextIndex;
	                var edge = prevIndex === nextIndex;
	
	                var itemShown;
	
	                [this.index, this.prevIndex].filter(function (i) { return !includes([nextIndex, prevIndex], i); }).forEach(function (i) {
	                    trigger(slides[i], 'itemhidden', [this$1]);
	
	                    if (edge) {
	                        itemShown = true;
	                        this$1.prevIndex = prevIndex;
	                    }
	
	                });
	
	                if (this.index === prevIndex && this.prevIndex !== prevIndex || itemShown) {
	                    trigger(slides[this.index], 'itemshown', [this]);
	                }
	
	                if (changed) {
	                    this.prevIndex = prevIndex;
	                    this.index = nextIndex;
	
	                    !edge && trigger(prev, 'beforeitemhide', [this]);
	                    trigger(next, 'beforeitemshow', [this]);
	                }
	
	                this._transitioner = this._translate(Math.abs(this.percent), prev, !edge && next);
	
	                if (changed) {
	                    !edge && trigger(prev, 'itemhide', [this]);
	                    trigger(next, 'itemshow', [this]);
	                }
	
	            },
	
	            end: function() {
	
	                off(window, 'scroll', this.unbindMove);
	                this.unbindMove && this.unbindMove();
	                off(document, pointerUp, this.end, true);
	
	                if (this.dragging) {
	
	                    this.dragging = null;
	
	                    if (this.index === this.prevIndex) {
	                        this.percent = 1 - this.percent;
	                        this.dir *= -1;
	                        this._show(false, this.index, true);
	                        this._transitioner = null;
	                    } else {
	
	                        var dirChange = (isRtl ? this.dir * (isRtl ? 1 : -1) : this.dir) < 0 === this.prevPos > this.pos;
	                        this.index = dirChange ? this.index : this.prevIndex;
	
	                        if (dirChange) {
	                            this.percent = 1 - this.percent;
	                        }
	
	                        this.show(this.dir > 0 && !dirChange || this.dir < 0 && dirChange ? 'next' : 'previous', true);
	                    }
	
	                    preventClick();
	
	                }
	
	                this.drag
	                    = this.percent
	                    = null;
	
	            }
	
	        }
	
	    };
	
	    function hasTextNodesOnly(el) {
	        return !el.children.length && el.childNodes.length;
	    }
	
	    var SliderNav = {
	
	        data: {
	            selNav: false
	        },
	
	        computed: {
	
	            nav: function(ref, $el) {
	                var selNav = ref.selNav;
	
	                return $(selNav, $el);
	            },
	
	            selNavItem: function(ref) {
	                var attrItem = ref.attrItem;
	
	                return ("[" + attrItem + "],[data-" + attrItem + "]");
	            },
	
	            navItems: function(_, $el) {
	                return $$(this.selNavItem, $el);
	            }
	
	        },
	
	        update: {
	
	            write: function() {
	                var this$1 = this;
	
	
	                if (this.nav && this.length !== this.nav.children.length) {
	                    html(this.nav, this.slides.map(function (_, i) { return ("<li " + (this$1.attrItem) + "=\"" + i + "\"><a href=\"#\"></a></li>"); }).join(''));
	                }
	
	                toggleClass($$(this.selNavItem, this.$el).concat(this.nav), 'uk-hidden', !this.maxIndex);
	
	                this.updateNav();
	
	            },
	
	            events: ['resize']
	
	        },
	
	        events: [
	
	            {
	
	                name: 'click',
	
	                delegate: function() {
	                    return this.selNavItem;
	                },
	
	                handler: function(e) {
	                    e.preventDefault();
	                    this.show(data(e.current, this.attrItem));
	                }
	
	            },
	
	            {
	
	                name: 'itemshow',
	                handler: 'updateNav'
	
	            }
	
	        ],
	
	        methods: {
	
	            updateNav: function() {
	                var this$1 = this;
	
	
	                var i = this.getValidIndex();
	                this.navItems.forEach(function (el) {
	
	                    var cmd = data(el, this$1.attrItem);
	
	                    toggleClass(el, this$1.clsActive, toNumber(cmd) === i);
	                    toggleClass(el, 'uk-invisible', this$1.finite && (cmd === 'previous' && i === 0 || cmd === 'next' && i >= this$1.maxIndex));
	                });
	
	            }
	
	        }
	
	    };
	
	    var Slider = {
	
	        mixins: [SliderAutoplay, SliderDrag, SliderNav],
	
	        props: {
	            clsActivated: Boolean,
	            easing: String,
	            index: Number,
	            finite: Boolean,
	            velocity: Number
	        },
	
	        data: function () { return ({
	            easing: 'ease',
	            finite: false,
	            velocity: 1,
	            index: 0,
	            stack: [],
	            percent: 0,
	            clsActive: 'uk-active',
	            clsActivated: false,
	            Transitioner: false,
	            transitionOptions: {}
	        }); },
	
	        computed: {
	
	            duration: function(ref, $el) {
	                var velocity = ref.velocity;
	
	                return speedUp($el.offsetWidth / velocity);
	            },
	
	            length: function() {
	                return this.slides.length;
	            },
	
	            list: function(ref, $el) {
	                var selList = ref.selList;
	
	                return $(selList, $el);
	            },
	
	            maxIndex: function() {
	                return this.length - 1;
	            },
	
	            selSlides: function(ref) {
	                var selList = ref.selList;
	
	                return (selList + " > *");
	            },
	
	            slides: function() {
	                return toNodes(this.list.children);
	            }
	
	        },
	
	        events: {
	
	            itemshown: function() {
	                this.$update(this.list);
	            }
	
	        },
	
	        methods: {
	
	            show: function(index$$1, force) {
	                var this$1 = this;
	                if ( force === void 0 ) force = false;
	
	
	                if (this.dragging || !this.length) {
	                    return;
	                }
	
	                var ref = this;
	                var stack = ref.stack;
	                var queueIndex = force ? 0 : stack.length;
	                var reset = function () {
	                    stack.splice(queueIndex, 1);
	
	                    if (stack.length) {
	                        this$1.show(stack.shift(), true);
	                    }
	                };
	
	                stack[force ? 'unshift' : 'push'](index$$1);
	
	                if (!force && stack.length > 1) {
	
	                    if (stack.length === 2) {
	                        this._transitioner.forward(Math.min(this.duration, 200));
	                    }
	
	                    return;
	                }
	
	                var prevIndex = this.index;
	                var prev = hasClass(this.slides, this.clsActive) && this.slides[prevIndex];
	                var nextIndex = this.getIndex(index$$1, this.index);
	                var next = this.slides[nextIndex];
	
	                if (prev === next) {
	                    reset();
	                    return;
	                }
	
	                this.dir = getDirection(index$$1, prevIndex);
	                this.prevIndex = prevIndex;
	                this.index = nextIndex;
	
	                prev && trigger(prev, 'beforeitemhide', [this]);
	                if (!trigger(next, 'beforeitemshow', [this, prev])) {
	                    this.index = this.prevIndex;
	                    reset();
	                    return;
	                }
	
	                var promise = this._show(prev, next, force).then(function () {
	
	                    prev && trigger(prev, 'itemhidden', [this$1]);
	                    trigger(next, 'itemshown', [this$1]);
	
	                    return new Promise(function (resolve) {
	                        fastdom.write(function () {
	                            stack.shift();
	                            if (stack.length) {
	                                this$1.show(stack.shift(), true);
	                            } else {
	                                this$1._transitioner = null;
	                            }
	                            resolve();
	                        });
	                    });
	
	                });
	
	                prev && trigger(prev, 'itemhide', [this]);
	                trigger(next, 'itemshow', [this]);
	
	                return promise;
	
	            },
	
	            getIndex: function(index$$1, prev) {
	                if ( index$$1 === void 0 ) index$$1 = this.index;
	                if ( prev === void 0 ) prev = this.index;
	
	                return clamp(getIndex(index$$1, this.slides, prev, this.finite), 0, this.maxIndex);
	            },
	
	            getValidIndex: function(index$$1, prevIndex) {
	                if ( index$$1 === void 0 ) index$$1 = this.index;
	                if ( prevIndex === void 0 ) prevIndex = this.prevIndex;
	
	                return this.getIndex(index$$1, prevIndex);
	            },
	
	            _show: function(prev, next, force) {
	
	                this._transitioner = this._getTransitioner(
	                    prev,
	                    next,
	                    this.dir,
	                    assign({
	                        easing: force
	                            ? next.offsetWidth < 600
	                                ? 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' /* easeOutQuad */
	                                : 'cubic-bezier(0.165, 0.84, 0.44, 1)' /* easeOutQuart */
	                            : this.easing
	                    }, this.transitionOptions)
	                );
	
	                if (!force && !prev) {
	                    this._transitioner.translate(1);
	                    return Promise.resolve();
	                }
	
	                var ref = this.stack;
	                var length = ref.length;
	                return this._transitioner[length > 1 ? 'forward' : 'show'](length > 1 ? Math.min(this.duration, 75 + 75 / (length - 1)) : this.duration, this.percent);
	
	            },
	
	            _getDistance: function(prev, next) {
	                return new this._getTransitioner(prev, prev !== next && next).getDistance();
	            },
	
	            _translate: function(percent, prev, next) {
	                if ( prev === void 0 ) prev = this.prevIndex;
	                if ( next === void 0 ) next = this.index;
	
	                var transitioner = this._getTransitioner(prev !== next ? prev : false, next);
	                transitioner.translate(percent);
	                return transitioner;
	            },
	
	            _getTransitioner: function(prev, next, dir, options) {
	                if ( prev === void 0 ) prev = this.prevIndex;
	                if ( next === void 0 ) next = this.index;
	                if ( dir === void 0 ) dir = this.dir || 1;
	                if ( options === void 0 ) options = this.transitionOptions;
	
	                return new this.Transitioner(
	                    isNumber(prev) ? this.slides[prev] : prev,
	                    isNumber(next) ? this.slides[next] : next,
	                    dir * (isRtl ? -1 : 1),
	                    options
	                );
	            }
	
	        }
	
	    };
	
	    function getDirection(index$$1, prevIndex) {
	        return index$$1 === 'next'
	            ? 1
	            : index$$1 === 'previous'
	                ? -1
	                : index$$1 < prevIndex
	                    ? -1
	                    : 1;
	    }
	
	    function speedUp(x) {
	        return .5 * x + 300; // parabola through (400,500; 600,600; 1800,1200)
	    }
	
	    var Slideshow = {
	
	        mixins: [Slider],
	
	        props: {
	            animation: String
	        },
	
	        data: {
	            animation: 'slide',
	            clsActivated: 'uk-transition-active',
	            Animations: Animations,
	            Transitioner: Transitioner
	        },
	
	        computed: {
	
	            animation: function(ref) {
	                var animation = ref.animation;
	                var Animations$$1 = ref.Animations;
	
	                return assign(animation in Animations$$1 ? Animations$$1[animation] : Animations$$1.slide, {name: animation});
	            },
	
	            transitionOptions: function() {
	                return {animation: this.animation};
	            }
	
	        },
	
	        events: {
	
	            'itemshow itemhide itemshown itemhidden': function(ref) {
	                var target = ref.target;
	
	                this.$update(target);
	            },
	
	            itemshow: function() {
	                isNumber(this.prevIndex) && fastdom.flush(); // iOS 10+ will honor the video.play only if called from a gesture handler
	            },
	
	            beforeitemshow: function(ref) {
	                var target = ref.target;
	
	                addClass(target, this.clsActive);
	            },
	
	            itemshown: function(ref) {
	                var target = ref.target;
	
	                addClass(target, this.clsActivated);
	            },
	
	            itemhidden: function(ref) {
	                var target = ref.target;
	
	                removeClass(target, this.clsActive, this.clsActivated);
	            }
	
	        }
	
	    };
	
	    var LightboxPanel = {
	
	        mixins: [Container, Modal, Togglable, Slideshow],
	
	        functional: true,
	
	        props: {
	            delayControls: Number,
	            preload: Number,
	            videoAutoplay: Boolean,
	            template: String
	        },
	
	        data: function () { return ({
	            preload: 1,
	            videoAutoplay: false,
	            delayControls: 3000,
	            items: [],
	            cls: 'uk-open',
	            clsPage: 'uk-lightbox-page',
	            selList: '.uk-lightbox-items',
	            attrItem: 'uk-lightbox-item',
	            selClose: '.uk-close-large',
	            pauseOnHover: false,
	            velocity: 2,
	            Animations: Animations$1,
	            template: "<div class=\"uk-lightbox uk-overflow-hidden\"> <ul class=\"uk-lightbox-items\"></ul> <div class=\"uk-lightbox-toolbar uk-position-top uk-text-right uk-transition-slide-top uk-transition-opaque\"> <button class=\"uk-lightbox-toolbar-icon uk-close-large\" type=\"button\" uk-close></button> </div> <a class=\"uk-lightbox-button uk-position-center-left uk-position-medium uk-transition-fade\" href=\"#\" uk-slidenav-previous uk-lightbox-item=\"previous\"></a> <a class=\"uk-lightbox-button uk-position-center-right uk-position-medium uk-transition-fade\" href=\"#\" uk-slidenav-next uk-lightbox-item=\"next\"></a> <div class=\"uk-lightbox-toolbar uk-lightbox-caption uk-position-bottom uk-text-center uk-transition-slide-bottom uk-transition-opaque\"></div> </div>"
	        }); },
	
	        created: function() {
	            var this$1 = this;
	
	
	            this.$mount(append(this.container, this.template));
	
	            this.caption = $('.uk-lightbox-caption', this.$el);
	
	            this.items.forEach(function () { return append(this$1.list, '<li></li>'); });
	
	        },
	
	        events: [
	
	            {
	
	                name: (pointerMove + " " + pointerDown + " keydown"),
	
	                handler: 'showControls'
	
	            },
	
	            {
	
	                name: pointerUp,
	
	                self: true,
	
	                delegate: function() {
	                    return this.selSlides;
	                },
	
	                handler: function(e) {
	                    e.preventDefault();
	                    this.hide();
	                }
	
	            },
	
	            {
	
	                name: 'shown',
	
	                self: true,
	
	                handler: function() {
	                    this.startAutoplay();
	                    this.showControls();
	                }
	
	            },
	
	            {
	
	                name: 'hide',
	
	                self: true,
	
	                handler: function() {
	
	                    this.stopAutoplay();
	                    this.hideControls();
	
	                    removeClass(this.slides, this.clsActive);
	                    Transition.stop(this.slides);
	
	                }
	            },
	
	            {
	
	                name: 'hidden',
	
	                self: true,
	
	                handler: function() {
	                    this.$destroy(true);
	                }
	
	            },
	
	            {
	
	                name: 'keyup',
	
	                el: document,
	
	                handler: function(e) {
	
	                    if (!this.isToggled(this.$el)) {
	                        return;
	                    }
	
	                    switch (e.keyCode) {
	                        case 37:
	                            this.show('previous');
	                            break;
	                        case 39:
	                            this.show('next');
	                            break;
	                    }
	                }
	            },
	
	            {
	
	                name: 'beforeitemshow',
	
	                handler: function(e) {
	
	                    if (this.isToggled()) {
	                        return;
	                    }
	
	                    this.draggable = false;
	
	                    e.preventDefault();
	
	                    this.toggleNow(this.$el, true);
	
	                    this.animation = Animations$1['scale'];
	                    removeClass(e.target, this.clsActive);
	                    this.stack.splice(1, 0, this.index);
	
	                }
	
	            },
	
	            {
	
	                name: 'itemshow',
	
	                handler: function(ref) {
	                    var target = ref.target;
	
	
	                    var i = index(target);
	                    var ref$1 = this.getItem(i);
	                    var caption = ref$1.caption;
	
	                    css(this.caption, 'display', caption ? '' : 'none');
	                    html(this.caption, caption);
	
	                    for (var j = 0; j <= this.preload; j++) {
	                        this.loadItem(this.getIndex(i + j));
	                        this.loadItem(this.getIndex(i - j));
	                    }
	
	                }
	
	            },
	
	            {
	
	                name: 'itemshown',
	
	                handler: function() {
	                    this.draggable = this.$props.draggable;
	                }
	
	            },
	
	            {
	
	                name: 'itemload',
	
	                handler: function(_, item) {
	                    var this$1 = this;
	
	
	                    var source = item.source;
	                    var type = item.type;
	                    var alt = item.alt;
	
	                    this.setItem(item, '<span uk-spinner></span>');
	
	                    if (!source) {
	                        return;
	                    }
	
	                    var matches$$1;
	
	                    // Image
	                    if (type === 'image' || source.match(/\.(jp(e)?g|png|gif|svg)($|\?)/i)) {
	
	                        getImage(source).then(
	                            function (img) { return this$1.setItem(item, ("<img width=\"" + (img.width) + "\" height=\"" + (img.height) + "\" src=\"" + source + "\" alt=\"" + (alt ? alt : '') + "\">")); },
	                            function () { return this$1.setError(item); }
	                        );
	
	                        // Video
	                    } else if (type === 'video' || source.match(/\.(mp4|webm|ogv)($|\?)/i)) {
	
	                        var video = $(("<video controls playsinline" + (item.poster ? (" poster=\"" + (item.poster) + "\"") : '') + " uk-video=\"" + (this.videoAutoplay) + "\"></video>"));
	                        attr(video, 'src', source);
	
	                        once(video, 'error loadedmetadata', function (type) {
	                            if (type === 'error') {
	                                this$1.setError(item);
	                            } else {
	                                attr(video, {width: video.videoWidth, height: video.videoHeight});
	                                this$1.setItem(item, video);
	                            }
	                        });
	
	                        // Iframe
	                    } else if (type === 'iframe' || source.match(/\.(html|php)($|\?)/i)) {
	
	                        this.setItem(item, ("<iframe class=\"uk-lightbox-iframe\" src=\"" + source + "\" frameborder=\"0\" allowfullscreen></iframe>"));
	
	                        // YouTube
	                    } else if ((matches$$1 = source.match(/\/\/.*?youtube(-nocookie)?\.[a-z]+\/watch\?v=([^&\s]+)/) || source.match(/()youtu\.be\/(.*)/))) {
	
	                        var id = matches$$1[2];
	                        var setIframe = function (width$$1, height$$1) {
	                            if ( width$$1 === void 0 ) width$$1 = 640;
	                            if ( height$$1 === void 0 ) height$$1 = 450;
	
	                            return this$1.setItem(item, getIframe(("https://www.youtube" + (matches$$1[1] || '') + ".com/embed/" + id), width$$1, height$$1, this$1.videoAutoplay));
	                        };
	
	                        getImage(("https://img.youtube.com/vi/" + id + "/maxresdefault.jpg")).then(
	                            function (ref) {
	                                var width$$1 = ref.width;
	                                var height$$1 = ref.height;
	
	                                // YouTube default 404 thumb, fall back to low resolution
	                                if (width$$1 === 120 && height$$1 === 90) {
	                                    getImage(("https://img.youtube.com/vi/" + id + "/0.jpg")).then(
	                                        function (ref) {
	                                            var width$$1 = ref.width;
	                                            var height$$1 = ref.height;
	
	                                            return setIframe(width$$1, height$$1);
	                                    },
	                                        setIframe
	                                    );
	                                } else {
	                                    setIframe(width$$1, height$$1);
	                                }
	                            },
	                            setIframe
	                        );
	
	                        // Vimeo
	                    } else if ((matches$$1 = source.match(/(\/\/.*?)vimeo\.[a-z]+\/([0-9]+).*?/))) {
	
	                        ajax(("https://vimeo.com/api/oembed.json?maxwidth=1920&url=" + (encodeURI(source))), {responseType: 'json', withCredentials: false})
	                            .then(
	                                function (ref) {
	                                    var ref_response = ref.response;
	                                    var height$$1 = ref_response.height;
	                                    var width$$1 = ref_response.width;
	
	                                    return this$1.setItem(item, getIframe(("https://player.vimeo.com/video/" + (matches$$1[2])), width$$1, height$$1, this$1.videoAutoplay));
	                        },
	                                function () { return this$1.setError(item); }
	                            );
	
	                    }
	
	                }
	
	            }
	
	        ],
	
	        methods: {
	
	            loadItem: function(index$$1) {
	                if ( index$$1 === void 0 ) index$$1 = this.index;
	
	
	                var item = this.getItem(index$$1);
	
	                if (item.content) {
	                    return;
	                }
	
	                trigger(this.$el, 'itemload', [item]);
	            },
	
	            getItem: function(index$$1) {
	                if ( index$$1 === void 0 ) index$$1 = this.index;
	
	                return this.items[index$$1] || {};
	            },
	
	            setItem: function(item, content) {
	                assign(item, {content: content});
	                var el = html(this.slides[this.items.indexOf(item)], content);
	                trigger(this.$el, 'itemloaded', [this, el]);
	                this.$update(el);
	            },
	
	            setError: function(item) {
	                this.setItem(item, '<span uk-icon="icon: bolt; ratio: 2"></span>');
	            },
	
	            showControls: function() {
	
	                clearTimeout(this.controlsTimer);
	                this.controlsTimer = setTimeout(this.hideControls, this.delayControls);
	
	                addClass(this.$el, 'uk-active', 'uk-transition-active');
	
	            },
	
	            hideControls: function() {
	                removeClass(this.$el, 'uk-active', 'uk-transition-active');
	            }
	
	        }
	
	    };
	
	    function getIframe(src, width$$1, height$$1, autoplay) {
	        return ("<iframe src=\"" + src + "\" width=\"" + width$$1 + "\" height=\"" + height$$1 + "\" style=\"max-width: 100%; box-sizing: border-box;\" frameborder=\"0\" allowfullscreen uk-video=\"autoplay: " + autoplay + "\" uk-responsive></iframe>");
	    }
	
	    var Lightbox = {
	
	        install: install$2,
	
	        props: {toggle: String},
	
	        data: {toggle: 'a'},
	
	        computed: {
	
	            toggles: {
	
	                get: function(ref, $el) {
	                    var toggle = ref.toggle;
	
	                    return $$(toggle, $el);
	                },
	
	                watch: function() {
	                    this.hide();
	                }
	
	            }
	
	        },
	
	        disconnected: function() {
	            this.hide();
	        },
	
	        events: [
	
	            {
	
	                name: 'click',
	
	                delegate: function() {
	                    return ((this.toggle) + ":not(.uk-disabled)");
	                },
	
	                handler: function(e) {
	                    e.preventDefault();
	                    this.show(index(this.toggles, e.current));
	                }
	
	            }
	
	        ],
	
	        methods: {
	
	            show: function(index$$1) {
	                var this$1 = this;
	
	
	                this.panel = this.panel || this.$create('lightboxPanel', assign({}, this.$props, {
	                    items: this.toggles.reduce(function (items, el) {
	                        items.push(['href', 'caption', 'type', 'poster', 'alt'].reduce(function (obj, attr$$1) {
	                            obj[attr$$1 === 'href' ? 'source' : attr$$1] = data(el, attr$$1);
	                            return obj;
	                        }, {}));
	                        return items;
	                    }, [])
	                }));
	
	                on(this.panel.$el, 'hidden', function () { return this$1.panel = false; });
	                return this.panel.show(index$$1);
	            },
	
	            hide: function() {
	
	                return this.panel && this.panel.hide();
	
	            }
	
	        }
	
	    };
	
	    function install$2(UIkit, Lightbox) {
	
	        if (!UIkit.lightboxPanel) {
	            UIkit.component('lightboxPanel', LightboxPanel);
	        }
	
	        assign(
	            Lightbox.props,
	            UIkit.component('lightboxPanel').options.props
	        );
	
	    }
	
	    var obj;
	
	    var containers = {};
	
	    var Notification = {
	
	        functional: true,
	
	        args: ['message', 'status'],
	
	        data: {
	            message: '',
	            status: '',
	            timeout: 5000,
	            group: null,
	            pos: 'top-center',
	            clsClose: 'uk-notification-close',
	            clsMsg: 'uk-notification-message'
	        },
	
	        install: install$3,
	
	        computed: {
	
	            marginProp: function(ref) {
	                var pos = ref.pos;
	
	                return ("margin" + (startsWith(pos, 'top') ? 'Top' : 'Bottom'));
	            },
	
	            startProps: function() {
	                var obj;
	
	                return ( obj = {opacity: 0}, obj[this.marginProp] = -this.$el.offsetHeight, obj );
	            }
	
	        },
	
	        created: function() {
	
	            if (!containers[this.pos]) {
	                containers[this.pos] = append(this.$container, ("<div class=\"uk-notification uk-notification-" + (this.pos) + "\"></div>"));
	            }
	
	            var container = css(containers[this.pos], 'display', 'block');
	
	            this.$mount(append(container,
	                ("<div class=\"" + (this.clsMsg) + (this.status ? (" " + (this.clsMsg) + "-" + (this.status)) : '') + "\"> <a href=\"#\" class=\"" + (this.clsClose) + "\" data-uk-close></a> <div>" + (this.message) + "</div> </div>")
	            ));
	
	        },
	
	        connected: function() {
	            var this$1 = this;
	            var obj;
	
	
	            var margin = toFloat(css(this.$el, this.marginProp));
	            Transition.start(
	                css(this.$el, this.startProps),
	                ( obj = {opacity: 1}, obj[this.marginProp] = margin, obj )
	            ).then(function () {
	                if (this$1.timeout) {
	                    this$1.timer = setTimeout(this$1.close, this$1.timeout);
	                }
	            });
	
	        },
	
	        events: ( obj = {
	
	            click: function(e) {
	                if (closest(e.target, 'a[href="#"],a[href=""]')) {
	                    e.preventDefault();
	                }
	                this.close();
	            }
	
	        }, obj[pointerEnter] = function () {
	                if (this.timer) {
	                    clearTimeout(this.timer);
	                }
	            }, obj[pointerLeave] = function () {
	                if (this.timeout) {
	                    this.timer = setTimeout(this.close, this.timeout);
	                }
	            }, obj ),
	
	        methods: {
	
	            close: function(immediate) {
	                var this$1 = this;
	
	
	                var removeFn = function () {
	
	                    trigger(this$1.$el, 'close', [this$1]);
	                    remove(this$1.$el);
	
	                    if (!containers[this$1.pos].children.length) {
	                        css(containers[this$1.pos], 'display', 'none');
	                    }
	
	                };
	
	                if (this.timer) {
	                    clearTimeout(this.timer);
	                }
	
	                if (immediate) {
	                    removeFn();
	                } else {
	                    Transition.start(this.$el, this.startProps).then(removeFn);
	                }
	            }
	
	        }
	
	    };
	
	    function install$3(UIkit) {
	        UIkit.notification.closeAll = function (group, immediate) {
	            apply(document.body, function (el) {
	                var notification = UIkit.getComponent(el, 'notification');
	                if (notification && (!group || group === notification.group)) {
	                    notification.close(immediate);
	                }
	            });
	        };
	    }
	
	    var props = ['x', 'y', 'bgx', 'bgy', 'rotate', 'scale', 'color', 'backgroundColor', 'borderColor', 'opacity', 'blur', 'hue', 'grayscale', 'invert', 'saturate', 'sepia', 'fopacity'];
	
	    var Parallax = {
	
	        mixins: [Media],
	
	        props: props.reduce(function (props, prop) {
	            props[prop] = 'list';
	            return props;
	        }, {}),
	
	        data: props.reduce(function (data$$1, prop) {
	            data$$1[prop] = undefined;
	            return data$$1;
	        }, {}),
	
	        computed: {
	
	            props: function(properties, $el) {
	                var this$1 = this;
	
	
	                return props.reduce(function (props, prop) {
	
	                    if (isUndefined(properties[prop])) {
	                        return props;
	                    }
	
	                    var isColor = prop.match(/color/i);
	                    var isCssProp = isColor || prop === 'opacity';
	
	                    var pos, bgPos, diff;
	                    var steps = properties[prop].slice(0);
	
	                    if (isCssProp) {
	                        css($el, prop, '');
	                    }
	
	                    if (steps.length < 2) {
	                        steps.unshift((prop === 'scale'
	                            ? 1
	                            : isCssProp
	                                ? css($el, prop)
	                                : 0) || 0);
	                    }
	
	                    var unit = includes(steps.join(''), '%') ? '%' : 'px';
	
	                    if (isColor) {
	
	                        var ref = $el.style;
	                        var color = ref.color;
	                        steps = steps.map(function (step) { return parseColor($el, step); });
	                        $el.style.color = color;
	
	                    } else {
	
	                        steps = steps.map(toFloat);
	
	                    }
	
	                    if (prop.match(/^bg/)) {
	
	                        css($el, ("background-position-" + (prop[2])), '');
	                        bgPos = css($el, 'backgroundPosition').split(' ')[prop[2] === 'x' ? 0 : 1]; // IE 11 can't read background-position-[x|y]
	
	                        if (this$1.covers) {
	
	                            var min = Math.min.apply(Math, steps);
	                            var max = Math.max.apply(Math, steps);
	                            var down = steps.indexOf(min) < steps.indexOf(max);
	
	                            diff = max - min;
	
	                            steps = steps.map(function (step) { return step - (down ? min : max); });
	                            pos = (down ? -diff : 0) + "px";
	
	                        } else {
	
	                            pos = bgPos;
	
	                        }
	                    }
	
	                    props[prop] = {steps: steps, unit: unit, pos: pos, bgPos: bgPos, diff: diff};
	
	                    return props;
	
	                }, {});
	
	            },
	
	            bgProps: function() {
	                var this$1 = this;
	
	                return ['bgx', 'bgy'].filter(function (bg) { return bg in this$1.props; });
	            },
	
	            covers: function(_, $el) {
	                return covers($el);
	            }
	
	        },
	
	        disconnected: function() {
	            delete this._image;
	        },
	
	        update: {
	
	            read: function(data$$1) {
	                var this$1 = this;
	
	
	                data$$1.active = this.matchMedia;
	
	                if (!data$$1.active) {
	                    return;
	                }
	
	                if (!data$$1.image && this.covers && this.bgProps.length) {
	                    var src = css(this.$el, 'backgroundImage').replace(/^none|url\(["']?(.+?)["']?\)$/, '$1');
	
	                    if (src) {
	                        var img = new Image();
	                        img.src = src;
	                        data$$1.image = img;
	
	                        if (!img.naturalWidth) {
	                            img.onload = function () { return this$1.$emit(); };
	                        }
	                    }
	
	                }
	
	                var image = data$$1.image;
	
	                if (!image || !image.naturalWidth) {
	                    return;
	                }
	
	                var dimEl = {
	                    width: this.$el.offsetWidth,
	                    height: this.$el.offsetHeight
	                };
	                var dimImage = {
	                    width: image.naturalWidth,
	                    height: image.naturalHeight
	                };
	
	                var dim = Dimensions.cover(dimImage, dimEl);
	
	                this.bgProps.forEach(function (prop) {
	
	                    var ref = this$1.props[prop];
	                    var diff = ref.diff;
	                    var bgPos = ref.bgPos;
	                    var steps = ref.steps;
	                    var attr$$1 = prop === 'bgy' ? 'height' : 'width';
	                    var span = dim[attr$$1] - dimEl[attr$$1];
	
	                    if (!bgPos.match(/%$|0px/)) {
	                        return;
	                    }
	
	                    if (span < diff) {
	                        dimEl[attr$$1] = dim[attr$$1] + diff - span;
	                    } else if (span > diff) {
	
	                        var bgPosFloat = parseFloat(bgPos);
	
	                        if (bgPosFloat) {
	                            this$1.props[prop].steps = steps.map(function (step) { return step - (span - diff) / (100 / bgPosFloat); });
	                        }
	                    }
	
	                    dim = Dimensions.cover(dimImage, dimEl);
	                });
	
	                data$$1.dim = dim;
	            },
	
	            write: function(ref) {
	                var dim = ref.dim;
	                var active = ref.active;
	
	
	                if (!active) {
	                    css(this.$el, {backgroundSize: '', backgroundRepeat: ''});
	                    return;
	                }
	
	                dim && css(this.$el, {
	                    backgroundSize: ((dim.width) + "px " + (dim.height) + "px"),
	                    backgroundRepeat: 'no-repeat'
	                });
	
	            },
	
	            events: ['resize']
	
	        },
	
	        methods: {
	
	            reset: function() {
	                var this$1 = this;
	
	                each(this.getCss(0), function (_, prop) { return css(this$1.$el, prop, ''); });
	            },
	
	            getCss: function(percent) {
	
	                var ref = this;
	                var props = ref.props;
	                var translated = false;
	
	                return Object.keys(props).reduce(function (css$$1, prop) {
	
	                    var ref = props[prop];
	                    var steps = ref.steps;
	                    var unit = ref.unit;
	                    var pos = ref.pos;
	                    var value = getValue(steps, percent);
	
	                    switch (prop) {
	
	                        // transforms
	                        case 'x':
	                        case 'y': {
	
	                            if (translated) {
	                                break;
	                            }
	
	                            var ref$1 = ['x', 'y'].map(function (dir) { return prop === dir
	                                ? toFloat(value).toFixed(0) + unit
	                                : props[dir]
	                                    ? getValue(props[dir].steps, percent, 1) + props[dir].unit
	                                    : 0; }
	                            );
	                            var x = ref$1[0];
	                            var y = ref$1[1];
	
	                            translated = css$$1.transform += " translate3d(" + x + ", " + y + ", 0)";
	                            break;
	                        }
	                        case 'rotate':
	                            css$$1.transform += " rotate(" + value + "deg)";
	                            break;
	                        case 'scale':
	                            css$$1.transform += " scale(" + value + ")";
	                            break;
	
	                        // bg image
	                        case 'bgy':
	                        case 'bgx':
	                            css$$1[("background-position-" + (prop[2]))] = "calc(" + pos + " + " + (value + unit) + ")";
	                            break;
	
	                        // color
	                        case 'color':
	                        case 'backgroundColor':
	                        case 'borderColor': {
	
	                            var ref$2 = getStep(steps, percent);
	                            var start = ref$2[0];
	                            var end = ref$2[1];
	                            var p = ref$2[2];
	
	                            css$$1[prop] = "rgba(" + (start.map(function (value, i) {
	                                    value = value + p * (end[i] - value);
	                                    return i === 3 ? toFloat(value) : parseInt(value, 10);
	                                }).join(',')) + ")";
	                            break;
	                        }
	                        // CSS Filter
	                        case 'blur':
	                            css$$1.filter += " blur(" + value + "px)";
	                            break;
	                        case 'hue':
	                            css$$1.filter += " hue-rotate(" + value + "deg)";
	                            break;
	                        case 'fopacity':
	                            css$$1.filter += " opacity(" + value + "%)";
	                            break;
	                        case 'grayscale':
	                        case 'invert':
	                        case 'saturate':
	                        case 'sepia':
	                            css$$1.filter += " " + prop + "(" + value + "%)";
	                            break;
	
	                        default:
	                            css$$1[prop] = value;
	                    }
	
	                    return css$$1;
	
	                }, {transform: '', filter: ''});
	
	            }
	
	        }
	
	    };
	
	    function parseColor(el, color) {
	        return css(css(el, 'color', color), 'color').split(/[(),]/g).slice(1, -1).concat(1).slice(0, 4).map(function (n) { return toFloat(n); });
	    }
	
	    function getStep(steps, percent) {
	        var count = steps.length - 1;
	        var index$$1 = Math.min(Math.floor(count * percent), count - 1);
	        var step = steps.slice(index$$1, index$$1 + 2);
	
	        step.push(percent === 1 ? 1 : percent % (1 / count) * count);
	
	        return step;
	    }
	
	    function getValue(steps, percent, digits) {
	        if ( digits === void 0 ) digits = 2;
	
	        var ref = getStep(steps, percent);
	        var start = ref[0];
	        var end = ref[1];
	        var p = ref[2];
	        return (isNumber(start)
	                ? start + Math.abs(start - end) * p * (start < end ? 1 : -1)
	                : +end
	        ).toFixed(digits);
	    }
	
	    function covers(el) {
	        var ref = el.style;
	        var backgroundSize = ref.backgroundSize;
	        var covers = css(css(el, 'backgroundSize', ''), 'backgroundSize') === 'cover';
	        el.style.backgroundSize = backgroundSize;
	        return covers;
	    }
	
	    var Parallax$1 = {
	
	        mixins: [Parallax],
	
	        props: {
	            target: String,
	            viewport: Number,
	            easing: Number,
	        },
	
	        data: {
	            target: false,
	            viewport: 1,
	            easing: 1,
	        },
	
	        computed: {
	
	            target: function(ref, $el) {
	                var target = ref.target;
	
	                return getOffsetElement(target && query(target, $el) || $el);
	            }
	
	        },
	
	        update: {
	
	            read: function(ref, type) {
	                var percent = ref.percent;
	                var active = ref.active;
	
	
	                if (type !== 'scroll') {
	                    percent = false;
	                }
	
	                if (!active) {
	                    return;
	                }
	
	                var prev = percent;
	                percent = ease$1(scrolledOver(this.target) / (this.viewport || 1), this.easing);
	
	                return {
	                    percent: percent,
	                    style: prev !== percent ? this.getCss(percent) : false
	                };
	            },
	
	            write: function(ref) {
	                var style = ref.style;
	                var active = ref.active;
	
	
	                if (!active) {
	                    this.reset();
	                    return;
	                }
	
	                style && css(this.$el, style);
	
	            },
	
	            events: ['scroll', 'resize']
	        }
	
	    };
	
	    function ease$1(percent, easing) {
	        return clamp(percent * (1 - (easing - easing * percent)));
	    }
	
	    // SVG elements do not inherit from HTMLElement
	    function getOffsetElement(el) {
	        return el
	            ? 'offsetTop' in el
	                ? el
	                : getOffsetElement(el.parentNode)
	            : document.body;
	    }
	
	    var SliderReactive = {
	
	        update: {
	
	            write: function() {
	
	                if (this.stack.length || this.dragging) {
	                    return;
	                }
	
	                var index$$1 = this.getValidIndex();
	                delete this.index;
	                removeClass(this.slides, this.clsActive, this.clsActivated);
	                this.show(index$$1);
	
	            },
	
	            events: ['resize']
	
	        }
	
	    };
	
	    function Transitioner$1 (prev, next, dir, ref) {
	        var center = ref.center;
	        var easing = ref.easing;
	        var list = ref.list;
	
	
	        var deferred = new Deferred();
	
	        var from = prev
	            ? getLeft(prev, list, center)
	            : getLeft(next, list, center) + bounds(next).width * dir;
	        var to = next
	            ? getLeft(next, list, center)
	            : from + bounds(prev).width * dir * (isRtl ? -1 : 1);
	
	        return {
	
	            dir: dir,
	
	            show: function(duration, percent, linear) {
	                if ( percent === void 0 ) percent = 0;
	
	
	                var timing = linear ? 'linear' : easing;
	                duration -= Math.round(duration * clamp(percent, -1, 1));
	
	                this.translate(percent);
	
	                prev && this.updateTranslates();
	                percent = prev ? percent : clamp(percent, 0, 1);
	                triggerUpdate$1(this.getItemIn(), 'itemin', {percent: percent, duration: duration, timing: timing, dir: dir});
	                prev && triggerUpdate$1(this.getItemIn(true), 'itemout', {percent: 1 - percent, duration: duration, timing: timing, dir: dir});
	
	                Transition
	                    .start(list, {transform: translate(-to * (isRtl ? -1 : 1), 'px')}, duration, timing)
	                    .then(deferred.resolve, noop);
	
	                return deferred.promise;
	
	            },
	
	            stop: function() {
	                return Transition.stop(list);
	            },
	
	            cancel: function() {
	                Transition.cancel(list);
	            },
	
	            reset: function() {
	                css(list, 'transform', '');
	            },
	
	            forward: function(duration, percent) {
	                if ( percent === void 0 ) percent = this.percent();
	
	                Transition.cancel(list);
	                return this.show(duration, percent, true);
	            },
	
	            translate: function(percent) {
	
	                var distance = this.getDistance() * dir * (isRtl ? -1 : 1);
	
	                css(list, 'transform', translate(clamp(
	                    -to + (distance - distance * percent),
	                    -getWidth(list),
	                    bounds(list).width
	                ) * (isRtl ? -1 : 1), 'px'));
	
	                this.updateTranslates();
	
	                if (prev) {
	                    percent = clamp(percent, -1, 1);
	                    triggerUpdate$1(this.getItemIn(), 'itemtranslatein', {percent: percent, dir: dir});
	                    triggerUpdate$1(this.getItemIn(true), 'itemtranslateout', {percent: 1 - percent, dir: dir});
	                }
	
	            },
	
	            percent: function() {
	                return Math.abs((css(list, 'transform').split(',')[4] * (isRtl ? -1 : 1) + from) / (to - from));
	            },
	
	            getDistance: function() {
	                return Math.abs(to - from);
	            },
	
	            getItemIn: function(out) {
	                if ( out === void 0 ) out = false;
	
	
	                var actives = this.getActives();
	                var all = sortBy(slides(list), 'offsetLeft');
	                var i = index(all, actives[dir * (out ? -1 : 1) > 0 ? actives.length - 1 : 0]);
	
	                return ~i && all[i + (prev && !out ? dir : 0)];
	
	            },
	
	            getActives: function() {
	
	                var left = getLeft(prev || next, list, center);
	
	                return sortBy(slides(list).filter(function (slide) {
	                    var slideLeft = getElLeft(slide, list);
	                    return slideLeft >= left && slideLeft + bounds(slide).width <= bounds(list).width + left;
	                }), 'offsetLeft');
	
	            },
	
	            updateTranslates: function() {
	
	                var actives = this.getActives();
	
	                slides(list).forEach(function (slide) {
	                    var isActive = includes(actives, slide);
	
	                    triggerUpdate$1(slide, ("itemtranslate" + (isActive ? 'in' : 'out')), {
	                        percent: isActive ? 1 : 0,
	                        dir: slide.offsetLeft <= next.offsetLeft ? 1 : -1
	                    });
	                });
	            }
	
	        };
	
	    }
	
	    function getLeft(el, list, center) {
	
	        var left = getElLeft(el, list);
	
	        return center
	            ? left - centerEl(el, list)
	            : Math.min(left, getMax(list));
	
	    }
	
	    function getMax(list) {
	        return Math.max(0, getWidth(list) - bounds(list).width);
	    }
	
	    function getWidth(list) {
	        return slides(list).reduce(function (right, el) { return bounds(el).width + right; }, 0);
	    }
	
	    function getMaxWidth(list) {
	        return slides(list).reduce(function (right, el) { return Math.max(right, bounds(el).width); }, 0);
	    }
	
	    function centerEl(el, list) {
	        return bounds(list).width / 2 - bounds(el).width / 2;
	    }
	
	    function getElLeft(el, list) {
	        return (position(el).left + (isRtl ? bounds(el).width - bounds(list).width : 0)) * (isRtl ? -1 : 1);
	    }
	
	    function bounds(el) {
	        return el.getBoundingClientRect();
	    }
	
	    function triggerUpdate$1(el, type, data$$1) {
	        trigger(el, createEvent(type, false, false, data$$1));
	    }
	
	    function slides(list) {
	        return toNodes(list.children);
	    }
	
	    var Slider$1 = {
	
	        mixins: [Class, Slider, SliderReactive],
	
	        props: {
	            center: Boolean,
	            sets: Boolean,
	        },
	
	        data: {
	            center: false,
	            sets: false,
	            attrItem: 'uk-slider-item',
	            selList: '.uk-slider-items',
	            selNav: '.uk-slider-nav',
	            clsContainer: 'uk-slider-container',
	            Transitioner: Transitioner$1
	        },
	
	        computed: {
	
	            avgWidth: function() {
	                return getWidth(this.list) / this.length;
	            },
	
	            finite: function(ref) {
	                var finite = ref.finite;
	
	                return finite || getWidth(this.list) < bounds(this.list).width + getMaxWidth(this.list) + this.center;
	            },
	
	            maxIndex: function() {
	
	                if (!this.finite || this.center && !this.sets) {
	                    return this.length - 1;
	                }
	
	                if (this.center) {
	                    return this.sets[this.sets.length - 1];
	                }
	
	                css(this.slides, 'order', '');
	
	                var max = getMax(this.list);
	                var i = this.length;
	
	                while (i--) {
	                    if (getElLeft(this.list.children[i], this.list) < max) {
	                        return Math.min(i + 1, this.length - 1);
	                    }
	                }
	
	                return 0;
	            },
	
	            sets: function(ref) {
	                var this$1 = this;
	                var sets = ref.sets;
	
	
	                var width$$1 = bounds(this.list).width / (this.center ? 2 : 1);
	
	                var left = 0;
	                var leftCenter = width$$1;
	                var slideLeft = 0;
	
	                sets = sets && this.slides.reduce(function (sets, slide, i) {
	
	                    var ref = bounds(slide);
	                    var slideWidth = ref.width;
	                    var slideRight = slideLeft + slideWidth;
	
	                    if (slideRight > left) {
	
	                        if (!this$1.center && i > this$1.maxIndex) {
	                            i = this$1.maxIndex;
	                        }
	
	                        if (!includes(sets, i)) {
	
	                            var cmp = this$1.slides[i + 1];
	                            if (this$1.center && cmp && slideWidth < leftCenter - bounds(cmp).width / 2) {
	                                leftCenter -= slideWidth;
	                            } else {
	                                leftCenter = width$$1;
	                                sets.push(i);
	                                left = slideLeft + width$$1 + (this$1.center ? slideWidth / 2 : 0);
	                            }
	
	                        }
	                    }
	
	                    slideLeft += slideWidth;
	
	                    return sets;
	
	                }, []);
	
	                return sets && sets.length && sets;
	
	            },
	
	            transitionOptions: function() {
	                return {
	                    center: this.center,
	                    list: this.list
	                };
	            }
	
	        },
	
	        connected: function() {
	            toggleClass(this.$el, this.clsContainer, !$(("." + (this.clsContainer)), this.$el));
	        },
	
	        update: {
	
	            write: function() {
	                var this$1 = this;
	
	
	                $$(("[" + (this.attrItem) + "],[data-" + (this.attrItem) + "]"), this.$el).forEach(function (el) {
	                    var index$$1 = data(el, this$1.attrItem);
	                    this$1.maxIndex && toggleClass(el, 'uk-hidden', isNumeric(index$$1) && (this$1.sets && !includes(this$1.sets, toFloat(index$$1)) || index$$1 > this$1.maxIndex));
	                });
	
	            },
	
	            events: ['resize']
	
	        },
	
	        events: {
	
	            beforeitemshow: function(e) {
	
	                if (!this.dragging && this.sets && this.stack.length < 2 && !includes(this.sets, this.index)) {
	                    this.index = this.getValidIndex();
	                }
	
	                var diff = Math.abs(
	                    this.index
	                    - this.prevIndex
	                    + (this.dir > 0 && this.index < this.prevIndex || this.dir < 0 && this.index > this.prevIndex ? (this.maxIndex + 1) * this.dir : 0)
	                );
	
	                if (!this.dragging && diff > 1) {
	
	                    for (var i = 0; i < diff; i++) {
	                        this.stack.splice(1, 0, this.dir > 0 ? 'next' : 'previous');
	                    }
	
	                    e.preventDefault();
	                    return;
	                }
	
	                this.duration = speedUp(this.avgWidth / this.velocity)
	                    * (bounds(
	                        this.dir < 0 || !this.slides[this.prevIndex]
	                            ? this.slides[this.index]
	                            : this.slides[this.prevIndex]
	                    ).width / this.avgWidth);
	
	                this.reorder();
	
	            },
	
	            itemshow: function() {
	                !isUndefined(this.prevIndex) && addClass(this._getTransitioner().getItemIn(), this.clsActive);
	            },
	
	            itemshown: function() {
	                var this$1 = this;
	
	                var actives = this._getTransitioner(this.index).getActives();
	                this.slides.forEach(function (slide) { return toggleClass(slide, this$1.clsActive, includes(actives, slide)); });
	                (!this.sets || includes(this.sets, toFloat(this.index))) && this.slides.forEach(function (slide) { return toggleClass(slide, this$1.clsActivated, includes(actives, slide)); });
	            }
	
	        },
	
	        methods: {
	
	            reorder: function() {
	                var this$1 = this;
	
	
	                css(this.slides, 'order', '');
	
	                if (this.finite) {
	                    return;
	                }
	
	                var index$$1 = this.dir > 0 && this.slides[this.prevIndex] ? this.prevIndex : this.index;
	
	                this.slides.forEach(function (slide, i) { return css(slide, 'order', this$1.dir > 0 && i < index$$1
	                        ? 1
	                        : this$1.dir < 0 && i >= this$1.index
	                            ? -1
	                            : ''
	                    ); }
	                );
	
	                if (!this.center) {
	                    return;
	                }
	
	                var next = this.slides[index$$1];
	                var width$$1 = bounds(this.list).width / 2 - bounds(next).width / 2;
	                var j = 0;
	
	                while (width$$1 > 0) {
	                    var slideIndex = this.getIndex(--j + index$$1, index$$1);
	                    var slide = this.slides[slideIndex];
	
	                    css(slide, 'order', slideIndex > index$$1 ? -2 : -1);
	                    width$$1 -= bounds(slide).width;
	                }
	
	            },
	
	            getValidIndex: function(index$$1, prevIndex) {
	                if ( index$$1 === void 0 ) index$$1 = this.index;
	                if ( prevIndex === void 0 ) prevIndex = this.prevIndex;
	
	
	                index$$1 = this.getIndex(index$$1, prevIndex);
	
	                if (!this.sets) {
	                    return index$$1;
	                }
	
	                var prev;
	
	                do {
	
	                    if (includes(this.sets, index$$1)) {
	                        return index$$1;
	                    }
	
	                    prev = index$$1;
	                    index$$1 = this.getIndex(index$$1 + this.dir, prevIndex);
	
	                } while (index$$1 !== prev);
	
	                return index$$1;
	            }
	
	        }
	
	    };
	
	    var SliderParallax = {
	
	        mixins: [Parallax],
	
	        data: {
	            selItem: '!li'
	        },
	
	        computed: {
	
	            item: function(ref, $el) {
	                var selItem = ref.selItem;
	
	                return query(selItem, $el);
	            }
	
	        },
	
	        events: [
	
	            {
	
	                name: 'itemshown',
	
	                self: true,
	
	                el: function() {
	                    return this.item;
	                },
	
	                handler: function() {
	                    css(this.$el, this.getCss(.5));
	                }
	
	            },
	
	            {
	                name: 'itemin itemout',
	
	                self: true,
	
	                el: function() {
	                    return this.item;
	                },
	
	                handler: function(ref) {
	                    var type = ref.type;
	                    var ref_detail = ref.detail;
	                    var percent = ref_detail.percent;
	                    var duration = ref_detail.duration;
	                    var timing = ref_detail.timing;
	                    var dir = ref_detail.dir;
	
	
	                    Transition.cancel(this.$el);
	                    css(this.$el, this.getCss(getCurrent(type, dir, percent)));
	
	                    Transition.start(this.$el, this.getCss(isIn(type)
	                        ? .5
	                        : dir > 0
	                            ? 1
	                            : 0
	                    ), duration, timing).catch(noop);
	
	                }
	            },
	
	            {
	                name: 'transitioncanceled transitionend',
	
	                self: true,
	
	                el: function() {
	                    return this.item;
	                },
	
	                handler: function() {
	                    Transition.cancel(this.$el);
	                }
	
	            },
	
	            {
	                name: 'itemtranslatein itemtranslateout',
	
	                self: true,
	
	                el: function() {
	                    return this.item;
	                },
	
	                handler: function(ref) {
	                    var type = ref.type;
	                    var ref_detail = ref.detail;
	                    var percent = ref_detail.percent;
	                    var dir = ref_detail.dir;
	
	                    Transition.cancel(this.$el);
	                    css(this.$el, this.getCss(getCurrent(type, dir, percent)));
	                }
	            }
	
	        ]
	
	    };
	
	    function isIn(type) {
	        return endsWith(type, 'in');
	    }
	
	    function getCurrent(type, dir, percent) {
	
	        percent /= 2;
	
	        return !isIn(type)
	            ? dir < 0
	                ? percent
	                : 1 - percent
	            : dir < 0
	                ? 1 - percent
	                : percent;
	    }
	
	    var Animations$2 = assign({}, Animations, {
	
	        fade: {
	
	            show: function() {
	                return [
	                    {opacity: 0, zIndex: 0},
	                    {zIndex: -1}
	                ];
	            },
	
	            percent: function(current) {
	                return 1 - css(current, 'opacity');
	            },
	
	            translate: function(percent) {
	                return [
	                    {opacity: 1 - percent, zIndex: 0},
	                    {zIndex: -1}
	                ];
	            }
	
	        },
	
	        scale: {
	
	            show: function() {
	                return [
	                    {opacity: 0, transform: scale3d(1 + .5), zIndex: 0},
	                    {zIndex: -1}
	                ];
	            },
	
	            percent: function(current) {
	                return 1 - css(current, 'opacity');
	            },
	
	            translate: function(percent) {
	                return [
	                    {opacity: 1 - percent, transform: scale3d(1 + .5 * percent), zIndex: 0},
	                    {zIndex: -1}
	                ];
	            }
	
	        },
	
	        pull: {
	
	            show: function(dir) {
	                return dir < 0
	                    ? [
	                        {transform: translate(30), zIndex: -1},
	                        {transform: translate(), zIndex: 0} ]
	                    : [
	                        {transform: translate(-100), zIndex: 0},
	                        {transform: translate(), zIndex: -1}
	                    ];
	            },
	
	            percent: function(current, next, dir) {
	                return dir < 0
	                    ? 1 - translated(next)
	                    : translated(current);
	            },
	
	            translate: function(percent, dir) {
	                return dir < 0
	                    ? [
	                        {transform: translate(30 * percent), zIndex: -1},
	                        {transform: translate(-100 * (1 - percent)), zIndex: 0} ]
	                    : [
	                        {transform: translate(-percent * 100), zIndex: 0},
	                        {transform: translate(30 * (1 - percent)), zIndex: -1}
	                    ];
	            }
	
	        },
	
	        push: {
	
	            show: function(dir) {
	                return dir < 0
	                    ? [
	                        {transform: translate(100), zIndex: 0},
	                        {transform: translate(), zIndex: -1} ]
	                    : [
	                        {transform: translate(-30), zIndex: -1},
	                        {transform: translate(), zIndex: 0}
	                    ];
	            },
	
	            percent: function(current, next, dir) {
	                return dir > 0
	                    ? 1 - translated(next)
	                    : translated(current);
	            },
	
	            translate: function(percent, dir) {
	                return dir < 0
	                    ? [
	                        {transform: translate(percent * 100), zIndex: 0},
	                        {transform: translate(-30 * (1 - percent)), zIndex: -1} ]
	                    : [
	                        {transform: translate(-30 * percent), zIndex: -1},
	                        {transform: translate(100 * (1 - percent)), zIndex: 0}
	                    ];
	            }
	
	        }
	
	    });
	
	    var Slideshow$1 = {
	
	        mixins: [Class, Slideshow, SliderReactive],
	
	        props: {
	            ratio: String,
	            minHeight: Boolean,
	            maxHeight: Boolean,
	        },
	
	        data: {
	            ratio: '16:9',
	            minHeight: false,
	            maxHeight: false,
	            selList: '.uk-slideshow-items',
	            attrItem: 'uk-slideshow-item',
	            selNav: '.uk-slideshow-nav',
	            Animations: Animations$2
	        },
	
	        update: {
	
	            read: function() {
	
	                var ref = this.ratio.split(':').map(Number);
	                var width$$1 = ref[0];
	                var height$$1 = ref[1];
	
	                height$$1 = height$$1 * this.list.offsetWidth / width$$1;
	
	                if (this.minHeight) {
	                    height$$1 = Math.max(this.minHeight, height$$1);
	                }
	
	                if (this.maxHeight) {
	                    height$$1 = Math.min(this.maxHeight, height$$1);
	                }
	
	                return {height: height$$1 - boxModelAdjust(this.list, 'content-box')};
	            },
	
	            write: function(ref) {
	                var height$$1 = ref.height;
	
	                css(this.list, 'minHeight', height$$1);
	            },
	
	            events: ['resize']
	
	        }
	
	    };
	
	    var Sortable = {
	
	        mixins: [Class, Animate],
	
	        props: {
	            group: String,
	            threshold: Number,
	            clsItem: String,
	            clsPlaceholder: String,
	            clsDrag: String,
	            clsDragState: String,
	            clsBase: String,
	            clsNoDrag: String,
	            clsEmpty: String,
	            clsCustom: String,
	            handle: String
	        },
	
	        data: {
	            group: false,
	            threshold: 5,
	            clsItem: 'uk-sortable-item',
	            clsPlaceholder: 'uk-sortable-placeholder',
	            clsDrag: 'uk-sortable-drag',
	            clsDragState: 'uk-drag',
	            clsBase: 'uk-sortable',
	            clsNoDrag: 'uk-sortable-nodrag',
	            clsEmpty: 'uk-sortable-empty',
	            clsCustom: '',
	            handle: false
	        },
	
	        created: function() {
	            var this$1 = this;
	
	            ['init', 'start', 'move', 'end'].forEach(function (key) {
	                var fn = this$1[key];
	                this$1[key] = function (e) {
	                    this$1.scrollY = window.pageYOffset;
	                    var ref = getPos$1(e, 'page');
	                    var x = ref.x;
	                    var y = ref.y;
	                    this$1.pos = {x: x, y: y};
	
	                    fn(e);
	                };
	            });
	        },
	
	        events: {
	
	            name: pointerDown,
	            passive: false,
	            handler: 'init'
	
	        },
	
	        update: {
	
	            write: function() {
	
	                if (this.clsEmpty) {
	                    toggleClass(this.$el, this.clsEmpty, !this.$el.children.length);
	                }
	
	                css(this.handle ? $$(this.handle, this.$el) : this.$el.children, 'touchAction', 'none');
	
	                if (!this.drag) {
	                    return;
	                }
	
	                offset(this.drag, {top: this.pos.y + this.origin.top, left: this.pos.x + this.origin.left});
	
	                var ref = offset(this.drag);
	                var top = ref.top;
	                var offsetHeight = ref.height;
	                var bottom = top + offsetHeight;
	                var scroll;
	
	                if (top > 0 && top < this.scrollY) {
	                    scroll = this.scrollY - 5;
	                } else if (bottom < height(document) && bottom > height(window) + this.scrollY) {
	                    scroll = this.scrollY + 5;
	                }
	
	                scroll && setTimeout(function () { return scrollTop(window, scroll); }, 5);
	            }
	
	        },
	
	        methods: {
	
	            init: function(e) {
	
	                var target = e.target;
	                var button = e.button;
	                var defaultPrevented = e.defaultPrevented;
	                var ref = toNodes(this.$el.children).filter(function (el) { return within(target, el); });
	                var placeholder = ref[0];
	
	                if (!placeholder
	                    || isInput(target)
	                    || this.handle && !within(target, this.handle)
	                    || button > 0
	                    || within(target, ("." + (this.clsNoDrag)))
	                    || defaultPrevented
	                ) {
	                    return;
	                }
	
	                e.preventDefault();
	
	                this.touched = [this];
	                this.placeholder = placeholder;
	                this.origin = assign({target: target, index: index(placeholder)}, this.pos);
	
	                on(document, pointerMove, this.move);
	                on(document, pointerUp, this.end);
	                on(window, 'scroll', this.scroll);
	
	                if (!this.threshold) {
	                    this.start(e);
	                }
	
	            },
	
	            start: function(e) {
	
	                this.drag = append(this.$container, this.placeholder.outerHTML.replace(/^<li/i, '<div').replace(/li>$/i, 'div>'));
	
	                css(this.drag, assign({
	                    boxSizing: 'border-box',
	                    width: this.placeholder.offsetWidth,
	                    height: this.placeholder.offsetHeight
	                }, css(this.placeholder, ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom'])));
	                attr(this.drag, 'uk-no-boot', '');
	                addClass(this.drag, this.clsDrag, this.clsCustom);
	
	                height(this.drag.firstElementChild, height(this.placeholder.firstElementChild));
	
	                var ref = offset(this.placeholder);
	                var left = ref.left;
	                var top = ref.top;
	                assign(this.origin, {left: left - this.pos.x, top: top - this.pos.y});
	
	                addClass(this.placeholder, this.clsPlaceholder);
	                addClass(this.$el.children, this.clsItem);
	                addClass(document.documentElement, this.clsDragState);
	
	                trigger(this.$el, 'start', [this, this.placeholder]);
	
	                this.move(e);
	            },
	
	            move: function(e) {
	
	                if (!this.drag) {
	
	                    if (Math.abs(this.pos.x - this.origin.x) > this.threshold || Math.abs(this.pos.y - this.origin.y) > this.threshold) {
	                        this.start(e);
	                    }
	
	                    return;
	                }
	
	                this.$emit();
	
	                var target = e.type === 'mousemove' ? e.target : document.elementFromPoint(this.pos.x - window.pageXOffset, this.pos.y - window.pageYOffset);
	
	                var sortable = this.getSortable(target);
	                var previous = this.getSortable(this.placeholder);
	                var move = sortable !== previous;
	
	                if (!sortable || within(target, this.placeholder) || move && (!sortable.group || sortable.group !== previous.group)) {
	                    return;
	                }
	
	                target = sortable.$el === target.parentNode && target || toNodes(sortable.$el.children).filter(function (element) { return within(target, element); })[0];
	
	                if (move) {
	                    previous.remove(this.placeholder);
	                } else if (!target) {
	                    return;
	                }
	
	                sortable.insert(this.placeholder, target);
	
	                if (!includes(this.touched, sortable)) {
	                    this.touched.push(sortable);
	                }
	
	            },
	
	            end: function(e) {
	
	                off(document, pointerMove, this.move);
	                off(document, pointerUp, this.end);
	                off(window, 'scroll', this.scroll);
	
	                if (!this.drag) {
	                    if (e.type === 'touchend') {
	                        e.target.click();
	                    }
	
	                    return;
	                }
	
	                preventClick();
	
	                var sortable = this.getSortable(this.placeholder);
	
	                if (this === sortable) {
	                    if (this.origin.index !== index(this.placeholder)) {
	                        trigger(this.$el, 'moved', [this, this.placeholder]);
	                    }
	                } else {
	                    trigger(sortable.$el, 'added', [sortable, this.placeholder]);
	                    trigger(this.$el, 'removed', [this, this.placeholder]);
	                }
	
	                trigger(this.$el, 'stop', [this, this.placeholder]);
	
	                remove(this.drag);
	                this.drag = null;
	
	                var classes = this.touched.map(function (sortable) { return ((sortable.clsPlaceholder) + " " + (sortable.clsItem)); }).join(' ');
	                this.touched.forEach(function (sortable) { return removeClass(sortable.$el.children, classes); });
	
	                removeClass(document.documentElement, this.clsDragState);
	
	            },
	
	            scroll: function() {
	                var scroll = window.pageYOffset;
	                if (scroll !== this.scrollY) {
	                    this.pos.y += scroll - this.scrollY;
	                    this.scrollY = scroll;
	                    this.$emit();
	                }
	            },
	
	            insert: function(element, target) {
	                var this$1 = this;
	
	
	                addClass(this.$el.children, this.clsItem);
	
	                var insert = function () {
	
	                    if (target) {
	
	                        if (!within(element, this$1.$el) || isPredecessor(element, target)) {
	                            before(target, element);
	                        } else {
	                            after(target, element);
	                        }
	
	                    } else {
	                        append(this$1.$el, element);
	                    }
	
	                };
	
	                if (this.animation) {
	                    this.animate(insert);
	                } else {
	                    insert();
	                }
	
	            },
	
	            remove: function(element) {
	
	                if (!within(element, this.$el)) {
	                    return;
	                }
	
	                if (this.animation) {
	                    this.animate(function () { return remove(element); });
	                } else {
	                    remove(element);
	                }
	
	            },
	
	            getSortable: function(element) {
	                return element && (this.$getComponent(element, 'sortable') || this.getSortable(element.parentNode));
	            }
	
	        }
	
	    };
	
	    function isPredecessor(element, target) {
	        return element.parentNode === target.parentNode && index(element) > index(target);
	    }
	
	    var obj$1;
	
	    var actives = [];
	
	    var Tooltip = {
	
	        mixins: [Container, Togglable, Position],
	
	        args: 'title',
	
	        props: {
	            delay: Number,
	            title: String
	        },
	
	        data: {
	            pos: 'top',
	            title: '',
	            delay: 0,
	            animation: ['uk-animation-scale-up'],
	            duration: 100,
	            cls: 'uk-active',
	            clsPos: 'uk-tooltip'
	        },
	
	        beforeConnect: function() {
	            this._hasTitle = hasAttr(this.$el, 'title');
	            attr(this.$el, {title: '', 'aria-expanded': false});
	        },
	
	        disconnected: function() {
	            this.hide();
	            attr(this.$el, {title: this._hasTitle ? this.title : null, 'aria-expanded': null});
	        },
	
	        methods: {
	
	            show: function() {
	                var this$1 = this;
	
	
	                if (includes(actives, this)) {
	                    return;
	                }
	
	                actives.forEach(function (active) { return active.hide(); });
	                actives.push(this);
	
	                this._unbind = on(document, pointerUp, function (e) { return !within(e.target, this$1.$el) && this$1.hide(); });
	
	                clearTimeout(this.showTimer);
	                this.showTimer = setTimeout(function () {
	                    this$1._show();
	                    this$1.hideTimer = setInterval(function () {
	
	                        if (!isVisible(this$1.$el)) {
	                            this$1.hide();
	                        }
	
	                    }, 150);
	                }, this.delay);
	            },
	
	            hide: function() {
	
	                var index$$1 = actives.indexOf(this);
	
	                if (!~index$$1 || matches(this.$el, 'input') && this.$el === document.activeElement) {
	                    return;
	                }
	
	                actives.splice(index$$1, 1);
	
	                clearTimeout(this.showTimer);
	                clearInterval(this.hideTimer);
	                attr(this.$el, 'aria-expanded', false);
	                this.toggleElement(this.tooltip, false);
	                this.tooltip && remove(this.tooltip);
	                this.tooltip = false;
	                this._unbind();
	
	            },
	
	            _show: function() {
	
	                this.tooltip = append(this.container,
	                    ("<div class=\"" + (this.clsPos) + "\" aria-expanded=\"true\" aria-hidden> <div class=\"" + (this.clsPos) + "-inner\">" + (this.title) + "</div> </div>")
	                );
	
	                this.positionAt(this.tooltip, this.$el);
	
	                this.origin = this.getAxis() === 'y'
	                    ? ((flipPosition(this.dir)) + "-" + (this.align))
	                    : ((this.align) + "-" + (flipPosition(this.dir)));
	
	                this.toggleElement(this.tooltip, true);
	
	            }
	
	        },
	
	        events: ( obj$1 = {}, obj$1[("focus " + pointerEnter + " " + pointerDown)] = function (e) {
	                if (e.type !== pointerDown || !isTouch(e)) {
	                    this.show();
	                }
	            }, obj$1.blur = 'hide', obj$1[pointerLeave] = function (e) {
	                if (!isTouch(e)) {
	                    this.hide();
	                }
	            }, obj$1 )
	
	    };
	
	    var Upload = {
	
	        props: {
	            allow: String,
	            clsDragover: String,
	            concurrent: Number,
	            maxSize: Number,
	            method: String,
	            mime: String,
	            msgInvalidMime: String,
	            msgInvalidName: String,
	            msgInvalidSize: String,
	            multiple: Boolean,
	            name: String,
	            params: Object,
	            type: String,
	            url: String,
	        },
	
	        data: {
	            allow: false,
	            clsDragover: 'uk-dragover',
	            concurrent: 1,
	            maxSize: 0,
	            method: 'POST',
	            mime: false,
	            msgInvalidMime: 'Invalid File Type: %s',
	            msgInvalidName: 'Invalid File Name: %s',
	            msgInvalidSize: 'Invalid File Size: %s Kilobytes Max',
	            multiple: false,
	            name: 'files[]',
	            params: {},
	            type: '',
	            url: '',
	            abort: noop,
	            beforeAll: noop,
	            beforeSend: noop,
	            complete: noop,
	            completeAll: noop,
	            error: noop,
	            fail: noop,
	            load: noop,
	            loadEnd: noop,
	            loadStart: noop,
	            progress: noop
	        },
	
	        events: {
	
	            change: function(e) {
	
	                if (!matches(e.target, 'input[type="file"]')) {
	                    return;
	                }
	
	                e.preventDefault();
	
	                if (e.target.files) {
	                    this.upload(e.target.files);
	                }
	
	                e.target.value = '';
	            },
	
	            drop: function(e) {
	                stop(e);
	
	                var transfer = e.dataTransfer;
	
	                if (!transfer || !transfer.files) {
	                    return;
	                }
	
	                removeClass(this.$el, this.clsDragover);
	
	                this.upload(transfer.files);
	            },
	
	            dragenter: function(e) {
	                stop(e);
	            },
	
	            dragover: function(e) {
	                stop(e);
	                addClass(this.$el, this.clsDragover);
	            },
	
	            dragleave: function(e) {
	                stop(e);
	                removeClass(this.$el, this.clsDragover);
	            }
	
	        },
	
	        methods: {
	
	            upload: function(files) {
	                var this$1 = this;
	
	
	                if (!files.length) {
	                    return;
	                }
	
	                trigger(this.$el, 'upload', [files]);
	
	                for (var i = 0; i < files.length; i++) {
	
	                    if (this.maxSize && this.maxSize * 1000 < files[i].size) {
	                        this.fail(this.msgInvalidSize.replace('%s', this.maxSize));
	                        return;
	                    }
	
	                    if (this.allow && !match$1(this.allow, files[i].name)) {
	                        this.fail(this.msgInvalidName.replace('%s', this.allow));
	                        return;
	                    }
	
	                    if (this.mime && !match$1(this.mime, files[i].type)) {
	                        this.fail(this.msgInvalidMime.replace('%s', this.mime));
	                        return;
	                    }
	
	                }
	
	                if (!this.multiple) {
	                    files = [files[0]];
	                }
	
	                this.beforeAll(this, files);
	
	                var chunks = chunk(files, this.concurrent);
	                var upload = function (files) {
	
	                    var data$$1 = new FormData();
	
	                    files.forEach(function (file) { return data$$1.append(this$1.name, file); });
	
	                    for (var key in this$1.params) {
	                        data$$1.append(key, this$1.params[key]);
	                    }
	
	                    ajax(this$1.url, {
	                        data: data$$1,
	                        method: this$1.method,
	                        responseType: this$1.type,
	                        beforeSend: function (env) {
	
	                            var xhr = env.xhr;
	                            xhr.upload && on(xhr.upload, 'progress', this$1.progress);
	                            ['loadStart', 'load', 'loadEnd', 'abort'].forEach(function (type) { return on(xhr, type.toLowerCase(), this$1[type]); }
	                            );
	
	                            this$1.beforeSend(env);
	
	                        }
	                    }).then(
	                        function (xhr) {
	
	                            this$1.complete(xhr);
	
	                            if (chunks.length) {
	                                upload(chunks.shift());
	                            } else {
	                                this$1.completeAll(xhr);
	                            }
	
	                        },
	                        function (e) { return this$1.error(e); }
	                    );
	
	                };
	
	                upload(chunks.shift());
	
	            }
	
	        }
	
	    };
	
	    function match$1(pattern, path) {
	        return path.match(new RegExp(("^" + (pattern.replace(/\//g, '\\/').replace(/\*\*/g, '(\\/[^\\/]+)*').replace(/\*/g, '[^\\/]+').replace(/((?!\\))\?/g, '$1.')) + "$"), 'i'));
	    }
	
	    function chunk(files, size) {
	        var chunks = [];
	        for (var i = 0; i < files.length; i += size) {
	            var chunk = [];
	            for (var j = 0; j < size; j++) {
	                chunk.push(files[i + j]);
	            }
	            chunks.push(chunk);
	        }
	        return chunks;
	    }
	
	    function stop(e) {
	        e.preventDefault();
	        e.stopPropagation();
	    }
	
	    UIkit.component('countdown', Countdown);
	    UIkit.component('filter', Filter);
	    UIkit.component('lightbox', Lightbox);
	    UIkit.component('lightboxPanel', LightboxPanel);
	    UIkit.component('notification', Notification);
	    UIkit.component('parallax', Parallax$1);
	    UIkit.component('slider', Slider$1);
	    UIkit.component('sliderParallax', SliderParallax);
	    UIkit.component('slideshow', Slideshow$1);
	    UIkit.component('slideshowParallax', SliderParallax);
	    UIkit.component('sortable', Sortable);
	    UIkit.component('tooltip', Tooltip);
	    UIkit.component('upload', Upload);
	
	    {
	        boot(UIkit);
	    }
	
	    return UIkit;
	
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(221).setImmediate))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/anonymus.0d3aba00.jpg";

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(132);
	} else {
	  module.exports = require('./formik.cjs.development.js');
	}

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = Point;
	
	/**
	 * A standalone point geometry with useful accessor, comparison, and
	 * modification methods.
	 *
	 * @class Point
	 * @param {Number} x the x-coordinate. this could be longitude or screen
	 * pixels, or any other sort of unit.
	 * @param {Number} y the y-coordinate. this could be latitude or screen
	 * pixels, or any other sort of unit.
	 * @example
	 * var point = new Point(-77, 38);
	 */
	function Point(x, y) {
	    this.x = x;
	    this.y = y;
	}
	
	Point.prototype = {
	
	    /**
	     * Clone this point, returning a new point that can be modified
	     * without affecting the old one.
	     * @return {Point} the clone
	     */
	    clone: function() { return new Point(this.x, this.y); },
	
	    /**
	     * Add this point's x & y coordinates to another point,
	     * yielding a new point.
	     * @param {Point} p the other point
	     * @return {Point} output point
	     */
	    add:     function(p) { return this.clone()._add(p); },
	
	    /**
	     * Subtract this point's x & y coordinates to from point,
	     * yielding a new point.
	     * @param {Point} p the other point
	     * @return {Point} output point
	     */
	    sub:     function(p) { return this.clone()._sub(p); },
	
	    /**
	     * Multiply this point's x & y coordinates by point,
	     * yielding a new point.
	     * @param {Point} p the other point
	     * @return {Point} output point
	     */
	    multByPoint:    function(p) { return this.clone()._multByPoint(p); },
	
	    /**
	     * Divide this point's x & y coordinates by point,
	     * yielding a new point.
	     * @param {Point} p the other point
	     * @return {Point} output point
	     */
	    divByPoint:     function(p) { return this.clone()._divByPoint(p); },
	
	    /**
	     * Multiply this point's x & y coordinates by a factor,
	     * yielding a new point.
	     * @param {Point} k factor
	     * @return {Point} output point
	     */
	    mult:    function(k) { return this.clone()._mult(k); },
	
	    /**
	     * Divide this point's x & y coordinates by a factor,
	     * yielding a new point.
	     * @param {Point} k factor
	     * @return {Point} output point
	     */
	    div:     function(k) { return this.clone()._div(k); },
	
	    /**
	     * Rotate this point around the 0, 0 origin by an angle a,
	     * given in radians
	     * @param {Number} a angle to rotate around, in radians
	     * @return {Point} output point
	     */
	    rotate:  function(a) { return this.clone()._rotate(a); },
	
	    /**
	     * Rotate this point around p point by an angle a,
	     * given in radians
	     * @param {Number} a angle to rotate around, in radians
	     * @param {Point} p Point to rotate around
	     * @return {Point} output point
	     */
	    rotateAround:  function(a,p) { return this.clone()._rotateAround(a,p); },
	
	    /**
	     * Multiply this point by a 4x1 transformation matrix
	     * @param {Array<Number>} m transformation matrix
	     * @return {Point} output point
	     */
	    matMult: function(m) { return this.clone()._matMult(m); },
	
	    /**
	     * Calculate this point but as a unit vector from 0, 0, meaning
	     * that the distance from the resulting point to the 0, 0
	     * coordinate will be equal to 1 and the angle from the resulting
	     * point to the 0, 0 coordinate will be the same as before.
	     * @return {Point} unit vector point
	     */
	    unit:    function() { return this.clone()._unit(); },
	
	    /**
	     * Compute a perpendicular point, where the new y coordinate
	     * is the old x coordinate and the new x coordinate is the old y
	     * coordinate multiplied by -1
	     * @return {Point} perpendicular point
	     */
	    perp:    function() { return this.clone()._perp(); },
	
	    /**
	     * Return a version of this point with the x & y coordinates
	     * rounded to integers.
	     * @return {Point} rounded point
	     */
	    round:   function() { return this.clone()._round(); },
	
	    /**
	     * Return the magitude of this point: this is the Euclidean
	     * distance from the 0, 0 coordinate to this point's x and y
	     * coordinates.
	     * @return {Number} magnitude
	     */
	    mag: function() {
	        return Math.sqrt(this.x * this.x + this.y * this.y);
	    },
	
	    /**
	     * Judge whether this point is equal to another point, returning
	     * true or false.
	     * @param {Point} other the other point
	     * @return {boolean} whether the points are equal
	     */
	    equals: function(other) {
	        return this.x === other.x &&
	               this.y === other.y;
	    },
	
	    /**
	     * Calculate the distance from this point to another point
	     * @param {Point} p the other point
	     * @return {Number} distance
	     */
	    dist: function(p) {
	        return Math.sqrt(this.distSqr(p));
	    },
	
	    /**
	     * Calculate the distance from this point to another point,
	     * without the square root step. Useful if you're comparing
	     * relative distances.
	     * @param {Point} p the other point
	     * @return {Number} distance
	     */
	    distSqr: function(p) {
	        var dx = p.x - this.x,
	            dy = p.y - this.y;
	        return dx * dx + dy * dy;
	    },
	
	    /**
	     * Get the angle from the 0, 0 coordinate to this point, in radians
	     * coordinates.
	     * @return {Number} angle
	     */
	    angle: function() {
	        return Math.atan2(this.y, this.x);
	    },
	
	    /**
	     * Get the angle from this point to another point, in radians
	     * @param {Point} b the other point
	     * @return {Number} angle
	     */
	    angleTo: function(b) {
	        return Math.atan2(this.y - b.y, this.x - b.x);
	    },
	
	    /**
	     * Get the angle between this point and another point, in radians
	     * @param {Point} b the other point
	     * @return {Number} angle
	     */
	    angleWith: function(b) {
	        return this.angleWithSep(b.x, b.y);
	    },
	
	    /*
	     * Find the angle of the two vectors, solving the formula for
	     * the cross product a x b = |a||b|sin(θ) for θ.
	     * @param {Number} x the x-coordinate
	     * @param {Number} y the y-coordinate
	     * @return {Number} the angle in radians
	     */
	    angleWithSep: function(x, y) {
	        return Math.atan2(
	            this.x * y - this.y * x,
	            this.x * x + this.y * y);
	    },
	
	    _matMult: function(m) {
	        var x = m[0] * this.x + m[1] * this.y,
	            y = m[2] * this.x + m[3] * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _add: function(p) {
	        this.x += p.x;
	        this.y += p.y;
	        return this;
	    },
	
	    _sub: function(p) {
	        this.x -= p.x;
	        this.y -= p.y;
	        return this;
	    },
	
	    _mult: function(k) {
	        this.x *= k;
	        this.y *= k;
	        return this;
	    },
	
	    _div: function(k) {
	        this.x /= k;
	        this.y /= k;
	        return this;
	    },
	
	    _multByPoint: function(p) {
	        this.x *= p.x;
	        this.y *= p.y;
	        return this;
	    },
	
	    _divByPoint: function(p) {
	        this.x /= p.x;
	        this.y /= p.y;
	        return this;
	    },
	
	    _unit: function() {
	        this._div(this.mag());
	        return this;
	    },
	
	    _perp: function() {
	        var y = this.y;
	        this.y = this.x;
	        this.x = -y;
	        return this;
	    },
	
	    _rotate: function(angle) {
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle),
	            x = cos * this.x - sin * this.y,
	            y = sin * this.x + cos * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _rotateAround: function(angle, p) {
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle),
	            x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y),
	            y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _round: function() {
	        this.x = Math.round(this.x);
	        this.y = Math.round(this.y);
	        return this;
	    }
	};
	
	/**
	 * Construct a point from an array if necessary, otherwise if the input
	 * is already a Point, or an unknown type, return it unchanged
	 * @param {Array<Number>|Point|*} a any kind of input value
	 * @return {Point} constructed point, or passed-through value.
	 * @example
	 * // this
	 * var point = Point.convert([0, 1]);
	 * // is equivalent to
	 * var point = new Point(0, 1);
	 */
	Point.convert = function (a) {
	    if (a instanceof Point) {
	        return a;
	    }
	    if (Array.isArray(a)) {
	        return new Point(a[0], a[1]);
	    }
	    return a;
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	var bind = __webpack_require__(43);
	var Axios = __webpack_require__(101);
	var defaults = __webpack_require__(22);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(40);
	axios.CancelToken = __webpack_require__(100);
	axios.isCancel = __webpack_require__(41);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(115);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(40);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(22);
	var utils = __webpack_require__(2);
	var InterceptorManager = __webpack_require__(102);
	var dispatchRequest = __webpack_require__(103);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	var transformData = __webpack_require__(106);
	var isCancel = __webpack_require__(41);
	var defaults = __webpack_require__(22);
	var isAbsoluteURL = __webpack_require__(111);
	var combineURLs = __webpack_require__(109);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(42);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(140);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(281);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(127);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.deepmerge = factory());
	}(this, (function () { 'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}
	
	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}
	
	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}
	
	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			Object.keys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		Object.keys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = deepmerge(target[key], source[key], options);
			}
		});
		return destination
	}
	
	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	
		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}
	
	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}
	
		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};
	
	var deepmerge_1 = deepmerge;
	
	return deepmerge_1;
	
	})));


/***/ }),
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var t,n=__webpack_require__(81),r=__webpack_require__(1),i=e(__webpack_require__(219)),o=e(__webpack_require__(129)),a=e(__webpack_require__(240)),s=e(__webpack_require__(128)),u=e(__webpack_require__(222)),l=e(__webpack_require__(210)),d=e(__webpack_require__(217)),p=(t=s({})).Provider,c=t.Consumer;function h(e){var t=function(t){return r.createElement(c,null,function(i){return r.createElement(e,n.__assign({},t,{formik:i}))})},i=e.displayName||e.name||e.constructor&&e.constructor.name||"Component";return t.WrappedComponent=e,t.displayName="FormikConnect("+i+")",a(t,e)}function m(e,t,n,r){void 0===r&&(r=0);for(var i=d(t);e&&r<i.length;)e=e[i[r++]];return void 0===e?n:e}function f(e,t,r){for(var i={},o=i,a=0,s=d(t);a<s.length-1;a++){var u=s[a],p=m(e,s.slice(0,a+1));if(o[u])o=o[u];else if(p)o=o[u]=l(p);else{var c=s[a+1];o=o[u]=S(c)&&Number(c)>=0?[]:{}}}if((0===a?e:o)[s[a]]===r)return e;void 0===r?delete o[s[a]]:o[s[a]]=r;var h=n.__assign({},e,i);return 0===a&&void 0===r&&delete h[s[a]],h}function v(e,t,n,r){void 0===n&&(n=new WeakMap),void 0===r&&(r={});for(var i=0,o=Object.keys(e);i<o.length;i++){var a=o[i],s=e[a];g(s)?n.get(s)||(n.set(s,!0),r[a]=Array.isArray(s)?[]:{},v(s,t,n,r[a])):r[a]=t}return r}var F=function(e){return"function"==typeof e},g=function(e){return null!==e&&"object"==typeof e},S=function(e){return String(Math.floor(Number(e)))===e},_=function(e){return"[object String]"===Object.prototype.toString.call(e)},y=function(e){return e!=e},k=function(e){return 0===r.Children.count(e)},b=function(e){return g(e)&&F(e.then)};function C(e){var t=!1;return[new Promise(function(n,r){e.then(function(e){return t?r({isCanceled:!0}):n(e)},function(e){return r(t?{isCanceled:!0}:e)})}),function(){t=!0}]}var V=function(e){function t(t){var r=e.call(this,t)||this;return r.hcCache={},r.hbCache={},r.registerField=function(e,t){r.fields[e]=t},r.unregisterField=function(e){delete r.fields[e]},r.setErrors=function(e){r.setState({errors:e})},r.setTouched=function(e){r.setState({touched:e},function(){r.props.validateOnBlur&&r.runValidations(r.state.values)})},r.setValues=function(e){r.setState({values:e},function(){r.props.validateOnChange&&r.runValidations(e)})},r.setStatus=function(e){r.setState({status:e})},r.setError=function(e){r.setState({error:e})},r.setSubmitting=function(e){r.didMount&&r.setState({isSubmitting:e})},r.validateField=function(e){return r.setState({isValidating:!0}),r.runSingleFieldLevelValidation(e,m(r.state.values,e)).then(function(t){return r.didMount&&r.setState({errors:f(r.state.errors,e,t),isValidating:!1}),t})},r.runSingleFieldLevelValidation=function(e,t){return new Promise(function(n){return n(r.fields[e].props.validate(t))}).then(function(e){return e},function(e){return e})},r.runValidationSchema=function(e){return new Promise(function(t){var n=r.props.validationSchema,i=F(n)?n():n;E(e,i).then(function(){t({})},function(e){t(x(e))})})},r.runValidations=function(e){void 0===e&&(e=r.state.values),r.validator&&r.validator();var t=C(Promise.all([r.runFieldLevelValidations(e),r.props.validationSchema?r.runValidationSchema(e):{},r.props.validate?r.runValidateHandler(e):{}]).then(function(e){return o.all([e[0],e[1],e[2]],{arrayMerge:O})})),n=t[0];return r.validator=t[1],n.then(function(e){return r.didMount&&r.setState(function(t){return i(t.errors,e)?null:{errors:e}}),e}).catch(function(e){return e})},r.handleChange=function(e){var t=function(e,t){var i,o=t,a=e;if(!_(e)){e.persist&&e.persist();var s=e.target,u=s.type,l=s.name,d=s.value,p=s.checked;o=t||(l||s.id),a=/number|range/.test(u)?(i=parseFloat(d),y(i)?"":i):/checkbox/.test(u)?p:d}o&&r.setState(function(e){return n.__assign({},e,{values:f(e.values,o,a)})},function(){r.props.validateOnChange&&r.runValidations(f(r.state.values,o,a))})};if(_(e))return F(r.hcCache[e])?r.hcCache[e]:r.hcCache[e]=function(n){return t(n,e)};t(e)},r.setFieldValue=function(e,t,i){void 0===i&&(i=!0),r.didMount&&r.setState(function(r){return n.__assign({},r,{values:f(r.values,e,t)})},function(){r.props.validateOnChange&&i&&r.runValidations(r.state.values)})},r.handleSubmit=function(e){e&&e.preventDefault&&e.preventDefault(),r.submitForm()},r.submitForm=function(){return r.setState(function(e){return{touched:v(e.values,!0),isSubmitting:!0,isValidating:!0,submitCount:e.submitCount+1}}),r.runValidations(r.state.values).then(function(e){r.didMount&&r.setState({isValidating:!1}),0===Object.keys(e).length?r.executeSubmit():r.didMount&&r.setState({isSubmitting:!1})})},r.executeSubmit=function(){r.props.onSubmit(r.state.values,r.getFormikActions())},r.handleBlur=function(e){var t=function(e,t){e.persist&&e.persist();var n=e.target,i=n.name,o=t||(i||n.id);r.setState(function(e){return{touched:f(e.touched,o,!0)}}),r.props.validateOnBlur&&r.runValidations(r.state.values)};if(_(e))return F(r.hbCache[e])?r.hbCache[e]:r.hbCache[e]=function(n){return t(n,e)};t(e)},r.setFieldTouched=function(e,t,i){void 0===t&&(t=!0),void 0===i&&(i=!0),r.setState(function(r){return n.__assign({},r,{touched:f(r.touched,e,t)})},function(){r.props.validateOnBlur&&i&&r.runValidations(r.state.values)})},r.setFieldError=function(e,t){r.setState(function(r){return n.__assign({},r,{errors:f(r.errors,e,t)})})},r.resetForm=function(e){var t=e||r.props.initialValues;r.initialValues=t,r.setState({isSubmitting:!1,isValidating:!1,errors:{},touched:{},error:void 0,status:r.props.initialStatus,values:t,submitCount:0})},r.handleReset=function(){if(r.props.onReset){var e=r.props.onReset(r.state.values,r.getFormikActions());b(e)?e.then(r.resetForm):r.resetForm()}else r.resetForm()},r.setFormikState=function(e,t){return r.setState(e,t)},r.validateForm=function(e){return r.setState({isValidating:!0}),r.runValidations(e).then(function(e){return r.didMount&&r.setState({isValidating:!1}),e})},r.getFormikActions=function(){return{resetForm:r.resetForm,submitForm:r.submitForm,validateForm:r.validateForm,validateField:r.validateField,setError:r.setError,setErrors:r.setErrors,setFieldError:r.setFieldError,setFieldTouched:r.setFieldTouched,setFieldValue:r.setFieldValue,setStatus:r.setStatus,setSubmitting:r.setSubmitting,setTouched:r.setTouched,setValues:r.setValues,setFormikState:r.setFormikState}},r.getFormikComputedProps=function(){var e=r.props.isInitialValid,t=!i(r.initialValues,r.state.values);return{dirty:t,isValid:t?r.state.errors&&0===Object.keys(r.state.errors).length:!1!==e&&F(e)?e(r.props):e,initialValues:r.initialValues}},r.getFormikBag=function(){return n.__assign({},r.state,r.getFormikActions(),r.getFormikComputedProps(),{registerField:r.registerField,unregisterField:r.unregisterField,handleBlur:r.handleBlur,handleChange:r.handleChange,handleReset:r.handleReset,handleSubmit:r.handleSubmit,validateOnChange:r.props.validateOnChange,validateOnBlur:r.props.validateOnBlur})},r.getFormikContext=function(){return n.__assign({},r.getFormikBag(),{validationSchema:r.props.validationSchema,validate:r.props.validate,initialValues:r.initialValues})},r.state={values:t.initialValues||{},errors:{},touched:{},isSubmitting:!1,isValidating:!1,submitCount:0,status:t.initialStatus},r.didMount=!1,r.fields={},r.initialValues=t.initialValues||{},u(!(t.component&&t.render),"You should not use <Formik component> and <Formik render> in the same <Formik> component; <Formik render> will be ignored"),u(!(t.component&&t.children&&!k(t.children)),"You should not use <Formik component> and <Formik children> in the same <Formik> component; <Formik children> will be ignored"),u(!(t.render&&t.children&&!k(t.children)),"You should not use <Formik render> and <Formik children> in the same <Formik> component; <Formik children> will be ignored"),r}return n.__extends(t,e),t.prototype.componentDidMount=function(){this.didMount=!0},t.prototype.componentWillUnmount=function(){this.didMount=!1,this.validator&&this.validator()},t.prototype.componentDidUpdate=function(e){this.props.enableReinitialize&&!i(e.initialValues,this.props.initialValues)&&(this.initialValues=this.props.initialValues,this.resetForm(this.props.initialValues))},t.prototype.runFieldLevelValidations=function(e){var t=this,n=Object.keys(this.fields).filter(function(e){return t.fields&&t.fields[e]&&t.fields[e].props.validate&&F(t.fields[e].props.validate)}),r=n.length>0?n.map(function(n){return t.runSingleFieldLevelValidation(n,m(e,n))}):[Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];return Promise.all(r).then(function(e){return e.reduce(function(e,t,r){return"DO_NOT_DELETE_YOU_WILL_BE_FIRED"===t?e:(t&&(e=f(e,n[r],t)),e)},{})})},t.prototype.runValidateHandler=function(e){var t=this;return new Promise(function(n){var r=t.props.validate(e);void 0===r?n({}):b(r)?r.then(function(){n({})},function(e){n(e)}):n(r)})},t.prototype.render=function(){var e=this.props,t=e.component,n=e.render,i=e.children,o=this.getFormikBag(),a=this.getFormikContext();return r.createElement(p,{value:a},t?r.createElement(t,o):n?n(o):i?F(i)?i(o):k(i)?null:r.Children.only(i):null)},t.defaultProps={validateOnChange:!0,validateOnBlur:!0,isInitialValid:!1,enableReinitialize:!1},t}(r.Component);function x(e){var t={};if(0===e.inner.length)return f(t,e.path,e.message);for(var n=0,r=e.inner;n<r.length;n++){var i=r[n];t[i.path]||(t=f(t,i.path,i.message))}return t}function E(e,t,n,r){void 0===n&&(n=!1),void 0===r&&(r={});var i={};for(var o in e)if(e.hasOwnProperty(o)){var a=String(o);i[a]=""!==e[a]?e[a]:void 0}return t[n?"validateSync":"validate"](i,{abortEarly:!1,context:r})}function O(e,t,n){var r=e.slice();return t.forEach(function(t,i){if(void 0===r[i]){var a=!1!==n.clone&&n.isMergeableObject(t);r[i]=a?o(Array.isArray(t)?[]:{},t,n):t}else n.isMergeableObject(t)?r[i]=o(e[i],t,n):-1===e.indexOf(t)&&r.push(t)}),r}var P=h(function(e){function t(t){var n=e.call(this,t)||this,r=t.render,i=t.children,o=t.component;return u(!(o&&r),"You should not use <Field component> and <Field render> in the same <Field> component; <Field component> will be ignored"),u(!(o&&i&&F(i)),"You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored."),u(!(r&&i&&!k(i)),"You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored"),n}return n.__extends(t,e),t.prototype.componentDidMount=function(){this.props.formik.registerField(this.props.name,this)},t.prototype.componentDidUpdate=function(e){this.props.name!==e.name&&(this.props.formik.unregisterField(e.name),this.props.formik.registerField(this.props.name,this)),this.props.validate!==e.validate&&this.props.formik.registerField(this.props.name,this)},t.prototype.componentWillUnmount=function(){this.props.formik.unregisterField(this.props.name)},t.prototype.render=function(){var e=this.props,t=e.name,i=e.render,o=e.children,a=e.component,s=void 0===a?"input":a,u=e.formik,l=n.__rest(e,["validate","name","render","children","component","formik"]),d=n.__rest(u,["validate","validationSchema"]),p={value:"radio"===l.type||"checkbox"===l.type?l.value:m(u.values,t),name:t,onChange:u.handleChange,onBlur:u.handleBlur},c={field:p,form:d};if(i)return i(c);if(F(o))return o(c);if("string"==typeof s){var h=l.innerRef,f=n.__rest(l,["innerRef"]);return r.createElement(s,n.__assign({ref:h},p,f,{children:o}))}return r.createElement(s,n.__assign({},c,l,{children:o}))},t}(r.Component)),w=h(function(e){var t=e.formik,i=t.handleReset,o=t.handleSubmit,a=n.__rest(e,["formik"]);return r.createElement("form",n.__assign({onReset:i,onSubmit:o},a))});w.displayName="Form";var M=function(e,t,n){var r=(e||[]).slice(),i=r[t];return r.splice(t,1),r.splice(n,0,i),r},R=function(e,t,n){var r=(e||[]).slice(),i=r[t];return r[t]=r[n],r[n]=i,r},A=function(e,t,n){var r=(e||[]).slice();return r.splice(t,0,n),r},B=function(e,t,n){var r=(e||[]).slice();return r[t]=n,r},j=h(function(e){function t(t){var r=e.call(this,t)||this;return r.updateArrayField=function(e,t,i){var o=r.props,a=o.name,s=o.validateOnChange,u=o.formik,l=u.validateForm;(0,u.setFormikState)(function(r){var o="function"==typeof i?i:e,s="function"==typeof t?t:e;return n.__assign({},r,{values:f(r.values,a,e(m(r.values,a))),errors:i?f(r.errors,a,o(m(r.errors,a))):r.errors,touched:t?f(r.touched,a,s(m(r.touched,a))):r.touched})},function(){s&&l()})},r.push=function(e){return r.updateArrayField(function(t){return(t||[]).concat([l(e)])},!1,!1)},r.handlePush=function(e){return function(){return r.push(e)}},r.swap=function(e,t){return r.updateArrayField(function(n){return R(n,e,t)},!0,!0)},r.handleSwap=function(e,t){return function(){return r.swap(e,t)}},r.move=function(e,t){return r.updateArrayField(function(n){return M(n,e,t)},!0,!0)},r.handleMove=function(e,t){return function(){return r.move(e,t)}},r.insert=function(e,t){return r.updateArrayField(function(n){return A(n,e,t)},function(t){return A(t,e,null)},function(t){return A(t,e,null)})},r.handleInsert=function(e,t){return function(){return r.insert(e,t)}},r.replace=function(e,t){return r.updateArrayField(function(n){return B(n,e,t)},!1,!1)},r.handleReplace=function(e,t){return function(){return r.replace(e,t)}},r.unshift=function(e){var t=-1;return r.updateArrayField(function(n){var r=n?[e].concat(n):[e];return t<0&&(t=r.length),r},function(e){var n=e?[null].concat(e):[null];return t<0&&(t=n.length),n},function(e){var n=e?[null].concat(e):[null];return t<0&&(t=n.length),n}),t},r.handleUnshift=function(e){return function(){return r.unshift(e)}},r.handleRemove=function(e){return function(){return r.remove(e)}},r.handlePop=function(){return function(){return r.pop()}},r.remove=r.remove.bind(r),r.pop=r.pop.bind(r),r}return n.__extends(t,e),t.prototype.remove=function(e){var t;return this.updateArrayField(function(n){var r=n?n.slice():[];return t||(t=r[e]),F(r.splice)&&r.splice(e,1),r},!0,!0),t},t.prototype.pop=function(){var e;return this.updateArrayField(function(t){var n=t;return e||(e=n&&n.pop&&n.pop()),n},!0,!0),e},t.prototype.render=function(){var e={push:this.push,pop:this.pop,swap:this.swap,move:this.move,insert:this.insert,replace:this.replace,unshift:this.unshift,remove:this.remove,handlePush:this.handlePush,handlePop:this.handlePop,handleSwap:this.handleSwap,handleMove:this.handleMove,handleInsert:this.handleInsert,handleReplace:this.handleReplace,handleUnshift:this.handleUnshift,handleRemove:this.handleRemove},t=this.props,i=t.component,o=t.render,a=t.children,s=t.name,u=t.formik,l=n.__rest(u,["validate","validationSchema"]),d=n.__assign({},e,{form:l,name:s});return i?r.createElement(i,d):o?o(d):a?"function"==typeof a?a(d):k(a)?null:r.Children.only(a):null},t.defaultProps={validateOnChange:!0},t}(r.Component)),U=h(function(e){function t(t){var n=e.call(this,t)||this,r=t.render,i=t.children,o=t.component;return u(!(o&&r),"You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored"),u(!(o&&i&&F(i)),"You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored."),u(!(r&&i&&!k(i)),"You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored"),n}return n.__extends(t,e),t.prototype.shouldComponentUpdate=function(e){return this.props.shouldUpdate?this.props.shouldUpdate(e,this.props):m(this.props.formik.values,this.props.name)!==m(e.formik.values,this.props.name)||m(this.props.formik.errors,this.props.name)!==m(e.formik.errors,this.props.name)||m(this.props.formik.touched,this.props.name)!==m(e.formik.touched,this.props.name)||Object.keys(this.props).length!==Object.keys(e).length||this.props.formik.isSubmitting!==e.formik.isSubmitting},t.prototype.componentDidMount=function(){this.props.formik.registerField(this.props.name,this)},t.prototype.componentDidUpdate=function(e){this.props.name!==e.name&&(this.props.formik.unregisterField(e.name),this.props.formik.registerField(this.props.name,this)),this.props.validate!==e.validate&&this.props.formik.registerField(this.props.name,this)},t.prototype.componentWillUnmount=function(){this.props.formik.unregisterField(this.props.name)},t.prototype.render=function(){var e=this.props,t=e.name,i=e.render,o=e.children,a=e.component,s=void 0===a?"input":a,u=e.formik,l=n.__rest(e,["validate","name","render","children","component","formik","shouldUpdate"]),d=n.__rest(u,["validate","validationSchema"]),p={value:"radio"===l.type||"checkbox"===l.type?l.value:m(u.values,t),name:t,onChange:u.handleChange,onBlur:u.handleBlur},c={field:p,form:d};if(i)return i(c);if(F(o))return o(c);if("string"==typeof s){var h=l.innerRef,f=n.__rest(l,["innerRef"]);return r.createElement(s,n.__assign({ref:h},p,f,{children:o}))}return r.createElement(s,n.__assign({},c,l,{children:o}))},t}(r.Component)),D=h(function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return n.__extends(t,e),t.prototype.shouldComponentUpdate=function(e){return m(this.props.formik.errors,this.props.name)!==m(e.formik.errors,this.props.name)||m(this.props.formik.touched,this.props.name)!==m(e.formik.touched,this.props.name)||Object.keys(this.props).length!==Object.keys(e).length},t.prototype.render=function(){var e=this.props,t=e.component,i=e.formik,o=e.render,a=e.children,s=e.name,u=n.__rest(e,["component","formik","render","children","name"]),l=m(i.touched,s),d=m(i.errors,s);return l&&d?o?F(o)?o(d):null:a?F(a)?a(d):null:t?r.createElement(t,u,d):d:null},t}(r.Component));exports.Formik=V,exports.yupToFormErrors=x,exports.validateYupSchema=E,exports.Field=P,exports.Form=w,exports.withFormik=function(e){var t=e.mapPropsToValues,i=void 0===t?function(e){var t={};for(var n in e)e.hasOwnProperty(n)&&"function"!=typeof e[n]&&(t[n]=e[n]);return t}:t,o=n.__rest(e,["mapPropsToValues"]);return function(e){var t=e.displayName||e.name||e.constructor&&e.constructor.name||"Component",s=function(a){function s(){var t=null!==a&&a.apply(this,arguments)||this;return t.validate=function(e){return o.validate(e,t.props)},t.validationSchema=function(){return F(o.validationSchema)?o.validationSchema(t.props):o.validationSchema},t.handleSubmit=function(e,r){return o.handleSubmit(e,n.__assign({},r,{props:t.props}))},t.renderFormComponent=function(i){return r.createElement(e,n.__assign({},t.props,i))},t}return n.__extends(s,a),s.prototype.render=function(){var e=this.props,t=n.__rest(e,["children"]);return r.createElement(V,n.__assign({},t,o,{validate:o.validate&&this.validate,validationSchema:o.validationSchema&&this.validationSchema,initialValues:i(this.props),initialStatus:o.mapPropsToStatus&&o.mapPropsToStatus(this.props),onSubmit:this.handleSubmit,render:this.renderFormComponent}))},s.displayName="WithFormik("+t+")",s}(r.Component);return a(s,e)}},exports.move=M,exports.swap=R,exports.insert=A,exports.replace=B,exports.FieldArray=j,exports.getIn=m,exports.setIn=f,exports.setNestedObjectValues=v,exports.isFunction=F,exports.isObject=g,exports.isInteger=S,exports.isString=_,exports.isNaN=y,exports.isEmptyChildren=k,exports.isPromise=b,exports.getActiveElement=function(e){if(void 0===(e=e||("undefined"!=typeof document?document:void 0)))return null;try{return e.activeElement||e.body}catch(t){return e.body}},exports.makeCancelable=C,exports.FastField=U,exports.FormikProvider=p,exports.FormikConsumer=c,exports.connect=h,exports.ErrorMessage=D;
	//# sourceMappingURL=formik.cjs.production.js.map


/***/ }),
/* 133 */,
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _omit = __webpack_require__(137);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _shallowEqual = __webpack_require__(139);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// utils
	
	
	var mainStyle = {
	  width: '100%',
	  height: '100%',
	  left: 0,
	  top: 0,
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};
	
	var style = {
	  width: 0,
	  height: 0,
	  left: 0,
	  top: 0,
	  backgroundColor: 'transparent',
	  position: 'absolute'
	};
	
	var GoogleMapMarkers = function (_Component) {
	  _inherits(GoogleMapMarkers, _Component);
	
	  /* eslint-disable react/forbid-prop-types */
	  function GoogleMapMarkers(props) {
	    _classCallCheck(this, GoogleMapMarkers);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this._getState = function () {
	      return {
	        children: _this.props.dispatcher.getChildren(),
	        updateCounter: _this.props.dispatcher.getUpdateCounter()
	      };
	    };
	
	    _this._onChangeHandler = function () {
	      if (!_this.dimensionsCache_) {
	        return;
	      }
	
	      var prevChildCount = (_this.state.children || []).length;
	      var state = _this._getState();
	
	      _this.setState(state, function () {
	        return (state.children || []).length !== prevChildCount && _this._onMouseChangeHandler();
	      });
	    };
	
	    _this._onChildClick = function () {
	      if (_this.props.onChildClick) {
	        if (_this.hoverChildProps_) {
	          var hoverKey = _this.hoverKey_;
	          var childProps = _this.hoverChildProps_;
	          // click works only on hovered item
	          _this.props.onChildClick(hoverKey, childProps);
	        }
	      }
	    };
	
	    _this._onChildMouseDown = function () {
	      if (_this.props.onChildMouseDown) {
	        if (_this.hoverChildProps_) {
	          var hoverKey = _this.hoverKey_;
	          var childProps = _this.hoverChildProps_;
	          // works only on hovered item
	          _this.props.onChildMouseDown(hoverKey, childProps);
	        }
	      }
	    };
	
	    _this._onChildMouseEnter = function (hoverKey, childProps) {
	      if (!_this.dimensionsCache_) {
	        return;
	      }
	
	      if (_this.props.onChildMouseEnter) {
	        _this.props.onChildMouseEnter(hoverKey, childProps);
	      }
	
	      _this.hoverChildProps_ = childProps;
	      _this.hoverKey_ = hoverKey;
	      _this.setState({ hoverKey: hoverKey });
	    };
	
	    _this._onChildMouseLeave = function () {
	      if (!_this.dimensionsCache_) {
	        return;
	      }
	
	      var hoverKey = _this.hoverKey_;
	      var childProps = _this.hoverChildProps_;
	
	      if (hoverKey !== undefined && hoverKey !== null) {
	        if (_this.props.onChildMouseLeave) {
	          _this.props.onChildMouseLeave(hoverKey, childProps);
	        }
	
	        _this.hoverKey_ = null;
	        _this.hoverChildProps_ = null;
	        _this.setState({ hoverKey: null });
	      }
	    };
	
	    _this._onMouseAllow = function (value) {
	      if (!value) {
	        _this._onChildMouseLeave();
	      }
	
	      _this.allowMouse_ = value;
	    };
	
	    _this._onMouseChangeHandler = function () {
	      if (_this.allowMouse_) {
	        _this._onMouseChangeHandlerRaf();
	      }
	    };
	
	    _this._onMouseChangeHandlerRaf = function () {
	      if (!_this.dimensionsCache_) {
	        return;
	      }
	
	      var mp = _this.props.dispatcher.getMousePosition();
	
	      if (mp) {
	        var distances = [];
	        var hoverDistance = _this.props.getHoverDistance();
	
	        _react2.default.Children.forEach(_this.state.children, function (child, childIndex) {
	          if (!child) return;
	          // layers
	          if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
	            return;
	          }
	
	          var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
	          var dist = _this.props.distanceToMouse(_this.dimensionsCache_[childKey], mp, child.props);
	          if (dist < hoverDistance) {
	            distances.push({
	              key: childKey,
	              dist: dist,
	              props: child.props
	            });
	          }
	        });
	
	        if (distances.length) {
	          distances.sort(function (a, b) {
	            return a.dist - b.dist;
	          });
	          var hoverKey = distances[0].key;
	          var childProps = distances[0].props;
	
	          if (_this.hoverKey_ !== hoverKey) {
	            _this._onChildMouseLeave();
	
	            _this._onChildMouseEnter(hoverKey, childProps);
	          }
	        } else {
	          _this._onChildMouseLeave();
	        }
	      } else {
	        _this._onChildMouseLeave();
	      }
	    };
	
	    _this._getDimensions = function (key) {
	      var childKey = key;
	      return _this.dimensionsCache_[childKey];
	    };
	
	    _this.props.dispatcher.on('kON_CHANGE', _this._onChangeHandler);
	    _this.props.dispatcher.on('kON_MOUSE_POSITION_CHANGE', _this._onMouseChangeHandler);
	    _this.props.dispatcher.on('kON_CLICK', _this._onChildClick);
	    _this.props.dispatcher.on('kON_MDOWN', _this._onChildMouseDown);
	
	    _this.dimensionsCache_ = {};
	    _this.hoverKey_ = null;
	    _this.hoverChildProps_ = null;
	    _this.allowMouse_ = true;
	
	    _this.state = _extends({}, _this._getState(), { hoverKey: null });
	    return _this;
	  }
	  /* eslint-enable react/forbid-prop-types */
	
	  GoogleMapMarkers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    if (this.props.experimental === true) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)((0, _omit2.default)(this.state, ['hoverKey']), (0, _omit2.default)(nextState, ['hoverKey']));
	    }
	
	    return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	  };
	
	  GoogleMapMarkers.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.dispatcher.removeListener('kON_CHANGE', this._onChangeHandler);
	    this.props.dispatcher.removeListener('kON_MOUSE_POSITION_CHANGE', this._onMouseChangeHandler);
	    this.props.dispatcher.removeListener('kON_CLICK', this._onChildClick);
	    this.props.dispatcher.removeListener('kON_MDOWN', this._onChildMouseDown);
	
	    this.dimensionsCache_ = null;
	  };
	
	  GoogleMapMarkers.prototype.render = function render() {
	    var _this2 = this;
	
	    var mainElementStyle = this.props.style || mainStyle;
	    this.dimensionsCache_ = {};
	
	    var markers = _react2.default.Children.map(this.state.children, function (child, childIndex) {
	      if (!child) return undefined;
	      if (child.props.latLng === undefined && child.props.lat === undefined && child.props.lng === undefined) {
	        return _react2.default.cloneElement(child, {
	          $geoService: _this2.props.geoService,
	          $onMouseAllow: _this2._onMouseAllow,
	          $prerender: _this2.props.prerender
	        });
	      }
	
	      var latLng = child.props.latLng !== undefined ? child.props.latLng : { lat: child.props.lat, lng: child.props.lng };
	
	      var pt = _this2.props.insideMapPanes ? _this2.props.geoService.fromLatLngToDivPixel(latLng) : _this2.props.geoService.fromLatLngToCenterPixel(latLng);
	
	      var stylePtPos = {
	        left: pt.x,
	        top: pt.y
	      };
	
	      // If the component has a southeast corner defined (either as a LatLng, or a separate
	      // lat and lng pair), set the width and height based on the distance between the northwest
	      // and the southeast corner to lock the overlay to the correct geographic bounds.
	      if (child.props.seLatLng !== undefined || child.props.seLat !== undefined && child.props.seLng !== undefined) {
	        var seLatLng = child.props.seLatLng !== undefined ? child.props.seLatLng : { lat: child.props.seLat, lng: child.props.seLng };
	
	        var sePt = _this2.props.insideMapPanes ? _this2.props.geoService.fromLatLngToDivPixel(seLatLng) : _this2.props.geoService.fromLatLngToCenterPixel(seLatLng);
	
	        stylePtPos.width = sePt.x - pt.x;
	        stylePtPos.height = sePt.y - pt.y;
	      }
	
	      var containerPt = _this2.props.geoService.fromLatLngToContainerPixel(latLng);
	
	      // to prevent rerender on child element i need to pass
	      // const params $getDimensions and $dimensionKey instead of dimension object
	      var childKey = child.key !== undefined && child.key !== null ? child.key : childIndex;
	
	      _this2.dimensionsCache_[childKey] = _extends({
	        x: containerPt.x,
	        y: containerPt.y
	      }, latLng);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: childKey,
	          style: _extends({}, style, stylePtPos),
	          className: child.props.$markerHolderClassName
	        },
	        _react2.default.cloneElement(child, {
	          $hover: childKey === _this2.state.hoverKey,
	          $getDimensions: _this2._getDimensions,
	          $dimensionKey: childKey,
	          $geoService: _this2.props.geoService,
	          $onMouseAllow: _this2._onMouseAllow,
	          $prerender: _this2.props.prerender
	        })
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { style: mainElementStyle },
	      markers
	    );
	  };
	
	  return GoogleMapMarkers;
	}(_react.Component);
	
	GoogleMapMarkers.propTypes = {
	  geoService: _propTypes2.default.any,
	  style: _propTypes2.default.any,
	  distanceToMouse: _propTypes2.default.func,
	  dispatcher: _propTypes2.default.any,
	  onChildClick: _propTypes2.default.func,
	  onChildMouseDown: _propTypes2.default.func,
	  onChildMouseLeave: _propTypes2.default.func,
	  onChildMouseEnter: _propTypes2.default.func,
	  getHoverDistance: _propTypes2.default.func,
	  insideMapPanes: _propTypes2.default.bool,
	  prerender: _propTypes2.default.bool
	};
	GoogleMapMarkers.defaultProps = {
	  insideMapPanes: false,
	  prerender: false
	};
	exports.default = GoogleMapMarkers;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _wrap2 = __webpack_require__(136);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LatLng = function () {
	  function LatLng(lat, lng) {
	    _classCallCheck(this, LatLng);
	
	    if (isNaN(lat) || isNaN(lng)) {
	      throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	    }
	    this.lat = +lat;
	    this.lng = +lng;
	  }
	
	  LatLng.prototype.wrap = function wrap() {
	    return new LatLng(this.lat, (0, _wrap2.wrap)(this.lng, -180, 180));
	  };
	
	  return LatLng;
	}();
	
	LatLng.convert = function (a) {
	  if (a instanceof LatLng) {
	    return a;
	  }
	
	  if (Array.isArray(a)) {
	    return new LatLng(a[0], a[1]);
	  }
	
	  if ('lng' in a && 'lat' in a) {
	    return new LatLng(a.lat, a.lng);
	  }
	
	  return a;
	};
	
	exports.default = LatLng;

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.wrap = wrap;
	/* eslint-disable import/prefer-default-export */
	
	function wrap(n, min, max) {
	  var d = max - min;
	  return n === max ? n : ((n - min) % d + d) % d + min;
	}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/utils/omit.js
	var omit = function omit(obj, keys) {
	  var rest = _objectWithoutProperties(obj, []);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (key in rest) {
	      delete rest[key];
	    }
	  }
	  return rest;
	};
	
	exports.default = omit;

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addPassiveEventListener;
	// feature detection for passive support
	// see: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	function hasPassiveSupport() {
	  var passiveSupported = false;
	
	  try {
	    var options = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        passiveSupported = true;
	      }
	    });
	
	    window.addEventListener('test', options, options);
	    window.removeEventListener('test', options, options);
	  } catch (err) {
	    passiveSupported = false;
	  }
	
	  return passiveSupported;
	}
	
	function addPassiveEventListener(element, eventName, func, capture) {
	  element.addEventListener(eventName, func, hasPassiveSupport() ? {
	    capture: capture,
	    passive: true
	  } : capture);
	}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  }
	  // Step 6.a: NaN == NaN
	  // eslint-disable-next-line no-self-compare
	  return x !== x && y !== y;
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;
	/* src: https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/shallowEqual.js */

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 141 */,
/* 142 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(6),
	    root = __webpack_require__(5);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(178),
	    hashDelete = __webpack_require__(179),
	    hashGet = __webpack_require__(180),
	    hashHas = __webpack_require__(181),
	    hashSet = __webpack_require__(182);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(6),
	    root = __webpack_require__(5);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(6),
	    root = __webpack_require__(5);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(14),
	    stackClear = __webpack_require__(203),
	    stackDelete = __webpack_require__(204),
	    stackGet = __webpack_require__(205),
	    stackHas = __webpack_require__(206),
	    stackSet = __webpack_require__(207);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(5);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(6),
	    root = __webpack_require__(5);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 151 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(17),
	    keys = __webpack_require__(31);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(17),
	    keysIn = __webpack_require__(64);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(147),
	    arrayEach = __webpack_require__(150),
	    assignValue = __webpack_require__(50),
	    baseAssign = __webpack_require__(152),
	    baseAssignIn = __webpack_require__(153),
	    cloneBuffer = __webpack_require__(165),
	    copyArray = __webpack_require__(53),
	    copySymbols = __webpack_require__(170),
	    copySymbolsIn = __webpack_require__(171),
	    getAllKeys = __webpack_require__(174),
	    getAllKeysIn = __webpack_require__(175),
	    getTag = __webpack_require__(27),
	    initCloneArray = __webpack_require__(183),
	    initCloneByTag = __webpack_require__(184),
	    initCloneObject = __webpack_require__(185),
	    isArray = __webpack_require__(10),
	    isBuffer = __webpack_require__(61),
	    isMap = __webpack_require__(212),
	    isObject = __webpack_require__(11),
	    isSet = __webpack_require__(213),
	    keys = __webpack_require__(31);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(11);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(9),
	    isObjectLike = __webpack_require__(7);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(27),
	    isObjectLike = __webpack_require__(7);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(62),
	    isMasked = __webpack_require__(188),
	    isObject = __webpack_require__(11),
	    toSource = __webpack_require__(58);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(27),
	    isObjectLike = __webpack_require__(7);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(9),
	    isLength = __webpack_require__(63),
	    isObjectLike = __webpack_require__(7);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(28),
	    nativeKeys = __webpack_require__(200);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(11),
	    isPrototype = __webpack_require__(28),
	    nativeKeysIn = __webpack_require__(201);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(15),
	    arrayMap = __webpack_require__(48),
	    isArray = __webpack_require__(10),
	    isSymbol = __webpack_require__(30);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(5);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)(module)))

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(25);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 167 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(15);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(25);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(17),
	    getSymbols = __webpack_require__(26);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(17),
	    getSymbolsIn = __webpack_require__(56);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(5);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(6);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(52),
	    getSymbols = __webpack_require__(26),
	    keys = __webpack_require__(31);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(52),
	    getSymbolsIn = __webpack_require__(56),
	    keysIn = __webpack_require__(64);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(15);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(19);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 179 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(19);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(19);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(19);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(25),
	    cloneDataView = __webpack_require__(166),
	    cloneRegExp = __webpack_require__(167),
	    cloneSymbol = __webpack_require__(168),
	    cloneTypedArray = __webpack_require__(169);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(155),
	    getPrototype = __webpack_require__(55),
	    isPrototype = __webpack_require__(28);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 187 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(172);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(16);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(16);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(16);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(16);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(144),
	    ListCache = __webpack_require__(14),
	    Map = __webpack_require__(23);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(18);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(18);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(18);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(18);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(215);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(57);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(14);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(14),
	    Map = __webpack_require__(23),
	    MapCache = __webpack_require__(46);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(199);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(30);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(154);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(156),
	    isObjectLike = __webpack_require__(7);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(157),
	    baseUnary = __webpack_require__(24),
	    nodeUtil = __webpack_require__(29);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(159),
	    baseUnary = __webpack_require__(24),
	    nodeUtil = __webpack_require__(29);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(160),
	    baseUnary = __webpack_require__(24),
	    nodeUtil = __webpack_require__(29);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(46);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(48),
	    copyArray = __webpack_require__(53),
	    isArray = __webpack_require__(10),
	    isSymbol = __webpack_require__(30),
	    stringToPath = __webpack_require__(208),
	    toKey = __webpack_require__(209),
	    toString = __webpack_require__(218);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(164);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(32)))

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(220);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bullet = function Bullet(props) {
	    return _react2.default.createElement('span', {
	        style: {
	            display: 'inline-block',
	            position: 'relative',
	            top: '-0.1em',
	            verticalAlign: 'middle',
	            height: '.9em',
	            marginRight: '10px',
	            borderLeft: '5px solid ' + props.colore
	        }
	    });
	};
	
	exports.default = Bullet;
	module.exports = exports['default'];

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover.66ab517e.png";

/***/ }),
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} [once=false] Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Hold the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var events = this._events
	    , names = []
	    , name;
	
	  if (!events) return names;
	
	  for (name in events) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var generateHeatmap = exports.generateHeatmap = function generateHeatmap(instance, _ref) {
	  var positions = _ref.positions;
	  return new instance.visualization.HeatmapLayer({
	    data: positions.reduce(function (acc, _ref2) {
	      var lat = _ref2.lat,
	          lng = _ref2.lng,
	          _ref2$weight = _ref2.weight,
	          weight = _ref2$weight === undefined ? 1 : _ref2$weight;
	
	      acc.push({
	        location: new instance.LatLng(lat, lng),
	        weight: weight
	      });
	      return acc;
	    }, [])
	  });
	};
	
	var optionsHeatmap = exports.optionsHeatmap = function optionsHeatmap(instance, _ref3) {
	  var _ref3$options = _ref3.options,
	      options = _ref3$options === undefined ? {} : _ref3$options;
	  return Object.keys(options).map(function (option) {
	    return instance.set(option, options[option]);
	  });
	};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(75);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _google_map_map = __webpack_require__(284);
	
	var _google_map_map2 = _interopRequireDefault(_google_map_map);
	
	var _marker_dispatcher = __webpack_require__(288);
	
	var _marker_dispatcher2 = _interopRequireDefault(_marker_dispatcher);
	
	var _google_map_markers = __webpack_require__(134);
	
	var _google_map_markers2 = _interopRequireDefault(_google_map_markers);
	
	var _google_map_markers_prerender = __webpack_require__(285);
	
	var _google_map_markers_prerender2 = _interopRequireDefault(_google_map_markers_prerender);
	
	var _google_heatmap = __webpack_require__(282);
	
	var _google_map_loader = __webpack_require__(287);
	
	var _google_map_loader2 = _interopRequireDefault(_google_map_loader);
	
	var _geo = __webpack_require__(291);
	
	var _geo2 = _interopRequireDefault(_geo);
	
	var _raf = __webpack_require__(299);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _pick = __webpack_require__(298);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _omit = __webpack_require__(137);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _log = __webpack_require__(297);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _isEmpty = __webpack_require__(293);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isNumber = __webpack_require__(294);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _detect = __webpack_require__(289);
	
	var _detect2 = _interopRequireDefault(_detect);
	
	var _shallowEqual = __webpack_require__(139);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _isPlainObject = __webpack_require__(295);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isArraysEqualEps = __webpack_require__(292);
	
	var _isArraysEqualEps2 = _interopRequireDefault(_isArraysEqualEps);
	
	var _detectElementResize = __webpack_require__(290);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	var _passiveEvents = __webpack_require__(138);
	
	var _passiveEvents2 = _interopRequireDefault(_passiveEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable import/no-extraneous-dependencies, react/forbid-prop-types, react/no-find-dom-node, no-console */
	
	
	// helpers
	
	
	// loaders
	
	
	// utils
	
	
	// consts
	var kEPS = 0.00001;
	var K_GOOGLE_TILE_SIZE = 256;
	// real minZoom calculated here _getMinZoom
	var K_IDLE_TIMEOUT = 100;
	var K_IDLE_CLICK_TIMEOUT = 300;
	var DEFAULT_MIN_ZOOM = 3;
	// Starting with version 3.32, the maps API calls `draw()` each frame during
	// a zoom animation.
	var DRAW_CALLED_DURING_ANIMATION_VERSION = 32;
	var IS_REACT_16 = _reactDom2.default.createPortal !== undefined;
	
	var createPortal = IS_REACT_16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	
	function defaultOptions_() /* maps */{
	  return {
	    overviewMapControl: false,
	    streetViewControl: false,
	    rotateControl: true,
	    mapTypeControl: false,
	    // disable poi
	    styles: [{
	      featureType: 'poi',
	      elementType: 'labels',
	      stylers: [{ visibility: 'off' }]
	    }],
	    minZoom: DEFAULT_MIN_ZOOM // dynamically recalculted if possible during init
	  };
	}
	
	var latLng2Obj = function latLng2Obj(latLng) {
	  return (0, _isPlainObject2.default)(latLng) ? latLng : { lat: latLng[0], lng: latLng[1] };
	};
	
	var _checkMinZoom = function _checkMinZoom(zoom, minZoom) {
	  if (false) {
	    if (zoom < minZoom) {
	      console.warn('GoogleMap: ' + // eslint-disable-line
	      'minZoom option is less than recommended ' + 'minZoom option for your map sizes.\n' + 'overrided to value ' + minZoom);
	    }
	  }
	
	  if (minZoom < zoom) {
	    return zoom;
	  }
	  return minZoom;
	};
	
	var isFullScreen = function isFullScreen() {
	  return document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement;
	};
	
	var GoogleMap = function (_Component) {
	  _inherits(GoogleMap, _Component);
	
	  // eslint-disable-line
	
	  function GoogleMap(props) {
	    _classCallCheck(this, GoogleMap);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this._getMinZoom = function () {
	      if (_this.geoService_.getWidth() > 0 || _this.geoService_.getHeight() > 0) {
	        var tilesPerWidth = Math.ceil(_this.geoService_.getWidth() / K_GOOGLE_TILE_SIZE) + 2;
	        var tilesPerHeight = Math.ceil(_this.geoService_.getHeight() / K_GOOGLE_TILE_SIZE) + 2;
	        var maxTilesPerDim = Math.max(tilesPerWidth, tilesPerHeight);
	        return Math.ceil((0, _log2.default)(maxTilesPerDim));
	      }
	      return DEFAULT_MIN_ZOOM;
	    };
	
	    _this._computeMinZoom = function (minZoom) {
	      if (!(0, _isEmpty2.default)(minZoom)) {
	        return minZoom;
	      }
	      return _this._getMinZoom();
	    };
	
	    _this._mapDomResizeCallback = function () {
	      _this.resetSizeOnIdle_ = true;
	      if (_this.maps_) {
	        var originalCenter = _this.props.center || _this.props.defaultCenter;
	        var currentCenter = _this.map_.getCenter();
	        _this.maps_.event.trigger(_this.map_, 'resize');
	        _this.map_.setCenter(_this.props.resetBoundsOnResize ? originalCenter : currentCenter);
	      }
	    };
	
	    _this._setLayers = function (layerTypes) {
	      layerTypes.forEach(function (layerType) {
	        _this.layers_[layerType] = new _this.maps_[layerType]();
	        _this.layers_[layerType].setMap(_this.map_);
	      });
	    };
	
	    _this._renderPortal = function () {
	      return _react2.default.createElement(_google_map_markers2.default, {
	        experimental: _this.props.experimental,
	        onChildClick: _this._onChildClick,
	        onChildMouseDown: _this._onChildMouseDown,
	        onChildMouseEnter: _this._onChildMouseEnter,
	        onChildMouseLeave: _this._onChildMouseLeave,
	        geoService: _this.geoService_,
	        insideMapPanes: true,
	        distanceToMouse: _this.props.distanceToMouse,
	        getHoverDistance: _this._getHoverDistance,
	        dispatcher: _this.markersDispatcher_
	      });
	    };
	
	    _this._initMap = function () {
	      // only initialize the map once
	      if (_this.initialized_) {
	        return;
	      }
	      _this.initialized_ = true;
	
	      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
	      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
	
	      _this._onBoundsChanged(); // now we can calculate map bounds center etc...
	
	      var bootstrapURLKeys = _extends({}, _this.props.apiKey && { key: _this.props.apiKey }, _this.props.bootstrapURLKeys);
	
	      _this.props.googleMapLoader(bootstrapURLKeys, _this.props.heatmapLibrary).then(function (maps) {
	        if (!_this.mounted_) {
	          return;
	        }
	
	        var centerLatLng = _this.geoService_.getCenter();
	
	        var propsOptions = {
	          zoom: _this.props.zoom || _this.props.defaultZoom,
	          center: new maps.LatLng(centerLatLng.lat, centerLatLng.lng)
	        };
	
	        // Start Heatmap
	        if (_this.props.heatmap.positions) {
	          Object.assign(_this, {
	            heatmap: (0, _google_heatmap.generateHeatmap)(maps, _this.props.heatmap)
	          });
	          (0, _google_heatmap.optionsHeatmap)(_this.heatmap, _this.props.heatmap);
	        }
	        // End Heatmap
	
	        // prevent to exapose full api
	        // next props must be exposed (console.log(Object.keys(pick(maps, isPlainObject))))
	        // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
	        // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition",
	        // "SymbolPath", "ZoomControlStyle",
	        // "event", "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem",
	        // "DistanceMatrixStatus",
	        // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType",
	        // "GeocoderStatus", "KmlLayerStatus",
	        // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference",
	        // "TravelMode", "UnitSystem"
	        var mapPlainObjects = (0, _pick2.default)(maps, _isPlainObject2.default);
	        var options = typeof _this.props.options === 'function' ? _this.props.options(mapPlainObjects) : _this.props.options;
	        var defaultOptions = defaultOptions_(mapPlainObjects);
	
	        var draggableOptions = !(0, _isEmpty2.default)(_this.props.draggable) && {
	          draggable: _this.props.draggable
	        };
	
	        var minZoom = _this._computeMinZoom(options.minZoom);
	        _this.minZoom_ = minZoom;
	
	        var preMapOptions = _extends({}, defaultOptions, {
	          minZoom: minZoom
	        }, options, propsOptions);
	
	        _this.defaultDraggableOption_ = !(0, _isEmpty2.default)(preMapOptions.draggable) ? preMapOptions.draggable : _this.defaultDraggableOption_;
	
	        var mapOptions = _extends({}, preMapOptions, draggableOptions);
	
	        mapOptions.minZoom = _checkMinZoom(mapOptions.minZoom, minZoom);
	
	        var map = new maps.Map(_reactDom2.default.findDOMNode(_this.googleMapDom_), mapOptions);
	
	        _this.map_ = map;
	        _this.maps_ = maps;
	
	        _this._setLayers(_this.props.layerTypes);
	
	        // Parse `google.maps.version` to capture the major version number.
	        var versionMatch = maps.version.match(/^3\.(\d+)\./);
	        // The major version is the first (and only) captured group.
	        var mapsVersion = versionMatch && Number(versionMatch[1]);
	
	        // render in overlay
	        var this_ = _this;
	        var overlay = Object.assign(new maps.OverlayView(), {
	          onAdd: function onAdd() {
	            var K_MAX_WIDTH = typeof screen !== 'undefined' ? screen.width + 'px' : '2000px';
	            var K_MAX_HEIGHT = typeof screen !== 'undefined' ? screen.height + 'px' : '2000px';
	
	            var div = document.createElement('div');
	            div.style.backgroundColor = 'transparent';
	            div.style.position = 'absolute';
	            div.style.left = '0px';
	            div.style.top = '0px';
	            div.style.width = K_MAX_WIDTH; // prevents some chrome draw defects
	            div.style.height = K_MAX_HEIGHT;
	
	            if (this_.props.overlayViewDivStyle) {
	              var overlayViewDivStyle = this_.props.overlayViewDivStyle;
	
	              if ((typeof overlayViewDivStyle === 'undefined' ? 'undefined' : _typeof(overlayViewDivStyle)) === 'object') {
	                Object.keys(overlayViewDivStyle).forEach(function (property) {
	                  div.style[property] = overlayViewDivStyle[property];
	                });
	              }
	            }
	
	            var panes = this.getPanes();
	            panes.overlayMouseTarget.appendChild(div);
	            this_.geoService_.setMapCanvasProjection(maps, overlay.getProjection());
	
	            if (!IS_REACT_16) {
	              createPortal(this_, this_._renderPortal(), div,
	              // remove prerendered markers
	              function () {
	                return this_.setState({ overlay: div });
	              });
	            } else {
	              this_.setState({ overlay: div });
	            }
	          },
	          onRemove: function onRemove() {
	            var renderedOverlay = this_.state.overlay;
	            if (renderedOverlay && !IS_REACT_16) {
	              _reactDom2.default.unmountComponentAtNode(renderedOverlay);
	            }
	            this_.setState({ overlay: null });
	          },
	          draw: function draw() {
	            this_.updateCounter_++;
	            this_._onBoundsChanged(map, maps, !this_.props.debounced);
	
	            if (!this_.googleApiLoadedCalled_) {
	              this_._onGoogleApiLoaded({ map: map, maps: maps });
	              this_.googleApiLoadedCalled_ = true;
	            }
	
	            if (this_.mouse_) {
	              var latLng = this_.geoService_.fromContainerPixelToLatLng(this_.mouse_);
	              this_.mouse_.lat = latLng.lat;
	              this_.mouse_.lng = latLng.lng;
	            }
	
	            this_._onChildMouseMove();
	
	            if (this_.markersDispatcher_) {
	              this_.markersDispatcher_.emit('kON_CHANGE');
	              if (this_.fireMouseEventOnIdle_) {
	                this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	              }
	            }
	          }
	        });
	
	        _this.overlay_ = overlay;
	
	        overlay.setMap(map);
	        if (_this.props.heatmap.positions) {
	          _this.heatmap.setMap(map);
	        }
	
	        if (_this.props.onTilesLoaded) {
	          maps.event.addListener(map, 'tilesloaded', function () {
	            this_._onTilesLoaded();
	          });
	        }
	
	        maps.event.addListener(map, 'zoom_changed', function () {
	          // recalc position at zoom start
	          if (this_.geoService_.getZoom() !== map.getZoom()) {
	            if (!this_.zoomAnimationInProgress_) {
	              this_.zoomAnimationInProgress_ = true;
	              this_._onZoomAnimationStart();
	            }
	
	            // If draw() is not called each frame during a zoom animation,
	            // simulate it.
	            if (mapsVersion < DRAW_CALLED_DURING_ANIMATION_VERSION) {
	              var TIMEOUT_ZOOM = 300;
	
	              if (new Date().getTime() - _this.zoomControlClickTime_ < TIMEOUT_ZOOM) {
	                // there is strange Google Map Api behavior in chrome when zoom animation of map
	                // is started only on second raf call, if was click on zoom control
	                // or +- keys pressed, so i wait for two rafs before change state
	
	                // this does not fully prevent animation jump
	                // but reduce it's occurence probability
	                (0, _raf2.default)(function () {
	                  return (0, _raf2.default)(function () {
	                    this_.updateCounter_++;
	                    this_._onBoundsChanged(map, maps);
	                  });
	                });
	              } else {
	                this_.updateCounter_++;
	                this_._onBoundsChanged(map, maps);
	              }
	            }
	          }
	        });
	
	        maps.event.addListener(map, 'idle', function () {
	          if (_this.resetSizeOnIdle_) {
	            _this._setViewSize();
	            var currMinZoom = _this._computeMinZoom(_this.props.options.minZoom);
	
	            if (currMinZoom !== _this.minZoom_) {
	              _this.minZoom_ = currMinZoom;
	              map.setOptions({ minZoom: currMinZoom });
	            }
	
	            _this.resetSizeOnIdle_ = false;
	          }
	
	          if (this_.zoomAnimationInProgress_) {
	            this_.zoomAnimationInProgress_ = false;
	            this_._onZoomAnimationEnd();
	          }
	
	          this_.updateCounter_++;
	          this_._onBoundsChanged(map, maps);
	
	          this_.dragTime_ = 0;
	
	          if (this_.markersDispatcher_) {
	            this_.markersDispatcher_.emit('kON_CHANGE');
	          }
	        });
	
	        maps.event.addListener(map, 'mouseover', function () {
	          // has advantage over div MouseLeave
	          this_.mouseInMap_ = true;
	        });
	
	        // an alternative way to know the mouse is back within the map
	        // This would not fire when clicking/interacting with google maps
	        // own on-map countrols+markers. This handles an edge case for touch devices
	        // + 'draggable:false' custom option. See #332 for more details.
	        maps.event.addListener(map, 'click', function () {
	          this_.mouseInMap_ = true;
	        });
	
	        maps.event.addListener(map, 'mouseout', function () {
	          // has advantage over div MouseLeave
	          this_.mouseInMap_ = false;
	          this_.mouse_ = null;
	          this_.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	        });
	
	        maps.event.addListener(map, 'drag', function () {
	          this_.dragTime_ = new Date().getTime();
	          this_._onDrag(map);
	        });
	        // user choosing satellite vs roads, etc
	        maps.event.addListener(map, 'maptypeid_changed', function () {
	          this_._onMapTypeIdChange(map.getMapTypeId());
	        });
	      }).catch(function (e) {
	        // notify callback of load failure
	        _this._onGoogleApiLoaded({ map: null, maps: null });
	        console.error(e); // eslint-disable-line no-console
	        throw e;
	      });
	    };
	
	    _this._onGoogleApiLoaded = function () {
	      if (_this.props.onGoogleApiLoaded) {
	        var _this$props;
	
	        if (false) {
	          console.warn('GoogleMap: ' + // eslint-disable-line
	          'Usage of internal api objects is dangerous ' + 'and can cause a lot of issues.\n' + 'To hide this warning add yesIWantToUseGoogleMapApiInternals={true} ' + 'to <GoogleMap instance');
	        }
	
	        (_this$props = _this.props).onGoogleApiLoaded.apply(_this$props, arguments);
	      }
	    };
	
	    _this._getHoverDistance = function () {
	      return _this.props.hoverDistance;
	    };
	
	    _this._onDrag = function () {
	      var _this$props2;
	
	      return _this.props.onDrag && (_this$props2 = _this.props).onDrag.apply(_this$props2, arguments);
	    };
	
	    _this._onMapTypeIdChange = function () {
	      var _this$props3;
	
	      return _this.props.onMapTypeIdChange && (_this$props3 = _this.props).onMapTypeIdChange.apply(_this$props3, arguments);
	    };
	
	    _this._onZoomAnimationStart = function () {
	      var _this$props4;
	
	      return _this.props.onZoomAnimationStart && (_this$props4 = _this.props).onZoomAnimationStart.apply(_this$props4, arguments);
	    };
	
	    _this._onZoomAnimationEnd = function () {
	      var _this$props5;
	
	      return _this.props.onZoomAnimationEnd && (_this$props5 = _this.props).onZoomAnimationEnd.apply(_this$props5, arguments);
	    };
	
	    _this._onTilesLoaded = function () {
	      return _this.props.onTilesLoaded && _this.props.onTilesLoaded();
	    };
	
	    _this._onChildClick = function () {
	      if (_this.props.onChildClick) {
	        var _this$props6;
	
	        return (_this$props6 = _this.props).onChildClick.apply(_this$props6, arguments);
	      }
	      return undefined;
	    };
	
	    _this._onChildMouseDown = function (hoverKey, childProps) {
	      _this.childMouseDownArgs_ = [hoverKey, childProps];
	      if (_this.props.onChildMouseDown) {
	        _this.props.onChildMouseDown(hoverKey, childProps, _extends({}, _this.mouse_));
	      }
	    };
	
	    _this._onChildMouseUp = function () {
	      if (_this.childMouseDownArgs_) {
	        if (_this.props.onChildMouseUp) {
	          var _this$props7;
	
	          (_this$props7 = _this.props).onChildMouseUp.apply(_this$props7, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
	        }
	        _this.childMouseDownArgs_ = null;
	        _this.childMouseUpTime_ = new Date().getTime();
	      }
	    };
	
	    _this._onChildMouseMove = function () {
	      if (_this.childMouseDownArgs_) {
	        if (_this.props.onChildMouseMove) {
	          var _this$props8;
	
	          (_this$props8 = _this.props).onChildMouseMove.apply(_this$props8, _this.childMouseDownArgs_.concat([_extends({}, _this.mouse_)]));
	        }
	      }
	    };
	
	    _this._onChildMouseEnter = function () {
	      if (_this.props.onChildMouseEnter) {
	        var _this$props9;
	
	        return (_this$props9 = _this.props).onChildMouseEnter.apply(_this$props9, arguments);
	      }
	      return undefined;
	    };
	
	    _this._onChildMouseLeave = function () {
	      if (_this.props.onChildMouseLeave) {
	        var _this$props10;
	
	        return (_this$props10 = _this.props).onChildMouseLeave.apply(_this$props10, arguments);
	      }
	      return undefined;
	    };
	
	    _this._setViewSize = function () {
	      if (!_this.mounted_) return;
	      if (isFullScreen()) {
	        _this.geoService_.setViewSize(window.innerWidth, window.innerHeight);
	      } else {
	        var mapDom = _reactDom2.default.findDOMNode(_this.googleMapDom_);
	        _this.geoService_.setViewSize(mapDom.clientWidth, mapDom.clientHeight);
	      }
	      _this._onBoundsChanged();
	    };
	
	    _this._onWindowResize = function () {
	      _this.resetSizeOnIdle_ = true;
	    };
	
	    _this._onMapMouseMove = function (e) {
	      if (!_this.mouseInMap_) return;
	
	      var currTime = new Date().getTime();
	      var K_RECALC_CLIENT_RECT_MS = 50;
	
	      if (currTime - _this.mouseMoveTime_ > K_RECALC_CLIENT_RECT_MS) {
	        _this.boundingRect_ = e.currentTarget.getBoundingClientRect();
	      }
	      _this.mouseMoveTime_ = currTime;
	
	      var mousePosX = e.clientX - _this.boundingRect_.left;
	      var mousePosY = e.clientY - _this.boundingRect_.top;
	
	      if (!_this.mouse_) {
	        _this.mouse_ = { x: 0, y: 0, lat: 0, lng: 0 };
	      }
	
	      _this.mouse_.x = mousePosX;
	      _this.mouse_.y = mousePosY;
	
	      var latLng = _this.geoService_.fromContainerPixelToLatLng(_this.mouse_);
	      _this.mouse_.lat = latLng.lat;
	      _this.mouse_.lng = latLng.lng;
	
	      _this._onChildMouseMove();
	
	      if (currTime - _this.dragTime_ < K_IDLE_TIMEOUT) {
	        _this.fireMouseEventOnIdle_ = true;
	      } else {
	        _this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	        _this.fireMouseEventOnIdle_ = false;
	      }
	    };
	
	    _this._onClick = function () {
	      var _this$props11;
	
	      return _this.props.onClick && !_this.childMouseDownArgs_ && new Date().getTime() - _this.childMouseUpTime_ > K_IDLE_CLICK_TIMEOUT && _this.dragTime_ === 0 && (_this$props11 = _this.props).onClick.apply(_this$props11, arguments);
	    };
	
	    _this._onMapClick = function (event) {
	      if (_this.markersDispatcher_) {
	        // support touch events and recalculate mouse position on click
	        _this._onMapMouseMove(event);
	        var currTime = new Date().getTime();
	        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
	          if (_this.mouse_) {
	            _this._onClick(_extends({}, _this.mouse_, {
	              event: event
	            }));
	          }
	
	          _this.markersDispatcher_.emit('kON_CLICK', event);
	        }
	      }
	    };
	
	    _this._onMapMouseDownNative = function (event) {
	      if (!_this.mouseInMap_) return;
	
	      _this._onMapMouseDown(event);
	    };
	
	    _this._onMapMouseDown = function (event) {
	      if (_this.markersDispatcher_) {
	        var currTime = new Date().getTime();
	        if (currTime - _this.dragTime_ > K_IDLE_TIMEOUT) {
	          // Hovered marker detected at mouse move could be deleted at mouse down time
	          // so it will be good to force hovered marker recalculation
	          _this._onMapMouseMove(event);
	          _this.markersDispatcher_.emit('kON_MDOWN', event);
	        }
	      }
	    };
	
	    _this._onMapMouseDownCapture = function () {
	      if ((0, _detect2.default)().isChrome) {
	        // to fix strange zoom in chrome
	        _this.zoomControlClickTime_ = new Date().getTime();
	      }
	    };
	
	    _this._onKeyDownCapture = function () {
	      if ((0, _detect2.default)().isChrome) {
	        _this.zoomControlClickTime_ = new Date().getTime();
	      }
	    };
	
	    _this._isCenterDefined = function (center) {
	      return center && ((0, _isPlainObject2.default)(center) && (0, _isNumber2.default)(center.lat) && (0, _isNumber2.default)(center.lng) || center.length === 2 && (0, _isNumber2.default)(center[0]) && (0, _isNumber2.default)(center[1]));
	    };
	
	    _this._onBoundsChanged = function (map, maps, callExtBoundsChange) {
	      if (map) {
	        var gmC = map.getCenter();
	        _this.geoService_.setView([gmC.lat(), gmC.lng()], map.getZoom(), 0);
	      }
	
	      if ((_this.props.onChange || _this.props.onBoundsChange) && _this.geoService_.canProject()) {
	        var zoom = _this.geoService_.getZoom();
	        var bounds = _this.geoService_.getBounds();
	        var centerLatLng = _this.geoService_.getCenter();
	
	        if (!(0, _isArraysEqualEps2.default)(bounds, _this.prevBounds_, kEPS)) {
	          if (callExtBoundsChange !== false) {
	            var marginBounds = _this.geoService_.getBounds(_this.props.margin);
	            if (_this.props.onBoundsChange) {
	              _this.props.onBoundsChange(_this.centerIsObject_ ? _extends({}, centerLatLng) : [centerLatLng.lat, centerLatLng.lng], zoom, bounds, marginBounds);
	            }
	
	            if (_this.props.onChange) {
	              _this.props.onChange({
	                center: _extends({}, centerLatLng),
	                zoom: zoom,
	                bounds: {
	                  nw: {
	                    lat: bounds[0],
	                    lng: bounds[1]
	                  },
	                  se: {
	                    lat: bounds[2],
	                    lng: bounds[3]
	                  },
	                  sw: {
	                    lat: bounds[4],
	                    lng: bounds[5]
	                  },
	                  ne: {
	                    lat: bounds[6],
	                    lng: bounds[7]
	                  }
	                },
	                marginBounds: {
	                  nw: {
	                    lat: marginBounds[0],
	                    lng: marginBounds[1]
	                  },
	                  se: {
	                    lat: marginBounds[2],
	                    lng: marginBounds[3]
	                  },
	                  sw: {
	                    lat: marginBounds[4],
	                    lng: marginBounds[5]
	                  },
	                  ne: {
	                    lat: marginBounds[6],
	                    lng: marginBounds[7]
	                  }
	                },
	
	                size: _this.geoService_.hasSize() ? {
	                  width: _this.geoService_.getWidth(),
	                  height: _this.geoService_.getHeight()
	                } : {
	                  width: 0,
	                  height: 0
	                }
	              });
	            }
	
	            _this.prevBounds_ = bounds;
	          }
	        }
	      }
	    };
	
	    _this._registerChild = function (ref) {
	      _this.googleMapDom_ = ref;
	    };
	
	    _this.mounted_ = false;
	    _this.initialized_ = false;
	    _this.googleApiLoadedCalled_ = false;
	
	    _this.map_ = null;
	    _this.maps_ = null;
	    _this.prevBounds_ = null;
	    _this.heatmap = null;
	
	    _this.layers_ = {};
	
	    _this.mouse_ = null;
	    _this.mouseMoveTime_ = 0;
	    _this.boundingRect_ = null;
	    _this.mouseInMap_ = true;
	
	    _this.dragTime_ = 0;
	    _this.fireMouseEventOnIdle_ = false;
	    _this.updateCounter_ = 0;
	
	    _this.markersDispatcher_ = new _marker_dispatcher2.default(_this);
	    _this.geoService_ = new _geo2.default(K_GOOGLE_TILE_SIZE);
	    _this.centerIsObject_ = (0, _isPlainObject2.default)(_this.props.center);
	
	    _this.minZoom_ = DEFAULT_MIN_ZOOM;
	    _this.defaultDraggableOption_ = true;
	
	    _this.zoomControlClickTime_ = 0;
	
	    _this.childMouseDownArgs_ = null;
	    _this.childMouseUpTime_ = 0;
	
	    _this.googleMapDom_ = null;
	
	    if (false) {
	      if (_this.props.apiKey) {
	        console.warn('GoogleMap: ' + // eslint-disable-line no-console
	        'apiKey is deprecated, use ' + 'bootstrapURLKeys={{key: YOUR_API_KEY}} instead.');
	      }
	
	      if (_this.props.onBoundsChange) {
	        console.warn('GoogleMap: ' + // eslint-disable-line no-console
	        'onBoundsChange is deprecated, use ' + 'onChange({center, zoom, bounds, ...other}) instead.');
	      }
	
	      if ((0, _isEmpty2.default)(_this.props.center) && (0, _isEmpty2.default)(_this.props.defaultCenter)) {
	        console.warn('GoogleMap: center or defaultCenter property must be defined' // eslint-disable-line no-console
	        );
	      }
	
	      if ((0, _isEmpty2.default)(_this.props.zoom) && (0, _isEmpty2.default)(_this.props.defaultZoom)) {
	        console.warn('GoogleMap: zoom or defaultZoom property must be defined' // eslint-disable-line no-console
	        );
	      }
	    }
	
	    if (_this._isCenterDefined(_this.props.center || _this.props.defaultCenter)) {
	      var propsCenter = latLng2Obj(_this.props.center || _this.props.defaultCenter);
	      _this.geoService_.setView(propsCenter, _this.props.zoom || _this.props.defaultZoom, 0);
	    }
	
	    _this.zoomAnimationInProgress_ = false;
	
	    _this.state = {
	      overlay: null
	    };
	    return _this;
	  }
	
	  GoogleMap.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.mounted_ = true;
	    (0, _passiveEvents2.default)(window, 'resize', this._onWindowResize, false);
	    (0, _passiveEvents2.default)(window, 'keydown', this._onKeyDownCapture, true);
	    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
	    // gmap can't prevent map drag if mousedown event already occured
	    // the only workaround I find is prevent mousedown native browser event
	
	    if (mapDom) {
	      (0, _passiveEvents2.default)(mapDom, 'mousedown', this._onMapMouseDownNative, true);
	    }
	
	    (0, _passiveEvents2.default)(window, 'mouseup', this._onChildMouseUp, false);
	    var bootstrapURLKeys = _extends({}, this.props.apiKey && { key: this.props.apiKey }, this.props.bootstrapURLKeys);
	
	    this.props.googleMapLoader(bootstrapURLKeys, this.props.heatmapLibrary); // we can start load immediatly
	
	    setTimeout(function () {
	      // to detect size
	      _this2._setViewSize();
	      if (_this2._isCenterDefined(_this2.props.center || _this2.props.defaultCenter)) {
	        _this2._initMap();
	      }
	    }, 0, this);
	    if (this.props.resetBoundsOnResize) {
	      var that = this;
	      _detectElementResize2.default.addResizeListener(mapDom, that._mapDomResizeCallback);
	    }
	  };
	
	  GoogleMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    if (false) {
	      if (!(0, _shallowEqual2.default)(this.props.defaultCenter, nextProps.defaultCenter)) {
	        console.warn("GoogleMap: defaultCenter prop changed. You can't change default props.");
	      }
	
	      if (!(0, _shallowEqual2.default)(this.props.defaultZoom, nextProps.defaultZoom)) {
	        console.warn("GoogleMap: defaultZoom prop changed. You can't change default props.");
	      }
	    }
	
	    if (!this._isCenterDefined(this.props.center) && this._isCenterDefined(nextProps.center)) {
	      setTimeout(function () {
	        return _this3._initMap();
	      }, 0);
	    }
	
	    if (this.map_) {
	      var centerLatLng = this.geoService_.getCenter();
	      if (this._isCenterDefined(nextProps.center)) {
	        var nextPropsCenter = latLng2Obj(nextProps.center);
	        var currCenter = this._isCenterDefined(this.props.center) ? latLng2Obj(this.props.center) : null;
	
	        if (!currCenter || Math.abs(nextPropsCenter.lat - currCenter.lat) + Math.abs(nextPropsCenter.lng - currCenter.lng) > kEPS) {
	          if (Math.abs(nextPropsCenter.lat - centerLatLng.lat) + Math.abs(nextPropsCenter.lng - centerLatLng.lng) > kEPS) {
	            this.map_.panTo({
	              lat: nextPropsCenter.lat,
	              lng: nextPropsCenter.lng
	            });
	          }
	        }
	      }
	
	      if (!(0, _isEmpty2.default)(nextProps.zoom)) {
	        // if zoom chaged by user
	        if (Math.abs(nextProps.zoom - this.props.zoom) > 0) {
	          this.map_.setZoom(nextProps.zoom);
	        }
	      }
	
	      if (!(0, _isEmpty2.default)(this.props.draggable) && (0, _isEmpty2.default)(nextProps.draggable)) {
	        // reset to default
	        this.map_.setOptions({ draggable: this.defaultDraggableOption_ });
	      } else if (!(0, _shallowEqual2.default)(this.props.draggable, nextProps.draggable)) {
	        // also prevent this on window 'mousedown' event to prevent map move
	        this.map_.setOptions({ draggable: nextProps.draggable });
	      }
	
	      // use shallowEqual to try avoid calling map._setOptions if only the ref changes
	      if (!(0, _isEmpty2.default)(nextProps.options) && !(0, _shallowEqual2.default)(this.props.options, nextProps.options)) {
	        var mapPlainObjects = (0, _pick2.default)(this.maps_, _isPlainObject2.default);
	        var options = typeof nextProps.options === 'function' ? nextProps.options(mapPlainObjects) : nextProps.options;
	        // remove zoom, center and draggable options as these are managed by google-maps-react
	        options = (0, _omit2.default)(options, ['zoom', 'center', 'draggable']);
	
	        if ('minZoom' in options) {
	          var minZoom = this._computeMinZoom(options.minZoom);
	          options.minZoom = _checkMinZoom(options.minZoom, minZoom);
	        }
	
	        this.map_.setOptions(options);
	      }
	
	      if (!(0, _shallowEqual2.default)(nextProps.layerTypes, this.props.layerTypes)) {
	        Object.keys(this.layers_).forEach(function (layerKey) {
	          _this3.layers_[layerKey].setMap(null);
	          delete _this3.layers_[layerKey];
	        });
	        this._setLayers(nextProps.layerTypes);
	      }
	    }
	  };
	
	  GoogleMap.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    // draggable does not affect inner components
	    return !(0, _shallowEqual2.default)((0, _omit2.default)(this.props, ['draggable']), (0, _omit2.default)(nextProps, ['draggable'])) || !(0, _shallowEqual2.default)(this.state, nextState);
	  };
	
	  GoogleMap.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    this.markersDispatcher_.emit('kON_CHANGE');
	
	    if (!(0, _shallowEqual2.default)(this.props.hoverDistance, prevProps.hoverDistance)) {
	      this.markersDispatcher_.emit('kON_MOUSE_POSITION_CHANGE');
	    }
	  };
	
	  GoogleMap.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.mounted_ = false;
	    var mapDom = _reactDom2.default.findDOMNode(this.googleMapDom_);
	    if (mapDom) {
	      mapDom.removeEventListener('mousedown', this._onMapMouseDownNative, true);
	    }
	    window.removeEventListener('resize', this._onWindowResize);
	    window.removeEventListener('keydown', this._onKeyDownCapture);
	    window.removeEventListener('mouseup', this._onChildMouseUp, false);
	    if (this.props.resetBoundsOnResize) {
	      _detectElementResize2.default.removeResizeListener(mapDom, this._mapDomResizeCallback);
	    }
	
	    if (this.overlay_) {
	      // this triggers overlay_.onRemove(), which will unmount the <GoogleMapMarkers/>
	      this.overlay_.setMap(null);
	    }
	
	    if (this.maps_ && this.map_) {
	      // fix google, as otherwise listeners works even without map
	      this.map_.setOptions({ scrollwheel: false });
	      this.maps_.event.clearInstanceListeners(this.map_);
	    }
	
	    this.map_ = null;
	    this.maps_ = null;
	    this.markersDispatcher_.dispose();
	
	    this.resetSizeOnIdle_ = false;
	
	    delete this.map_;
	    delete this.markersDispatcher_;
	  };
	  // calc minZoom if map size available
	  // it's better to not set minZoom less than this calculation gives
	  // otherwise there is no homeomorphism between screen coordinates and map
	  // (one map coordinate can have different screen coordinates)
	
	
	  // this method works only if this.props.onChildMouseDown was called
	
	
	  // this method works only if this.props.onChildMouseDown was called
	
	
	  // K_IDLE_CLICK_TIMEOUT - looks like 300 is enough
	
	
	  // gmap can't prevent map drag if mousedown event already occured
	  // the only workaround I find is prevent mousedown native browser event
	
	
	  GoogleMap.prototype.render = function render() {
	    var overlay = this.state.overlay;
	    var mapMarkerPrerender = !overlay ? _react2.default.createElement(_google_map_markers_prerender2.default, {
	      experimental: this.props.experimental,
	      onChildClick: this._onChildClick,
	      onChildMouseDown: this._onChildMouseDown,
	      onChildMouseEnter: this._onChildMouseEnter,
	      onChildMouseLeave: this._onChildMouseLeave,
	      geoService: this.geoService_,
	      insideMapPanes: false,
	      distanceToMouse: this.props.distanceToMouse,
	      getHoverDistance: this._getHoverDistance,
	      dispatcher: this.markersDispatcher_
	    }) : null;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: this.props.style,
	        onMouseMove: this._onMapMouseMove,
	        onMouseDownCapture: this._onMapMouseDownCapture,
	        onClick: this._onMapClick
	      },
	      _react2.default.createElement(_google_map_map2.default, { registerChild: this._registerChild }),
	      IS_REACT_16 && overlay && createPortal(this._renderPortal(), overlay),
	      mapMarkerPrerender
	    );
	  };
	
	  return GoogleMap;
	}(_react.Component);
	
	GoogleMap.propTypes = {
	  apiKey: _propTypes2.default.string,
	  bootstrapURLKeys: _propTypes2.default.any,
	
	  defaultCenter: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
	    lat: _propTypes2.default.number,
	    lng: _propTypes2.default.number
	  })]),
	  center: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
	    lat: _propTypes2.default.number,
	    lng: _propTypes2.default.number
	  })]),
	  defaultZoom: _propTypes2.default.number,
	  zoom: _propTypes2.default.number,
	  onBoundsChange: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onChildClick: _propTypes2.default.func,
	  onChildMouseDown: _propTypes2.default.func,
	  onChildMouseUp: _propTypes2.default.func,
	  onChildMouseMove: _propTypes2.default.func,
	  onChildMouseEnter: _propTypes2.default.func,
	  onChildMouseLeave: _propTypes2.default.func,
	  onZoomAnimationStart: _propTypes2.default.func,
	  onZoomAnimationEnd: _propTypes2.default.func,
	  onDrag: _propTypes2.default.func,
	  onMapTypeIdChange: _propTypes2.default.func,
	  onTilesLoaded: _propTypes2.default.func,
	  options: _propTypes2.default.any,
	  distanceToMouse: _propTypes2.default.func,
	  hoverDistance: _propTypes2.default.number,
	  debounced: _propTypes2.default.bool,
	  margin: _propTypes2.default.array,
	  googleMapLoader: _propTypes2.default.any,
	  onGoogleApiLoaded: _propTypes2.default.func,
	  yesIWantToUseGoogleMapApiInternals: _propTypes2.default.bool,
	  draggable: _propTypes2.default.bool,
	  style: _propTypes2.default.any,
	  resetBoundsOnResize: _propTypes2.default.bool,
	  layerTypes: _propTypes2.default.arrayOf(_propTypes2.default.string) // ['TransitLayer', 'TrafficLayer']
	};
	GoogleMap.defaultProps = {
	  distanceToMouse: function distanceToMouse(pt, mousePos /* , markerProps */) {
	    return Math.sqrt((pt.x - mousePos.x) * (pt.x - mousePos.x) + (pt.y - mousePos.y) * (pt.y - mousePos.y));
	  },
	
	  hoverDistance: 30,
	  debounced: true,
	  options: defaultOptions_,
	  googleMapLoader: _google_map_loader2.default,
	  yesIWantToUseGoogleMapApiInternals: false,
	  style: {
	    width: '100%',
	    height: '100%',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	  layerTypes: [],
	  heatmap: {},
	  heatmapLibrary: false
	};
	GoogleMap.googleMapLoader = _google_map_loader2.default;
	exports.default = GoogleMap;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var style = {
	  width: '100%',
	  height: '100%',
	  left: 0,
	  top: 0,
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	};
	
	var GoogleMapMap = function (_Component) {
	  _inherits(GoogleMapMap, _Component);
	
	  function GoogleMapMap() {
	    _classCallCheck(this, GoogleMapMap);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  GoogleMapMap.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return false; // disable react on this div
	  };
	
	  GoogleMapMap.prototype.render = function render() {
	    var registerChild = this.props.registerChild;
	
	    return _react2.default.createElement('div', { ref: registerChild, style: style });
	  };
	
	  return GoogleMapMap;
	}(_react.Component);
	
	exports.default = GoogleMapMap;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { style: style },
	    _react2.default.createElement(_google_map_markers2.default, _extends({}, props, { prerender: true }))
	  );
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _google_map_markers = __webpack_require__(134);
	
	var _google_map_markers2 = _interopRequireDefault(_google_map_markers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = {
	  width: '50%',
	  height: '50%',
	  left: '50%',
	  top: '50%',
	  // backgroundColor: 'red',
	  margin: 0,
	  padding: 0,
	  position: 'absolute'
	  // opacity: 0.3
	};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _google_map = __webpack_require__(283);
	
	var _google_map2 = _interopRequireDefault(_google_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _google_map2.default;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var BASE_URL = 'https://maps';
	var DEFAULT_URL = BASE_URL + '.googleapis.com';
	var API_PATH = '/maps/api/js?callback=_$_google_map_initialize_$_';
	
	var getUrl = function getUrl(region) {
	  if (region && region.toLowerCase() === 'cn') {
	    return BASE_URL + '.google.cn';
	  }
	  return DEFAULT_URL;
	};
	
	var $script_ = null;
	
	var loadPromise_ = void 0;
	
	var resolveCustomPromise_ = void 0;
	
	var _customPromise = new Promise(function (resolve) {
	  resolveCustomPromise_ = resolve;
	});
	
	// TODO add libraries language and other map options
	
	exports.default = function (bootstrapURLKeys, heatmapLibrary) {
	  if (!$script_) {
	    $script_ = __webpack_require__(321); // eslint-disable-line
	  }
	
	  // call from outside google-map-react
	  // will be as soon as loadPromise_ resolved
	  if (!bootstrapURLKeys) {
	    return _customPromise;
	  }
	
	  if (loadPromise_) {
	    return loadPromise_;
	  }
	
	  loadPromise_ = new Promise(function (resolve, reject) {
	    if (typeof window === 'undefined') {
	      reject(new Error('google map cannot be loaded outside browser env'));
	      return;
	    }
	
	    if (window.google && window.google.maps) {
	      resolve(window.google.maps);
	      return;
	    }
	
	    if (typeof window._$_google_map_initialize_$_ !== 'undefined') {
	      reject(new Error('google map initialization error'));
	    }
	
	    window._$_google_map_initialize_$_ = function () {
	      delete window._$_google_map_initialize_$_;
	      resolve(window.google.maps);
	    };
	
	    if (false) {
	      if (Object.keys(bootstrapURLKeys).indexOf('callback') > -1) {
	        var message = '"callback" key in bootstrapURLKeys is not allowed,\n                          use onGoogleApiLoaded property instead';
	        // eslint-disable-next-line no-console
	        console.error(message);
	        throw new Error(message);
	      }
	    }
	
	    var params = Object.keys(bootstrapURLKeys).reduce(function (r, key) {
	      return r + '&' + key + '=' + bootstrapURLKeys[key];
	    }, '');
	
	    var baseUrl = getUrl(bootstrapURLKeys.region);
	    var libraries = heatmapLibrary ? '&libraries=visualization' : '';
	
	    $script_('' + baseUrl + API_PATH + params + libraries, function () {
	      return typeof window.google === 'undefined' && reject(new Error('google map initialization error (not loaded)'));
	    });
	  });
	
	  resolveCustomPromise_(loadPromise_);
	
	  return loadPromise_;
	};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _eventemitter = __webpack_require__(277);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarkerDispatcher = function (_EventEmitter) {
	  _inherits(MarkerDispatcher, _EventEmitter);
	
	  function MarkerDispatcher(gmapInstance) {
	    _classCallCheck(this, MarkerDispatcher);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.gmapInstance = gmapInstance;
	    return _this;
	  }
	
	  MarkerDispatcher.prototype.getChildren = function getChildren() {
	    return this.gmapInstance.props.children;
	  };
	
	  MarkerDispatcher.prototype.getMousePosition = function getMousePosition() {
	    return this.gmapInstance.mouse_;
	  };
	
	  MarkerDispatcher.prototype.getUpdateCounter = function getUpdateCounter() {
	    return this.gmapInstance.updateCounter_;
	  };
	
	  MarkerDispatcher.prototype.dispose = function dispose() {
	    this.gmapInstance = null;
	    this.removeAllListeners();
	  };
	
	  return MarkerDispatcher;
	}(_eventemitter2.default);
	
	exports.default = MarkerDispatcher;

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = detectBrowser;
	// http://stackoverflow.com/questions/5899783/detect-safari-chrome-ie-firefox-opera-with-user-agent
	var detectBrowserResult_ = null;
	
	function detectBrowser() {
	  if (detectBrowserResult_) {
	    return detectBrowserResult_;
	  }
	
	  if (typeof navigator !== 'undefined') {
	    var isExplorer = navigator.userAgent.indexOf('MSIE') > -1;
	    var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
	    var isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1;
	
	    var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
	    var isSafari = navigator.userAgent.indexOf('Safari') > -1;
	
	    if (isChrome && isSafari) {
	      isSafari = false;
	    }
	
	    if (isChrome && isOpera) {
	      isChrome = false;
	    }
	
	    detectBrowserResult_ = {
	      isExplorer: isExplorer,
	      isFirefox: isFirefox,
	      isOpera: isOpera,
	      isChrome: isChrome,
	      isSafari: isSafari
	    };
	    return detectBrowserResult_;
	  }
	
	  detectBrowserResult_ = {
	    isChrome: true,
	    isExplorer: false,
	    isFirefox: false,
	    isOpera: false,
	    isSafari: false
	  };
	
	  return detectBrowserResult_;
	}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _passiveEvents = __webpack_require__(138);
	
	var _passiveEvents2 = _interopRequireDefault(_passiveEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reliable `window` and `document` detection
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// Check `document` and `window` in case of server-side rendering
	/* eslint-disable */
	/**
	* Detect Element Resize.
	* Forked in order to guard against unsafe 'window' and 'document' references.
	*
	* https://github.com/sdecima/javascript-detect-element-resize
	* Sebastian Decima
	*
	* version: 0.5.3
	**/
	
	var _window;
	if (canUseDOM) {
	  _window = window;
	} else if (typeof self !== 'undefined') {
	  _window = self;
	} else {
	  _window = undefined;
	}
	
	var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	var stylesCreated = false;
	
	if (canUseDOM && !attachEvent) {
	  var requestFrame = function () {
	    var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	      return _window.setTimeout(fn, 20);
	    };
	    return function (fn) {
	      return raf(fn);
	    };
	  }();
	
	  var cancelFrame = function () {
	    var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	    return function (id) {
	      return cancel(id);
	    };
	  }();
	
	  var resetTriggers = function resetTriggers(element) {
	    var triggers = element.__resizeTriggers__,
	        expand = triggers.firstElementChild,
	        contract = triggers.lastElementChild,
	        expandChild = expand.firstElementChild;
	    contract.scrollLeft = contract.scrollWidth;
	    contract.scrollTop = contract.scrollHeight;
	    expandChild.style.width = expand.offsetWidth + 1 + 'px';
	    expandChild.style.height = expand.offsetHeight + 1 + 'px';
	    expand.scrollLeft = expand.scrollWidth;
	    expand.scrollTop = expand.scrollHeight;
	  };
	
	  var checkTriggers = function checkTriggers(element) {
	    return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	  };
	
	  var scrollListener = function scrollListener(e) {
	    var element = this;
	    resetTriggers(this);
	    if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
	    this.__resizeRAF__ = requestFrame(function () {
	      if (checkTriggers(element)) {
	        element.__resizeLast__.width = element.offsetWidth;
	        element.__resizeLast__.height = element.offsetHeight;
	        element.__resizeListeners__.forEach(function (fn) {
	          fn.call(element, e);
	        });
	      }
	    });
	  };
	
	  /* Detect CSS Animations support to detect element display/re-attach */
	  var animation = false,
	      animationstring = 'animation',
	      keyframeprefix = '',
	      animationstartevent = 'animationstart',
	      domPrefixes = 'Webkit Moz O ms'.split(' '),
	      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	      pfx = '';
	
	  if (canUseDOM) {
	    var elm = document.createElement('fakeelement');
	    if (elm.style.animationName !== undefined) {
	      animation = true;
	    }
	
	    if (animation === false) {
	      for (var i = 0; i < domPrefixes.length; i++) {
	        if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	          pfx = domPrefixes[i];
	          animationstring = pfx + 'Animation';
	          keyframeprefix = '-' + pfx.toLowerCase() + '-';
	          animationstartevent = startEvents[i];
	          animation = true;
	          break;
	        }
	      }
	    }
	  }
	
	  var animationName = 'resizeanim';
	  var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	  var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	}
	
	var createStyles = function createStyles() {
	  if (!stylesCreated) {
	    //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	    var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	        head = document.head || document.getElementsByTagName('head')[0],
	        style = document.createElement('style');
	
	    style.type = 'text/css';
	    if (style.styleSheet) {
	      style.styleSheet.cssText = css;
	    } else {
	      style.appendChild(document.createTextNode(css));
	    }
	
	    head.appendChild(style);
	    stylesCreated = true;
	  }
	};
	
	var addResizeListener = function addResizeListener(element, fn) {
	  if (element.parentNode === undefined) {
	    var tempParentDiv = document.createElement('div');
	    element.parentNode = tempParentDiv;
	  }
	  element = element.parentNode;
	  if (attachEvent) element.attachEvent('onresize', fn);else {
	    if (!element.__resizeTriggers__) {
	      if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
	      createStyles();
	      element.__resizeLast__ = {};
	      element.__resizeListeners__ = [];
	      (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
	      element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	      element.appendChild(element.__resizeTriggers__);
	      resetTriggers(element);
	
	      (0, _passiveEvents2.default)(element, 'scroll', scrollListener, true);
	
	      /* Listen for a css animation to detect element display/re-attach */
	      animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
	        if (e.animationName == animationName) resetTriggers(element);
	      });
	    }
	    element.__resizeListeners__.push(fn);
	  }
	};
	
	var removeResizeListener = function removeResizeListener(element, fn) {
	  element = element.parentNode;
	  if (attachEvent) element.detachEvent('onresize', fn);else {
	    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	    if (!element.__resizeListeners__.length) {
	      element.removeEventListener('scroll', scrollListener);
	      element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	    }
	  }
	};
	
	module.exports = {
	  addResizeListener: addResizeListener,
	  removeResizeListener: removeResizeListener
	};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _pointGeometry = __webpack_require__(98);
	
	var _pointGeometry2 = _interopRequireDefault(_pointGeometry);
	
	var _lat_lng = __webpack_require__(135);
	
	var _lat_lng2 = _interopRequireDefault(_lat_lng);
	
	var _transform = __webpack_require__(296);
	
	var _transform2 = _interopRequireDefault(_transform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Geo = function () {
	  function Geo(tileSize) {
	    _classCallCheck(this, Geo);
	
	    // left_top view пользует гугл
	    // super();
	    this.hasSize_ = false;
	    this.hasView_ = false;
	    this.transform_ = new _transform2.default(tileSize || 512);
	  }
	
	  Geo.prototype.setView = function setView(center, zoom, bearing) {
	    this.transform_.center = _lat_lng2.default.convert(center);
	    this.transform_.zoom = +zoom;
	    this.transform_.bearing = +bearing;
	    this.hasView_ = true;
	  };
	
	  Geo.prototype.setViewSize = function setViewSize(width, height) {
	    this.transform_.width = width;
	    this.transform_.height = height;
	    this.hasSize_ = true;
	  };
	
	  Geo.prototype.setMapCanvasProjection = function setMapCanvasProjection(maps, mapCanvasProjection) {
	    this.maps_ = maps;
	    this.mapCanvasProjection_ = mapCanvasProjection;
	  };
	
	  Geo.prototype.canProject = function canProject() {
	    return this.hasSize_ && this.hasView_;
	  };
	
	  Geo.prototype.hasSize = function hasSize() {
	    return this.hasSize_;
	  };
	
	  /** Returns the pixel position relative to the map center. */
	
	
	  Geo.prototype.fromLatLngToCenterPixel = function fromLatLngToCenterPixel(ptLatLng) {
	    return this.transform_.locationPoint(_lat_lng2.default.convert(ptLatLng));
	  };
	
	  /**
	   * Returns the pixel position relative to the map panes,
	   * or relative to the map center if there are no panes.
	   */
	
	
	  Geo.prototype.fromLatLngToDivPixel = function fromLatLngToDivPixel(ptLatLng) {
	    if (this.mapCanvasProjection_) {
	      var latLng = new this.maps_.LatLng(ptLatLng.lat, ptLatLng.lng);
	      return this.mapCanvasProjection_.fromLatLngToDivPixel(latLng);
	    }
	    return this.fromLatLngToCenterPixel(ptLatLng);
	  };
	
	  /** Returns the pixel position relative to the map top-left. */
	
	
	  Geo.prototype.fromLatLngToContainerPixel = function fromLatLngToContainerPixel(ptLatLng) {
	    if (this.mapCanvasProjection_) {
	      var latLng = new this.maps_.LatLng(ptLatLng.lat, ptLatLng.lng);
	      return this.mapCanvasProjection_.fromLatLngToContainerPixel(latLng);
	    }
	
	    var pt = this.fromLatLngToCenterPixel(ptLatLng);
	    pt.x -= this.transform_.worldSize * Math.round(pt.x / this.transform_.worldSize);
	
	    pt.x += this.transform_.width / 2;
	    pt.y += this.transform_.height / 2;
	
	    return pt;
	  };
	
	  /** Returns the LatLng for the given offset from the map top-left. */
	
	
	  Geo.prototype.fromContainerPixelToLatLng = function fromContainerPixelToLatLng(ptXY) {
	    if (this.mapCanvasProjection_) {
	      var latLng = this.mapCanvasProjection_.fromContainerPixelToLatLng(ptXY);
	      return { lat: latLng.lat(), lng: latLng.lng() };
	    }
	
	    var ptxy = _extends({}, ptXY);
	    ptxy.x -= this.transform_.width / 2;
	    ptxy.y -= this.transform_.height / 2;
	    var ptRes = this.transform_.pointLocation(_pointGeometry2.default.convert(ptxy));
	
	    ptRes.lng -= 360 * Math.round(ptRes.lng / 360); // convert 2 google format
	    return ptRes;
	  };
	
	  Geo.prototype.getWidth = function getWidth() {
	    return this.transform_.width;
	  };
	
	  Geo.prototype.getHeight = function getHeight() {
	    return this.transform_.height;
	  };
	
	  Geo.prototype.getZoom = function getZoom() {
	    return this.transform_.zoom;
	  };
	
	  Geo.prototype.getCenter = function getCenter() {
	    var ptRes = this.transform_.pointLocation({ x: 0, y: 0 });
	
	    return ptRes;
	  };
	
	  Geo.prototype.getBounds = function getBounds(margins, roundFactor) {
	    var bndT = margins && margins[0] || 0;
	    var bndR = margins && margins[1] || 0;
	    var bndB = margins && margins[2] || 0;
	    var bndL = margins && margins[3] || 0;
	
	    if (this.getWidth() - bndR - bndL > 0 && this.getHeight() - bndT - bndB > 0) {
	      var topLeftCorner = this.transform_.pointLocation(_pointGeometry2.default.convert({
	        x: bndL - this.getWidth() / 2,
	        y: bndT - this.getHeight() / 2
	      }));
	      var bottomRightCorner = this.transform_.pointLocation(_pointGeometry2.default.convert({
	        x: this.getWidth() / 2 - bndR,
	        y: this.getHeight() / 2 - bndB
	      }));
	
	      var res = [topLeftCorner.lat, topLeftCorner.lng, // NW
	      bottomRightCorner.lat, bottomRightCorner.lng, // SE
	      bottomRightCorner.lat, topLeftCorner.lng, // SW
	      topLeftCorner.lat, bottomRightCorner.lng];
	
	      if (roundFactor) {
	        res = res.map(function (r) {
	          return Math.round(r * roundFactor) / roundFactor;
	        });
	      }
	      return res;
	    }
	
	    return [0, 0, 0, 0];
	  };
	
	  return Geo;
	}();
	
	exports.default = Geo;

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isArraysEqualEps;
	function isArraysEqualEps(arrayA, arrayB, eps) {
	  if (arrayA && arrayB) {
	    for (var i = 0; i !== arrayA.length; ++i) {
	      if (Math.abs(arrayA[i] - arrayB[i]) > eps) {
	        return false;
	      }
	    }
	    return true;
	  }
	  return false;
	}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isEmpty = function isEmpty(val) {
	  // check for empty object {}, array []
	  if (val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	    if (Object.keys(val).length === 0) {
	      return true;
	    }
	  } else if (val === null || val === undefined || val === '') {
	    // check for undefined, null and ""
	    return true;
	  }
	  return false;
	};
	
	exports.default = isEmpty;

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isNumber;
	function isObjectLike(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	
	var objectToString = Object.prototype.toString;
	
	function isNumber(value) {
	  var numberTag = '[object Number]';
	  return typeof value === 'number' || isObjectLike(value) && objectToString.call(value) === numberTag;
	}

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isPlainObject;
	// source taken from https://github.com/rackt/redux/blob/master/src/utils/isPlainObject.js
	var fnToString = function fnToString(fn) {
	  return Function.prototype.toString.call(fn);
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
	    return false;
	  }
	
	  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;
	
	  if (proto === null) {
	    return true;
	  }
	
	  var constructor = proto.constructor;
	
	  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
	}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable class-methods-use-this */
	
	
	var _pointGeometry = __webpack_require__(98);
	
	var _pointGeometry2 = _interopRequireDefault(_pointGeometry);
	
	var _lat_lng = __webpack_require__(135);
	
	var _lat_lng2 = _interopRequireDefault(_lat_lng);
	
	var _wrap = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// A single transform, generally used for a single tile to be scaled, rotated, and zoomed.
	var Transform = function () {
	  function Transform(tileSize, minZoom, maxZoom) {
	    _classCallCheck(this, Transform);
	
	    this.tileSize = tileSize || 512; // constant
	
	    this._minZoom = minZoom || 0;
	    this._maxZoom = maxZoom || 52;
	
	    this.latRange = [-85.05113, 85.05113];
	
	    this.width = 0;
	    this.height = 0;
	    this.zoom = 0;
	    this.center = new _lat_lng2.default(0, 0);
	    this.angle = 0;
	  }
	
	  Transform.prototype.zoomScale = function zoomScale(zoom) {
	    return Math.pow(2, zoom);
	  };
	
	  Transform.prototype.scaleZoom = function scaleZoom(scale) {
	    return Math.log(scale) / Math.LN2;
	  };
	
	  Transform.prototype.project = function project(latlng, worldSize) {
	    return new _pointGeometry2.default(this.lngX(latlng.lng, worldSize), this.latY(latlng.lat, worldSize));
	  };
	
	  Transform.prototype.unproject = function unproject(point, worldSize) {
	    return new _lat_lng2.default(this.yLat(point.y, worldSize), this.xLng(point.x, worldSize));
	  };
	
	  // lat/lon <-> absolute pixel coords convertion
	  Transform.prototype.lngX = function lngX(lon, worldSize) {
	    return (180 + lon) * (worldSize || this.worldSize) / 360;
	  };
	
	  // latitude to absolute y coord
	
	
	  Transform.prototype.latY = function latY(lat, worldSize) {
	    var y = 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360));
	    return (180 - y) * (worldSize || this.worldSize) / 360;
	  };
	
	  Transform.prototype.xLng = function xLng(x, worldSize) {
	    return x * 360 / (worldSize || this.worldSize) - 180;
	  };
	
	  Transform.prototype.yLat = function yLat(y, worldSize) {
	    var y2 = 180 - y * 360 / (worldSize || this.worldSize);
	    return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
	  };
	
	  Transform.prototype.locationPoint = function locationPoint(latlng) {
	    var p = this.project(latlng);
	    return this.centerPoint._sub(this.point._sub(p)._rotate(this.angle));
	  };
	
	  Transform.prototype.pointLocation = function pointLocation(p) {
	    var p2 = this.centerPoint._sub(p)._rotate(-this.angle);
	    return this.unproject(this.point.sub(p2));
	  };
	
	  _createClass(Transform, [{
	    key: 'minZoom',
	    get: function get() {
	      return this._minZoom;
	    },
	    set: function set(zoom) {
	      this._minZoom = zoom;
	      this.zoom = Math.max(this.zoom, zoom);
	    }
	  }, {
	    key: 'maxZoom',
	    get: function get() {
	      return this._maxZoom;
	    },
	    set: function set(zoom) {
	      this._maxZoom = zoom;
	      this.zoom = Math.min(this.zoom, zoom);
	    }
	  }, {
	    key: 'worldSize',
	    get: function get() {
	      return this.tileSize * this.scale;
	    }
	  }, {
	    key: 'centerPoint',
	    get: function get() {
	      return new _pointGeometry2.default(0, 0); // this.size._div(2);
	    }
	  }, {
	    key: 'size',
	    get: function get() {
	      return new _pointGeometry2.default(this.width, this.height);
	    }
	  }, {
	    key: 'bearing',
	    get: function get() {
	      return -this.angle / Math.PI * 180;
	    },
	    set: function set(bearing) {
	      this.angle = -(0, _wrap.wrap)(bearing, -180, 180) * Math.PI / 180;
	    }
	  }, {
	    key: 'zoom',
	    get: function get() {
	      return this._zoom;
	    },
	    set: function set(zoom) {
	      var zoomV = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
	      this._zoom = zoomV;
	      this.scale = this.zoomScale(zoomV);
	      this.tileZoom = Math.floor(zoomV);
	      this.zoomFraction = zoomV - this.tileZoom;
	    }
	  }, {
	    key: 'x',
	    get: function get() {
	      return this.lngX(this.center.lng);
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this.latY(this.center.lat);
	    }
	  }, {
	    key: 'point',
	    get: function get() {
	      return new _pointGeometry2.default(this.x, this.y);
	    }
	  }]);
	
	  return Transform;
	}();
	
	exports.default = Transform;

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var log2 = Math.log2 ? Math.log2 : function (x) {
	  return Math.log(x) / Math.LN2;
	};
	
	exports.default = log2;

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = pick;
	// source taken from https://github.com/rackt/redux/blob/master/src/utils/pick.js
	
	function pick(obj, fn) {
	  return Object.keys(obj).reduce(function (result, key) {
	    if (fn(obj[key])) {
	      result[key] = obj[key]; // eslint-disable-line
	    }
	    return result;
	  }, {});
	}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = raf;
	function raf(callback) {
	  if (window.requestAnimationFrame) {
	    return window.requestAnimationFrame(callback);
	  }
	
	  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
	
	  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
	}

/***/ }),
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      fn(el)
	      return 1
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ }),
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(13);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _formik = __webpack_require__(95);
	
	var _reactToastify = __webpack_require__(67);
	
	var _bullet = __webpack_require__(227);
	
	var _bullet2 = _interopRequireDefault(_bullet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chisono = function (_Component) {
	    _inherits(Chisono, _Component);
	
	    function Chisono(props) {
	        _classCallCheck(this, Chisono);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            accento: '',
	            bio: ''
	        };
	        return _this;
	    }
	
	    Chisono.prototype.componentDidMount = function componentDidMount() {
	        this.setState({
	            accento: this.props.sito.coloreAccento || '#03a9f4',
	            bio: this.props.sito.bio || ''
	        });
	    };
	
	    Chisono.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'about', className: 'uk-section uk-section-secondary uk-section-large' },
	            _react2.default.createElement(
	                'div',
	                { className: 'uk-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'uk-grid-large', 'data-uk-grid': true },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'uk-width-expand@s' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'uk-clearfix' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'uk-margin uk-text-bold uk-text-uppercase' },
	                                _react2.default.createElement(_bullet2.default, { colore: this.state.accento }),
	                                this.props.user.name
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'uk-margin-small-top' },
	                            this.state.bio.split('\n').map(function (item, key) {
	                                return _react2.default.createElement(
	                                    'p',
	                                    { key: key },
	                                    item
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'uk-width-auto@s' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'uk-clearfix' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'uk-margin uk-text-bold uk-text-uppercase' },
	                                _react2.default.createElement(_bullet2.default, { colore: this.state.accento }),
	                                'Richiedi info'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _formik.Formik,
	                            {
	                                initialValues: {
	                                    nome: '',
	                                    email: '',
	                                    telefono: '',
	                                    messaggio: ''
	                                },
	                                validate: function validate(values) {
	                                    var errors = {};
	
	                                    if (!values.nome) {
	                                        errors.nome = _react2.default.createElement(
	                                            'span',
	                                            { className: 'uk-text-meta uk-text-danger' },
	                                            'Campo richiesto'
	                                        );
	                                    }
	
	                                    if (!values.telefono) {
	                                        errors.telefono = _react2.default.createElement(
	                                            'span',
	                                            { className: 'uk-text-meta uk-text-danger' },
	                                            'Campo richiesto'
	                                        );
	                                    }
	
	                                    if (!values.messaggio) {
	                                        errors.messaggio = _react2.default.createElement(
	                                            'span',
	                                            { className: 'uk-text-meta uk-text-danger' },
	                                            'Campo richiesto'
	                                        );
	                                    }
	
	                                    if (!values.email) {
	                                        errors.email = _react2.default.createElement(
	                                            'span',
	                                            { className: 'uk-text-meta uk-text-danger' },
	                                            'Campo richiesto'
	                                        );
	                                    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
	                                        errors.email = _react2.default.createElement(
	                                            'span',
	                                            { className: 'uk-text-meta uk-text-danger' },
	                                            'Indirizzo email non valido'
	                                        );
	                                    }
	
	                                    return errors;
	                                },
	
	                                onSubmit: function onSubmit(values, actions) {
	
	                                    var corpo = '<p>' + values.nome + '</p>' + '<p>' + values.email + '</p>' + '<p>' + values.telefono + '</p>' + '<p>' + values.messaggio + '</p>';
	
	                                    var email = {
	                                        email: "info@prowed.it",
	                                        nome: "Prowedding",
	                                        nomeA: _this2.props.user.name, //nome fotografo,
	                                        emailA: _this2.props.user.email, //email fotografo,
	                                        soggetto: "Messaggio ricevuto dal tuo modulo contatti",
	                                        html: corpo
	                                    };
	
	                                    _axios2.default.post('https://www.prowedding.it/.netlify/functions/email', email).then(function (res) {
	
	                                        if (res.status === 200) {
	                                            _reactToastify.toast.success('Grazie. Il tuo messaggio è stato inviato con successo.');
	                                            actions.setSubmitting(false);
	                                            actions.resetForm({});
	                                        } else {
	                                            _reactToastify.toast.error('Attenzione. Si è verificato un errore.');
	                                            actions.setSubmitting(false);
	                                            console.log(res.data.message);
	                                        }
	                                    });
	                                }
	                            },
	                            function (_ref) {
	                                var values = _ref.values,
	                                    errors = _ref.errors,
	                                    touched = _ref.touched,
	                                    handleChange = _ref.handleChange,
	                                    handleSubmit = _ref.handleSubmit,
	                                    isSubmitting = _ref.isSubmitting;
	                                return _react2.default.createElement(
	                                    'form',
	                                    { onSubmit: handleSubmit, className: 'uk-margin-small-top' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-margin' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'uk-inline uk-width-1-1' },
	                                            _react2.default.createElement('span', { className: 'uk-form-icon', href: '#', 'data-uk-icon': 'icon: user' }),
	                                            _react2.default.createElement('input', {
	                                                className: errors.nome && touched.nome ? 'uk-input uk-form-large uk-form-danger' : 'uk-input uk-form-large',
	                                                type: 'text',
	                                                placeholder: 'Nome e Cognome',
	                                                name: 'nome',
	                                                onChange: handleChange,
	                                                value: values.nome || ''
	                                            }),
	                                            errors.nome && touched.nome && errors.nome
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-margin' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'uk-inline uk-width-1-1' },
	                                            _react2.default.createElement('span', { className: 'uk-form-icon', href: '#', 'data-uk-icon': 'icon: mail' }),
	                                            _react2.default.createElement('input', {
	                                                className: errors.email && touched.email ? 'uk-input uk-form-large uk-form-danger' : 'uk-input uk-form-large',
	                                                type: 'text',
	                                                placeholder: 'Email',
	                                                name: 'email',
	                                                onChange: handleChange,
	                                                value: values.email || ''
	                                            }),
	                                            errors.email && touched.email && errors.email
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-margin' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'uk-inline uk-width-1-1' },
	                                            _react2.default.createElement('span', { className: 'uk-form-icon', href: '#', 'data-uk-icon': 'icon: receiver' }),
	                                            _react2.default.createElement('input', {
	                                                className: errors.telefono && touched.telefono ? 'uk-input uk-form-large uk-form-danger' : 'uk-input uk-form-large',
	                                                type: 'text',
	                                                placeholder: 'Telefono',
	                                                name: 'telefono',
	                                                onChange: handleChange,
	                                                value: values.telefono || ''
	                                            }),
	                                            errors.telefono && touched.telefono && errors.telefono
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-margin' },
	                                        _react2.default.createElement('textarea', {
	
	                                            className: errors.messaggio && touched.messaggio ? 'uk-textarea uk-form-large uk-form-danger' : 'uk-textarea uk-form-large',
	                                            rows: '5',
	                                            name: 'messaggio',
	                                            placeholder: 'Messaggio',
	                                            onChange: handleChange,
	                                            value: values.messaggio || ''
	                                        }),
	                                        errors.messaggio && touched.messaggio && errors.messaggio
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-margin' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: 'uk-button uk-button-default' },
	                                            isSubmitting ? 'Attendere...' : 'Invia Messaggio'
	                                        )
	                                    )
	                                );
	                            }
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Chisono;
	}(_react.Component);
	
	exports.default = Chisono;
	module.exports = exports['default'];

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(13);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _formik = __webpack_require__(95);
	
	var _reactToastify = __webpack_require__(67);
	
	var _bullet = __webpack_require__(227);
	
	var _bullet2 = _interopRequireDefault(_bullet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contatti = function (_Component) {
	    _inherits(Contatti, _Component);
	
	    function Contatti(props) {
	        _classCallCheck(this, Contatti);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            accento: ''
	        };
	        return _this;
	    }
	
	    Contatti.prototype.componentDidMount = function componentDidMount() {
	        this.setState({ accento: this.props.sito.coloreAccento || '#03a9f4' });
	    };
	
	    Contatti.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'contatti', className: 'uk-section uk-light', style: { backgroundColor: this.state.accento } },
	            _react2.default.createElement(
	                'div',
	                { className: 'uk-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'uk-grid-large', 'data-uk-grid': true },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'uk-width-expand@s' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'uk-clearfix' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'uk-margin uk-text-bold uk-text-uppercase' },
	                                _react2.default.createElement(_bullet2.default, { colore: 'rgba(255, 255, 255, .1)' }),
	                                'Contattaci'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _formik.Formik,
	                            {
	                                initialValues: {
	                                    nome: '',
	                                    email: '',
	                                    telefono: '',
	                                    messaggio: ''
	                                },
	                                validate: function validate(values) {
	                                    var errors = {};
	
	                                    if (!values.nome) {
	                                        errors.nome = _react2.default.createElement(
	                                            'span',
	                                            { className: 'uk-text-meta uk-text-danger' },
	                                            'Campo richiesto'
	                                        );
	                                    }
	
	                                    if (!values.telefono) {
	                                        errors.telefono = _react2.default.createElement(
	                                            'span',
	                                            { className: 'uk-text-meta uk-text-danger' },
	                                            'Campo richiesto'
	                                        );
	                                    }
	
	                                    if (!values.messaggio) {
	                                        errors.messaggio = _react2.default.createElement(
	                                            'span',
	                                            { className: 'uk-text-meta uk-text-danger' },
	                                            'Campo richiesto'
	                                        );
	                                    }
	
	                                    if (!values.email) {
	                                        errors.email = _react2.default.createElement(
	                                            'span',
	                                            { className: 'uk-text-meta uk-text-danger' },
	                                            'Campo richiesto'
	                                        );
	                                    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
	                                        errors.email = _react2.default.createElement(
	                                            'span',
	                                            { className: 'uk-text-meta uk-text-danger' },
	                                            'Indirizzo email non valido'
	                                        );
	                                    }
	
	                                    return errors;
	                                },
	
	                                onSubmit: function onSubmit(values, actions) {
	
	                                    var corpo = '<p>' + values.nome + '</p>' + '<p>' + values.email + '</p>' + '<p>' + values.telefono + '</p>' + '<p>' + values.messaggio + '</p>';
	
	                                    var email = {
	                                        email: "info@prowed.it",
	                                        nome: "Prowedding",
	                                        nomeA: _this2.props.user.name, //nome fotografo,
	                                        emailA: _this2.props.user.email, //email fotografo,
	                                        soggetto: "Messaggio ricevuto dal tuo modulo contatti",
	                                        html: corpo
	                                    };
	
	                                    _axios2.default.post('https://www.prowedding.it/.netlify/functions/email', email).then(function (res) {
	
	                                        if (res.status === 200) {
	                                            _reactToastify.toast.success('Grazie. Il tuo messaggio è stato inviato con successo.');
	                                            actions.setSubmitting(false);
	                                            actions.resetForm({});
	                                        } else {
	                                            _reactToastify.toast.error('Attenzione. Si è verificato un errore.');
	                                            actions.setSubmitting(false);
	                                            console.log(res.data.message);
	                                        }
	                                    });
	                                }
	                            },
	                            function (_ref) {
	                                var values = _ref.values,
	                                    errors = _ref.errors,
	                                    touched = _ref.touched,
	                                    handleChange = _ref.handleChange,
	                                    handleSubmit = _ref.handleSubmit,
	                                    isSubmitting = _ref.isSubmitting;
	                                return _react2.default.createElement(
	                                    'form',
	                                    { onSubmit: handleSubmit, className: 'uk-margin-small-top' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-margin' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'uk-inline uk-width-1-1' },
	                                            _react2.default.createElement('span', { className: 'uk-form-icon', href: '#', 'data-uk-icon': 'icon: user' }),
	                                            _react2.default.createElement('input', {
	                                                className: errors.nome && touched.nome ? 'uk-input uk-form-large uk-form-danger' : 'uk-input uk-form-large',
	                                                type: 'text',
	                                                placeholder: 'Nome e Cognome',
	                                                name: 'nome',
	                                                onChange: handleChange,
	                                                value: values.nome || ''
	                                            }),
	                                            errors.nome && touched.nome && errors.nome
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-margin' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'uk-inline uk-width-1-1' },
	                                            _react2.default.createElement('span', { className: 'uk-form-icon', href: '#', 'data-uk-icon': 'icon: mail' }),
	                                            _react2.default.createElement('input', {
	                                                className: errors.email && touched.email ? 'uk-input uk-form-large uk-form-danger' : 'uk-input uk-form-large',
	                                                type: 'text',
	                                                placeholder: 'Email',
	                                                name: 'email',
	                                                onChange: handleChange,
	                                                value: values.email || ''
	                                            }),
	                                            errors.email && touched.email && errors.email
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-margin' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'uk-inline uk-width-1-1' },
	                                            _react2.default.createElement('span', { className: 'uk-form-icon', href: '#', 'data-uk-icon': 'icon: receiver' }),
	                                            _react2.default.createElement('input', {
	                                                className: errors.telefono && touched.telefono ? 'uk-input uk-form-large uk-form-danger' : 'uk-input uk-form-large',
	                                                type: 'text',
	                                                placeholder: 'Telefono',
	                                                name: 'telefono',
	                                                onChange: handleChange,
	                                                value: values.telefono || ''
	                                            }),
	                                            errors.telefono && touched.telefono && errors.telefono
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-margin' },
	                                        _react2.default.createElement('textarea', {
	
	                                            className: errors.messaggio && touched.messaggio ? 'uk-textarea uk-form-large uk-form-danger' : 'uk-textarea uk-form-large',
	                                            rows: '5',
	                                            name: 'messaggio',
	                                            placeholder: 'Messaggio',
	                                            onChange: handleChange,
	                                            value: values.messaggio || ''
	                                        }),
	                                        errors.messaggio && touched.messaggio && errors.messaggio
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-margin' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            { className: 'uk-button uk-button-default' },
	                                            isSubmitting ? 'Attendere...' : 'Invia Messaggio'
	                                        )
	                                    )
	                                );
	                            }
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'uk-width-auto@s uk-margin-large-top' },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'uk-list uk-list-large uk-text-lead' },
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'uk-flex uk-flex-middle' },
	                                _react2.default.createElement('span', { className: 'uk-margin-small-right', 'data-uk-icon': 'icon: home; ratio: 1.7' }),
	                                this.props.user.via1
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'uk-flex uk-flex-middle' },
	                                _react2.default.createElement('span', { className: 'uk-margin-small-right', 'data-uk-icon': 'icon:location; ratio: 1.7' }),
	                                this.props.user.citta1,
	                                ' (',
	                                this.props.user.provincia1,
	                                ')'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'uk-flex uk-flex-middle' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'uk-visible@s' },
	                                    _react2.default.createElement('span', { className: 'uk-margin-small-right', 'data-uk-icon': 'icon:receiver; ratio: 1.7' }),
	                                    this.props.user.telefono1a
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: "tel:" + this.props.user.telefono1a, className: 'uk-hidden@s uk-button uk-button-danger' },
	                                    'Chiama Ora'
	                                )
	                            ),
	                            this.props.user.telefono1b !== '' && _react2.default.createElement(
	                                'li',
	                                { className: 'uk-flex uk-flex-middle' },
	                                _react2.default.createElement('span', { className: 'uk-margin-small-right uk-visible@s', 'data-uk-icon': 'icon:receiver; ratio: 1.7' }),
	                                this.props.user.telefono1b
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Contatti;
	}(_react.Component);
	
	exports.default = Contatti;
	module.exports = exports['default'];

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bullet = __webpack_require__(227);
	
	var _bullet2 = _interopRequireDefault(_bullet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Faq = function (_Component) {
	    _inherits(Faq, _Component);
	
	    function Faq(props) {
	        _classCallCheck(this, Faq);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            accento: '',
	            faq: ''
	        };
	        return _this;
	    }
	
	    Faq.prototype.componentDidMount = function componentDidMount() {
	        this.setState({
	            accento: this.props.sito.coloreAccento || '#03a9f4',
	            faq: this.props.sito.faq || ''
	        });
	    };
	
	    Faq.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'faq', className: 'uk-section uk-section-muted uk-section-large' },
	            _react2.default.createElement(
	                'div',
	                { className: 'uk-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'uk-clearfix' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'uk-margin uk-text-bold uk-text-uppercase' },
	                        _react2.default.createElement(_bullet2.default, { colore: this.state.accento }),
	                        'FAQ'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'uk-margin-small-top' },
	                    this.state.faq.split('\n').map(function (item, key) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: key },
	                            _react2.default.createElement(
	                                'p',
	                                { className: key % 2 ? "" : "uk-text-lead" },
	                                item
	                            ),
	                            key % 2 ? _react2.default.createElement('div', { className: 'uk-margin-medium' }) : null
	                        );
	                    })
	                )
	            )
	        );
	    };
	
	    return Faq;
	}(_react.Component);
	
	exports.default = Faq;
	module.exports = exports['default'];

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	
	    var nome = props.user.name === undefined ? 'Prowedding' : props.user.name;
	    var piva = props.user.partitaIva === undefined ? '01234567890' : props.user.partitaIva;
	
	    return _react2.default.createElement(
	        'footer',
	        { className: 'uk-section-secondary' },
	        _react2.default.createElement(
	            'div',
	            { className: 'uk-section uk-section-xsmall', style: { backgroundColor: 'rgba(0,0,0,0.15)' } },
	            _react2.default.createElement(
	                'div',
	                { className: 'uk-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'uk-grid uk-child-width-1-2@s uk-text-center uk-text-left@s', 'data-uk-grid': '' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'uk-text-small uk-text-muted' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'uk-text-uppercase' },
	                            '\xA9 ',
	                            new Date().getFullYear(),
	                            ' ',
	                            nome,
	                            ' - P.IVA ',
	                            piva
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'uk-text-small uk-text-muted uk-text-center uk-text-right@s' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://www.webartsdesign.it' },
	                            'Crafted with ',
	                            _react2.default.createElement('span', { 'data-uk-icon': 'heart', className: 'uk-text-danger' }),
	                            ' by Webartsdesign'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gdpr = function (_Component) {
	    _inherits(Gdpr, _Component);
	
	    function Gdpr(props) {
	        _classCallCheck(this, Gdpr);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            consent: true
	        };
	        return _this;
	    }
	
	    Gdpr.prototype.componentDidMount = function componentDidMount() {
	        this.setState({ enableAnal: localStorage.getItem('Prowedding_analytics') ? JSON.parse(localStorage.getItem('Prowedding_analytics')) : null });
	        var visualizzo = localStorage.getItem('Prowedding_consent') ? JSON.parse(localStorage.getItem('Prowedding_consent')) : true;
	        if (visualizzo) {
	            try {
	                this.UIkit = __webpack_require__(82);
	                this.UIkit.modal('#gdpr').show();
	            } catch (e) {
	                console.error(e);
	            }
	        }
	    };
	
	    Gdpr.prototype.componentWillUnmount = function componentWillUnmount() {
	        try {
	            this.UIkit = __webpack_require__(82);
	            this.UIkit.modal('#gdpr').hide();
	        } catch (e) {
	            console.error(e);
	        }
	    };
	
	    Gdpr.prototype.setAcconsento = function setAcconsento() {
	        localStorage.setItem('Prowedding_analytics', true);
	        localStorage.setItem('Prowedding_consent', false);
	    };
	
	    Gdpr.prototype.goPolicy = function goPolicy() {
	        localStorage.setItem('Prowedding_analytics', true);
	        localStorage.setItem('Prowedding_consent', false);
	        (0, _gatsbyLink.navigateTo)('/professionista/cookie-policy?user=' + this.props.user.userId);
	    };
	
	    Gdpr.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'gdpr', 'data-uk-modal': 'bg-close: false' },
	            _react2.default.createElement(
	                'div',
	                { className: 'uk-modal-dialog' },
	                _react2.default.createElement('button', { onClick: this.setAcconsento.bind(this), className: 'uk-modal-close-default', type: 'button', 'data-uk-close': true }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'uk-modal-header' },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'uk-modal-title' },
	                        'Uso dei Cookie'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'uk-modal-body' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'uk-text-small' },
	                        'In questo sito, facciamo uso di cookie (o tecnologie similari) per memorizzare informazioni nel tuo computer o dispositivo mobile al fine di migliorare la tua esperienza online. I cookie sono piccoli file di testo che ti consentono di navigare in modo efficiente, ricordare le tue preferenze, aiutarci a comprendere la performance del sito e migliorare in generale la tua esperienza di utilizzo.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'uk-text-small uk-text-bold' },
	                        'Chiudendo questo messaggio acconsenti all\'utilizzo dei cookie in base alle tue (eventuali) preferenze.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'uk-modal-footer uk-text-right' },
	                    _react2.default.createElement(
	                        'button',
	                        { onClick: this.goPolicy.bind(this), className: 'uk-button uk-button-default uk-margin-small-right uk-modal-close' },
	                        'Cookie Policy'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { onClick: this.setAcconsento.bind(this), className: 'uk-button uk-button-secondary uk-modal-close' },
	                        'Acconsento'
	                    )
	                )
	            )
	        );
	    };
	
	    return Gdpr;
	}(_react.Component);
	
	exports.default = Gdpr;
	module.exports = exports['default'];

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	
		return _react2.default.createElement(
			'header',
			{ className: 'uk-position-top uk-light' },
			_react2.default.createElement(
				'nav',
				{ className: 'trans uk-navbar-container uk-navbar-transparent', 'data-uk-navbar': true, 'data-uk-sticky': '' },
				_react2.default.createElement(
					'a',
					{ className: 'uk-link-reset', href: '#top', 'data-uk-scroll': true },
					_react2.default.createElement(
						'h1',
						{ className: 'uk-navbar-item uk-logo uk-text-uppercase uk-margin-remove' },
						props.logo
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'uk-navbar-left uk-visible@s' },
					_react2.default.createElement(
						'ul',
						{ className: 'uk-navbar-nav', 'data-uk-scrollspy-nav': 'closest: li; scroll:true' },
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '#top' },
								'Top'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '#about' },
								'About'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '#portfolio' },
								'Portfolio'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '#faq' },
								'Faq'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: '#contatti' },
								'Contatti'
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'uk-navbar-right uk-visible@s' },
					_react2.default.createElement(
						'ul',
						{ className: 'uk-navbar-nav' },
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/professionista/cookie-policy?user=" + props.user },
								'Cookie Policy'
							)
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/professionista/privacy-policy?user=" + props.user },
								'Privacy Policy'
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(419);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _anonymus = __webpack_require__(83);
	
	var _anonymus2 = _interopRequireDefault(_anonymus);
	
	var _cover = __webpack_require__(245);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeroOrizzontale = function (_Component) {
		_inherits(HeroOrizzontale, _Component);
	
		function HeroOrizzontale(props) {
			_classCallCheck(this, HeroOrizzontale);
	
			var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
			_this.state = {
				opacity: 0,
				opacityP: 0,
				cover: _cover2.default,
				coverType: '',
				effettoCover: '',
				coloreCover: ''
			};
			return _this;
		}
	
		HeroOrizzontale.prototype.componentDidMount = function componentDidMount() {
	
			this.setState({
				cover: this.props.sito.cover || _cover2.default,
				coverType: this.props.sito.coverType || 'image/png',
				effettoCover: this.props.sito.effettoCover || 'nessuno',
				coloreCover: this.props.sito.coloreCover || '#333333'
			});
		};
	
		HeroOrizzontale.prototype.imgLoaded = function imgLoaded() {
			this.setState({ opacity: 1 });
		};
	
		HeroOrizzontale.prototype.prfLoaded = function prfLoaded() {
			this.setState({ opacityP: 1 });
		};
	
		HeroOrizzontale.prototype.render = function render() {
	
			return _react2.default.createElement(
				'div',
				{
					id: 'top',
					className: 'uk-flex uk-flex-center uk-flex-middle uk-light uk-position-relative',
					'data-uk-height-viewport': '',
					style: { backgroundColor: this.state.coloreCover, overflow: 'hidden' }
				},
				this.state.coverType.includes('image') ? _react2.default.createElement('img', {
					className: this.state.effettoCover !== 'nessuno' ? 'uk-blend-' + this.state.effettoCover : '',
					onLoad: this.imgLoaded.bind(this), src: this.state.cover, style: {
						top: 0,
						left: 0,
						position: 'absolute',
						objectFit: 'cover',
						objectPosition: 'center top',
						height: '100%',
						width: '100%',
						opacity: this.state.opacity,
						transition: 'opacity 0.8s',
						WebkitTransition: 'opacity 0.8s',
						msTransition: 'opacity 0.8s'
					}
				}) : _react2.default.createElement(
					'video',
					{
						onCanPlay: this.imgLoaded.bind(this),
						className: this.state.effettoCover !== 'nessuno' ? 'uk-blend-' + this.state.effettoCover : '',
						loop: true,
						muted: true,
						playsInline: true,
						'data-uk-video': 'autoplay: inview',
						style: {
							top: 0,
							left: 0,
							position: 'absolute',
							objectFit: 'cover',
							objectPosition: 'center top',
							height: '100%',
							width: '100%',
							opacity: this.state.opacity,
							transition: 'opacity 0.8s',
							WebkitTransition: 'opacity 0.8s',
							msTransition: 'opacity 0.8s'
						} },
					_react2.default.createElement('source', { src: this.state.cover, type: this.state.coverType })
				),
				_react2.default.createElement(_header2.default, { logo: this.props.user.name, user: this.props.user.userId }),
				_react2.default.createElement(
					'div',
					{ className: 'uk-text-center', style: { zIndex: '2' } },
					_react2.default.createElement('img', {
						onLoad: this.prfLoaded.bind(this),
						className: 'uk-border-circle',
						src: this.props.user.foto || _anonymus2.default,
						width: '200',
						height: '200',
						alt: '',
						style: {
							border: '8px solid rgba(255,255,255,0.3)',
							opacity: this.state.opacityP,
							transition: 'opacity 0.3s',
							WebkitTransition: 'opacity 0.3s',
							msTransition: 'opacity 0.3s'
						}
					}),
					_react2.default.createElement(
						'div',
						{ className: 'uk-text-center uk-margin' },
						_react2.default.createElement(
							'h2',
							{ className: 'uk-card-title uk-margin-remove uk-text-uppercase' },
							this.props.user.name
						),
						_react2.default.createElement(
							'p',
							{ className: 'uk-margin-small uk-text-uppercase' },
							this.props.user.ruolo
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'uk-flex uk-flex-center' },
						this.props.user.twitter && _react2.default.createElement(
							'div',
							{ className: 'uk-margin-small-left uk-margin-small-right' },
							_react2.default.createElement('a', { target: '_blank', 'data-uk-icon': 'icon: twitter;ratio: 1', href: this.props.user.twitter, className: 'uk-icon-link uk-icon' })
						),
						this.props.user.instagram && _react2.default.createElement(
							'div',
							{ className: 'uk-margin-small-left uk-margin-small-right' },
							_react2.default.createElement('a', { target: '_blank', 'data-uk-icon': 'icon: instagram;ratio: 1', href: this.props.user.instagram, className: 'uk-icon-link uk-icon' })
						),
						this.props.user.facebook && _react2.default.createElement(
							'div',
							{ target: '_blank', className: 'uk-margin-small-left uk-margin-small-right' },
							_react2.default.createElement('a', { 'data-uk-icon': 'icon: facebook;ratio: 1', href: this.props.user.facebook, className: 'uk-icon-link uk-icon' })
						),
						this.props.user.web && _react2.default.createElement(
							'div',
							{ target: '_blank', className: 'uk-margin-small-left uk-margin-small-right' },
							_react2.default.createElement('a', { 'data-uk-icon': 'icon: link;ratio: 1', href: this.props.user.web, className: 'uk-icon-link uk-icon' })
						)
					)
				)
			);
		};
	
		return HeroOrizzontale;
	}(_react.Component);
	
	exports.default = HeroOrizzontale;
	module.exports = exports['default'];

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(77);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _footer = __webpack_require__(417);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _hero = __webpack_require__(420);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _chisono = __webpack_require__(414);
	
	var _chisono2 = _interopRequireDefault(_chisono);
	
	var _portfolio = __webpack_require__(424);
	
	var _portfolio2 = _interopRequireDefault(_portfolio);
	
	var _faq = __webpack_require__(416);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _contatti = __webpack_require__(415);
	
	var _contatti2 = _interopRequireDefault(_contatti);
	
	var _mappa = __webpack_require__(422);
	
	var _mappa2 = _interopRequireDefault(_mappa);
	
	var _gdpr = __webpack_require__(418);
	
	var _gdpr2 = _interopRequireDefault(_gdpr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LayoutOrizzontale = function (_Component) {
	    _inherits(LayoutOrizzontale, _Component);
	
	    function LayoutOrizzontale(props) {
	        _classCallCheck(this, LayoutOrizzontale);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            enableAnal: null
	        };
	        return _this;
	    }
	
	    LayoutOrizzontale.prototype.componentDidMount = function componentDidMount() {
	        this.setState({ enableAnal: localStorage.getItem('Prowedding_analytics') ? JSON.parse(localStorage.getItem('Prowedding_analytics')) : null });
	    };
	
	    LayoutOrizzontale.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    this.props.sito.titolo,
	                    ' - Prowedding'
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: this.props.sito.descrizione }),
	                _react2.default.createElement('meta', { property: 'og:url', content: window.location.href }),
	                _react2.default.createElement('meta', { property: 'og:title', content: this.props.sito.titolo }),
	                _react2.default.createElement('meta', { property: 'og:description', content: this.props.sito.descrizione }),
	                _react2.default.createElement('meta', { property: 'og:image', content: this.props.sito.cover }),
	                _react2.default.createElement(
	                    'script',
	                    null,
	                    '\n\t\t\t\t\t\t\t\t\t(function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n\t\t\t\t\t\t\t\t\t(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n\t\t\t\t\t\t\t\t\tm=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n\t\t\t\t\t\t\t\t\t})(window,document,\'script\',\'https://www.google-analytics.com/analytics.js\',\'ga\');\n\t\n\t\t\t\t\t\t\t\t\twindow[\'ga-disable-' + this.props.sito.codice + '\'] = ' + !this.state.enableAnal + ';\n\n\t\t\t\t\t\t\t\t\tga(\'set\', \'anonymizeIp\', true);\n\t\t\t\t\t\t\t\t\tga(\'create\', \'' + this.props.sito.codice + '\', \'auto\');\n\t\t\t\t\t\t\t\t\tga(\'send\', \'pageview\');\n\t\t\t\t\t\t\t\t'
	                )
	            ),
	            _react2.default.createElement(_hero2.default, { user: this.props.user, sito: this.props.sito }),
	            _react2.default.createElement(_chisono2.default, { user: this.props.user, sito: this.props.sito }),
	            _react2.default.createElement(_portfolio2.default, { sito: this.props.sito }),
	            _react2.default.createElement(_faq2.default, { sito: this.props.sito }),
	            _react2.default.createElement(_contatti2.default, { user: this.props.user, sito: this.props.sito }),
	            _react2.default.createElement(_mappa2.default, { user: this.props.user, sito: this.props.sito }),
	            _react2.default.createElement(_footer2.default, { user: this.props.user }),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_gdpr2.default, { user: this.props.user })
	            )
	        );
	    };
	
	    return LayoutOrizzontale;
	}(_react.Component);
	
	exports.default = LayoutOrizzontale;
	module.exports = exports['default'];

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _googleMapReact = __webpack_require__(286);
	
	var _googleMapReact2 = _interopRequireDefault(_googleMapReact);
	
	var _point = __webpack_require__(425);
	
	var _point2 = _interopRequireDefault(_point);
	
	var _stile = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Mappa = function (_Component) {
	    _inherits(Mappa, _Component);
	
	    function Mappa() {
	        _classCallCheck(this, Mappa);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Mappa.prototype.render = function render() {
	        var _props = this.props,
	            user = _props.user,
	            sito = _props.sito;
	
	
	        var stileDef = _stile.stile1;
	        var altz = '450px';
	
	        switch (sito.mappa) {
	            case 'stile2':
	                stileDef = _stile.stile2;
	                break;
	            case 'stile3':
	                stileDef = _stile.stile3;
	                break;
	            case 'stile4':
	                stileDef = _stile.stile4;
	                break;
	            case 'stile5':
	                stileDef = _stile.stile5;
	                break;
	            case 'stile6':
	                stileDef = _stile.stile6;
	                break;
	            default:
	                stileDef = _stile.stile1;
	
	        }
	
	        switch (sito.altezzaMappa) {
	            case 'full':
	                altz = '100vh';
	                break;
	            case 'bassa':
	                altz = '300px';
	                break;
	            default:
	                altz = '450px';
	
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: { height: altz } },
	            _react2.default.createElement(
	                _googleMapReact2.default,
	                {
	                    bootstrapURLKeys: { key: 'AIzaSyBci-Kct7x2uLWWDWqBV0ciOcfL6TPCSsM' },
	                    defaultCenter: { lat: user.lat1, lng: user.lng1 },
	                    defaultZoom: 11,
	                    yesIWantToUseGoogleMapApiInternals: true,
	                    options: { styles: stileDef }
	                },
	                _react2.default.createElement(_point2.default, {
	                    lat: user.lat1,
	                    lng: user.lng1,
	                    nome: user.name,
	                    provincia: user.provincia1,
	                    citta: user.citta1,
	                    via: user.via1,
	                    immagine: user.foto,
	                    colore: sito.coloreAccento || '#03a9f4'
	                })
	            )
	        );
	    };
	
	    return Mappa;
	}(_react.Component);
	
	exports.default = Mappa;
	module.exports = exports['default'];

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var stile1 = exports.stile1 = [{
	    "featureType": "administrative.country",
	    "elementType": "geometry",
	    "stylers": [{
	        "visibility": "simplified"
	    }, {
	        "hue": "#ff0000"
	    }]
	}];
	
	var stile2 = exports.stile2 = [{
	    "featureType": "all",
	    "elementType": "all",
	    "stylers": [{
	        "visibility": "on"
	    }]
	}, {
	    "featureType": "all",
	    "elementType": "labels",
	    "stylers": [{
	        "visibility": "off"
	    }, {
	        "saturation": "-100"
	    }]
	}, {
	    "featureType": "all",
	    "elementType": "labels.text.fill",
	    "stylers": [{
	        "saturation": 36
	    }, {
	        "color": "#000000"
	    }, {
	        "lightness": 40
	    }, {
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "all",
	    "elementType": "labels.text.stroke",
	    "stylers": [{
	        "visibility": "off"
	    }, {
	        "color": "#000000"
	    }, {
	        "lightness": 16
	    }]
	}, {
	    "featureType": "all",
	    "elementType": "labels.icon",
	    "stylers": [{
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "administrative",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "color": "#000000"
	    }, {
	        "lightness": 20
	    }]
	}, {
	    "featureType": "administrative",
	    "elementType": "geometry.stroke",
	    "stylers": [{
	        "color": "#000000"
	    }, {
	        "lightness": 17
	    }, {
	        "weight": 1.2
	    }]
	}, {
	    "featureType": "landscape",
	    "elementType": "geometry",
	    "stylers": [{
	        "color": "#000000"
	    }, {
	        "lightness": 20
	    }]
	}, {
	    "featureType": "landscape",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "color": "#4d6059"
	    }]
	}, {
	    "featureType": "landscape",
	    "elementType": "geometry.stroke",
	    "stylers": [{
	        "color": "#4d6059"
	    }]
	}, {
	    "featureType": "landscape.natural",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "color": "#4d6059"
	    }]
	}, {
	    "featureType": "poi",
	    "elementType": "geometry",
	    "stylers": [{
	        "lightness": 21
	    }]
	}, {
	    "featureType": "poi",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "color": "#4d6059"
	    }]
	}, {
	    "featureType": "poi",
	    "elementType": "geometry.stroke",
	    "stylers": [{
	        "color": "#4d6059"
	    }]
	}, {
	    "featureType": "road",
	    "elementType": "geometry",
	    "stylers": [{
	        "visibility": "on"
	    }, {
	        "color": "#7f8d89"
	    }]
	}, {
	    "featureType": "road",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "color": "#7f8d89"
	    }]
	}, {
	    "featureType": "road.highway",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "color": "#7f8d89"
	    }, {
	        "lightness": 17
	    }]
	}, {
	    "featureType": "road.highway",
	    "elementType": "geometry.stroke",
	    "stylers": [{
	        "color": "#7f8d89"
	    }, {
	        "lightness": 29
	    }, {
	        "weight": 0.2
	    }]
	}, {
	    "featureType": "road.arterial",
	    "elementType": "geometry",
	    "stylers": [{
	        "color": "#000000"
	    }, {
	        "lightness": 18
	    }]
	}, {
	    "featureType": "road.arterial",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "color": "#7f8d89"
	    }]
	}, {
	    "featureType": "road.arterial",
	    "elementType": "geometry.stroke",
	    "stylers": [{
	        "color": "#7f8d89"
	    }]
	}, {
	    "featureType": "road.local",
	    "elementType": "geometry",
	    "stylers": [{
	        "color": "#000000"
	    }, {
	        "lightness": 16
	    }]
	}, {
	    "featureType": "road.local",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "color": "#7f8d89"
	    }]
	}, {
	    "featureType": "road.local",
	    "elementType": "geometry.stroke",
	    "stylers": [{
	        "color": "#7f8d89"
	    }]
	}, {
	    "featureType": "transit",
	    "elementType": "geometry",
	    "stylers": [{
	        "color": "#000000"
	    }, {
	        "lightness": 19
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "all",
	    "stylers": [{
	        "color": "#2b3638"
	    }, {
	        "visibility": "on"
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "geometry",
	    "stylers": [{
	        "color": "#2b3638"
	    }, {
	        "lightness": 17
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "color": "#24282b"
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "geometry.stroke",
	    "stylers": [{
	        "color": "#24282b"
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "labels",
	    "stylers": [{
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "labels.text",
	    "stylers": [{
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "labels.text.fill",
	    "stylers": [{
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "labels.text.stroke",
	    "stylers": [{
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "labels.icon",
	    "stylers": [{
	        "visibility": "off"
	    }]
	}];
	
	var stile3 = exports.stile3 = [{
	    "featureType": "landscape",
	    "stylers": [{
	        "hue": "#FFAD00"
	    }, {
	        "saturation": 50.2
	    }, {
	        "lightness": -34.8
	    }, {
	        "gamma": 1
	    }]
	}, {
	    "featureType": "road.highway",
	    "stylers": [{
	        "hue": "#FFAD00"
	    }, {
	        "saturation": -19.8
	    }, {
	        "lightness": -1.8
	    }, {
	        "gamma": 1
	    }]
	}, {
	    "featureType": "road.arterial",
	    "stylers": [{
	        "hue": "#FFAD00"
	    }, {
	        "saturation": 72.4
	    }, {
	        "lightness": -32.6
	    }, {
	        "gamma": 1
	    }]
	}, {
	    "featureType": "road.local",
	    "stylers": [{
	        "hue": "#FFAD00"
	    }, {
	        "saturation": 74.4
	    }, {
	        "lightness": -18
	    }, {
	        "gamma": 1
	    }]
	}, {
	    "featureType": "water",
	    "stylers": [{
	        "hue": "#00FFA6"
	    }, {
	        "saturation": -63.2
	    }, {
	        "lightness": 38
	    }, {
	        "gamma": 1
	    }]
	}, {
	    "featureType": "poi",
	    "stylers": [{
	        "hue": "#FFC300"
	    }, {
	        "saturation": 54.2
	    }, {
	        "lightness": -14.4
	    }, {
	        "gamma": 1
	    }]
	}];
	
	var stile4 = exports.stile4 = [{
	    "featureType": "poi",
	    "elementType": "all",
	    "stylers": [{
	        "hue": "#000000"
	    }, {
	        "saturation": -100
	    }, {
	        "lightness": -100
	    }, {
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "poi",
	    "elementType": "all",
	    "stylers": [{
	        "hue": "#000000"
	    }, {
	        "saturation": -100
	    }, {
	        "lightness": -100
	    }, {
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "administrative",
	    "elementType": "all",
	    "stylers": [{
	        "hue": "#000000"
	    }, {
	        "saturation": 0
	    }, {
	        "lightness": -100
	    }, {
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "road",
	    "elementType": "labels",
	    "stylers": [{
	        "hue": "#ffffff"
	    }, {
	        "saturation": -100
	    }, {
	        "lightness": 100
	    }, {
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "labels",
	    "stylers": [{
	        "hue": "#000000"
	    }, {
	        "saturation": -100
	    }, {
	        "lightness": -100
	    }, {
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "road.local",
	    "elementType": "all",
	    "stylers": [{
	        "hue": "#ffffff"
	    }, {
	        "saturation": -100
	    }, {
	        "lightness": 100
	    }, {
	        "visibility": "on"
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "geometry",
	    "stylers": [{
	        "hue": "#ffffff"
	    }, {
	        "saturation": -100
	    }, {
	        "lightness": 100
	    }, {
	        "visibility": "on"
	    }]
	}, {
	    "featureType": "transit",
	    "elementType": "labels",
	    "stylers": [{
	        "hue": "#000000"
	    }, {
	        "saturation": 0
	    }, {
	        "lightness": -100
	    }, {
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "landscape",
	    "elementType": "labels",
	    "stylers": [{
	        "hue": "#000000"
	    }, {
	        "saturation": -100
	    }, {
	        "lightness": -100
	    }, {
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "road",
	    "elementType": "geometry",
	    "stylers": [{
	        "hue": "#bbbbbb"
	    }, {
	        "saturation": -100
	    }, {
	        "lightness": 26
	    }, {
	        "visibility": "on"
	    }]
	}, {
	    "featureType": "landscape",
	    "elementType": "geometry",
	    "stylers": [{
	        "hue": "#dddddd"
	    }, {
	        "saturation": -100
	    }, {
	        "lightness": -3
	    }, {
	        "visibility": "on"
	    }]
	}];
	
	var stile5 = exports.stile5 = [{
	    "featureType": "landscape.natural",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "visibility": "on"
	    }, {
	        "color": "#e0efef"
	    }]
	}, {
	    "featureType": "poi",
	    "elementType": "geometry.fill",
	    "stylers": [{
	        "visibility": "on"
	    }, {
	        "hue": "#1900ff"
	    }, {
	        "color": "#c0e8e8"
	    }]
	}, {
	    "featureType": "road",
	    "elementType": "geometry",
	    "stylers": [{
	        "lightness": 100
	    }, {
	        "visibility": "simplified"
	    }]
	}, {
	    "featureType": "road",
	    "elementType": "labels",
	    "stylers": [{
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "transit.line",
	    "elementType": "geometry",
	    "stylers": [{
	        "visibility": "on"
	    }, {
	        "lightness": 700
	    }]
	}, {
	    "featureType": "water",
	    "elementType": "all",
	    "stylers": [{
	        "color": "#7dcdcd"
	    }]
	}];
	
	var stile6 = exports.stile6 = [{
	    "featureType": "water",
	    "elementType": "geometry",
	    "stylers": [{
	        "color": "#193341"
	    }]
	}, {
	    "featureType": "landscape",
	    "elementType": "geometry",
	    "stylers": [{
	        "color": "#2c5a71"
	    }]
	}, {
	    "featureType": "road",
	    "elementType": "geometry",
	    "stylers": [{
	        "color": "#29768a"
	    }, {
	        "lightness": -37
	    }]
	}, {
	    "featureType": "poi",
	    "elementType": "geometry",
	    "stylers": [{
	        "color": "#406d80"
	    }]
	}, {
	    "featureType": "transit",
	    "elementType": "geometry",
	    "stylers": [{
	        "color": "#406d80"
	    }]
	}, {
	    "elementType": "labels.text.stroke",
	    "stylers": [{
	        "visibility": "on"
	    }, {
	        "color": "#3e606f"
	    }, {
	        "weight": 2
	    }, {
	        "gamma": 0.84
	    }]
	}, {
	    "elementType": "labels.text.fill",
	    "stylers": [{
	        "color": "#ffffff"
	    }]
	}, {
	    "featureType": "administrative",
	    "elementType": "geometry",
	    "stylers": [{
	        "weight": 0.6
	    }, {
	        "color": "#1a3541"
	    }]
	}, {
	    "elementType": "labels.icon",
	    "stylers": [{
	        "visibility": "off"
	    }]
	}, {
	    "featureType": "poi.park",
	    "elementType": "geometry",
	    "stylers": [{
	        "color": "#2c5a71"
	    }]
	}];

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uikit = __webpack_require__(82);
	
	var _uikit2 = _interopRequireDefault(_uikit);
	
	__webpack_require__(131);
	
	var _bullet = __webpack_require__(227);
	
	var _bullet2 = _interopRequireDefault(_bullet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portfolio = function (_Component) {
	    _inherits(Portfolio, _Component);
	
	    function Portfolio(props) {
	        _classCallCheck(this, Portfolio);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            accento: '',
	            media: [],
	            mediaFiltrato: [],
	            currentPage: 1,
	            perPage: 9,
	            visibile: 'isAll'
	        };
	        return _this;
	    }
	
	    Portfolio.prototype.componentDidMount = function componentDidMount() {
	        var _props$sito = this.props.sito,
	            portfolio = _props$sito.portfolio,
	            coloreAccento = _props$sito.coloreAccento;
	
	
	        this.setState({
	            media: portfolio || [],
	            mediaFiltrato: portfolio || [],
	            accento: coloreAccento || '#03a9f4'
	        });
	    };
	
	    Portfolio.prototype.filtraMedia = function filtraMedia(tipo) {
	        var media = this.state.media;
	
	
	        var mediaFiltrato = [];
	
	        if (tipo === 'isFoto') {
	            mediaFiltrato = media.filter(function (f) {
	                return f.contentType.includes('image');
	            });
	        } else if (tipo === 'isVideo') {
	            mediaFiltrato = media.filter(function (f) {
	                return f.contentType.includes('video');
	            });
	        } else {
	            mediaFiltrato = media;
	        }
	
	        this.setState({
	            visibile: tipo,
	            mediaFiltrato: mediaFiltrato
	        });
	    };
	
	    Portfolio.prototype.cambiaPagina = function cambiaPagina(numero) {
	        this.setState({ currentPage: Number(numero) });
	    };
	
	    Portfolio.prototype.showLightbox = function showLightbox(ind) {
	        var media = this.state.media;
	
	        var temp = [];
	
	        media && media.map(function (item) {
	            return temp.push({ source: item.url, caption: item.descBreve });
	        });
	
	        _uikit2.default.lightboxPanel({
	            items: temp
	        }).show(ind);
	    };
	
	    Portfolio.prototype.render = function render() {
	        var _this2 = this;
	
	        var _state = this.state,
	            media = _state.media,
	            mediaFiltrato = _state.mediaFiltrato,
	            currentPage = _state.currentPage,
	            perPage = _state.perPage,
	            accento = _state.accento,
	            visibile = _state.visibile;
	
	        // Logic for displaying current media
	
	        var indexOfLastMedia = currentPage * perPage;
	        var indexOfFirstMedia = indexOfLastMedia - perPage;
	        var currentMedia = mediaFiltrato.length > 0 && mediaFiltrato.slice(indexOfFirstMedia, indexOfLastMedia);
	
	        // Logic for displaying page numbers
	        var pageNumbers = [];
	        for (var i = 1; i <= Math.ceil(mediaFiltrato.length / perPage); i++) {
	            pageNumbers.push(i);
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'portfolio', className: 'uk-section uk-section-default uk-section-large' },
	            _react2.default.createElement(
	                'div',
	                { className: 'uk-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'uk-clearfix' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'uk-float-right' },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'uk-subnav uk-subnav-pill', style: { marginTop: '5px' } },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { onClick: this.filtraMedia.bind(this, 'isAll'), style: visibile === 'isAll' ? { background: accento, color: '#fff', cursor: 'default' } : { background: '#fff', cursor: 'pointer' } },
	                                    'Tutto'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { onClick: this.filtraMedia.bind(this, 'isFoto'), style: visibile === 'isFoto' ? { background: accento, color: '#fff', cursor: 'default' } : { background: '#fff', cursor: 'pointer' } },
	                                    'Foto'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { onClick: this.filtraMedia.bind(this, 'isVideo'), style: visibile === 'isVideo' ? { background: accento, color: '#fff', cursor: 'default' } : { background: '#fff', cursor: 'pointer' } },
	                                    'Video'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'uk-float-left' },
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'uk-text-bold uk-text-uppercase' },
	                            _react2.default.createElement(_bullet2.default, { colore: this.state.accento }),
	                            'Portfolio'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'js-filter uk-margin-small-top uk-grid-small uk-grid-match uk-child-width-1-3@s', 'data-uk-grid': true, 'data-uk-scrollspy': 'cls: uk-animation-fade; target: > div; delay: 90;' },
	                    currentMedia && currentMedia.map(function (item, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: index },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'uk-inline-clip uk-transition-toggle ' },
	                                item.contentType.includes('image') ? _react2.default.createElement(
	                                    'div',
	                                    { style: { cursor: 'pointer' }, onClick: _this2.showLightbox.bind(_this2, index + (currentPage - 1) * perPage) },
	                                    _react2.default.createElement('div', {
	                                        className: 'uk-height-medium uk-background-cover',
	                                        'data-src': item.url,
	                                        'data-uk-img': true,
	                                        alt: item.descBreve
	                                    }),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-transition-fade uk-position-cover uk-position-small uk-overlay uk-overlay-default uk-flex uk-flex-center uk-flex-middle' },
	                                        _react2.default.createElement('span', { className: 'uk-margin-remove', 'data-uk-icon': 'icon: plus; ratio: 3' })
	                                    )
	                                ) : _react2.default.createElement(
	                                    'div',
	                                    {
	                                        className: 'uk-position-relative uk-height-medium',
	                                        onClick: _this2.showLightbox.bind(_this2, index + (currentPage - 1) * perPage),
	                                        style: { cursor: 'pointer', overflow: 'hidden' } },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-card-badge uk-label', style: { background: accento, color: '#fff' } },
	                                        'Video'
	                                    ),
	                                    _react2.default.createElement(
	                                        'video',
	                                        { loop: true, muted: true, playsInline: true,
	                                            style: {
	                                                top: 0,
	                                                left: 0,
	                                                position: 'absolute',
	                                                objectFit: 'cover',
	                                                objectPosition: 'center top',
	                                                height: '100%',
	                                                width: '100%'
	                                            }
	                                        },
	                                        _react2.default.createElement('source', { src: item.url, type: item.contentType })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'uk-transition-fade uk-position-cover uk-position-small uk-overlay uk-overlay-default uk-flex uk-flex-center uk-flex-middle' },
	                                        _react2.default.createElement('span', { className: 'uk-margin-remove', 'data-uk-icon': 'icon: play; ratio: 3.5' })
	                                    )
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'uk-pagination uk-flex-center pagi', 'data-uk-margin': true },
	                    pageNumbers.map(function (numero) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: numero },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#portfolio',
	                                    'data-uk-scroll': 'duration: 600',
	                                    onClick: function onClick() {
	                                        return setTimeout(_this2.cambiaPagina.bind(_this2, numero), 600);
	                                    },
	                                    style: currentPage === numero ? { background: accento, color: '#fff', cursor: 'default' } : { background: '#fff' } },
	                                numero
	                            )
	                        );
	                    })
	                )
	            )
	        );
	    };
	
	    return Portfolio;
	}(_react.Component);
	
	exports.default = Portfolio;
	module.exports = exports['default'];

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Point = function Point(props) {
	    return _react2.default.createElement(
	        'div',
	        { style: { width: '50px' } },
	        _react2.default.createElement(
	            'div',
	            { className: 'pinfix', style: { background: props.colore } },
	            _react2.default.createElement('img', { className: 'uk-border-circle', width: '50', height: '50', src: props.immagine, 'data-uk-tooltip': props.nome })
	        ),
	        _react2.default.createElement('div', { className: 'pulse' })
	    );
	};
	
	exports.default = Point;
	module.exports = exports['default'];

/***/ }),
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _firebase = __webpack_require__(8);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _manutenzione = __webpack_require__(679);
	
	var _manutenzione2 = _interopRequireDefault(_manutenzione);
	
	var _layoutorizzontale = __webpack_require__(421);
	
	var _layoutorizzontale2 = _interopRequireDefault(_layoutorizzontale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Professionista = function (_Component) {
		_inherits(Professionista, _Component);
	
		function Professionista(props) {
			_classCallCheck(this, Professionista);
	
			var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
			_this.state = {
				sito: {},
				account: {},
				loading: true
			};
			return _this;
		}
	
		Professionista.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			var posizione = this.props.location.search.substr(6).indexOf('&');
	
			var userId = "";
	
			if (posizione > -1) {
				userId = this.props.location.search.substr(6, posizione);
			} else {
				userId = this.props.location.search.substr(6);
			}
	
			_firebase2.default.database().ref().child('account/' + userId).on('value', function (snapshot) {
				snapshot.val() !== null && _this2.setState({ account: snapshot.val() });
				snapshot.val() !== null && _firebase2.default.database().ref().child('sito/' + userId).on('value', function (sito) {
					_this2.setState({ sito: sito.val(), loading: false });
				});
			});
		};
	
		Professionista.prototype.render = function render() {
	
			return _react2.default.createElement(
				_react.Fragment,
				null,
				!this.state.loading ? _react2.default.createElement(
					_react.Fragment,
					null,
					this.state.sito === null ? _react2.default.createElement(
						'section',
						{ className: 'uk-section uk-section-large' },
						_react2.default.createElement(
							'div',
							{ className: 'uk-flex uk-flex-center uk-margin' },
							_react2.default.createElement('img', { src: _manutenzione2.default, style: { maxWidth: '300px' } })
						),
						_react2.default.createElement(
							'h1',
							{ className: 'uk-heading-medium uk-text-center' },
							'Sito in manutenzione'
						)
					) : _react2.default.createElement(_layoutorizzontale2.default, { user: this.state.account, sito: this.state.sito })
				) : _react2.default.createElement(
					'div',
					{ className: 'uk-position-center' },
					_react2.default.createElement('div', { className: 'loadr' }),
					_react2.default.createElement('div', { className: 'loadr' })
				)
			);
		};
	
		return Professionista;
	}(_react.Component);
	
	exports.default = Professionista;
	module.exports = exports['default'];

/***/ }),
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/manutenzione.9e296d21.png";

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-professionista-index-js-13990bbfb40eca5036c8.js